var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("@walletconnect/web3-subprovider", [], e) : "object" == typeof exports ? exports["@walletconnect/web3-subprovider"] = e() : t["@walletconnect/web3-subprovider"] = e();
}(this, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var i = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        r.d(n, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 64);
  }([function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : t.exports = function (t, e) {
      t.super_ = e;

      var r = function r() {};

      r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
    };
  }, function (t, e, r) {
    var n = r(7),
        i = n.Buffer;

    function o(t, e) {
      for (var r in t) {
        e[r] = t[r];
      }
    }

    function a(t, e, r) {
      return i(t, e, r);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = a), o(i, a), a.from = function (t, e, r) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return i(t, e, r);
    }, a.alloc = function (t, e, r) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var n = i(t);
      return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
    }, a.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return i(t);
    }, a.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return n.SlowBuffer(t);
    };
  }, function (t, e, r) {
    (function (t) {
      !function (t, e) {
        "use strict";

        function n(t, e) {
          if (!t) throw new Error(e || "Assertion failed");
        }

        function i(t, e) {
          t.super_ = e;

          var r = function r() {};

          r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
        }

        function o(t, e, r) {
          if (o.isBN(t)) return t;
          this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== t && ("le" !== e && "be" !== e || (r = e, e = 10), this._init(t || 0, e || 10, r || "be"));
        }

        var a;
        "object" == typeof t ? t.exports = o : e.BN = o, o.BN = o, o.wordSize = 26;

        try {
          a = r(129).Buffer;
        } catch (t) {}

        function s(t, e, r) {
          for (var n = 0, i = Math.min(t.length, r), o = e; o < i; o++) {
            var a = t.charCodeAt(o) - 48;
            n <<= 4, n |= a >= 49 && a <= 54 ? a - 49 + 10 : a >= 17 && a <= 22 ? a - 17 + 10 : 15 & a;
          }

          return n;
        }

        function f(t, e, r, n) {
          for (var i = 0, o = Math.min(t.length, r), a = e; a < o; a++) {
            var s = t.charCodeAt(a) - 48;
            i *= n, i += s >= 49 ? s - 49 + 10 : s >= 17 ? s - 17 + 10 : s;
          }

          return i;
        }

        o.isBN = function (t) {
          return t instanceof o || null !== t && "object" == typeof t && t.constructor.wordSize === o.wordSize && Array.isArray(t.words);
        }, o.max = function (t, e) {
          return t.cmp(e) > 0 ? t : e;
        }, o.min = function (t, e) {
          return t.cmp(e) < 0 ? t : e;
        }, o.prototype._init = function (t, e, r) {
          if ("number" == typeof t) return this._initNumber(t, e, r);
          if ("object" == typeof t) return this._initArray(t, e, r);
          "hex" === e && (e = 16), n(e === (0 | e) && e >= 2 && e <= 36);
          var i = 0;
          "-" === (t = t.toString().replace(/\s+/g, ""))[0] && i++, 16 === e ? this._parseHex(t, i) : this._parseBase(t, e, i), "-" === t[0] && (this.negative = 1), this.strip(), "le" === r && this._initArray(this.toArray(), e, r);
        }, o.prototype._initNumber = function (t, e, r) {
          t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [67108863 & t], this.length = 1) : t < 4503599627370496 ? (this.words = [67108863 & t, t / 67108864 & 67108863], this.length = 2) : (n(t < 9007199254740992), this.words = [67108863 & t, t / 67108864 & 67108863, 1], this.length = 3), "le" === r && this._initArray(this.toArray(), e, r);
        }, o.prototype._initArray = function (t, e, r) {
          if (n("number" == typeof t.length), t.length <= 0) return this.words = [0], this.length = 1, this;
          this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);

          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var o,
              a,
              s = 0;
          if ("be" === r) for (i = t.length - 1, o = 0; i >= 0; i -= 3) {
            a = t[i] | t[i - 1] << 8 | t[i - 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
          } else if ("le" === r) for (i = 0, o = 0; i < t.length; i += 3) {
            a = t[i] | t[i + 1] << 8 | t[i + 2] << 16, this.words[o] |= a << s & 67108863, this.words[o + 1] = a >>> 26 - s & 67108863, (s += 24) >= 26 && (s -= 26, o++);
          }
          return this.strip();
        }, o.prototype._parseHex = function (t, e) {
          this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);

          for (var r = 0; r < this.length; r++) {
            this.words[r] = 0;
          }

          var n,
              i,
              o = 0;

          for (r = t.length - 6, n = 0; r >= e; r -= 6) {
            i = s(t, r, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303, (o += 24) >= 26 && (o -= 26, n++);
          }

          r + 6 !== e && (i = s(t, e, r + 6), this.words[n] |= i << o & 67108863, this.words[n + 1] |= i >>> 26 - o & 4194303), this.strip();
        }, o.prototype._parseBase = function (t, e, r) {
          this.words = [0], this.length = 1;

          for (var n = 0, i = 1; i <= 67108863; i *= e) {
            n++;
          }

          n--, i = i / e | 0;

          for (var o = t.length - r, a = o % n, s = Math.min(o, o - a) + r, u = 0, c = r; c < s; c += n) {
            u = f(t, c, c + n, e), this.imuln(i), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
          }

          if (0 !== a) {
            var h = 1;

            for (u = f(t, c, t.length, e), c = 0; c < a; c++) {
              h *= e;
            }

            this.imuln(h), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
          }
        }, o.prototype.copy = function (t) {
          t.words = new Array(this.length);

          for (var e = 0; e < this.length; e++) {
            t.words[e] = this.words[e];
          }

          t.length = this.length, t.negative = this.negative, t.red = this.red;
        }, o.prototype.clone = function () {
          var t = new o(null);
          return this.copy(t), t;
        }, o.prototype._expand = function (t) {
          for (; this.length < t;) {
            this.words[this.length++] = 0;
          }

          return this;
        }, o.prototype.strip = function () {
          for (; this.length > 1 && 0 === this.words[this.length - 1];) {
            this.length--;
          }

          return this._normSign();
        }, o.prototype._normSign = function () {
          return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
        }, o.prototype.inspect = function () {
          return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
        };
        var u = ["", "0", "00", "000", "0000", "00000", "000000", "0000000", "00000000", "000000000", "0000000000", "00000000000", "000000000000", "0000000000000", "00000000000000", "000000000000000", "0000000000000000", "00000000000000000", "000000000000000000", "0000000000000000000", "00000000000000000000", "000000000000000000000", "0000000000000000000000", "00000000000000000000000", "000000000000000000000000", "0000000000000000000000000"],
            c = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5],
            h = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

        function l(t, e, r) {
          r.negative = e.negative ^ t.negative;
          var n = t.length + e.length | 0;
          r.length = n, n = n - 1 | 0;
          var i = 0 | t.words[0],
              o = 0 | e.words[0],
              a = i * o,
              s = 67108863 & a,
              f = a / 67108864 | 0;
          r.words[0] = s;

          for (var u = 1; u < n; u++) {
            for (var c = f >>> 26, h = 67108863 & f, l = Math.min(u, e.length - 1), d = Math.max(0, u - t.length + 1); d <= l; d++) {
              var p = u - d | 0;
              c += (a = (i = 0 | t.words[p]) * (o = 0 | e.words[d]) + h) / 67108864 | 0, h = 67108863 & a;
            }

            r.words[u] = 0 | h, f = 0 | c;
          }

          return 0 !== f ? r.words[u] = 0 | f : r.length--, r.strip();
        }

        o.prototype.toString = function (t, e) {
          var r;

          if (e = 0 | e || 1, 16 === (t = t || 10) || "hex" === t) {
            r = "";

            for (var i = 0, o = 0, a = 0; a < this.length; a++) {
              var s = this.words[a],
                  f = (16777215 & (s << i | o)).toString(16);
              r = 0 !== (o = s >>> 24 - i & 16777215) || a !== this.length - 1 ? u[6 - f.length] + f + r : f + r, (i += 2) >= 26 && (i -= 26, a--);
            }

            for (0 !== o && (r = o.toString(16) + r); r.length % e != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          if (t === (0 | t) && t >= 2 && t <= 36) {
            var l = c[t],
                d = h[t];
            r = "";
            var p = this.clone();

            for (p.negative = 0; !p.isZero();) {
              var g = p.modn(d).toString(t);
              r = (p = p.idivn(d)).isZero() ? g + r : u[l - g.length] + g + r;
            }

            for (this.isZero() && (r = "0" + r); r.length % e != 0;) {
              r = "0" + r;
            }

            return 0 !== this.negative && (r = "-" + r), r;
          }

          n(!1, "Base should be between 2 and 36");
        }, o.prototype.toNumber = function () {
          var t = this.words[0];
          return 2 === this.length ? t += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? t += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -t : t;
        }, o.prototype.toJSON = function () {
          return this.toString(16);
        }, o.prototype.toBuffer = function (t, e) {
          return n(void 0 !== a), this.toArrayLike(a, t, e);
        }, o.prototype.toArray = function (t, e) {
          return this.toArrayLike(Array, t, e);
        }, o.prototype.toArrayLike = function (t, e, r) {
          var i = this.byteLength(),
              o = r || Math.max(1, i);
          n(i <= o, "byte array longer than desired length"), n(o > 0, "Requested array length <= 0"), this.strip();
          var a,
              s,
              f = "le" === e,
              u = new t(o),
              c = this.clone();

          if (f) {
            for (s = 0; !c.isZero(); s++) {
              a = c.andln(255), c.iushrn(8), u[s] = a;
            }

            for (; s < o; s++) {
              u[s] = 0;
            }
          } else {
            for (s = 0; s < o - i; s++) {
              u[s] = 0;
            }

            for (s = 0; !c.isZero(); s++) {
              a = c.andln(255), c.iushrn(8), u[o - s - 1] = a;
            }
          }

          return u;
        }, Math.clz32 ? o.prototype._countBits = function (t) {
          return 32 - Math.clz32(t);
        } : o.prototype._countBits = function (t) {
          var e = t,
              r = 0;
          return e >= 4096 && (r += 13, e >>>= 13), e >= 64 && (r += 7, e >>>= 7), e >= 8 && (r += 4, e >>>= 4), e >= 2 && (r += 2, e >>>= 2), r + e;
        }, o.prototype._zeroBits = function (t) {
          if (0 === t) return 26;
          var e = t,
              r = 0;
          return 0 == (8191 & e) && (r += 13, e >>>= 13), 0 == (127 & e) && (r += 7, e >>>= 7), 0 == (15 & e) && (r += 4, e >>>= 4), 0 == (3 & e) && (r += 2, e >>>= 2), 0 == (1 & e) && r++, r;
        }, o.prototype.bitLength = function () {
          var t = this.words[this.length - 1],
              e = this._countBits(t);

          return 26 * (this.length - 1) + e;
        }, o.prototype.zeroBits = function () {
          if (this.isZero()) return 0;

          for (var t = 0, e = 0; e < this.length; e++) {
            var r = this._zeroBits(this.words[e]);

            if (t += r, 26 !== r) break;
          }

          return t;
        }, o.prototype.byteLength = function () {
          return Math.ceil(this.bitLength() / 8);
        }, o.prototype.toTwos = function (t) {
          return 0 !== this.negative ? this.abs().inotn(t).iaddn(1) : this.clone();
        }, o.prototype.fromTwos = function (t) {
          return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
        }, o.prototype.isNeg = function () {
          return 0 !== this.negative;
        }, o.prototype.neg = function () {
          return this.clone().ineg();
        }, o.prototype.ineg = function () {
          return this.isZero() || (this.negative ^= 1), this;
        }, o.prototype.iuor = function (t) {
          for (; this.length < t.length;) {
            this.words[this.length++] = 0;
          }

          for (var e = 0; e < t.length; e++) {
            this.words[e] = this.words[e] | t.words[e];
          }

          return this.strip();
        }, o.prototype.ior = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuor(t);
        }, o.prototype.or = function (t) {
          return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
        }, o.prototype.uor = function (t) {
          return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
        }, o.prototype.iuand = function (t) {
          var e;
          e = this.length > t.length ? t : this;

          for (var r = 0; r < e.length; r++) {
            this.words[r] = this.words[r] & t.words[r];
          }

          return this.length = e.length, this.strip();
        }, o.prototype.iand = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuand(t);
        }, o.prototype.and = function (t) {
          return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
        }, o.prototype.uand = function (t) {
          return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
        }, o.prototype.iuxor = function (t) {
          var e, r;
          this.length > t.length ? (e = this, r = t) : (e = t, r = this);

          for (var n = 0; n < r.length; n++) {
            this.words[n] = e.words[n] ^ r.words[n];
          }

          if (this !== e) for (; n < e.length; n++) {
            this.words[n] = e.words[n];
          }
          return this.length = e.length, this.strip();
        }, o.prototype.ixor = function (t) {
          return n(0 == (this.negative | t.negative)), this.iuxor(t);
        }, o.prototype.xor = function (t) {
          return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
        }, o.prototype.uxor = function (t) {
          return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
        }, o.prototype.inotn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = 0 | Math.ceil(t / 26),
              r = t % 26;
          this._expand(e), r > 0 && e--;

          for (var i = 0; i < e; i++) {
            this.words[i] = 67108863 & ~this.words[i];
          }

          return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
        }, o.prototype.notn = function (t) {
          return this.clone().inotn(t);
        }, o.prototype.setn = function (t, e) {
          n("number" == typeof t && t >= 0);
          var r = t / 26 | 0,
              i = t % 26;
          return this._expand(r + 1), this.words[r] = e ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
        }, o.prototype.iadd = function (t) {
          var e, r, n;
          if (0 !== this.negative && 0 === t.negative) return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
          if (0 === this.negative && 0 !== t.negative) return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
          this.length > t.length ? (r = this, n = t) : (r = t, n = this);

          for (var i = 0, o = 0; o < n.length; o++) {
            e = (0 | r.words[o]) + (0 | n.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
          }

          for (; 0 !== i && o < r.length; o++) {
            e = (0 | r.words[o]) + i, this.words[o] = 67108863 & e, i = e >>> 26;
          }

          if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;else if (r !== this) for (; o < r.length; o++) {
            this.words[o] = r.words[o];
          }
          return this;
        }, o.prototype.add = function (t) {
          var e;
          return 0 !== t.negative && 0 === this.negative ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : 0 === t.negative && 0 !== this.negative ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
        }, o.prototype.isub = function (t) {
          if (0 !== t.negative) {
            t.negative = 0;
            var e = this.iadd(t);
            return t.negative = 1, e._normSign();
          }

          if (0 !== this.negative) return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
          var r,
              n,
              i = this.cmp(t);
          if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
          i > 0 ? (r = this, n = t) : (r = t, n = this);

          for (var o = 0, a = 0; a < n.length; a++) {
            o = (e = (0 | r.words[a]) - (0 | n.words[a]) + o) >> 26, this.words[a] = 67108863 & e;
          }

          for (; 0 !== o && a < r.length; a++) {
            o = (e = (0 | r.words[a]) + o) >> 26, this.words[a] = 67108863 & e;
          }

          if (0 === o && a < r.length && r !== this) for (; a < r.length; a++) {
            this.words[a] = r.words[a];
          }
          return this.length = Math.max(this.length, a), r !== this && (this.negative = 1), this.strip();
        }, o.prototype.sub = function (t) {
          return this.clone().isub(t);
        };

        var d = function d(t, e, r) {
          var n,
              i,
              o,
              a = t.words,
              s = e.words,
              f = r.words,
              u = 0,
              c = 0 | a[0],
              h = 8191 & c,
              l = c >>> 13,
              d = 0 | a[1],
              p = 8191 & d,
              g = d >>> 13,
              A = 0 | a[2],
              b = 8191 & A,
              v = A >>> 13,
              y = 0 | a[3],
              w = 8191 & y,
              m = y >>> 13,
              _ = 0 | a[4],
              I = 8191 & _,
              E = _ >>> 13,
              P = 0 | a[5],
              S = 8191 & P,
              x = P >>> 13,
              C = 0 | a[6],
              M = 8191 & C,
              T = C >>> 13,
              k = 0 | a[7],
              R = 8191 & k,
              B = k >>> 13,
              L = 0 | a[8],
              O = 8191 & L,
              j = L >>> 13,
              D = 0 | a[9],
              H = 8191 & D,
              z = D >>> 13,
              N = 0 | s[0],
              q = 8191 & N,
              U = N >>> 13,
              V = 0 | s[1],
              W = 8191 & V,
              Y = V >>> 13,
              F = 0 | s[2],
              Z = 8191 & F,
              X = F >>> 13,
              K = 0 | s[3],
              J = 8191 & K,
              G = K >>> 13,
              Q = 0 | s[4],
              $ = 8191 & Q,
              tt = Q >>> 13,
              et = 0 | s[5],
              rt = 8191 & et,
              nt = et >>> 13,
              it = 0 | s[6],
              ot = 8191 & it,
              at = it >>> 13,
              st = 0 | s[7],
              ft = 8191 & st,
              ut = st >>> 13,
              ct = 0 | s[8],
              ht = 8191 & ct,
              lt = ct >>> 13,
              dt = 0 | s[9],
              pt = 8191 & dt,
              gt = dt >>> 13;

          r.negative = t.negative ^ e.negative, r.length = 19;
          var At = (u + (n = Math.imul(h, q)) | 0) + ((8191 & (i = (i = Math.imul(h, U)) + Math.imul(l, q) | 0)) << 13) | 0;
          u = ((o = Math.imul(l, U)) + (i >>> 13) | 0) + (At >>> 26) | 0, At &= 67108863, n = Math.imul(p, q), i = (i = Math.imul(p, U)) + Math.imul(g, q) | 0, o = Math.imul(g, U);
          var bt = (u + (n = n + Math.imul(h, W) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, Y) | 0) + Math.imul(l, W) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, Y) | 0) + (i >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, n = Math.imul(b, q), i = (i = Math.imul(b, U)) + Math.imul(v, q) | 0, o = Math.imul(v, U), n = n + Math.imul(p, W) | 0, i = (i = i + Math.imul(p, Y) | 0) + Math.imul(g, W) | 0, o = o + Math.imul(g, Y) | 0;
          var vt = (u + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, X) | 0) + Math.imul(l, Z) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, X) | 0) + (i >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, n = Math.imul(w, q), i = (i = Math.imul(w, U)) + Math.imul(m, q) | 0, o = Math.imul(m, U), n = n + Math.imul(b, W) | 0, i = (i = i + Math.imul(b, Y) | 0) + Math.imul(v, W) | 0, o = o + Math.imul(v, Y) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, X) | 0) + Math.imul(g, Z) | 0, o = o + Math.imul(g, X) | 0;
          var yt = (u + (n = n + Math.imul(h, J) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(l, J) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, G) | 0) + (i >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, n = Math.imul(I, q), i = (i = Math.imul(I, U)) + Math.imul(E, q) | 0, o = Math.imul(E, U), n = n + Math.imul(w, W) | 0, i = (i = i + Math.imul(w, Y) | 0) + Math.imul(m, W) | 0, o = o + Math.imul(m, Y) | 0, n = n + Math.imul(b, Z) | 0, i = (i = i + Math.imul(b, X) | 0) + Math.imul(v, Z) | 0, o = o + Math.imul(v, X) | 0, n = n + Math.imul(p, J) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(g, J) | 0, o = o + Math.imul(g, G) | 0;
          var wt = (u + (n = n + Math.imul(h, $) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, tt) | 0) + Math.imul(l, $) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, tt) | 0) + (i >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, n = Math.imul(S, q), i = (i = Math.imul(S, U)) + Math.imul(x, q) | 0, o = Math.imul(x, U), n = n + Math.imul(I, W) | 0, i = (i = i + Math.imul(I, Y) | 0) + Math.imul(E, W) | 0, o = o + Math.imul(E, Y) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, X) | 0) + Math.imul(m, Z) | 0, o = o + Math.imul(m, X) | 0, n = n + Math.imul(b, J) | 0, i = (i = i + Math.imul(b, G) | 0) + Math.imul(v, J) | 0, o = o + Math.imul(v, G) | 0, n = n + Math.imul(p, $) | 0, i = (i = i + Math.imul(p, tt) | 0) + Math.imul(g, $) | 0, o = o + Math.imul(g, tt) | 0;
          var mt = (u + (n = n + Math.imul(h, rt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, nt) | 0) + Math.imul(l, rt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, nt) | 0) + (i >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, n = Math.imul(M, q), i = (i = Math.imul(M, U)) + Math.imul(T, q) | 0, o = Math.imul(T, U), n = n + Math.imul(S, W) | 0, i = (i = i + Math.imul(S, Y) | 0) + Math.imul(x, W) | 0, o = o + Math.imul(x, Y) | 0, n = n + Math.imul(I, Z) | 0, i = (i = i + Math.imul(I, X) | 0) + Math.imul(E, Z) | 0, o = o + Math.imul(E, X) | 0, n = n + Math.imul(w, J) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(m, J) | 0, o = o + Math.imul(m, G) | 0, n = n + Math.imul(b, $) | 0, i = (i = i + Math.imul(b, tt) | 0) + Math.imul(v, $) | 0, o = o + Math.imul(v, tt) | 0, n = n + Math.imul(p, rt) | 0, i = (i = i + Math.imul(p, nt) | 0) + Math.imul(g, rt) | 0, o = o + Math.imul(g, nt) | 0;

          var _t = (u + (n = n + Math.imul(h, ot) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, at) | 0) + Math.imul(l, ot) | 0)) << 13) | 0;

          u = ((o = o + Math.imul(l, at) | 0) + (i >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, n = Math.imul(R, q), i = (i = Math.imul(R, U)) + Math.imul(B, q) | 0, o = Math.imul(B, U), n = n + Math.imul(M, W) | 0, i = (i = i + Math.imul(M, Y) | 0) + Math.imul(T, W) | 0, o = o + Math.imul(T, Y) | 0, n = n + Math.imul(S, Z) | 0, i = (i = i + Math.imul(S, X) | 0) + Math.imul(x, Z) | 0, o = o + Math.imul(x, X) | 0, n = n + Math.imul(I, J) | 0, i = (i = i + Math.imul(I, G) | 0) + Math.imul(E, J) | 0, o = o + Math.imul(E, G) | 0, n = n + Math.imul(w, $) | 0, i = (i = i + Math.imul(w, tt) | 0) + Math.imul(m, $) | 0, o = o + Math.imul(m, tt) | 0, n = n + Math.imul(b, rt) | 0, i = (i = i + Math.imul(b, nt) | 0) + Math.imul(v, rt) | 0, o = o + Math.imul(v, nt) | 0, n = n + Math.imul(p, ot) | 0, i = (i = i + Math.imul(p, at) | 0) + Math.imul(g, ot) | 0, o = o + Math.imul(g, at) | 0;
          var It = (u + (n = n + Math.imul(h, ft) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ut) | 0) + Math.imul(l, ft) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, ut) | 0) + (i >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, n = Math.imul(O, q), i = (i = Math.imul(O, U)) + Math.imul(j, q) | 0, o = Math.imul(j, U), n = n + Math.imul(R, W) | 0, i = (i = i + Math.imul(R, Y) | 0) + Math.imul(B, W) | 0, o = o + Math.imul(B, Y) | 0, n = n + Math.imul(M, Z) | 0, i = (i = i + Math.imul(M, X) | 0) + Math.imul(T, Z) | 0, o = o + Math.imul(T, X) | 0, n = n + Math.imul(S, J) | 0, i = (i = i + Math.imul(S, G) | 0) + Math.imul(x, J) | 0, o = o + Math.imul(x, G) | 0, n = n + Math.imul(I, $) | 0, i = (i = i + Math.imul(I, tt) | 0) + Math.imul(E, $) | 0, o = o + Math.imul(E, tt) | 0, n = n + Math.imul(w, rt) | 0, i = (i = i + Math.imul(w, nt) | 0) + Math.imul(m, rt) | 0, o = o + Math.imul(m, nt) | 0, n = n + Math.imul(b, ot) | 0, i = (i = i + Math.imul(b, at) | 0) + Math.imul(v, ot) | 0, o = o + Math.imul(v, at) | 0, n = n + Math.imul(p, ft) | 0, i = (i = i + Math.imul(p, ut) | 0) + Math.imul(g, ft) | 0, o = o + Math.imul(g, ut) | 0;
          var Et = (u + (n = n + Math.imul(h, ht) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, lt) | 0) + Math.imul(l, ht) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, lt) | 0) + (i >>> 13) | 0) + (Et >>> 26) | 0, Et &= 67108863, n = Math.imul(H, q), i = (i = Math.imul(H, U)) + Math.imul(z, q) | 0, o = Math.imul(z, U), n = n + Math.imul(O, W) | 0, i = (i = i + Math.imul(O, Y) | 0) + Math.imul(j, W) | 0, o = o + Math.imul(j, Y) | 0, n = n + Math.imul(R, Z) | 0, i = (i = i + Math.imul(R, X) | 0) + Math.imul(B, Z) | 0, o = o + Math.imul(B, X) | 0, n = n + Math.imul(M, J) | 0, i = (i = i + Math.imul(M, G) | 0) + Math.imul(T, J) | 0, o = o + Math.imul(T, G) | 0, n = n + Math.imul(S, $) | 0, i = (i = i + Math.imul(S, tt) | 0) + Math.imul(x, $) | 0, o = o + Math.imul(x, tt) | 0, n = n + Math.imul(I, rt) | 0, i = (i = i + Math.imul(I, nt) | 0) + Math.imul(E, rt) | 0, o = o + Math.imul(E, nt) | 0, n = n + Math.imul(w, ot) | 0, i = (i = i + Math.imul(w, at) | 0) + Math.imul(m, ot) | 0, o = o + Math.imul(m, at) | 0, n = n + Math.imul(b, ft) | 0, i = (i = i + Math.imul(b, ut) | 0) + Math.imul(v, ft) | 0, o = o + Math.imul(v, ut) | 0, n = n + Math.imul(p, ht) | 0, i = (i = i + Math.imul(p, lt) | 0) + Math.imul(g, ht) | 0, o = o + Math.imul(g, lt) | 0;
          var Pt = (u + (n = n + Math.imul(h, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, gt) | 0) + Math.imul(l, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(l, gt) | 0) + (i >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, n = Math.imul(H, W), i = (i = Math.imul(H, Y)) + Math.imul(z, W) | 0, o = Math.imul(z, Y), n = n + Math.imul(O, Z) | 0, i = (i = i + Math.imul(O, X) | 0) + Math.imul(j, Z) | 0, o = o + Math.imul(j, X) | 0, n = n + Math.imul(R, J) | 0, i = (i = i + Math.imul(R, G) | 0) + Math.imul(B, J) | 0, o = o + Math.imul(B, G) | 0, n = n + Math.imul(M, $) | 0, i = (i = i + Math.imul(M, tt) | 0) + Math.imul(T, $) | 0, o = o + Math.imul(T, tt) | 0, n = n + Math.imul(S, rt) | 0, i = (i = i + Math.imul(S, nt) | 0) + Math.imul(x, rt) | 0, o = o + Math.imul(x, nt) | 0, n = n + Math.imul(I, ot) | 0, i = (i = i + Math.imul(I, at) | 0) + Math.imul(E, ot) | 0, o = o + Math.imul(E, at) | 0, n = n + Math.imul(w, ft) | 0, i = (i = i + Math.imul(w, ut) | 0) + Math.imul(m, ft) | 0, o = o + Math.imul(m, ut) | 0, n = n + Math.imul(b, ht) | 0, i = (i = i + Math.imul(b, lt) | 0) + Math.imul(v, ht) | 0, o = o + Math.imul(v, lt) | 0;
          var St = (u + (n = n + Math.imul(p, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, gt) | 0) + Math.imul(g, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(g, gt) | 0) + (i >>> 13) | 0) + (St >>> 26) | 0, St &= 67108863, n = Math.imul(H, Z), i = (i = Math.imul(H, X)) + Math.imul(z, Z) | 0, o = Math.imul(z, X), n = n + Math.imul(O, J) | 0, i = (i = i + Math.imul(O, G) | 0) + Math.imul(j, J) | 0, o = o + Math.imul(j, G) | 0, n = n + Math.imul(R, $) | 0, i = (i = i + Math.imul(R, tt) | 0) + Math.imul(B, $) | 0, o = o + Math.imul(B, tt) | 0, n = n + Math.imul(M, rt) | 0, i = (i = i + Math.imul(M, nt) | 0) + Math.imul(T, rt) | 0, o = o + Math.imul(T, nt) | 0, n = n + Math.imul(S, ot) | 0, i = (i = i + Math.imul(S, at) | 0) + Math.imul(x, ot) | 0, o = o + Math.imul(x, at) | 0, n = n + Math.imul(I, ft) | 0, i = (i = i + Math.imul(I, ut) | 0) + Math.imul(E, ft) | 0, o = o + Math.imul(E, ut) | 0, n = n + Math.imul(w, ht) | 0, i = (i = i + Math.imul(w, lt) | 0) + Math.imul(m, ht) | 0, o = o + Math.imul(m, lt) | 0;
          var xt = (u + (n = n + Math.imul(b, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(b, gt) | 0) + Math.imul(v, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(v, gt) | 0) + (i >>> 13) | 0) + (xt >>> 26) | 0, xt &= 67108863, n = Math.imul(H, J), i = (i = Math.imul(H, G)) + Math.imul(z, J) | 0, o = Math.imul(z, G), n = n + Math.imul(O, $) | 0, i = (i = i + Math.imul(O, tt) | 0) + Math.imul(j, $) | 0, o = o + Math.imul(j, tt) | 0, n = n + Math.imul(R, rt) | 0, i = (i = i + Math.imul(R, nt) | 0) + Math.imul(B, rt) | 0, o = o + Math.imul(B, nt) | 0, n = n + Math.imul(M, ot) | 0, i = (i = i + Math.imul(M, at) | 0) + Math.imul(T, ot) | 0, o = o + Math.imul(T, at) | 0, n = n + Math.imul(S, ft) | 0, i = (i = i + Math.imul(S, ut) | 0) + Math.imul(x, ft) | 0, o = o + Math.imul(x, ut) | 0, n = n + Math.imul(I, ht) | 0, i = (i = i + Math.imul(I, lt) | 0) + Math.imul(E, ht) | 0, o = o + Math.imul(E, lt) | 0;
          var Ct = (u + (n = n + Math.imul(w, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, gt) | 0) + Math.imul(m, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(m, gt) | 0) + (i >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, n = Math.imul(H, $), i = (i = Math.imul(H, tt)) + Math.imul(z, $) | 0, o = Math.imul(z, tt), n = n + Math.imul(O, rt) | 0, i = (i = i + Math.imul(O, nt) | 0) + Math.imul(j, rt) | 0, o = o + Math.imul(j, nt) | 0, n = n + Math.imul(R, ot) | 0, i = (i = i + Math.imul(R, at) | 0) + Math.imul(B, ot) | 0, o = o + Math.imul(B, at) | 0, n = n + Math.imul(M, ft) | 0, i = (i = i + Math.imul(M, ut) | 0) + Math.imul(T, ft) | 0, o = o + Math.imul(T, ut) | 0, n = n + Math.imul(S, ht) | 0, i = (i = i + Math.imul(S, lt) | 0) + Math.imul(x, ht) | 0, o = o + Math.imul(x, lt) | 0;
          var Mt = (u + (n = n + Math.imul(I, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(I, gt) | 0) + Math.imul(E, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(E, gt) | 0) + (i >>> 13) | 0) + (Mt >>> 26) | 0, Mt &= 67108863, n = Math.imul(H, rt), i = (i = Math.imul(H, nt)) + Math.imul(z, rt) | 0, o = Math.imul(z, nt), n = n + Math.imul(O, ot) | 0, i = (i = i + Math.imul(O, at) | 0) + Math.imul(j, ot) | 0, o = o + Math.imul(j, at) | 0, n = n + Math.imul(R, ft) | 0, i = (i = i + Math.imul(R, ut) | 0) + Math.imul(B, ft) | 0, o = o + Math.imul(B, ut) | 0, n = n + Math.imul(M, ht) | 0, i = (i = i + Math.imul(M, lt) | 0) + Math.imul(T, ht) | 0, o = o + Math.imul(T, lt) | 0;
          var Tt = (u + (n = n + Math.imul(S, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(S, gt) | 0) + Math.imul(x, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(x, gt) | 0) + (i >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, n = Math.imul(H, ot), i = (i = Math.imul(H, at)) + Math.imul(z, ot) | 0, o = Math.imul(z, at), n = n + Math.imul(O, ft) | 0, i = (i = i + Math.imul(O, ut) | 0) + Math.imul(j, ft) | 0, o = o + Math.imul(j, ut) | 0, n = n + Math.imul(R, ht) | 0, i = (i = i + Math.imul(R, lt) | 0) + Math.imul(B, ht) | 0, o = o + Math.imul(B, lt) | 0;
          var kt = (u + (n = n + Math.imul(M, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(M, gt) | 0) + Math.imul(T, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(T, gt) | 0) + (i >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, n = Math.imul(H, ft), i = (i = Math.imul(H, ut)) + Math.imul(z, ft) | 0, o = Math.imul(z, ut), n = n + Math.imul(O, ht) | 0, i = (i = i + Math.imul(O, lt) | 0) + Math.imul(j, ht) | 0, o = o + Math.imul(j, lt) | 0;
          var Rt = (u + (n = n + Math.imul(R, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(R, gt) | 0) + Math.imul(B, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(B, gt) | 0) + (i >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, n = Math.imul(H, ht), i = (i = Math.imul(H, lt)) + Math.imul(z, ht) | 0, o = Math.imul(z, lt);
          var Bt = (u + (n = n + Math.imul(O, pt) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(O, gt) | 0) + Math.imul(j, pt) | 0)) << 13) | 0;
          u = ((o = o + Math.imul(j, gt) | 0) + (i >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863;
          var Lt = (u + (n = Math.imul(H, pt)) | 0) + ((8191 & (i = (i = Math.imul(H, gt)) + Math.imul(z, pt) | 0)) << 13) | 0;
          return u = ((o = Math.imul(z, gt)) + (i >>> 13) | 0) + (Lt >>> 26) | 0, Lt &= 67108863, f[0] = At, f[1] = bt, f[2] = vt, f[3] = yt, f[4] = wt, f[5] = mt, f[6] = _t, f[7] = It, f[8] = Et, f[9] = Pt, f[10] = St, f[11] = xt, f[12] = Ct, f[13] = Mt, f[14] = Tt, f[15] = kt, f[16] = Rt, f[17] = Bt, f[18] = Lt, 0 !== u && (f[19] = u, r.length++), r;
        };

        function p(t, e, r) {
          return new g().mulp(t, e, r);
        }

        function g(t, e) {
          this.x = t, this.y = e;
        }

        Math.imul || (d = l), o.prototype.mulTo = function (t, e) {
          var r = this.length + t.length;
          return 10 === this.length && 10 === t.length ? d(this, t, e) : r < 63 ? l(this, t, e) : r < 1024 ? function (t, e, r) {
            r.negative = e.negative ^ t.negative, r.length = t.length + e.length;

            for (var n = 0, i = 0, o = 0; o < r.length - 1; o++) {
              var a = i;
              i = 0;

              for (var s = 67108863 & n, f = Math.min(o, e.length - 1), u = Math.max(0, o - t.length + 1); u <= f; u++) {
                var c = o - u,
                    h = (0 | t.words[c]) * (0 | e.words[u]),
                    l = 67108863 & h;
                s = 67108863 & (l = l + s | 0), i += (a = (a = a + (h / 67108864 | 0) | 0) + (l >>> 26) | 0) >>> 26, a &= 67108863;
              }

              r.words[o] = s, n = a, a = i;
            }

            return 0 !== n ? r.words[o] = n : r.length--, r.strip();
          }(this, t, e) : p(this, t, e);
        }, g.prototype.makeRBT = function (t) {
          for (var e = new Array(t), r = o.prototype._countBits(t) - 1, n = 0; n < t; n++) {
            e[n] = this.revBin(n, r, t);
          }

          return e;
        }, g.prototype.revBin = function (t, e, r) {
          if (0 === t || t === r - 1) return t;

          for (var n = 0, i = 0; i < e; i++) {
            n |= (1 & t) << e - i - 1, t >>= 1;
          }

          return n;
        }, g.prototype.permute = function (t, e, r, n, i, o) {
          for (var a = 0; a < o; a++) {
            n[a] = e[t[a]], i[a] = r[t[a]];
          }
        }, g.prototype.transform = function (t, e, r, n, i, o) {
          this.permute(o, t, e, r, n, i);

          for (var a = 1; a < i; a <<= 1) {
            for (var s = a << 1, f = Math.cos(2 * Math.PI / s), u = Math.sin(2 * Math.PI / s), c = 0; c < i; c += s) {
              for (var h = f, l = u, d = 0; d < a; d++) {
                var p = r[c + d],
                    g = n[c + d],
                    A = r[c + d + a],
                    b = n[c + d + a],
                    v = h * A - l * b;
                b = h * b + l * A, A = v, r[c + d] = p + A, n[c + d] = g + b, r[c + d + a] = p - A, n[c + d + a] = g - b, d !== s && (v = f * h - u * l, l = f * l + u * h, h = v);
              }
            }
          }
        }, g.prototype.guessLen13b = function (t, e) {
          var r = 1 | Math.max(e, t),
              n = 1 & r,
              i = 0;

          for (r = r / 2 | 0; r; r >>>= 1) {
            i++;
          }

          return 1 << i + 1 + n;
        }, g.prototype.conjugate = function (t, e, r) {
          if (!(r <= 1)) for (var n = 0; n < r / 2; n++) {
            var i = t[n];
            t[n] = t[r - n - 1], t[r - n - 1] = i, i = e[n], e[n] = -e[r - n - 1], e[r - n - 1] = -i;
          }
        }, g.prototype.normalize13b = function (t, e) {
          for (var r = 0, n = 0; n < e / 2; n++) {
            var i = 8192 * Math.round(t[2 * n + 1] / e) + Math.round(t[2 * n] / e) + r;
            t[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
          }

          return t;
        }, g.prototype.convert13b = function (t, e, r, i) {
          for (var o = 0, a = 0; a < e; a++) {
            o += 0 | t[a], r[2 * a] = 8191 & o, o >>>= 13, r[2 * a + 1] = 8191 & o, o >>>= 13;
          }

          for (a = 2 * e; a < i; ++a) {
            r[a] = 0;
          }

          n(0 === o), n(0 == (-8192 & o));
        }, g.prototype.stub = function (t) {
          for (var e = new Array(t), r = 0; r < t; r++) {
            e[r] = 0;
          }

          return e;
        }, g.prototype.mulp = function (t, e, r) {
          var n = 2 * this.guessLen13b(t.length, e.length),
              i = this.makeRBT(n),
              o = this.stub(n),
              a = new Array(n),
              s = new Array(n),
              f = new Array(n),
              u = new Array(n),
              c = new Array(n),
              h = new Array(n),
              l = r.words;
          l.length = n, this.convert13b(t.words, t.length, a, n), this.convert13b(e.words, e.length, u, n), this.transform(a, o, s, f, n, i), this.transform(u, o, c, h, n, i);

          for (var d = 0; d < n; d++) {
            var p = s[d] * c[d] - f[d] * h[d];
            f[d] = s[d] * h[d] + f[d] * c[d], s[d] = p;
          }

          return this.conjugate(s, f, n), this.transform(s, f, l, o, n, i), this.conjugate(l, o, n), this.normalize13b(l, n), r.negative = t.negative ^ e.negative, r.length = t.length + e.length, r.strip();
        }, o.prototype.mul = function (t) {
          var e = new o(null);
          return e.words = new Array(this.length + t.length), this.mulTo(t, e);
        }, o.prototype.mulf = function (t) {
          var e = new o(null);
          return e.words = new Array(this.length + t.length), p(this, t, e);
        }, o.prototype.imul = function (t) {
          return this.clone().mulTo(t, this);
        }, o.prototype.imuln = function (t) {
          n("number" == typeof t), n(t < 67108864);

          for (var e = 0, r = 0; r < this.length; r++) {
            var i = (0 | this.words[r]) * t,
                o = (67108863 & i) + (67108863 & e);
            e >>= 26, e += i / 67108864 | 0, e += o >>> 26, this.words[r] = 67108863 & o;
          }

          return 0 !== e && (this.words[r] = e, this.length++), this;
        }, o.prototype.muln = function (t) {
          return this.clone().imuln(t);
        }, o.prototype.sqr = function () {
          return this.mul(this);
        }, o.prototype.isqr = function () {
          return this.imul(this.clone());
        }, o.prototype.pow = function (t) {
          var e = function (t) {
            for (var e = new Array(t.bitLength()), r = 0; r < e.length; r++) {
              var n = r / 26 | 0,
                  i = r % 26;
              e[r] = (t.words[n] & 1 << i) >>> i;
            }

            return e;
          }(t);

          if (0 === e.length) return new o(1);

          for (var r = this, n = 0; n < e.length && 0 === e[n]; n++, r = r.sqr()) {
            ;
          }

          if (++n < e.length) for (var i = r.sqr(); n < e.length; n++, i = i.sqr()) {
            0 !== e[n] && (r = r.mul(i));
          }
          return r;
        }, o.prototype.iushln = function (t) {
          n("number" == typeof t && t >= 0);
          var e,
              r = t % 26,
              i = (t - r) / 26,
              o = 67108863 >>> 26 - r << 26 - r;

          if (0 !== r) {
            var a = 0;

            for (e = 0; e < this.length; e++) {
              var s = this.words[e] & o,
                  f = (0 | this.words[e]) - s << r;
              this.words[e] = f | a, a = s >>> 26 - r;
            }

            a && (this.words[e] = a, this.length++);
          }

          if (0 !== i) {
            for (e = this.length - 1; e >= 0; e--) {
              this.words[e + i] = this.words[e];
            }

            for (e = 0; e < i; e++) {
              this.words[e] = 0;
            }

            this.length += i;
          }

          return this.strip();
        }, o.prototype.ishln = function (t) {
          return n(0 === this.negative), this.iushln(t);
        }, o.prototype.iushrn = function (t, e, r) {
          var i;
          n("number" == typeof t && t >= 0), i = e ? (e - e % 26) / 26 : 0;
          var o = t % 26,
              a = Math.min((t - o) / 26, this.length),
              s = 67108863 ^ 67108863 >>> o << o,
              f = r;

          if (i -= a, i = Math.max(0, i), f) {
            for (var u = 0; u < a; u++) {
              f.words[u] = this.words[u];
            }

            f.length = a;
          }

          if (0 === a) ;else if (this.length > a) for (this.length -= a, u = 0; u < this.length; u++) {
            this.words[u] = this.words[u + a];
          } else this.words[0] = 0, this.length = 1;
          var c = 0;

          for (u = this.length - 1; u >= 0 && (0 !== c || u >= i); u--) {
            var h = 0 | this.words[u];
            this.words[u] = c << 26 - o | h >>> o, c = h & s;
          }

          return f && 0 !== c && (f.words[f.length++] = c), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
        }, o.prototype.ishrn = function (t, e, r) {
          return n(0 === this.negative), this.iushrn(t, e, r);
        }, o.prototype.shln = function (t) {
          return this.clone().ishln(t);
        }, o.prototype.ushln = function (t) {
          return this.clone().iushln(t);
        }, o.prototype.shrn = function (t) {
          return this.clone().ishrn(t);
        }, o.prototype.ushrn = function (t) {
          return this.clone().iushrn(t);
        }, o.prototype.testn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = t % 26,
              r = (t - e) / 26,
              i = 1 << e;
          return !(this.length <= r) && !!(this.words[r] & i);
        }, o.prototype.imaskn = function (t) {
          n("number" == typeof t && t >= 0);
          var e = t % 26,
              r = (t - e) / 26;
          if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;

          if (0 !== e && r++, this.length = Math.min(r, this.length), 0 !== e) {
            var i = 67108863 ^ 67108863 >>> e << e;
            this.words[this.length - 1] &= i;
          }

          return this.strip();
        }, o.prototype.maskn = function (t) {
          return this.clone().imaskn(t);
        }, o.prototype.iaddn = function (t) {
          return n("number" == typeof t), n(t < 67108864), t < 0 ? this.isubn(-t) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < t ? (this.words[0] = t - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
        }, o.prototype._iaddn = function (t) {
          this.words[0] += t;

          for (var e = 0; e < this.length && this.words[e] >= 67108864; e++) {
            this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
          }

          return this.length = Math.max(this.length, e + 1), this;
        }, o.prototype.isubn = function (t) {
          if (n("number" == typeof t), n(t < 67108864), t < 0) return this.iaddn(-t);
          if (0 !== this.negative) return this.negative = 0, this.iaddn(t), this.negative = 1, this;
          if (this.words[0] -= t, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;else for (var e = 0; e < this.length && this.words[e] < 0; e++) {
            this.words[e] += 67108864, this.words[e + 1] -= 1;
          }
          return this.strip();
        }, o.prototype.addn = function (t) {
          return this.clone().iaddn(t);
        }, o.prototype.subn = function (t) {
          return this.clone().isubn(t);
        }, o.prototype.iabs = function () {
          return this.negative = 0, this;
        }, o.prototype.abs = function () {
          return this.clone().iabs();
        }, o.prototype._ishlnsubmul = function (t, e, r) {
          var i,
              o,
              a = t.length + r;

          this._expand(a);

          var s = 0;

          for (i = 0; i < t.length; i++) {
            o = (0 | this.words[i + r]) + s;
            var f = (0 | t.words[i]) * e;
            s = ((o -= 67108863 & f) >> 26) - (f / 67108864 | 0), this.words[i + r] = 67108863 & o;
          }

          for (; i < this.length - r; i++) {
            s = (o = (0 | this.words[i + r]) + s) >> 26, this.words[i + r] = 67108863 & o;
          }

          if (0 === s) return this.strip();

          for (n(-1 === s), s = 0, i = 0; i < this.length; i++) {
            s = (o = -(0 | this.words[i]) + s) >> 26, this.words[i] = 67108863 & o;
          }

          return this.negative = 1, this.strip();
        }, o.prototype._wordDiv = function (t, e) {
          var r = (this.length, t.length),
              n = this.clone(),
              i = t,
              a = 0 | i.words[i.length - 1];
          0 !== (r = 26 - this._countBits(a)) && (i = i.ushln(r), n.iushln(r), a = 0 | i.words[i.length - 1]);
          var s,
              f = n.length - i.length;

          if ("mod" !== e) {
            (s = new o(null)).length = f + 1, s.words = new Array(s.length);

            for (var u = 0; u < s.length; u++) {
              s.words[u] = 0;
            }
          }

          var c = n.clone()._ishlnsubmul(i, 1, f);

          0 === c.negative && (n = c, s && (s.words[f] = 1));

          for (var h = f - 1; h >= 0; h--) {
            var l = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);

            for (l = Math.min(l / a | 0, 67108863), n._ishlnsubmul(i, l, h); 0 !== n.negative;) {
              l--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
            }

            s && (s.words[h] = l);
          }

          return s && s.strip(), n.strip(), "div" !== e && 0 !== r && n.iushrn(r), {
            div: s || null,
            mod: n
          };
        }, o.prototype.divmod = function (t, e, r) {
          return n(!t.isZero()), this.isZero() ? {
            div: new o(0),
            mod: new o(0)
          } : 0 !== this.negative && 0 === t.negative ? (s = this.neg().divmod(t, e), "mod" !== e && (i = s.div.neg()), "div" !== e && (a = s.mod.neg(), r && 0 !== a.negative && a.iadd(t)), {
            div: i,
            mod: a
          }) : 0 === this.negative && 0 !== t.negative ? (s = this.divmod(t.neg(), e), "mod" !== e && (i = s.div.neg()), {
            div: i,
            mod: s.mod
          }) : 0 != (this.negative & t.negative) ? (s = this.neg().divmod(t.neg(), e), "div" !== e && (a = s.mod.neg(), r && 0 !== a.negative && a.isub(t)), {
            div: s.div,
            mod: a
          }) : t.length > this.length || this.cmp(t) < 0 ? {
            div: new o(0),
            mod: this
          } : 1 === t.length ? "div" === e ? {
            div: this.divn(t.words[0]),
            mod: null
          } : "mod" === e ? {
            div: null,
            mod: new o(this.modn(t.words[0]))
          } : {
            div: this.divn(t.words[0]),
            mod: new o(this.modn(t.words[0]))
          } : this._wordDiv(t, e);
          var i, a, s;
        }, o.prototype.div = function (t) {
          return this.divmod(t, "div", !1).div;
        }, o.prototype.mod = function (t) {
          return this.divmod(t, "mod", !1).mod;
        }, o.prototype.umod = function (t) {
          return this.divmod(t, "mod", !0).mod;
        }, o.prototype.divRound = function (t) {
          var e = this.divmod(t);
          if (e.mod.isZero()) return e.div;
          var r = 0 !== e.div.negative ? e.mod.isub(t) : e.mod,
              n = t.ushrn(1),
              i = t.andln(1),
              o = r.cmp(n);
          return o < 0 || 1 === i && 0 === o ? e.div : 0 !== e.div.negative ? e.div.isubn(1) : e.div.iaddn(1);
        }, o.prototype.modn = function (t) {
          n(t <= 67108863);

          for (var e = (1 << 26) % t, r = 0, i = this.length - 1; i >= 0; i--) {
            r = (e * r + (0 | this.words[i])) % t;
          }

          return r;
        }, o.prototype.idivn = function (t) {
          n(t <= 67108863);

          for (var e = 0, r = this.length - 1; r >= 0; r--) {
            var i = (0 | this.words[r]) + 67108864 * e;
            this.words[r] = i / t | 0, e = i % t;
          }

          return this.strip();
        }, o.prototype.divn = function (t) {
          return this.clone().idivn(t);
        }, o.prototype.egcd = function (t) {
          n(0 === t.negative), n(!t.isZero());
          var e = this,
              r = t.clone();
          e = 0 !== e.negative ? e.umod(t) : e.clone();

          for (var i = new o(1), a = new o(0), s = new o(0), f = new o(1), u = 0; e.isEven() && r.isEven();) {
            e.iushrn(1), r.iushrn(1), ++u;
          }

          for (var c = r.clone(), h = e.clone(); !e.isZero();) {
            for (var l = 0, d = 1; 0 == (e.words[0] & d) && l < 26; ++l, d <<= 1) {
              ;
            }

            if (l > 0) for (e.iushrn(l); l-- > 0;) {
              (i.isOdd() || a.isOdd()) && (i.iadd(c), a.isub(h)), i.iushrn(1), a.iushrn(1);
            }

            for (var p = 0, g = 1; 0 == (r.words[0] & g) && p < 26; ++p, g <<= 1) {
              ;
            }

            if (p > 0) for (r.iushrn(p); p-- > 0;) {
              (s.isOdd() || f.isOdd()) && (s.iadd(c), f.isub(h)), s.iushrn(1), f.iushrn(1);
            }
            e.cmp(r) >= 0 ? (e.isub(r), i.isub(s), a.isub(f)) : (r.isub(e), s.isub(i), f.isub(a));
          }

          return {
            a: s,
            b: f,
            gcd: r.iushln(u)
          };
        }, o.prototype._invmp = function (t) {
          n(0 === t.negative), n(!t.isZero());
          var e = this,
              r = t.clone();
          e = 0 !== e.negative ? e.umod(t) : e.clone();

          for (var i, a = new o(1), s = new o(0), f = r.clone(); e.cmpn(1) > 0 && r.cmpn(1) > 0;) {
            for (var u = 0, c = 1; 0 == (e.words[0] & c) && u < 26; ++u, c <<= 1) {
              ;
            }

            if (u > 0) for (e.iushrn(u); u-- > 0;) {
              a.isOdd() && a.iadd(f), a.iushrn(1);
            }

            for (var h = 0, l = 1; 0 == (r.words[0] & l) && h < 26; ++h, l <<= 1) {
              ;
            }

            if (h > 0) for (r.iushrn(h); h-- > 0;) {
              s.isOdd() && s.iadd(f), s.iushrn(1);
            }
            e.cmp(r) >= 0 ? (e.isub(r), a.isub(s)) : (r.isub(e), s.isub(a));
          }

          return (i = 0 === e.cmpn(1) ? a : s).cmpn(0) < 0 && i.iadd(t), i;
        }, o.prototype.gcd = function (t) {
          if (this.isZero()) return t.abs();
          if (t.isZero()) return this.abs();
          var e = this.clone(),
              r = t.clone();
          e.negative = 0, r.negative = 0;

          for (var n = 0; e.isEven() && r.isEven(); n++) {
            e.iushrn(1), r.iushrn(1);
          }

          for (;;) {
            for (; e.isEven();) {
              e.iushrn(1);
            }

            for (; r.isEven();) {
              r.iushrn(1);
            }

            var i = e.cmp(r);

            if (i < 0) {
              var o = e;
              e = r, r = o;
            } else if (0 === i || 0 === r.cmpn(1)) break;

            e.isub(r);
          }

          return r.iushln(n);
        }, o.prototype.invm = function (t) {
          return this.egcd(t).a.umod(t);
        }, o.prototype.isEven = function () {
          return 0 == (1 & this.words[0]);
        }, o.prototype.isOdd = function () {
          return 1 == (1 & this.words[0]);
        }, o.prototype.andln = function (t) {
          return this.words[0] & t;
        }, o.prototype.bincn = function (t) {
          n("number" == typeof t);
          var e = t % 26,
              r = (t - e) / 26,
              i = 1 << e;
          if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;

          for (var o = i, a = r; 0 !== o && a < this.length; a++) {
            var s = 0 | this.words[a];
            o = (s += o) >>> 26, s &= 67108863, this.words[a] = s;
          }

          return 0 !== o && (this.words[a] = o, this.length++), this;
        }, o.prototype.isZero = function () {
          return 1 === this.length && 0 === this.words[0];
        }, o.prototype.cmpn = function (t) {
          var e,
              r = t < 0;
          if (0 !== this.negative && !r) return -1;
          if (0 === this.negative && r) return 1;
          if (this.strip(), this.length > 1) e = 1;else {
            r && (t = -t), n(t <= 67108863, "Number is too big");
            var i = 0 | this.words[0];
            e = i === t ? 0 : i < t ? -1 : 1;
          }
          return 0 !== this.negative ? 0 | -e : e;
        }, o.prototype.cmp = function (t) {
          if (0 !== this.negative && 0 === t.negative) return -1;
          if (0 === this.negative && 0 !== t.negative) return 1;
          var e = this.ucmp(t);
          return 0 !== this.negative ? 0 | -e : e;
        }, o.prototype.ucmp = function (t) {
          if (this.length > t.length) return 1;
          if (this.length < t.length) return -1;

          for (var e = 0, r = this.length - 1; r >= 0; r--) {
            var n = 0 | this.words[r],
                i = 0 | t.words[r];

            if (n !== i) {
              n < i ? e = -1 : n > i && (e = 1);
              break;
            }
          }

          return e;
        }, o.prototype.gtn = function (t) {
          return 1 === this.cmpn(t);
        }, o.prototype.gt = function (t) {
          return 1 === this.cmp(t);
        }, o.prototype.gten = function (t) {
          return this.cmpn(t) >= 0;
        }, o.prototype.gte = function (t) {
          return this.cmp(t) >= 0;
        }, o.prototype.ltn = function (t) {
          return -1 === this.cmpn(t);
        }, o.prototype.lt = function (t) {
          return -1 === this.cmp(t);
        }, o.prototype.lten = function (t) {
          return this.cmpn(t) <= 0;
        }, o.prototype.lte = function (t) {
          return this.cmp(t) <= 0;
        }, o.prototype.eqn = function (t) {
          return 0 === this.cmpn(t);
        }, o.prototype.eq = function (t) {
          return 0 === this.cmp(t);
        }, o.red = function (t) {
          return new _(t);
        }, o.prototype.toRed = function (t) {
          return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), t.convertTo(this)._forceRed(t);
        }, o.prototype.fromRed = function () {
          return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
        }, o.prototype._forceRed = function (t) {
          return this.red = t, this;
        }, o.prototype.forceRed = function (t) {
          return n(!this.red, "Already a number in reduction context"), this._forceRed(t);
        }, o.prototype.redAdd = function (t) {
          return n(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
        }, o.prototype.redIAdd = function (t) {
          return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
        }, o.prototype.redSub = function (t) {
          return n(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
        }, o.prototype.redISub = function (t) {
          return n(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
        }, o.prototype.redShl = function (t) {
          return n(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
        }, o.prototype.redMul = function (t) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
        }, o.prototype.redIMul = function (t) {
          return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
        }, o.prototype.redSqr = function () {
          return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
        }, o.prototype.redISqr = function () {
          return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
        }, o.prototype.redSqrt = function () {
          return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
        }, o.prototype.redInvm = function () {
          return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
        }, o.prototype.redNeg = function () {
          return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
        }, o.prototype.redPow = function (t) {
          return n(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
        };
        var A = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        function b(t, e) {
          this.name = t, this.p = new o(e, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
        }

        function v() {
          b.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
        }

        function y() {
          b.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
        }

        function w() {
          b.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
        }

        function m() {
          b.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
        }

        function _(t) {
          if ("string" == typeof t) {
            var e = o._prime(t);

            this.m = e.p, this.prime = e;
          } else n(t.gtn(1), "modulus must be greater than 1"), this.m = t, this.prime = null;
        }

        function I(t) {
          _.call(this, t), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
        }

        b.prototype._tmp = function () {
          var t = new o(null);
          return t.words = new Array(Math.ceil(this.n / 13)), t;
        }, b.prototype.ireduce = function (t) {
          var e,
              r = t;

          do {
            this.split(r, this.tmp), e = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
          } while (e > this.n);

          var n = e < this.n ? -1 : r.ucmp(this.p);
          return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : r.strip(), r;
        }, b.prototype.split = function (t, e) {
          t.iushrn(this.n, 0, e);
        }, b.prototype.imulK = function (t) {
          return t.imul(this.k);
        }, i(v, b), v.prototype.split = function (t, e) {
          for (var r = Math.min(t.length, 9), n = 0; n < r; n++) {
            e.words[n] = t.words[n];
          }

          if (e.length = r, t.length <= 9) return t.words[0] = 0, void (t.length = 1);
          var i = t.words[9];

          for (e.words[e.length++] = 4194303 & i, n = 10; n < t.length; n++) {
            var o = 0 | t.words[n];
            t.words[n - 10] = (4194303 & o) << 4 | i >>> 22, i = o;
          }

          i >>>= 22, t.words[n - 10] = i, 0 === i && t.length > 10 ? t.length -= 10 : t.length -= 9;
        }, v.prototype.imulK = function (t) {
          t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;

          for (var e = 0, r = 0; r < t.length; r++) {
            var n = 0 | t.words[r];
            e += 977 * n, t.words[r] = 67108863 & e, e = 64 * n + (e / 67108864 | 0);
          }

          return 0 === t.words[t.length - 1] && (t.length--, 0 === t.words[t.length - 1] && t.length--), t;
        }, i(y, b), i(w, b), i(m, b), m.prototype.imulK = function (t) {
          for (var e = 0, r = 0; r < t.length; r++) {
            var n = 19 * (0 | t.words[r]) + e,
                i = 67108863 & n;
            n >>>= 26, t.words[r] = i, e = n;
          }

          return 0 !== e && (t.words[t.length++] = e), t;
        }, o._prime = function (t) {
          if (A[t]) return A[t];
          var e;
          if ("k256" === t) e = new v();else if ("p224" === t) e = new y();else if ("p192" === t) e = new w();else {
            if ("p25519" !== t) throw new Error("Unknown prime " + t);
            e = new m();
          }
          return A[t] = e, e;
        }, _.prototype._verify1 = function (t) {
          n(0 === t.negative, "red works only with positives"), n(t.red, "red works only with red numbers");
        }, _.prototype._verify2 = function (t, e) {
          n(0 == (t.negative | e.negative), "red works only with positives"), n(t.red && t.red === e.red, "red works only with red numbers");
        }, _.prototype.imod = function (t) {
          return this.prime ? this.prime.ireduce(t)._forceRed(this) : t.umod(this.m)._forceRed(this);
        }, _.prototype.neg = function (t) {
          return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
        }, _.prototype.add = function (t, e) {
          this._verify2(t, e);

          var r = t.add(e);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
        }, _.prototype.iadd = function (t, e) {
          this._verify2(t, e);

          var r = t.iadd(e);
          return r.cmp(this.m) >= 0 && r.isub(this.m), r;
        }, _.prototype.sub = function (t, e) {
          this._verify2(t, e);

          var r = t.sub(e);
          return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
        }, _.prototype.isub = function (t, e) {
          this._verify2(t, e);

          var r = t.isub(e);
          return r.cmpn(0) < 0 && r.iadd(this.m), r;
        }, _.prototype.shl = function (t, e) {
          return this._verify1(t), this.imod(t.ushln(e));
        }, _.prototype.imul = function (t, e) {
          return this._verify2(t, e), this.imod(t.imul(e));
        }, _.prototype.mul = function (t, e) {
          return this._verify2(t, e), this.imod(t.mul(e));
        }, _.prototype.isqr = function (t) {
          return this.imul(t, t.clone());
        }, _.prototype.sqr = function (t) {
          return this.mul(t, t);
        }, _.prototype.sqrt = function (t) {
          if (t.isZero()) return t.clone();
          var e = this.m.andln(3);

          if (n(e % 2 == 1), 3 === e) {
            var r = this.m.add(new o(1)).iushrn(2);
            return this.pow(t, r);
          }

          for (var i = this.m.subn(1), a = 0; !i.isZero() && 0 === i.andln(1);) {
            a++, i.iushrn(1);
          }

          n(!i.isZero());
          var s = new o(1).toRed(this),
              f = s.redNeg(),
              u = this.m.subn(1).iushrn(1),
              c = this.m.bitLength();

          for (c = new o(2 * c * c).toRed(this); 0 !== this.pow(c, u).cmp(f);) {
            c.redIAdd(f);
          }

          for (var h = this.pow(c, i), l = this.pow(t, i.addn(1).iushrn(1)), d = this.pow(t, i), p = a; 0 !== d.cmp(s);) {
            for (var g = d, A = 0; 0 !== g.cmp(s); A++) {
              g = g.redSqr();
            }

            n(A < p);
            var b = this.pow(h, new o(1).iushln(p - A - 1));
            l = l.redMul(b), h = b.redSqr(), d = d.redMul(h), p = A;
          }

          return l;
        }, _.prototype.invm = function (t) {
          var e = t._invmp(this.m);

          return 0 !== e.negative ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
        }, _.prototype.pow = function (t, e) {
          if (e.isZero()) return new o(1).toRed(this);
          if (0 === e.cmpn(1)) return t.clone();
          var r = new Array(16);
          r[0] = new o(1).toRed(this), r[1] = t;

          for (var n = 2; n < r.length; n++) {
            r[n] = this.mul(r[n - 1], t);
          }

          var i = r[0],
              a = 0,
              s = 0,
              f = e.bitLength() % 26;

          for (0 === f && (f = 26), n = e.length - 1; n >= 0; n--) {
            for (var u = e.words[n], c = f - 1; c >= 0; c--) {
              var h = u >> c & 1;
              i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== a ? (a <<= 1, a |= h, (4 === ++s || 0 === n && 0 === c) && (i = this.mul(i, r[a]), s = 0, a = 0)) : s = 0;
            }

            f = 26;
          }

          return i;
        }, _.prototype.convertTo = function (t) {
          var e = t.umod(this.m);
          return e === t ? e.clone() : e;
        }, _.prototype.convertFrom = function (t) {
          var e = t.clone();
          return e.red = null, e;
        }, o.mont = function (t) {
          return new I(t);
        }, i(I, _), I.prototype.convertTo = function (t) {
          return this.imod(t.ushln(this.shift));
        }, I.prototype.convertFrom = function (t) {
          var e = this.imod(t.mul(this.rinv));
          return e.red = null, e;
        }, I.prototype.imul = function (t, e) {
          if (t.isZero() || e.isZero()) return t.words[0] = 0, t.length = 1, t;
          var r = t.imul(e),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              o = i;
          return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
        }, I.prototype.mul = function (t, e) {
          if (t.isZero() || e.isZero()) return new o(0)._forceRed(this);
          var r = t.mul(e),
              n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
              i = r.isub(n).iushrn(this.shift),
              a = i;
          return i.cmp(this.m) >= 0 ? a = i.isub(this.m) : i.cmpn(0) < 0 && (a = i.iadd(this.m)), a._forceRed(this);
        }, I.prototype.invm = function (t) {
          return this.imod(t._invmp(this.m).mul(this.r2))._forceRed(this);
        };
      }(t, this);
    }).call(this, r(24)(t));
  }, function (t, e, r) {
    "use strict";

    var n = e;
    n.version = r(130).version, n.utils = r(131), n.rand = r(132), n.curve = r(19), n.curves = r(138), n.ec = r(146), n.eddsa = r(150);
  }, function (t, e, r) {
    "use strict";

    var n = r(9),
        i = r(0);

    function o(t, e) {
      return 55296 == (64512 & t.charCodeAt(e)) && !(e < 0 || e + 1 >= t.length) && 56320 == (64512 & t.charCodeAt(e + 1));
    }

    function a(t) {
      return (t >>> 24 | t >>> 8 & 65280 | t << 8 & 16711680 | (255 & t) << 24) >>> 0;
    }

    function s(t) {
      return 1 === t.length ? "0" + t : t;
    }

    function f(t) {
      return 7 === t.length ? "0" + t : 6 === t.length ? "00" + t : 5 === t.length ? "000" + t : 4 === t.length ? "0000" + t : 3 === t.length ? "00000" + t : 2 === t.length ? "000000" + t : 1 === t.length ? "0000000" + t : t;
    }

    e.inherits = i, e.toArray = function (t, e) {
      if (Array.isArray(t)) return t.slice();
      if (!t) return [];
      var r = [];
      if ("string" == typeof t) {
        if (e) {
          if ("hex" === e) for ((t = t.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (t = "0" + t), i = 0; i < t.length; i += 2) {
            r.push(parseInt(t[i] + t[i + 1], 16));
          }
        } else for (var n = 0, i = 0; i < t.length; i++) {
          var a = t.charCodeAt(i);
          a < 128 ? r[n++] = a : a < 2048 ? (r[n++] = a >> 6 | 192, r[n++] = 63 & a | 128) : o(t, i) ? (a = 65536 + ((1023 & a) << 10) + (1023 & t.charCodeAt(++i)), r[n++] = a >> 18 | 240, r[n++] = a >> 12 & 63 | 128, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128) : (r[n++] = a >> 12 | 224, r[n++] = a >> 6 & 63 | 128, r[n++] = 63 & a | 128);
        }
      } else for (i = 0; i < t.length; i++) {
        r[i] = 0 | t[i];
      }
      return r;
    }, e.toHex = function (t) {
      for (var e = "", r = 0; r < t.length; r++) {
        e += s(t[r].toString(16));
      }

      return e;
    }, e.htonl = a, e.toHex32 = function (t, e) {
      for (var r = "", n = 0; n < t.length; n++) {
        var i = t[n];
        "little" === e && (i = a(i)), r += f(i.toString(16));
      }

      return r;
    }, e.zero2 = s, e.zero8 = f, e.join32 = function (t, e, r, i) {
      var o = r - e;
      n(o % 4 == 0);

      for (var a = new Array(o / 4), s = 0, f = e; s < a.length; s++, f += 4) {
        var u;
        u = "big" === i ? t[f] << 24 | t[f + 1] << 16 | t[f + 2] << 8 | t[f + 3] : t[f + 3] << 24 | t[f + 2] << 16 | t[f + 1] << 8 | t[f], a[s] = u >>> 0;
      }

      return a;
    }, e.split32 = function (t, e) {
      for (var r = new Array(4 * t.length), n = 0, i = 0; n < t.length; n++, i += 4) {
        var o = t[n];
        "big" === e ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
      }

      return r;
    }, e.rotr32 = function (t, e) {
      return t >>> e | t << 32 - e;
    }, e.rotl32 = function (t, e) {
      return t << e | t >>> 32 - e;
    }, e.sum32 = function (t, e) {
      return t + e >>> 0;
    }, e.sum32_3 = function (t, e, r) {
      return t + e + r >>> 0;
    }, e.sum32_4 = function (t, e, r, n) {
      return t + e + r + n >>> 0;
    }, e.sum32_5 = function (t, e, r, n, i) {
      return t + e + r + n + i >>> 0;
    }, e.sum64 = function (t, e, r, n) {
      var i = t[e],
          o = n + t[e + 1] >>> 0,
          a = (o < n ? 1 : 0) + r + i;
      t[e] = a >>> 0, t[e + 1] = o;
    }, e.sum64_hi = function (t, e, r, n) {
      return (e + n >>> 0 < e ? 1 : 0) + t + r >>> 0;
    }, e.sum64_lo = function (t, e, r, n) {
      return e + n >>> 0;
    }, e.sum64_4_hi = function (t, e, r, n, i, o, a, s) {
      var f = 0,
          u = e;
      return f += (u = u + n >>> 0) < e ? 1 : 0, f += (u = u + o >>> 0) < o ? 1 : 0, t + r + i + a + (f += (u = u + s >>> 0) < s ? 1 : 0) >>> 0;
    }, e.sum64_4_lo = function (t, e, r, n, i, o, a, s) {
      return e + n + o + s >>> 0;
    }, e.sum64_5_hi = function (t, e, r, n, i, o, a, s, f, u) {
      var c = 0,
          h = e;
      return c += (h = h + n >>> 0) < e ? 1 : 0, c += (h = h + o >>> 0) < o ? 1 : 0, c += (h = h + s >>> 0) < s ? 1 : 0, t + r + i + a + f + (c += (h = h + u >>> 0) < u ? 1 : 0) >>> 0;
    }, e.sum64_5_lo = function (t, e, r, n, i, o, a, s, f, u) {
      return e + n + o + s + u >>> 0;
    }, e.rotr64_hi = function (t, e, r) {
      return (e << 32 - r | t >>> r) >>> 0;
    }, e.rotr64_lo = function (t, e, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    }, e.shr64_hi = function (t, e, r) {
      return t >>> r;
    }, e.shr64_lo = function (t, e, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    };
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, e) {
    var r,
        n,
        i = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(t) {
      if (r === setTimeout) return setTimeout(t, 0);
      if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

      try {
        return r(t, 0);
      } catch (e) {
        try {
          return r.call(null, t, 0);
        } catch (e) {
          return r.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        r = o;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        n = a;
      }
    }();
    var f,
        u = [],
        c = !1,
        h = -1;

    function l() {
      c && f && (c = !1, f.length ? u = f.concat(u) : h = -1, u.length && d());
    }

    function d() {
      if (!c) {
        var t = s(l);
        c = !0;

        for (var e = u.length; e;) {
          for (f = u, u = []; ++h < e;) {
            f && f[h].run();
          }

          h = -1, e = u.length;
        }

        f = null, c = !1, function (t) {
          if (n === clearTimeout) return clearTimeout(t);
          if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

          try {
            n(t);
          } catch (e) {
            try {
              return n.call(null, t);
            } catch (e) {
              return n.call(this, t);
            }
          }
        }(t);
      }
    }

    function p(t, e) {
      this.fun = t, this.array = e;
    }

    function g() {}

    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        e[r - 1] = arguments[r];
      }
      u.push(new p(t, e)), 1 !== u.length || c || s(d);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */
      var n = r(100),
          i = r(101),
          o = r(102);

      function a() {
        return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function s(t, e) {
        if (a() < e) throw new RangeError("Invalid typed array length");
        return f.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = f.prototype : (null === t && (t = new f(e)), t.length = e), t;
      }

      function f(t, e, r) {
        if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(t, e, r);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return h(this, t);
        }

        return u(this, t, e, r);
      }

      function u(t, e, r, n) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
          if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
          f.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = f.prototype : t = l(t, e);
          return t;
        }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | p(e, r),
              i = (t = s(t, n)).write(e, r);
          i !== n && (t = t.slice(0, i));
          return t;
        }(t, e, r) : function (t, e) {
          if (f.isBuffer(e)) {
            var r = 0 | d(e.length);
            return 0 === (t = s(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
          }

          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? s(t, 0) : l(t, e);
            if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(t, e);
      }

      function c(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function h(t, e) {
        if (c(e), t = s(t, e < 0 ? 0 : 0 | d(e)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
          t[r] = 0;
        }
        return t;
      }

      function l(t, e) {
        var r = e.length < 0 ? 0 : 0 | d(e.length);
        t = s(t, r);

        for (var n = 0; n < r; n += 1) {
          t[n] = 255 & e[n];
        }

        return t;
      }

      function d(t) {
        if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | t;
      }

      function p(t, e) {
        if (f.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var r = t.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return N(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return q(t).length;

            default:
              if (n) return N(t).length;
              e = ("" + e).toLowerCase(), n = !0;
          }
        }
      }

      function g(t, e, r) {
        var n = t[e];
        t[e] = t[r], t[r] = n;
      }

      function A(t, e, r, n, i) {
        if (0 === t.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
          if (i) return -1;
          r = t.length - 1;
        } else if (r < 0) {
          if (!i) return -1;
          r = 0;
        }

        if ("string" == typeof e && (e = f.from(e, n)), f.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, r, n, i);
        if ("number" == typeof e) return e &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : b(t, [e], r, n, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function b(t, e, r, n, i) {
        var o,
            a = 1,
            s = t.length,
            f = e.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (t.length < 2 || e.length < 2) return -1;
          a = 2, s /= 2, f /= 2, r /= 2;
        }

        function u(t, e) {
          return 1 === a ? t[e] : t.readUInt16BE(e * a);
        }

        if (i) {
          var c = -1;

          for (o = r; o < s; o++) {
            if (u(t, o) === u(e, -1 === c ? 0 : o - c)) {
              if (-1 === c && (c = o), o - c + 1 === f) return c * a;
            } else -1 !== c && (o -= o - c), c = -1;
          }
        } else for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
          for (var h = !0, l = 0; l < f; l++) {
            if (u(t, o + l) !== u(e, l)) {
              h = !1;
              break;
            }
          }

          if (h) return o;
        }

        return -1;
      }

      function v(t, e, r, n) {
        r = Number(r) || 0;
        var i = t.length - r;
        n ? (n = Number(n)) > i && (n = i) : n = i;
        var o = e.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        n > o / 2 && (n = o / 2);

        for (var a = 0; a < n; ++a) {
          var s = parseInt(e.substr(2 * a, 2), 16);
          if (isNaN(s)) return a;
          t[r + a] = s;
        }

        return a;
      }

      function y(t, e, r, n) {
        return U(N(e, t.length - r), t, r, n);
      }

      function w(t, e, r, n) {
        return U(function (t) {
          for (var e = [], r = 0; r < t.length; ++r) {
            e.push(255 & t.charCodeAt(r));
          }

          return e;
        }(e), t, r, n);
      }

      function m(t, e, r, n) {
        return w(t, e, r, n);
      }

      function _(t, e, r, n) {
        return U(q(e), t, r, n);
      }

      function I(t, e, r, n) {
        return U(function (t, e) {
          for (var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) {
            r = t.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
          }

          return o;
        }(e, t.length - r), t, r, n);
      }

      function E(t, e, r) {
        return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
      }

      function P(t, e, r) {
        r = Math.min(t.length, r);

        for (var n = [], i = e; i < r;) {
          var o,
              a,
              s,
              f,
              u = t[i],
              c = null,
              h = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
          if (i + h <= r) switch (h) {
            case 1:
              u < 128 && (c = u);
              break;

            case 2:
              128 == (192 & (o = t[i + 1])) && (f = (31 & u) << 6 | 63 & o) > 127 && (c = f);
              break;

            case 3:
              o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (c = f);
              break;

            case 4:
              o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (c = f);
          }
          null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
        }

        return function (t) {
          var e = t.length;
          if (e <= S) return String.fromCharCode.apply(String, t);
          var r = "",
              n = 0;

          for (; n < e;) {
            r += String.fromCharCode.apply(String, t.slice(n, n += S));
          }

          return r;
        }(n);
      }

      e.Buffer = f, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return f.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = a(), f.poolSize = 8192, f._augment = function (t) {
        return t.__proto__ = f.prototype, t;
      }, f.from = function (t, e, r) {
        return u(null, t, e, r);
      }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
        value: null,
        configurable: !0
      })), f.alloc = function (t, e, r) {
        return function (t, e, r, n) {
          return c(e), e <= 0 ? s(t, e) : void 0 !== r ? "string" == typeof n ? s(t, e).fill(r, n) : s(t, e).fill(r) : s(t, e);
        }(null, t, e, r);
      }, f.allocUnsafe = function (t) {
        return h(null, t);
      }, f.allocUnsafeSlow = function (t) {
        return h(null, t);
      }, f.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, f.compare = function (t, e) {
        if (!f.isBuffer(t) || !f.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (t[i] !== e[i]) {
            r = t[i], n = e[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, f.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, f.concat = function (t, e) {
        if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return f.alloc(0);
        var r;
        if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
          e += t[r].length;
        }
        var n = f.allocUnsafe(e),
            i = 0;

        for (r = 0; r < t.length; ++r) {
          var a = t[r];
          if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(n, i), i += a.length;
        }

        return n;
      }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          g(this, e, e + 1);
        }

        return this;
      }, f.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          g(this, e, e + 3), g(this, e + 1, e + 2);
        }

        return this;
      }, f.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
        }

        return this;
      }, f.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? P(this, 0, t) : function (t, e, r) {
          var n = !1;
          if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
          if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
          if ((r >>>= 0) <= (e >>>= 0)) return "";

          for (t || (t = "utf8");;) {
            switch (t) {
              case "hex":
                return M(this, e, r);

              case "utf8":
              case "utf-8":
                return P(this, e, r);

              case "ascii":
                return x(this, e, r);

              case "latin1":
              case "binary":
                return C(this, e, r);

              case "base64":
                return E(this, e, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return T(this, e, r);

              default:
                if (n) throw new TypeError("Unknown encoding: " + t);
                t = (t + "").toLowerCase(), n = !0;
            }
          }
        }.apply(this, arguments);
      }, f.prototype.equals = function (t) {
        if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === f.compare(this, t);
      }, f.prototype.inspect = function () {
        var t = "",
            r = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
      }, f.prototype.compare = function (t, e, r, n, i) {
        if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
        if (n >= i && e >= r) return 0;
        if (n >= i) return -1;
        if (e >= r) return 1;
        if (this === t) return 0;

        for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), u = this.slice(n, i), c = t.slice(e, r), h = 0; h < s; ++h) {
          if (u[h] !== c[h]) {
            o = u[h], a = c[h];
            break;
          }
        }

        return o < a ? -1 : a < o ? 1 : 0;
      }, f.prototype.includes = function (t, e, r) {
        return -1 !== this.indexOf(t, e, r);
      }, f.prototype.indexOf = function (t, e, r) {
        return A(this, t, e, r, !0);
      }, f.prototype.lastIndexOf = function (t, e, r) {
        return A(this, t, e, r, !1);
      }, f.prototype.write = function (t, e, r, n) {
        if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var i = this.length - e;
        if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var o = !1;;) {
          switch (n) {
            case "hex":
              return v(this, t, e, r);

            case "utf8":
            case "utf-8":
              return y(this, t, e, r);

            case "ascii":
              return w(this, t, e, r);

            case "latin1":
            case "binary":
              return m(this, t, e, r);

            case "base64":
              return _(this, t, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return I(this, t, e, r);

            default:
              if (o) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), o = !0;
          }
        }
      }, f.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var S = 4096;

      function x(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(127 & t[i]);
        }

        return n;
      }

      function C(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(t[i]);
        }

        return n;
      }

      function M(t, e, r) {
        var n = t.length;
        (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

        for (var i = "", o = e; o < r; ++o) {
          i += z(t[o]);
        }

        return i;
      }

      function T(t, e, r) {
        for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
          i += String.fromCharCode(n[o] + 256 * n[o + 1]);
        }

        return i;
      }

      function k(t, e, r) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function R(t, e, r, n, i, o) {
        if (!f.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
        if (r + n > t.length) throw new RangeError("Index out of range");
      }

      function B(t, e, r, n) {
        e < 0 && (e = 65535 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
          t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
        }
      }

      function L(t, e, r, n) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
          t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
        }
      }

      function O(t, e, r, n, i, o) {
        if (r + n > t.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function j(t, e, r, n, o) {
        return o || O(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
      }

      function D(t, e, r, n, o) {
        return o || O(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
      }

      f.prototype.slice = function (t, e) {
        var r,
            n = this.length;
        if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = f.prototype;else {
          var i = e - t;
          r = new f(i, void 0);

          for (var o = 0; o < i; ++o) {
            r[o] = this[o + t];
          }
        }
        return r;
      }, f.prototype.readUIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || k(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n;
      }, f.prototype.readUIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || k(t, e, this.length);

        for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
          n += this[t + --e] * i;
        }

        return n;
      }, f.prototype.readUInt8 = function (t, e) {
        return e || k(t, 1, this.length), this[t];
      }, f.prototype.readUInt16LE = function (t, e) {
        return e || k(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, f.prototype.readUInt16BE = function (t, e) {
        return e || k(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, f.prototype.readUInt32LE = function (t, e) {
        return e || k(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, f.prototype.readUInt32BE = function (t, e) {
        return e || k(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, f.prototype.readIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || k(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
      }, f.prototype.readIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || k(t, e, this.length);

        for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
          o += this[t + --n] * i;
        }

        return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
      }, f.prototype.readInt8 = function (t, e) {
        return e || k(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, f.prototype.readInt16LE = function (t, e) {
        e || k(t, 2, this.length);
        var r = this[t] | this[t + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, f.prototype.readInt16BE = function (t, e) {
        e || k(t, 2, this.length);
        var r = this[t + 1] | this[t] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, f.prototype.readInt32LE = function (t, e) {
        return e || k(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, f.prototype.readInt32BE = function (t, e) {
        return e || k(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, f.prototype.readFloatLE = function (t, e) {
        return e || k(t, 4, this.length), i.read(this, t, !0, 23, 4);
      }, f.prototype.readFloatBE = function (t, e) {
        return e || k(t, 4, this.length), i.read(this, t, !1, 23, 4);
      }, f.prototype.readDoubleLE = function (t, e) {
        return e || k(t, 8, this.length), i.read(this, t, !0, 52, 8);
      }, f.prototype.readDoubleBE = function (t, e) {
        return e || k(t, 8, this.length), i.read(this, t, !1, 52, 8);
      }, f.prototype.writeUIntLE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = 1,
            o = 0;

        for (this[e] = 255 & t; ++o < r && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + r;
      }, f.prototype.writeUIntBE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = r - 1,
            o = 1;

        for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + r;
      }, f.prototype.writeUInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, f.prototype.writeUInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
      }, f.prototype.writeUInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
      }, f.prototype.writeUInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : L(this, t, e, !0), e + 4;
      }, f.prototype.writeUInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
      }, f.prototype.writeIntLE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          R(this, t, e, r, i - 1, -i);
        }

        var o = 0,
            a = 1,
            s = 0;

        for (this[e] = 255 & t; ++o < r && (a *= 256);) {
          t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
        }

        return e + r;
      }, f.prototype.writeIntBE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          R(this, t, e, r, i - 1, -i);
        }

        var o = r - 1,
            a = 1,
            s = 0;

        for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
          t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
        }

        return e + r;
      }, f.prototype.writeInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, f.prototype.writeInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
      }, f.prototype.writeInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
      }, f.prototype.writeInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : L(this, t, e, !0), e + 4;
      }, f.prototype.writeInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
      }, f.prototype.writeFloatLE = function (t, e, r) {
        return j(this, t, e, !0, r);
      }, f.prototype.writeFloatBE = function (t, e, r) {
        return j(this, t, e, !1, r);
      }, f.prototype.writeDoubleLE = function (t, e, r) {
        return D(this, t, e, !0, r);
      }, f.prototype.writeDoubleBE = function (t, e, r) {
        return D(this, t, e, !1, r);
      }, f.prototype.copy = function (t, e, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
        var i,
            o = n - r;
        if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
          t[i + e] = this[i + r];
        } else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          t[i + e] = this[i + r];
        } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
        return o;
      }, f.prototype.fill = function (t, e, r, n) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
            var i = t.charCodeAt(0);
            i < 256 && (t = i);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
        if (r <= e) return this;
        var o;
        if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
          this[o] = t;
        } else {
          var a = f.isBuffer(t) ? t : N(new f(t, n).toString()),
              s = a.length;

          for (o = 0; o < r - e; ++o) {
            this[o + e] = a[o % s];
          }
        }
        return this;
      };
      var H = /[^+\/0-9A-Za-z-_]/g;

      function z(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function N(t, e) {
        var r;
        e = e || 1 / 0;

        for (var n = t.length, i = null, o = [], a = 0; a < n; ++a) {
          if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (a + 1 === n) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = r;
              continue;
            }

            if (r < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), i = r;
              continue;
            }

            r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (e -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, r < 128) {
            if ((e -= 1) < 0) break;
            o.push(r);
          } else if (r < 2048) {
            if ((e -= 2) < 0) break;
            o.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((e -= 3) < 0) break;
            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return o;
      }

      function q(t) {
        return n.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
          }(t).replace(H, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function U(t, e, r, n) {
        for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
          e[i + r] = t[i];
        }

        return i;
      }
    }).call(this, r(5));
  }, function (t, e, r) {
    "use strict";

    var n = r(18),
        i = Object.keys || function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e;
    };

    t.exports = h;
    var o = r(11);
    o.inherits = r(0);
    var a = r(43),
        s = r(27);
    o.inherits(h, a);

    for (var f = i(s.prototype), u = 0; u < f.length; u++) {
      var c = f[u];
      h.prototype[c] || (h.prototype[c] = s.prototype[c]);
    }

    function h(t) {
      if (!(this instanceof h)) return new h(t);
      a.call(this, t), s.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", l);
    }

    function l() {
      this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
    }

    function d(t) {
      t.end();
    }

    Object.defineProperty(h.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(h.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(t) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
      }
    }), h.prototype._destroy = function (t, e) {
      this.push(null), this.end(), n.nextTick(e, t);
    };
  }, function (t, e) {
    function r(t, e) {
      if (!t) throw new Error(e || "Assertion failed");
    }

    t.exports = r, r.equal = function (t, e, r) {
      if (t != e) throw new Error(r || "Assertion failed: " + t + " != " + e);
    };
  }, function (t, e, r) {
    var n = r(1).Buffer;

    function i(t, e) {
      this._block = n.alloc(t), this._finalSize = e, this._blockSize = t, this._len = 0;
    }

    i.prototype.update = function (t, e) {
      "string" == typeof t && (e = e || "utf8", t = n.from(t, e));

      for (var r = this._block, i = this._blockSize, o = t.length, a = this._len, s = 0; s < o;) {
        for (var f = a % i, u = Math.min(o - s, i - f), c = 0; c < u; c++) {
          r[f + c] = t[s + c];
        }

        s += u, (a += u) % i == 0 && this._update(r);
      }

      return this._len += o, this;
    }, i.prototype.digest = function (t) {
      var e = this._len % this._blockSize;
      this._block[e] = 128, this._block.fill(0, e + 1), e >= this._finalSize && (this._update(this._block), this._block.fill(0));
      var r = 8 * this._len;
      if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);else {
        var n = (4294967295 & r) >>> 0,
            i = (r - n) / 4294967296;
        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
      }

      this._update(this._block);

      var o = this._hash();

      return t ? o.toString(t) : o;
    }, i.prototype._update = function () {
      throw new Error("_update must be implemented by subclass");
    }, t.exports = i;
  }, function (t, e, r) {
    (function (t) {
      function r(t) {
        return Object.prototype.toString.call(t);
      }

      e.isArray = function (t) {
        return Array.isArray ? Array.isArray(t) : "[object Array]" === r(t);
      }, e.isBoolean = function (t) {
        return "boolean" == typeof t;
      }, e.isNull = function (t) {
        return null === t;
      }, e.isNullOrUndefined = function (t) {
        return null == t;
      }, e.isNumber = function (t) {
        return "number" == typeof t;
      }, e.isString = function (t) {
        return "string" == typeof t;
      }, e.isSymbol = function (t) {
        return "symbol" == typeof t;
      }, e.isUndefined = function (t) {
        return void 0 === t;
      }, e.isRegExp = function (t) {
        return "[object RegExp]" === r(t);
      }, e.isObject = function (t) {
        return "object" == typeof t && null !== t;
      }, e.isDate = function (t) {
        return "[object Date]" === r(t);
      }, e.isError = function (t) {
        return "[object Error]" === r(t) || t instanceof Error;
      }, e.isFunction = function (t) {
        return "function" == typeof t;
      }, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }, e.isBuffer = t.isBuffer;
    }).call(this, r(7).Buffer);
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(9);

    function o() {
      this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
    }

    e.BlockHash = o, o.prototype.update = function (t, e) {
      if (t = n.toArray(t, e), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        var r = (t = this.pending).length % this._delta8;
        this.pending = t.slice(t.length - r, t.length), 0 === this.pending.length && (this.pending = null), t = n.join32(t, 0, t.length - r, this.endian);

        for (var i = 0; i < t.length; i += this._delta32) {
          this._update(t, i, i + this._delta32);
        }
      }

      return this;
    }, o.prototype.digest = function (t) {
      return this.update(this._pad()), i(null === this.pending), this._digest(t);
    }, o.prototype._pad = function () {
      var t = this.pendingTotal,
          e = this._delta8,
          r = e - (t + this.padLength) % e,
          n = new Array(r + this.padLength);
      n[0] = 128;

      for (var i = 1; i < r; i++) {
        n[i] = 0;
      }

      if (t <<= 3, "big" === this.endian) {
        for (var o = 8; o < this.padLength; o++) {
          n[i++] = 0;
        }

        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = t >>> 24 & 255, n[i++] = t >>> 16 & 255, n[i++] = t >>> 8 & 255, n[i++] = 255 & t;
      } else for (n[i++] = 255 & t, n[i++] = t >>> 8 & 255, n[i++] = t >>> 16 & 255, n[i++] = t >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++) {
        n[i++] = 0;
      }

      return n;
    };
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      e |= 0;

      for (var r = Math.max(t.length - e, 0), n = Array(r), i = 0; i < r; i++) {
        n[i] = t[e + i];
      }

      return n;
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.isAsync = void 0;
    var n,
        i = r(66),
        o = (n = i) && n.__esModule ? n : {
      default: n
    };
    var a = "function" == typeof Symbol;

    function s(t) {
      return a && "AsyncFunction" === t[Symbol.toStringTag];
    }

    e.default = function (t) {
      return s(t) ? (0, o.default)(t) : t;
    }, e.isAsync = s;
  }, function (t, e, r) {
    var n = r(72),
        i = r(38);

    t.exports = function (t) {
      return null != t && i(t.length) && !n(t);
    };
  }, function (t, e, r) {
    t.exports = i;
    var n = r(25).EventEmitter;

    function i() {
      n.call(this);
    }

    r(0)(i, n), i.Readable = r(26), i.Writable = r(109), i.Duplex = r(110), i.Transform = r(111), i.PassThrough = r(112), i.Stream = i, i.prototype.pipe = function (t, e) {
      var r = this;

      function i(e) {
        t.writable && !1 === t.write(e) && r.pause && r.pause();
      }

      function o() {
        r.readable && r.resume && r.resume();
      }

      r.on("data", i), t.on("drain", o), t._isStdio || e && !1 === e.end || (r.on("end", s), r.on("close", f));
      var a = !1;

      function s() {
        a || (a = !0, t.end());
      }

      function f() {
        a || (a = !0, "function" == typeof t.destroy && t.destroy());
      }

      function u(t) {
        if (c(), 0 === n.listenerCount(this, "error")) throw t;
      }

      function c() {
        r.removeListener("data", i), t.removeListener("drain", o), r.removeListener("end", s), r.removeListener("close", f), r.removeListener("error", u), t.removeListener("error", u), r.removeListener("end", c), r.removeListener("close", c), t.removeListener("close", c);
      }

      return r.on("error", u), t.on("error", u), r.on("end", c), r.on("close", c), t.on("close", c), t.emit("pipe", r), t;
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
        nextTick: function nextTick(t, r, n, i) {
          if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
          var o,
              a,
              s = arguments.length;

          switch (s) {
            case 0:
            case 1:
              return e.nextTick(t);

            case 2:
              return e.nextTick(function () {
                t.call(null, r);
              });

            case 3:
              return e.nextTick(function () {
                t.call(null, r, n);
              });

            case 4:
              return e.nextTick(function () {
                t.call(null, r, n, i);
              });

            default:
              for (o = new Array(s - 1), a = 0; a < o.length;) {
                o[a++] = arguments[a];
              }

              return e.nextTick(function () {
                t.apply(null, o);
              });
          }
        }
      } : t.exports = e;
    }).call(this, r(6));
  }, function (t, e, r) {
    "use strict";

    var n = e;
    n.base = r(134), n.short = r(135), n.mont = r(136), n.edwards = r(137);
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function () {
        if (null !== t) {
          var e = t;
          t = null, e.apply(this, arguments);
        }
      };
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function () {
        if (null === t) throw new Error("Callback was already called.");
        var e = t;
        t = null, e.apply(this, arguments);
      };
    }, t.exports = e.default;
  }, function (t, e, r) {
    var n = r(35),
        i = r(73),
        o = r(74),
        a = "[object Null]",
        s = "[object Undefined]",
        f = n ? n.toStringTag : void 0;

    t.exports = function (t) {
      return null == t ? void 0 === t ? s : a : f && f in Object(t) ? i(t) : o(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return null != t && "object" == typeof t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, r) {
    "use strict";

    var n,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (t, e, r) {
      return Function.prototype.apply.call(t, e, r);
    };
    n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };

    var a = Number.isNaN || function (t) {
      return t != t;
    };

    function s() {
      s.init.call(this);
    }

    t.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
    var f = 10;

    function u(t) {
      return void 0 === t._maxListeners ? s.defaultMaxListeners : t._maxListeners;
    }

    function c(t, e, r, n) {
      var i, o, a, s;
      if ("function" != typeof r) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
      if (void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), a = o[e]), void 0 === a) a = o[e] = r, ++t._eventsCount;else if ("function" == typeof a ? a = o[e] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), (i = u(t)) > 0 && a.length > i && !a.warned) {
        a.warned = !0;
        var f = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        f.name = "MaxListenersExceededWarning", f.emitter = t, f.type = e, f.count = a.length, s = f, console && console.warn && console.warn(s);
      }
      return t;
    }

    function h(t, e, r) {
      var n = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: r
      },
          i = function () {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t.push(arguments[e]);
        }

        this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, o(this.listener, this.target, t));
      }.bind(n);

      return i.listener = r, n.wrapFn = i, i;
    }

    function l(t, e, r) {
      var n = t._events;
      if (void 0 === n) return [];
      var i = n[e];
      return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (t) {
        for (var e = new Array(t.length), r = 0; r < e.length; ++r) {
          e[r] = t[r].listener || t[r];
        }

        return e;
      }(i) : p(i, i.length);
    }

    function d(t) {
      var e = this._events;

      if (void 0 !== e) {
        var r = e[t];
        if ("function" == typeof r) return 1;
        if (void 0 !== r) return r.length;
      }

      return 0;
    }

    function p(t, e) {
      for (var r = new Array(e), n = 0; n < e; ++n) {
        r[n] = t[n];
      }

      return r;
    }

    Object.defineProperty(s, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return f;
      },
      set: function set(t) {
        if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        f = t;
      }
    }), s.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, s.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this;
    }, s.prototype.getMaxListeners = function () {
      return u(this);
    }, s.prototype.emit = function (t) {
      for (var e = [], r = 1; r < arguments.length; r++) {
        e.push(arguments[r]);
      }

      var n = "error" === t,
          i = this._events;
      if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

      if (n) {
        var a;
        if (e.length > 0 && (a = e[0]), a instanceof Error) throw a;
        var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw s.context = a, s;
      }

      var f = i[t];
      if (void 0 === f) return !1;
      if ("function" == typeof f) o(f, this, e);else {
        var u = f.length,
            c = p(f, u);

        for (r = 0; r < u; ++r) {
          o(c[r], this, e);
        }
      }
      return !0;
    }, s.prototype.addListener = function (t, e) {
      return c(this, t, e, !1);
    }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (t, e) {
      return c(this, t, e, !0);
    }, s.prototype.once = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.on(t, h(this, t, e)), this;
    }, s.prototype.prependOnceListener = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.prependListener(t, h(this, t, e)), this;
    }, s.prototype.removeListener = function (t, e) {
      var r, n, i, o, a;
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      if (void 0 === (n = this._events)) return this;
      if (void 0 === (r = n[t])) return this;
      if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));else if ("function" != typeof r) {
        for (i = -1, o = r.length - 1; o >= 0; o--) {
          if (r[o] === e || r[o].listener === e) {
            a = r[o].listener, i = o;
            break;
          }
        }

        if (i < 0) return this;
        0 === i ? r.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) {
            t[e] = t[e + 1];
          }

          t.pop();
        }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, a || e);
      }
      return this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (t) {
      var e, r, n;
      if (void 0 === (r = this._events)) return this;
      if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;

      if (0 === arguments.length) {
        var i,
            o = Object.keys(r);

        for (n = 0; n < o.length; ++n) {
          "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (e = r[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) {
        this.removeListener(t, e[n]);
      }
      return this;
    }, s.prototype.listeners = function (t) {
      return l(this, t, !0);
    }, s.prototype.rawListeners = function (t) {
      return l(this, t, !1);
    }, s.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : d.call(t, e);
    }, s.prototype.listenerCount = d, s.prototype.eventNames = function () {
      return this._eventsCount > 0 ? n(this._events) : [];
    };
  }, function (t, e, r) {
    (e = t.exports = r(43)).Stream = e, e.Readable = e, e.Writable = r(27), e.Duplex = r(8), e.Transform = r(46), e.PassThrough = r(108);
  }, function (t, e, r) {
    "use strict";

    (function (e, n, i) {
      var o = r(18);

      function a(t) {
        var e = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (t, e, r) {
            var n = t.entry;
            t.entry = null;

            for (; n;) {
              var i = n.callback;
              e.pendingcb--, i(r), n = n.next;
            }

            e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
          }(e, t);
        };
      }

      t.exports = v;
      var s,
          f = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
      v.WritableState = b;
      var u = r(11);
      u.inherits = r(0);

      var c = {
        deprecate: r(107)
      },
          h = r(44),
          l = r(1).Buffer,
          d = i.Uint8Array || function () {};

      var p,
          g = r(45);

      function A() {}

      function b(t, e) {
        s = s || r(8), t = t || {};
        var n = e instanceof s;
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
        var i = t.highWaterMark,
            u = t.writableHighWaterMark,
            c = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (u || 0 === u) ? u : c, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var h = !1 === t.decodeStrings;
        this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
          !function (t, e) {
            var r = t._writableState,
                n = r.sync,
                i = r.writecb;
            if (function (t) {
              t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
            }(r), e) !function (t, e, r, n, i) {
              --e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(E, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), E(t, e));
            }(t, r, n, e, i);else {
              var a = _(r);

              a || r.corked || r.bufferProcessing || !r.bufferedRequest || m(t, r), n ? f(w, t, r, a, i) : w(t, r, a, i);
            }
          }(e, t);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
      }

      function v(t) {
        if (s = s || r(8), !(p.call(v, this) || this instanceof s)) return new v(t);
        this._writableState = new b(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
      }

      function y(t, e, r, n, i, o, a) {
        e.writelen = n, e.writecb = a, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
      }

      function w(t, e, r, n) {
        r || function (t, e) {
          0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
        }(t, e), e.pendingcb--, n(), E(t, e);
      }

      function m(t, e) {
        e.bufferProcessing = !0;
        var r = e.bufferedRequest;

        if (t._writev && r && r.next) {
          var n = e.bufferedRequestCount,
              i = new Array(n),
              o = e.corkedRequestsFree;
          o.entry = r;

          for (var s = 0, f = !0; r;) {
            i[s] = r, r.isBuf || (f = !1), r = r.next, s += 1;
          }

          i.allBuffers = f, y(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new a(e), e.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var u = r.chunk,
                c = r.encoding,
                h = r.callback;
            if (y(t, e, !1, e.objectMode ? 1 : u.length, u, c, h), r = r.next, e.bufferedRequestCount--, e.writing) break;
          }

          null === r && (e.lastBufferedRequest = null);
        }

        e.bufferedRequest = r, e.bufferProcessing = !1;
      }

      function _(t) {
        return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
      }

      function I(t, e) {
        t._final(function (r) {
          e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), E(t, e);
        });
      }

      function E(t, e) {
        var r = _(e);

        return r && (!function (t, e) {
          e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(I, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
        }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r;
      }

      u.inherits(v, h), b.prototype.getBuffer = function () {
        for (var t = this.bufferedRequest, e = []; t;) {
          e.push(t), t = t.next;
        }

        return e;
      }, function () {
        try {
          Object.defineProperty(b.prototype, "buffer", {
            get: c.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (t) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
        value: function value(t) {
          return !!p.call(this, t) || this === v && t && t._writableState instanceof b;
        }
      })) : p = function p(t) {
        return t instanceof this;
      }, v.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, v.prototype.write = function (t, e, r) {
        var n,
            i = this._writableState,
            a = !1,
            s = !i.objectMode && (n = t, l.isBuffer(n) || n instanceof d);
        return s && !l.isBuffer(t) && (t = function (t) {
          return l.from(t);
        }(t)), "function" == typeof e && (r = e, e = null), s ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = A), i.ended ? function (t, e) {
          var r = new Error("write after end");
          t.emit("error", r), o.nextTick(e, r);
        }(this, r) : (s || function (t, e, r, n) {
          var i = !0,
              a = !1;
          return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), o.nextTick(n, a), i = !1), i;
        }(this, i, t, r)) && (i.pendingcb++, a = function (t, e, r, n, i, o) {
          if (!r) {
            var a = function (t, e, r) {
              t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = l.from(e, r));
              return e;
            }(e, n, i);

            n !== a && (r = !0, i = "buffer", n = a);
          }

          var s = e.objectMode ? 1 : n.length;
          e.length += s;
          var f = e.length < e.highWaterMark;
          f || (e.needDrain = !0);

          if (e.writing || e.corked) {
            var u = e.lastBufferedRequest;
            e.lastBufferedRequest = {
              chunk: n,
              encoding: i,
              isBuf: r,
              callback: o,
              next: null
            }, u ? u.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
          } else y(t, e, !1, s, n, i, o);

          return f;
        }(this, i, s, t, e, r)), a;
      }, v.prototype.cork = function () {
        this._writableState.corked++;
      }, v.prototype.uncork = function () {
        var t = this._writableState;
        t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || m(this, t));
      }, v.prototype.setDefaultEncoding = function (t) {
        if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
        return this._writableState.defaultEncoding = t, this;
      }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), v.prototype._write = function (t, e, r) {
        r(new Error("_write() is not implemented"));
      }, v.prototype._writev = null, v.prototype.end = function (t, e, r) {
        var n = this._writableState;
        "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (t, e, r) {
          e.ending = !0, E(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r));
          e.ended = !0, t.writable = !1;
        }(this, n, r);
      }, Object.defineProperty(v.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(t) {
          this._writableState && (this._writableState.destroyed = t);
        }
      }), v.prototype.destroy = g.destroy, v.prototype._undestroy = g.undestroy, v.prototype._destroy = function (t, e) {
        this.end(), e(t);
      };
    }).call(this, r(6), r(34).setImmediate, r(5));
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = n.isEncoding || function (t) {
      switch ((t = "" + t) && t.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    function o(t) {
      var e;

      switch (this.encoding = function (t) {
        var e = function (t) {
          if (!t) return "utf8";

          for (var e;;) {
            switch (t) {
              case "utf8":
              case "utf-8":
                return "utf8";

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";

              case "latin1":
              case "binary":
                return "latin1";

              case "base64":
              case "ascii":
              case "hex":
                return t;

              default:
                if (e) return;
                t = ("" + t).toLowerCase(), e = !0;
            }
          }
        }(t);

        if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
        return e || t;
      }(t), this.encoding) {
        case "utf16le":
          this.text = f, this.end = u, e = 4;
          break;

        case "utf8":
          this.fillLast = s, e = 4;
          break;

        case "base64":
          this.text = c, this.end = h, e = 3;
          break;

        default:
          return this.write = l, void (this.end = d);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
    }

    function a(t) {
      return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
    }

    function s(t) {
      var e = this.lastTotal - this.lastNeed,
          r = function (t, e, r) {
        if (128 != (192 & e[0])) return t.lastNeed = 0, "�";

        if (t.lastNeed > 1 && e.length > 1) {
          if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
          if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�";
        }
      }(this, t);

      return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
    }

    function f(t, e) {
      if ((t.length - e) % 2 == 0) {
        var r = t.toString("utf16le", e);

        if (r) {
          var n = r.charCodeAt(r.length - 1);
          if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
        }

        return r;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }

    function u(t) {
      var e = t && t.length ? this.write(t) : "";

      if (this.lastNeed) {
        var r = this.lastTotal - this.lastNeed;
        return e + this.lastChar.toString("utf16le", 0, r);
      }

      return e;
    }

    function c(t, e) {
      var r = (t.length - e) % 3;
      return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
    }

    function h(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }

    function l(t) {
      return t.toString(this.encoding);
    }

    function d(t) {
      return t && t.length ? this.write(t) : "";
    }

    e.StringDecoder = o, o.prototype.write = function (t) {
      if (0 === t.length) return "";
      var e, r;

      if (this.lastNeed) {
        if (void 0 === (e = this.fillLast(t))) return "";
        r = this.lastNeed, this.lastNeed = 0;
      } else r = 0;

      return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
    }, o.prototype.end = function (t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + "�" : e;
    }, o.prototype.text = function (t, e) {
      var r = function (t, e, r) {
        var n = e.length - 1;
        if (n < r) return 0;
        var i = a(e[n]);
        if (i >= 0) return i > 0 && (t.lastNeed = i - 1), i;
        if (--n < r || -2 === i) return 0;
        if ((i = a(e[n])) >= 0) return i > 0 && (t.lastNeed = i - 2), i;
        if (--n < r || -2 === i) return 0;
        if ((i = a(e[n])) >= 0) return i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i;
        return 0;
      }(this, t, e);

      if (!this.lastNeed) return t.toString("utf8", e);
      this.lastTotal = r;
      var n = t.length - (r - this.lastNeed);
      return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
    }, o.prototype.fillLast = function (t) {
      if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0),
        i = r(121),
        o = r(122),
        a = r(123),
        s = r(128);

    function f(t) {
      s.call(this, "digest"), this._hash = t;
    }

    n(f, s), f.prototype._update = function (t) {
      this._hash.update(t);
    }, f.prototype._final = function () {
      return this._hash.digest();
    }, t.exports = function (t) {
      return "md5" === (t = t.toLowerCase()) ? new i() : "rmd160" === t || "ripemd160" === t ? new o() : new f(a(t));
    };
  }, function (t, e, r) {
    var n = e;
    n.utils = r(4), n.common = r(12), n.sha = r(139), n.ripemd = r(143), n.hmac = r(144), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
  }, function (t, e, r) {
    t.exports = function (t) {
      var e = {};

      function r(n) {
        if (e[n]) return e[n].exports;
        var i = e[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
      }

      return r.m = t, r.c = e, r.d = function (t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: n
        });
      }, r.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, r.t = function (t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) {
          r.d(n, i, function (e) {
            return t[e];
          }.bind(null, i));
        }
        return n;
      }, r.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return r.d(e, "a", e), e;
      }, r.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, r.p = "", r(r.s = 23);
    }([function (t, e, r) {
      "use strict";

      (function (t) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
         * @license  MIT
         */
        var n = r(26),
            i = r(27),
            o = r(12);

        function a() {
          return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }

        function s(t, e) {
          if (a() < e) throw new RangeError("Invalid typed array length");
          return f.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = f.prototype : (null === t && (t = new f(e)), t.length = e), t;
        }

        function f(t, e, r) {
          if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(t, e, r);

          if ("number" == typeof t) {
            if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
            return h(this, t);
          }

          return u(this, t, e, r);
        }

        function u(t, e, r, n) {
          if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
          return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
            if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
            if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
            return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), f.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = f.prototype : t = l(t, e), t;
          }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
            if ("string" == typeof r && "" !== r || (r = "utf8"), !f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
            var n = 0 | p(e, r),
                i = (t = s(t, n)).write(e, r);
            return i !== n && (t = t.slice(0, i)), t;
          }(t, e, r) : function (t, e) {
            if (f.isBuffer(e)) {
              var r = 0 | d(e.length);
              return 0 === (t = s(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
            }

            if (e) {
              if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? s(t, 0) : l(t, e);
              if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
            }

            var n;
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }(t, e);
        }

        function c(t) {
          if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
          if (t < 0) throw new RangeError('"size" argument must not be negative');
        }

        function h(t, e) {
          if (c(e), t = s(t, e < 0 ? 0 : 0 | d(e)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
            t[r] = 0;
          }
          return t;
        }

        function l(t, e) {
          var r = e.length < 0 ? 0 : 0 | d(e.length);
          t = s(t, r);

          for (var n = 0; n < r; n += 1) {
            t[n] = 255 & e[n];
          }

          return t;
        }

        function d(t) {
          if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
          return 0 | t;
        }

        function p(t, e) {
          if (f.isBuffer(t)) return t.length;
          if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
          "string" != typeof t && (t = "" + t);
          var r = t.length;
          if (0 === r) return 0;

          for (var n = !1;;) {
            switch (e) {
              case "ascii":
              case "latin1":
              case "binary":
                return r;

              case "utf8":
              case "utf-8":
              case void 0:
                return N(t).length;

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return 2 * r;

              case "hex":
                return r >>> 1;

              case "base64":
                return q(t).length;

              default:
                if (n) return N(t).length;
                e = ("" + e).toLowerCase(), n = !0;
            }
          }
        }

        function g(t, e, r) {
          var n = t[e];
          t[e] = t[r], t[r] = n;
        }

        function A(t, e, r, n, i) {
          if (0 === t.length) return -1;

          if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
            if (i) return -1;
            r = t.length - 1;
          } else if (r < 0) {
            if (!i) return -1;
            r = 0;
          }

          if ("string" == typeof e && (e = f.from(e, n)), f.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, r, n, i);
          if ("number" == typeof e) return e &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : b(t, [e], r, n, i);
          throw new TypeError("val must be string, number or Buffer");
        }

        function b(t, e, r, n, i) {
          var o,
              a = 1,
              s = t.length,
              f = e.length;

          if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
            if (t.length < 2 || e.length < 2) return -1;
            a = 2, s /= 2, f /= 2, r /= 2;
          }

          function u(t, e) {
            return 1 === a ? t[e] : t.readUInt16BE(e * a);
          }

          if (i) {
            var c = -1;

            for (o = r; o < s; o++) {
              if (u(t, o) === u(e, -1 === c ? 0 : o - c)) {
                if (-1 === c && (c = o), o - c + 1 === f) return c * a;
              } else -1 !== c && (o -= o - c), c = -1;
            }
          } else for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
            for (var h = !0, l = 0; l < f; l++) {
              if (u(t, o + l) !== u(e, l)) {
                h = !1;
                break;
              }
            }

            if (h) return o;
          }

          return -1;
        }

        function v(t, e, r, n) {
          r = Number(r) || 0;
          var i = t.length - r;
          n ? (n = Number(n)) > i && (n = i) : n = i;
          var o = e.length;
          if (o % 2 != 0) throw new TypeError("Invalid hex string");
          n > o / 2 && (n = o / 2);

          for (var a = 0; a < n; ++a) {
            var s = parseInt(e.substr(2 * a, 2), 16);
            if (isNaN(s)) return a;
            t[r + a] = s;
          }

          return a;
        }

        function y(t, e, r, n) {
          return U(N(e, t.length - r), t, r, n);
        }

        function w(t, e, r, n) {
          return U(function (t) {
            for (var e = [], r = 0; r < t.length; ++r) {
              e.push(255 & t.charCodeAt(r));
            }

            return e;
          }(e), t, r, n);
        }

        function m(t, e, r, n) {
          return w(t, e, r, n);
        }

        function _(t, e, r, n) {
          return U(q(e), t, r, n);
        }

        function I(t, e, r, n) {
          return U(function (t, e) {
            for (var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) {
              r = t.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
            }

            return o;
          }(e, t.length - r), t, r, n);
        }

        function E(t, e, r) {
          return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
        }

        function P(t, e, r) {
          r = Math.min(t.length, r);

          for (var n = [], i = e; i < r;) {
            var o,
                a,
                s,
                f,
                u = t[i],
                c = null,
                h = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
            if (i + h <= r) switch (h) {
              case 1:
                u < 128 && (c = u);
                break;

              case 2:
                128 == (192 & (o = t[i + 1])) && (f = (31 & u) << 6 | 63 & o) > 127 && (c = f);
                break;

              case 3:
                o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (c = f);
                break;

              case 4:
                o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (c = f);
            }
            null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
          }

          return function (t) {
            var e = t.length;
            if (e <= S) return String.fromCharCode.apply(String, t);

            for (var r = "", n = 0; n < e;) {
              r += String.fromCharCode.apply(String, t.slice(n, n += S));
            }

            return r;
          }(n);
        }

        e.Buffer = f, e.SlowBuffer = function (t) {
          return +t != t && (t = 0), f.alloc(+t);
        }, e.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
          try {
            var t = new Uint8Array(1);
            return t.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function foo() {
                return 42;
              }
            }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
          } catch (t) {
            return !1;
          }
        }(), e.kMaxLength = a(), f.poolSize = 8192, f._augment = function (t) {
          return t.__proto__ = f.prototype, t;
        }, f.from = function (t, e, r) {
          return u(null, t, e, r);
        }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
          value: null,
          configurable: !0
        })), f.alloc = function (t, e, r) {
          return function (t, e, r, n) {
            return c(e), e <= 0 ? s(t, e) : void 0 !== r ? "string" == typeof n ? s(t, e).fill(r, n) : s(t, e).fill(r) : s(t, e);
          }(null, t, e, r);
        }, f.allocUnsafe = function (t) {
          return h(null, t);
        }, f.allocUnsafeSlow = function (t) {
          return h(null, t);
        }, f.isBuffer = function (t) {
          return !(null == t || !t._isBuffer);
        }, f.compare = function (t, e) {
          if (!f.isBuffer(t) || !f.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
          if (t === e) return 0;

          for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
            if (t[i] !== e[i]) {
              r = t[i], n = e[i];
              break;
            }
          }

          return r < n ? -1 : n < r ? 1 : 0;
        }, f.isEncoding = function (t) {
          switch (String(t).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;

            default:
              return !1;
          }
        }, f.concat = function (t, e) {
          if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === t.length) return f.alloc(0);
          var r;
          if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
            e += t[r].length;
          }
          var n = f.allocUnsafe(e),
              i = 0;

          for (r = 0; r < t.length; ++r) {
            var a = t[r];
            if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
            a.copy(n, i), i += a.length;
          }

          return n;
        }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
          var t = this.length;
          if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

          for (var e = 0; e < t; e += 2) {
            g(this, e, e + 1);
          }

          return this;
        }, f.prototype.swap32 = function () {
          var t = this.length;
          if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

          for (var e = 0; e < t; e += 4) {
            g(this, e, e + 3), g(this, e + 1, e + 2);
          }

          return this;
        }, f.prototype.swap64 = function () {
          var t = this.length;
          if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

          for (var e = 0; e < t; e += 8) {
            g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
          }

          return this;
        }, f.prototype.toString = function () {
          var t = 0 | this.length;
          return 0 === t ? "" : 0 === arguments.length ? P(this, 0, t) : function (t, e, r) {
            var n = !1;
            if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
            if ((r >>>= 0) <= (e >>>= 0)) return "";

            for (t || (t = "utf8");;) {
              switch (t) {
                case "hex":
                  return M(this, e, r);

                case "utf8":
                case "utf-8":
                  return P(this, e, r);

                case "ascii":
                  return x(this, e, r);

                case "latin1":
                case "binary":
                  return C(this, e, r);

                case "base64":
                  return E(this, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return T(this, e, r);

                default:
                  if (n) throw new TypeError("Unknown encoding: " + t);
                  t = (t + "").toLowerCase(), n = !0;
              }
            }
          }.apply(this, arguments);
        }, f.prototype.equals = function (t) {
          if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
          return this === t || 0 === f.compare(this, t);
        }, f.prototype.inspect = function () {
          var t = "",
              r = e.INSPECT_MAX_BYTES;
          return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
        }, f.prototype.compare = function (t, e, r, n, i) {
          if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
          if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
          if (n >= i && e >= r) return 0;
          if (n >= i) return -1;
          if (e >= r) return 1;
          if (this === t) return 0;

          for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), u = this.slice(n, i), c = t.slice(e, r), h = 0; h < s; ++h) {
            if (u[h] !== c[h]) {
              o = u[h], a = c[h];
              break;
            }
          }

          return o < a ? -1 : a < o ? 1 : 0;
        }, f.prototype.includes = function (t, e, r) {
          return -1 !== this.indexOf(t, e, r);
        }, f.prototype.indexOf = function (t, e, r) {
          return A(this, t, e, r, !0);
        }, f.prototype.lastIndexOf = function (t, e, r) {
          return A(this, t, e, r, !1);
        }, f.prototype.write = function (t, e, r, n) {
          if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
            if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
          }
          var i = this.length - e;
          if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          n || (n = "utf8");

          for (var o = !1;;) {
            switch (n) {
              case "hex":
                return v(this, t, e, r);

              case "utf8":
              case "utf-8":
                return y(this, t, e, r);

              case "ascii":
                return w(this, t, e, r);

              case "latin1":
              case "binary":
                return m(this, t, e, r);

              case "base64":
                return _(this, t, e, r);

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return I(this, t, e, r);

              default:
                if (o) throw new TypeError("Unknown encoding: " + n);
                n = ("" + n).toLowerCase(), o = !0;
            }
          }
        }, f.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        var S = 4096;

        function x(t, e, r) {
          var n = "";
          r = Math.min(t.length, r);

          for (var i = e; i < r; ++i) {
            n += String.fromCharCode(127 & t[i]);
          }

          return n;
        }

        function C(t, e, r) {
          var n = "";
          r = Math.min(t.length, r);

          for (var i = e; i < r; ++i) {
            n += String.fromCharCode(t[i]);
          }

          return n;
        }

        function M(t, e, r) {
          var n = t.length;
          (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

          for (var i = "", o = e; o < r; ++o) {
            i += z(t[o]);
          }

          return i;
        }

        function T(t, e, r) {
          for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
            i += String.fromCharCode(n[o] + 256 * n[o + 1]);
          }

          return i;
        }

        function k(t, e, r) {
          if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
          if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
        }

        function R(t, e, r, n, i, o) {
          if (!f.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
          if (r + n > t.length) throw new RangeError("Index out of range");
        }

        function B(t, e, r, n) {
          e < 0 && (e = 65535 + e + 1);

          for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
            t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
          }
        }

        function L(t, e, r, n) {
          e < 0 && (e = 4294967295 + e + 1);

          for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
            t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
          }
        }

        function O(t, e, r, n, i, o) {
          if (r + n > t.length) throw new RangeError("Index out of range");
          if (r < 0) throw new RangeError("Index out of range");
        }

        function j(t, e, r, n, o) {
          return o || O(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
        }

        function D(t, e, r, n, o) {
          return o || O(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
        }

        f.prototype.slice = function (t, e) {
          var r,
              n = this.length;
          if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = f.prototype;else {
            var i = e - t;
            r = new f(i, void 0);

            for (var o = 0; o < i; ++o) {
              r[o] = this[o + t];
            }
          }
          return r;
        }, f.prototype.readUIntLE = function (t, e, r) {
          t |= 0, e |= 0, r || k(t, e, this.length);

          for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
            n += this[t + o] * i;
          }

          return n;
        }, f.prototype.readUIntBE = function (t, e, r) {
          t |= 0, e |= 0, r || k(t, e, this.length);

          for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
            n += this[t + --e] * i;
          }

          return n;
        }, f.prototype.readUInt8 = function (t, e) {
          return e || k(t, 1, this.length), this[t];
        }, f.prototype.readUInt16LE = function (t, e) {
          return e || k(t, 2, this.length), this[t] | this[t + 1] << 8;
        }, f.prototype.readUInt16BE = function (t, e) {
          return e || k(t, 2, this.length), this[t] << 8 | this[t + 1];
        }, f.prototype.readUInt32LE = function (t, e) {
          return e || k(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
        }, f.prototype.readUInt32BE = function (t, e) {
          return e || k(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
        }, f.prototype.readIntLE = function (t, e, r) {
          t |= 0, e |= 0, r || k(t, e, this.length);

          for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
            n += this[t + o] * i;
          }

          return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
        }, f.prototype.readIntBE = function (t, e, r) {
          t |= 0, e |= 0, r || k(t, e, this.length);

          for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
            o += this[t + --n] * i;
          }

          return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
        }, f.prototype.readInt8 = function (t, e) {
          return e || k(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
        }, f.prototype.readInt16LE = function (t, e) {
          e || k(t, 2, this.length);
          var r = this[t] | this[t + 1] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, f.prototype.readInt16BE = function (t, e) {
          e || k(t, 2, this.length);
          var r = this[t + 1] | this[t] << 8;
          return 32768 & r ? 4294901760 | r : r;
        }, f.prototype.readInt32LE = function (t, e) {
          return e || k(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
        }, f.prototype.readInt32BE = function (t, e) {
          return e || k(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
        }, f.prototype.readFloatLE = function (t, e) {
          return e || k(t, 4, this.length), i.read(this, t, !0, 23, 4);
        }, f.prototype.readFloatBE = function (t, e) {
          return e || k(t, 4, this.length), i.read(this, t, !1, 23, 4);
        }, f.prototype.readDoubleLE = function (t, e) {
          return e || k(t, 8, this.length), i.read(this, t, !0, 52, 8);
        }, f.prototype.readDoubleBE = function (t, e) {
          return e || k(t, 8, this.length), i.read(this, t, !1, 52, 8);
        }, f.prototype.writeUIntLE = function (t, e, r, n) {
          t = +t, e |= 0, r |= 0, n || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
          var i = 1,
              o = 0;

          for (this[e] = 255 & t; ++o < r && (i *= 256);) {
            this[e + o] = t / i & 255;
          }

          return e + r;
        }, f.prototype.writeUIntBE = function (t, e, r, n) {
          t = +t, e |= 0, r |= 0, n || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
          var i = r - 1,
              o = 1;

          for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
            this[e + i] = t / o & 255;
          }

          return e + r;
        }, f.prototype.writeUInt8 = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
        }, f.prototype.writeUInt16LE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
        }, f.prototype.writeUInt16BE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
        }, f.prototype.writeUInt32LE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : L(this, t, e, !0), e + 4;
        }, f.prototype.writeUInt32BE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
        }, f.prototype.writeIntLE = function (t, e, r, n) {
          if (t = +t, e |= 0, !n) {
            var i = Math.pow(2, 8 * r - 1);
            R(this, t, e, r, i - 1, -i);
          }

          var o = 0,
              a = 1,
              s = 0;

          for (this[e] = 255 & t; ++o < r && (a *= 256);) {
            t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
          }

          return e + r;
        }, f.prototype.writeIntBE = function (t, e, r, n) {
          if (t = +t, e |= 0, !n) {
            var i = Math.pow(2, 8 * r - 1);
            R(this, t, e, r, i - 1, -i);
          }

          var o = r - 1,
              a = 1,
              s = 0;

          for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
            t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
          }

          return e + r;
        }, f.prototype.writeInt8 = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
        }, f.prototype.writeInt16LE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
        }, f.prototype.writeInt16BE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
        }, f.prototype.writeInt32LE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : L(this, t, e, !0), e + 4;
        }, f.prototype.writeInt32BE = function (t, e, r) {
          return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
        }, f.prototype.writeFloatLE = function (t, e, r) {
          return j(this, t, e, !0, r);
        }, f.prototype.writeFloatBE = function (t, e, r) {
          return j(this, t, e, !1, r);
        }, f.prototype.writeDoubleLE = function (t, e, r) {
          return D(this, t, e, !0, r);
        }, f.prototype.writeDoubleBE = function (t, e, r) {
          return D(this, t, e, !1, r);
        }, f.prototype.copy = function (t, e, r, n) {
          if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
          if (0 === t.length || 0 === this.length) return 0;
          if (e < 0) throw new RangeError("targetStart out of bounds");
          if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
          if (n < 0) throw new RangeError("sourceEnd out of bounds");
          n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
          var i,
              o = n - r;
          if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
            t[i + e] = this[i + r];
          } else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
            t[i + e] = this[i + r];
          } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
          return o;
        }, f.prototype.fill = function (t, e, r, n) {
          if ("string" == typeof t) {
            if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
              var i = t.charCodeAt(0);
              i < 256 && (t = i);
            }

            if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
            if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
          } else "number" == typeof t && (t &= 255);

          if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
          if (r <= e) return this;
          var o;
          if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
            this[o] = t;
          } else {
            var a = f.isBuffer(t) ? t : N(new f(t, n).toString()),
                s = a.length;

            for (o = 0; o < r - e; ++o) {
              this[o + e] = a[o % s];
            }
          }
          return this;
        };
        var H = /[^+\/0-9A-Za-z-_]/g;

        function z(t) {
          return t < 16 ? "0" + t.toString(16) : t.toString(16);
        }

        function N(t, e) {
          var r;
          e = e || 1 / 0;

          for (var n = t.length, i = null, o = [], a = 0; a < n; ++a) {
            if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
              if (!i) {
                if (r > 56319) {
                  (e -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }

                if (a + 1 === n) {
                  (e -= 3) > -1 && o.push(239, 191, 189);
                  continue;
                }

                i = r;
                continue;
              }

              if (r < 56320) {
                (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                continue;
              }

              r = 65536 + (i - 55296 << 10 | r - 56320);
            } else i && (e -= 3) > -1 && o.push(239, 191, 189);

            if (i = null, r < 128) {
              if ((e -= 1) < 0) break;
              o.push(r);
            } else if (r < 2048) {
              if ((e -= 2) < 0) break;
              o.push(r >> 6 | 192, 63 & r | 128);
            } else if (r < 65536) {
              if ((e -= 3) < 0) break;
              o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
            } else {
              if (!(r < 1114112)) throw new Error("Invalid code point");
              if ((e -= 4) < 0) break;
              o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
            }
          }

          return o;
        }

        function q(t) {
          return n.toByteArray(function (t) {
            if ((t = function (t) {
              return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
            }(t).replace(H, "")).length < 2) return "";

            for (; t.length % 4 != 0;) {
              t += "=";
            }

            return t;
          }(t));
        }

        function U(t, e, r, n) {
          for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
            e[i + r] = t[i];
          }

          return i;
        }
      }).call(this, r(2));
    }, function (t, e) {
      var r,
          n,
          i = t.exports = {};

      function o() {
        throw new Error("setTimeout has not been defined");
      }

      function a() {
        throw new Error("clearTimeout has not been defined");
      }

      function s(t) {
        if (r === setTimeout) return setTimeout(t, 0);
        if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

        try {
          return r(t, 0);
        } catch (e) {
          try {
            return r.call(null, t, 0);
          } catch (e) {
            return r.call(this, t, 0);
          }
        }
      }

      !function () {
        try {
          r = "function" == typeof setTimeout ? setTimeout : o;
        } catch (t) {
          r = o;
        }

        try {
          n = "function" == typeof clearTimeout ? clearTimeout : a;
        } catch (t) {
          n = a;
        }
      }();
      var f,
          u = [],
          c = !1,
          h = -1;

      function l() {
        c && f && (c = !1, f.length ? u = f.concat(u) : h = -1, u.length && d());
      }

      function d() {
        if (!c) {
          var t = s(l);
          c = !0;

          for (var e = u.length; e;) {
            for (f = u, u = []; ++h < e;) {
              f && f[h].run();
            }

            h = -1, e = u.length;
          }

          f = null, c = !1, function (t) {
            if (n === clearTimeout) return clearTimeout(t);
            if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

            try {
              n(t);
            } catch (e) {
              try {
                return n.call(null, t);
              } catch (e) {
                return n.call(this, t);
              }
            }
          }(t);
        }
      }

      function p(t, e) {
        this.fun = t, this.array = e;
      }

      function g() {}

      i.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
          e[r - 1] = arguments[r];
        }
        u.push(new p(t, e)), 1 !== u.length || c || s(d);
      }, p.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
        return [];
      }, i.binding = function (t) {
        throw new Error("process.binding is not supported");
      }, i.cwd = function () {
        return "/";
      }, i.chdir = function (t) {
        throw new Error("process.chdir is not supported");
      }, i.umask = function () {
        return 0;
      };
    }, function (t, e) {
      var r;

      r = function () {
        return this;
      }();

      try {
        r = r || new Function("return this")();
      } catch (t) {
        "object" == typeof window && (r = window);
      }

      t.exports = r;
    }, function (t, e) {
      "function" == typeof Object.create ? t.exports = function (t, e) {
        t.super_ = e, t.prototype = Object.create(e.prototype, {
          constructor: {
            value: t,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        });
      } : t.exports = function (t, e) {
        t.super_ = e;

        var r = function r() {};

        r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(6),
          i = Object.keys || function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e;
      };

      t.exports = h;
      var o = r(5);
      o.inherits = r(3);
      var a = r(14),
          s = r(11);
      o.inherits(h, a);

      for (var f = i(s.prototype), u = 0; u < f.length; u++) {
        var c = f[u];
        h.prototype[c] || (h.prototype[c] = s.prototype[c]);
      }

      function h(t) {
        if (!(this instanceof h)) return new h(t);
        a.call(this, t), s.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", l);
      }

      function l() {
        this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
      }

      function d(t) {
        t.end();
      }

      Object.defineProperty(h.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), Object.defineProperty(h.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(t) {
          void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
        }
      }), h.prototype._destroy = function (t, e) {
        this.push(null), this.end(), n.nextTick(e, t);
      };
    }, function (t, e, r) {
      (function (t) {
        function r(t) {
          return Object.prototype.toString.call(t);
        }

        e.isArray = function (t) {
          return Array.isArray ? Array.isArray(t) : "[object Array]" === r(t);
        }, e.isBoolean = function (t) {
          return "boolean" == typeof t;
        }, e.isNull = function (t) {
          return null === t;
        }, e.isNullOrUndefined = function (t) {
          return null == t;
        }, e.isNumber = function (t) {
          return "number" == typeof t;
        }, e.isString = function (t) {
          return "string" == typeof t;
        }, e.isSymbol = function (t) {
          return "symbol" == typeof t;
        }, e.isUndefined = function (t) {
          return void 0 === t;
        }, e.isRegExp = function (t) {
          return "[object RegExp]" === r(t);
        }, e.isObject = function (t) {
          return "object" == typeof t && null !== t;
        }, e.isDate = function (t) {
          return "[object Date]" === r(t);
        }, e.isError = function (t) {
          return "[object Error]" === r(t) || t instanceof Error;
        }, e.isFunction = function (t) {
          return "function" == typeof t;
        }, e.isPrimitive = function (t) {
          return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
        }, e.isBuffer = t.isBuffer;
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
          nextTick: function nextTick(t, r, n, i) {
            if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
            var o,
                a,
                s = arguments.length;

            switch (s) {
              case 0:
              case 1:
                return e.nextTick(t);

              case 2:
                return e.nextTick(function () {
                  t.call(null, r);
                });

              case 3:
                return e.nextTick(function () {
                  t.call(null, r, n);
                });

              case 4:
                return e.nextTick(function () {
                  t.call(null, r, n, i);
                });

              default:
                for (o = new Array(s - 1), a = 0; a < o.length;) {
                  o[a++] = arguments[a];
                }

                return e.nextTick(function () {
                  t.apply(null, o);
                });
            }
          }
        } : t.exports = e;
      }).call(this, r(1));
    }, function (t, e, r) {
      var n = r(0),
          i = n.Buffer;

      function o(t, e) {
        for (var r in t) {
          e[r] = t[r];
        }
      }

      function a(t, e, r) {
        return i(t, e, r);
      }

      i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = a), o(i, a), a.from = function (t, e, r) {
        if ("number" == typeof t) throw new TypeError("Argument must not be a number");
        return i(t, e, r);
      }, a.alloc = function (t, e, r) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        var n = i(t);
        return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
      }, a.allocUnsafe = function (t) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        return i(t);
      }, a.allocUnsafeSlow = function (t) {
        if ("number" != typeof t) throw new TypeError("Argument must be a number");
        return n.SlowBuffer(t);
      };
    }, function (t, e, r) {
      "use strict";

      var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

      function i(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }

      e.assign = function (t) {
        for (var e = Array.prototype.slice.call(arguments, 1); e.length;) {
          var r = e.shift();

          if (r) {
            if ("object" != typeof r) throw new TypeError(r + "must be non-object");

            for (var n in r) {
              i(r, n) && (t[n] = r[n]);
            }
          }
        }

        return t;
      }, e.shrinkBuf = function (t, e) {
        return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t);
      };
      var o = {
        arraySet: function arraySet(t, e, r, n, i) {
          if (e.subarray && t.subarray) t.set(e.subarray(r, r + n), i);else for (var o = 0; o < n; o++) {
            t[i + o] = e[r + o];
          }
        },
        flattenChunks: function flattenChunks(t) {
          var e, r, n, i, o, a;

          for (n = 0, e = 0, r = t.length; e < r; e++) {
            n += t[e].length;
          }

          for (a = new Uint8Array(n), i = 0, e = 0, r = t.length; e < r; e++) {
            o = t[e], a.set(o, i), i += o.length;
          }

          return a;
        }
      },
          a = {
        arraySet: function arraySet(t, e, r, n, i) {
          for (var o = 0; o < n; o++) {
            t[i + o] = e[r + o];
          }
        },
        flattenChunks: function flattenChunks(t) {
          return [].concat.apply([], t);
        }
      };
      e.setTyped = function (t) {
        t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, o)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, a));
      }, e.setTyped(n);
    }, function (t, e, r) {
      "use strict";

      var n,
          i = "object" == typeof Reflect ? Reflect : null,
          o = i && "function" == typeof i.apply ? i.apply : function (t, e, r) {
        return Function.prototype.apply.call(t, e, r);
      };
      n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
        return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
      } : function (t) {
        return Object.getOwnPropertyNames(t);
      };

      var a = Number.isNaN || function (t) {
        return t != t;
      };

      function s() {
        s.init.call(this);
      }

      t.exports = s, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
      var f = 10;

      function u(t) {
        return void 0 === t._maxListeners ? s.defaultMaxListeners : t._maxListeners;
      }

      function c(t, e, r, n) {
        var i, o, a, s;
        if ("function" != typeof r) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
        if (void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), a = o[e]), void 0 === a) a = o[e] = r, ++t._eventsCount;else if ("function" == typeof a ? a = o[e] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), (i = u(t)) > 0 && a.length > i && !a.warned) {
          a.warned = !0;
          var f = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
          f.name = "MaxListenersExceededWarning", f.emitter = t, f.type = e, f.count = a.length, s = f, console && console.warn && console.warn(s);
        }
        return t;
      }

      function h(t, e, r) {
        var n = {
          fired: !1,
          wrapFn: void 0,
          target: t,
          type: e,
          listener: r
        },
            i = function () {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t.push(arguments[e]);
          }

          this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, o(this.listener, this.target, t));
        }.bind(n);

        return i.listener = r, n.wrapFn = i, i;
      }

      function l(t, e, r) {
        var n = t._events;
        if (void 0 === n) return [];
        var i = n[e];
        return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (t) {
          for (var e = new Array(t.length), r = 0; r < e.length; ++r) {
            e[r] = t[r].listener || t[r];
          }

          return e;
        }(i) : p(i, i.length);
      }

      function d(t) {
        var e = this._events;

        if (void 0 !== e) {
          var r = e[t];
          if ("function" == typeof r) return 1;
          if (void 0 !== r) return r.length;
        }

        return 0;
      }

      function p(t, e) {
        for (var r = new Array(e), n = 0; n < e; ++n) {
          r[n] = t[n];
        }

        return r;
      }

      Object.defineProperty(s, "defaultMaxListeners", {
        enumerable: !0,
        get: function get() {
          return f;
        },
        set: function set(t) {
          if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
          f = t;
        }
      }), s.init = function () {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
      }, s.prototype.setMaxListeners = function (t) {
        if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
        return this._maxListeners = t, this;
      }, s.prototype.getMaxListeners = function () {
        return u(this);
      }, s.prototype.emit = function (t) {
        for (var e = [], r = 1; r < arguments.length; r++) {
          e.push(arguments[r]);
        }

        var n = "error" === t,
            i = this._events;
        if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

        if (n) {
          var a;
          if (e.length > 0 && (a = e[0]), a instanceof Error) throw a;
          var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
          throw s.context = a, s;
        }

        var f = i[t];
        if (void 0 === f) return !1;
        if ("function" == typeof f) o(f, this, e);else {
          var u = f.length,
              c = p(f, u);

          for (r = 0; r < u; ++r) {
            o(c[r], this, e);
          }
        }
        return !0;
      }, s.prototype.addListener = function (t, e) {
        return c(this, t, e, !1);
      }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function (t, e) {
        return c(this, t, e, !0);
      }, s.prototype.once = function (t, e) {
        if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
        return this.on(t, h(this, t, e)), this;
      }, s.prototype.prependOnceListener = function (t, e) {
        if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
        return this.prependListener(t, h(this, t, e)), this;
      }, s.prototype.removeListener = function (t, e) {
        var r, n, i, o, a;
        if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
        if (void 0 === (n = this._events)) return this;
        if (void 0 === (r = n[t])) return this;
        if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));else if ("function" != typeof r) {
          for (i = -1, o = r.length - 1; o >= 0; o--) {
            if (r[o] === e || r[o].listener === e) {
              a = r[o].listener, i = o;
              break;
            }
          }

          if (i < 0) return this;
          0 === i ? r.shift() : function (t, e) {
            for (; e + 1 < t.length; e++) {
              t[e] = t[e + 1];
            }

            t.pop();
          }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, a || e);
        }
        return this;
      }, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function (t) {
        var e, r, n;
        if (void 0 === (r = this._events)) return this;
        if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;

        if (0 === arguments.length) {
          var i,
              o = Object.keys(r);

          for (n = 0; n < o.length; ++n) {
            "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
          }

          return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }

        if ("function" == typeof (e = r[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) {
          this.removeListener(t, e[n]);
        }
        return this;
      }, s.prototype.listeners = function (t) {
        return l(this, t, !0);
      }, s.prototype.rawListeners = function (t) {
        return l(this, t, !1);
      }, s.listenerCount = function (t, e) {
        return "function" == typeof t.listenerCount ? t.listenerCount(e) : d.call(t, e);
      }, s.prototype.listenerCount = d, s.prototype.eventNames = function () {
        return this._eventsCount > 0 ? n(this._events) : [];
      };
    }, function (t, e, r) {
      (e = t.exports = r(14)).Stream = e, e.Readable = e, e.Writable = r(11), e.Duplex = r(4), e.Transform = r(18), e.PassThrough = r(34);
    }, function (t, e, r) {
      "use strict";

      (function (e, n, i) {
        var o = r(6);

        function a(t) {
          var e = this;
          this.next = null, this.entry = null, this.finish = function () {
            !function (t, e, r) {
              var n = t.entry;

              for (t.entry = null; n;) {
                var i = n.callback;
                e.pendingcb--, i(void 0), n = n.next;
              }

              e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
            }(e, t);
          };
        }

        t.exports = v;
        var s,
            f = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
        v.WritableState = b;
        var u = r(5);
        u.inherits = r(3);

        var c,
            h = {
          deprecate: r(33)
        },
            l = r(15),
            d = r(7).Buffer,
            p = i.Uint8Array || function () {},
            g = r(16);

        function A() {}

        function b(t, e) {
          s = s || r(4), t = t || {};
          var n = e instanceof s;
          this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
          var i = t.highWaterMark,
              u = t.writableHighWaterMark,
              c = this.objectMode ? 16 : 16384;
          this.highWaterMark = i || 0 === i ? i : n && (u || 0 === u) ? u : c, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
          var h = !1 === t.decodeStrings;
          this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
            !function (t, e) {
              var r = t._writableState,
                  n = r.sync,
                  i = r.writecb;
              if (function (t) {
                t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
              }(r), e) !function (t, e, r, n, i) {
                --e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(E, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), E(t, e));
              }(t, r, n, e, i);else {
                var a = _(r);

                a || r.corked || r.bufferProcessing || !r.bufferedRequest || m(t, r), n ? f(w, t, r, a, i) : w(t, r, a, i);
              }
            }(e, t);
          }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
        }

        function v(t) {
          if (s = s || r(4), !(c.call(v, this) || this instanceof s)) return new v(t);
          this._writableState = new b(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), l.call(this);
        }

        function y(t, e, r, n, i, o, a) {
          e.writelen = n, e.writecb = a, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
        }

        function w(t, e, r, n) {
          r || function (t, e) {
            0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
          }(t, e), e.pendingcb--, n(), E(t, e);
        }

        function m(t, e) {
          e.bufferProcessing = !0;
          var r = e.bufferedRequest;

          if (t._writev && r && r.next) {
            var n = e.bufferedRequestCount,
                i = new Array(n),
                o = e.corkedRequestsFree;
            o.entry = r;

            for (var s = 0, f = !0; r;) {
              i[s] = r, r.isBuf || (f = !1), r = r.next, s += 1;
            }

            i.allBuffers = f, y(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new a(e), e.bufferedRequestCount = 0;
          } else {
            for (; r;) {
              var u = r.chunk,
                  c = r.encoding,
                  h = r.callback;
              if (y(t, e, !1, e.objectMode ? 1 : u.length, u, c, h), r = r.next, e.bufferedRequestCount--, e.writing) break;
            }

            null === r && (e.lastBufferedRequest = null);
          }

          e.bufferedRequest = r, e.bufferProcessing = !1;
        }

        function _(t) {
          return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
        }

        function I(t, e) {
          t._final(function (r) {
            e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), E(t, e);
          });
        }

        function E(t, e) {
          var r = _(e);

          return r && (function (t, e) {
            e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(I, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
          }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r;
        }

        u.inherits(v, l), b.prototype.getBuffer = function () {
          for (var t = this.bufferedRequest, e = []; t;) {
            e.push(t), t = t.next;
          }

          return e;
        }, function () {
          try {
            Object.defineProperty(b.prototype, "buffer", {
              get: h.deprecate(function () {
                return this.getBuffer();
              }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            });
          } catch (t) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (c = Function.prototype[Symbol.hasInstance], Object.defineProperty(v, Symbol.hasInstance, {
          value: function value(t) {
            return !!c.call(this, t) || this === v && t && t._writableState instanceof b;
          }
        })) : c = function c(t) {
          return t instanceof this;
        }, v.prototype.pipe = function () {
          this.emit("error", new Error("Cannot pipe, not readable"));
        }, v.prototype.write = function (t, e, r) {
          var n,
              i = this._writableState,
              a = !1,
              s = !i.objectMode && (n = t, d.isBuffer(n) || n instanceof p);
          return s && !d.isBuffer(t) && (t = function (t) {
            return d.from(t);
          }(t)), "function" == typeof e && (r = e, e = null), s ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = A), i.ended ? function (t, e) {
            var r = new Error("write after end");
            t.emit("error", r), o.nextTick(e, r);
          }(this, r) : (s || function (t, e, r, n) {
            var i = !0,
                a = !1;
            return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), o.nextTick(n, a), i = !1), i;
          }(this, i, t, r)) && (i.pendingcb++, a = function (t, e, r, n, i, o) {
            if (!r) {
              var a = function (t, e, r) {
                return t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = d.from(e, r)), e;
              }(e, n, i);

              n !== a && (r = !0, i = "buffer", n = a);
            }

            var s = e.objectMode ? 1 : n.length;
            e.length += s;
            var f = e.length < e.highWaterMark;

            if (f || (e.needDrain = !0), e.writing || e.corked) {
              var u = e.lastBufferedRequest;
              e.lastBufferedRequest = {
                chunk: n,
                encoding: i,
                isBuf: r,
                callback: o,
                next: null
              }, u ? u.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
            } else y(t, e, !1, s, n, i, o);

            return f;
          }(this, i, s, t, e, r)), a;
        }, v.prototype.cork = function () {
          this._writableState.corked++;
        }, v.prototype.uncork = function () {
          var t = this._writableState;
          t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || m(this, t));
        }, v.prototype.setDefaultEncoding = function (t) {
          if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
          return this._writableState.defaultEncoding = t, this;
        }, Object.defineProperty(v.prototype, "writableHighWaterMark", {
          enumerable: !1,
          get: function get() {
            return this._writableState.highWaterMark;
          }
        }), v.prototype._write = function (t, e, r) {
          r(new Error("_write() is not implemented"));
        }, v.prototype._writev = null, v.prototype.end = function (t, e, r) {
          var n = this._writableState;
          "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (t, e, r) {
            e.ending = !0, E(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r)), e.ended = !0, t.writable = !1;
          }(this, n, r);
        }, Object.defineProperty(v.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._writableState && this._writableState.destroyed;
          },
          set: function set(t) {
            this._writableState && (this._writableState.destroyed = t);
          }
        }), v.prototype.destroy = g.destroy, v.prototype._undestroy = g.undestroy, v.prototype._destroy = function (t, e) {
          this.end(), e(t);
        };
      }).call(this, r(1), r(31).setImmediate, r(2));
    }, function (t, e) {
      var r = {}.toString;

      t.exports = Array.isArray || function (t) {
        return "[object Array]" == r.call(t);
      };
    }, function (t, e, r) {
      t.exports = i;
      var n = r(9).EventEmitter;

      function i() {
        n.call(this);
      }

      r(3)(i, n), i.Readable = r(10), i.Writable = r(35), i.Duplex = r(36), i.Transform = r(37), i.PassThrough = r(38), i.Stream = i, i.prototype.pipe = function (t, e) {
        var r = this;

        function i(e) {
          t.writable && !1 === t.write(e) && r.pause && r.pause();
        }

        function o() {
          r.readable && r.resume && r.resume();
        }

        r.on("data", i), t.on("drain", o), t._isStdio || e && !1 === e.end || (r.on("end", s), r.on("close", f));
        var a = !1;

        function s() {
          a || (a = !0, t.end());
        }

        function f() {
          a || (a = !0, "function" == typeof t.destroy && t.destroy());
        }

        function u(t) {
          if (c(), 0 === n.listenerCount(this, "error")) throw t;
        }

        function c() {
          r.removeListener("data", i), t.removeListener("drain", o), r.removeListener("end", s), r.removeListener("close", f), r.removeListener("error", u), t.removeListener("error", u), r.removeListener("end", c), r.removeListener("close", c), t.removeListener("close", c);
        }

        return r.on("error", u), t.on("error", u), r.on("end", c), r.on("close", c), t.on("close", c), t.emit("pipe", r), t;
      };
    }, function (t, e, r) {
      "use strict";

      (function (e, n) {
        var i = r(6);
        t.exports = y;
        var o,
            a = r(12);
        y.ReadableState = v, r(9).EventEmitter;

        var s = function s(t, e) {
          return t.listeners(e).length;
        },
            f = r(15),
            u = r(7).Buffer,
            c = e.Uint8Array || function () {},
            h = r(5);

        h.inherits = r(3);
        var l = r(28),
            d = void 0;
        d = l && l.debuglog ? l.debuglog("stream") : function () {};
        var p,
            g = r(29),
            A = r(16);
        h.inherits(y, f);
        var b = ["error", "close", "destroy", "pause", "resume"];

        function v(t, e) {
          t = t || {};
          var n = e instanceof (o = o || r(4));
          this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
          var i = t.highWaterMark,
              a = t.readableHighWaterMark,
              s = this.objectMode ? 16 : 16384;
          this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new g(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = r(17).StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
        }

        function y(t) {
          if (o = o || r(4), !(this instanceof y)) return new y(t);
          this._readableState = new v(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), f.call(this);
        }

        function w(t, e, r, n, i) {
          var o,
              a = t._readableState;
          return null === e ? (a.reading = !1, function (t, e) {
            if (!e.ended) {
              if (e.decoder) {
                var r = e.decoder.end();
                r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
              }

              e.ended = !0, E(t);
            }
          }(t, a)) : (i || (o = function (t, e) {
            var r, n;
            return n = e, u.isBuffer(n) || n instanceof c || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk")), r;
          }(a, e)), o ? t.emit("error", o) : a.objectMode || e && e.length > 0 ? ("string" == typeof e || a.objectMode || Object.getPrototypeOf(e) === u.prototype || (e = function (t) {
            return u.from(t);
          }(e)), n ? a.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : m(t, a, e, !0) : a.ended ? t.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !r ? (e = a.decoder.write(e), a.objectMode || 0 !== e.length ? m(t, a, e, !1) : S(t, a)) : m(t, a, e, !1))) : n || (a.reading = !1)), function (t) {
            return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
          }(a);
        }

        function m(t, e, r, n) {
          e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && E(t)), S(t, e);
        }

        Object.defineProperty(y.prototype, "destroyed", {
          get: function get() {
            return void 0 !== this._readableState && this._readableState.destroyed;
          },
          set: function set(t) {
            this._readableState && (this._readableState.destroyed = t);
          }
        }), y.prototype.destroy = A.destroy, y.prototype._undestroy = A.undestroy, y.prototype._destroy = function (t, e) {
          this.push(null), e(t);
        }, y.prototype.push = function (t, e) {
          var r,
              n = this._readableState;
          return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = u.from(t, e), e = ""), r = !0), w(this, t, e, !1, r);
        }, y.prototype.unshift = function (t) {
          return w(this, t, null, !0, !1);
        }, y.prototype.isPaused = function () {
          return !1 === this._readableState.flowing;
        }, y.prototype.setEncoding = function (t) {
          return p || (p = r(17).StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
        };
        var _ = 8388608;

        function I(t, e) {
          return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
            return t >= _ ? t = _ : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
          }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
        }

        function E(t) {
          var e = t._readableState;
          e.needReadable = !1, e.emittedReadable || (d("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(P, t) : P(t));
        }

        function P(t) {
          d("emit readable"), t.emit("readable"), T(t);
        }

        function S(t, e) {
          e.readingMore || (e.readingMore = !0, i.nextTick(x, t, e));
        }

        function x(t, e) {
          for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (d("maybeReadMore read 0"), t.read(0), r !== e.length);) {
            r = e.length;
          }

          e.readingMore = !1;
        }

        function C(t) {
          d("readable nexttick read 0"), t.read(0);
        }

        function M(t, e) {
          e.reading || (d("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), T(t), e.flowing && !e.reading && t.read(0);
        }

        function T(t) {
          var e = t._readableState;

          for (d("flow", e.flowing); e.flowing && null !== t.read();) {
            ;
          }
        }

        function k(t, e) {
          return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function (t, e, r) {
            var n;
            return t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function (t, e) {
              var r = e.head,
                  n = 1,
                  i = r.data;

              for (t -= i.length; r = r.next;) {
                var o = r.data,
                    a = t > o.length ? o.length : t;

                if (a === o.length ? i += o : i += o.slice(0, t), 0 == (t -= a)) {
                  a === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(a));
                  break;
                }

                ++n;
              }

              return e.length -= n, i;
            }(t, e) : function (t, e) {
              var r = u.allocUnsafe(t),
                  n = e.head,
                  i = 1;

              for (n.data.copy(r), t -= n.data.length; n = n.next;) {
                var o = n.data,
                    a = t > o.length ? o.length : t;

                if (o.copy(r, r.length - t, 0, a), 0 == (t -= a)) {
                  a === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(a));
                  break;
                }

                ++i;
              }

              return e.length -= i, r;
            }(t, e), n;
          }(t, e.buffer, e.decoder), r);
          var r;
        }

        function R(t) {
          var e = t._readableState;
          if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
          e.endEmitted || (e.ended = !0, i.nextTick(B, e, t));
        }

        function B(t, e) {
          t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
        }

        function L(t, e) {
          for (var r = 0, n = t.length; r < n; r++) {
            if (t[r] === e) return r;
          }

          return -1;
        }

        y.prototype.read = function (t) {
          d("read", t), t = parseInt(t, 10);
          var e = this._readableState,
              r = t;
          if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return d("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? R(this) : E(this), null;
          if (0 === (t = I(t, e)) && e.ended) return 0 === e.length && R(this), null;
          var n,
              i = e.needReadable;
          return d("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && d("length less than watermark", i = !0), e.ended || e.reading ? d("reading or ended", i = !1) : i && (d("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = I(r, e))), null === (n = t > 0 ? k(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && R(this)), null !== n && this.emit("data", n), n;
        }, y.prototype._read = function (t) {
          this.emit("error", new Error("_read() is not implemented"));
        }, y.prototype.pipe = function (t, e) {
          var r = this,
              o = this._readableState;

          switch (o.pipesCount) {
            case 0:
              o.pipes = t;
              break;

            case 1:
              o.pipes = [o.pipes, t];
              break;

            default:
              o.pipes.push(t);
          }

          o.pipesCount += 1, d("pipe count=%d opts=%j", o.pipesCount, e);
          var f = e && !1 === e.end || t === n.stdout || t === n.stderr ? v : u;

          function u() {
            d("onend"), t.end();
          }

          o.endEmitted ? i.nextTick(f) : r.once("end", f), t.on("unpipe", function e(n, i) {
            d("onunpipe"), n === r && i && !1 === i.hasUnpiped && (i.hasUnpiped = !0, d("cleanup"), t.removeListener("close", A), t.removeListener("finish", b), t.removeListener("drain", c), t.removeListener("error", g), t.removeListener("unpipe", e), r.removeListener("end", u), r.removeListener("end", v), r.removeListener("data", p), h = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || c());
          });

          var c = function (t) {
            return function () {
              var e = t._readableState;
              d("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && s(t, "data") && (e.flowing = !0, T(t));
            };
          }(r);

          t.on("drain", c);
          var h = !1,
              l = !1;

          function p(e) {
            d("ondata"), l = !1, !1 !== t.write(e) || l || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== L(o.pipes, t)) && !h && (d("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, l = !0), r.pause());
          }

          function g(e) {
            d("onerror", e), v(), t.removeListener("error", g), 0 === s(t, "error") && t.emit("error", e);
          }

          function A() {
            t.removeListener("finish", b), v();
          }

          function b() {
            d("onfinish"), t.removeListener("close", A), v();
          }

          function v() {
            d("unpipe"), r.unpipe(t);
          }

          return r.on("data", p), function (t, e, r) {
            if ("function" == typeof t.prependListener) return t.prependListener(e, r);
            t._events && t._events[e] ? a(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r);
          }(t, "error", g), t.once("close", A), t.once("finish", b), t.emit("pipe", r), o.flowing || (d("pipe resume"), r.resume()), t;
        }, y.prototype.unpipe = function (t) {
          var e = this._readableState,
              r = {
            hasUnpiped: !1
          };
          if (0 === e.pipesCount) return this;
          if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r), this);

          if (!t) {
            var n = e.pipes,
                i = e.pipesCount;
            e.pipes = null, e.pipesCount = 0, e.flowing = !1;

            for (var o = 0; o < i; o++) {
              n[o].emit("unpipe", this, r);
            }

            return this;
          }

          var a = L(e.pipes, t);
          return -1 === a ? this : (e.pipes.splice(a, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r), this);
        }, y.prototype.on = function (t, e) {
          var r = f.prototype.on.call(this, t, e);
          if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
            var n = this._readableState;
            n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && E(this) : i.nextTick(C, this));
          }
          return r;
        }, y.prototype.addListener = y.prototype.on, y.prototype.resume = function () {
          var t = this._readableState;
          return t.flowing || (d("resume"), t.flowing = !0, function (t, e) {
            e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(M, t, e));
          }(this, t)), this;
        }, y.prototype.pause = function () {
          return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
        }, y.prototype.wrap = function (t) {
          var e = this,
              r = this._readableState,
              n = !1;

          for (var i in t.on("end", function () {
            if (d("wrapped end"), r.decoder && !r.ended) {
              var t = r.decoder.end();
              t && t.length && e.push(t);
            }

            e.push(null);
          }), t.on("data", function (i) {
            d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
          }), t) {
            void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
              return function () {
                return t[e].apply(t, arguments);
              };
            }(i));
          }

          for (var o = 0; o < b.length; o++) {
            t.on(b[o], this.emit.bind(this, b[o]));
          }

          return this._read = function (e) {
            d("wrapped _read", e), n && (n = !1, t.resume());
          }, this;
        }, Object.defineProperty(y.prototype, "readableHighWaterMark", {
          enumerable: !1,
          get: function get() {
            return this._readableState.highWaterMark;
          }
        }), y._fromList = k;
      }).call(this, r(2), r(1));
    }, function (t, e, r) {
      t.exports = r(9).EventEmitter;
    }, function (t, e, r) {
      "use strict";

      var n = r(6);

      function i(t, e) {
        t.emit("error", e);
      }

      t.exports = {
        destroy: function destroy(t, e) {
          var r = this,
              o = this._readableState && this._readableState.destroyed,
              a = this._writableState && this._writableState.destroyed;
          return o || a ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
            !e && t ? (n.nextTick(i, r, t), r._writableState && (r._writableState.errorEmitted = !0)) : e && e(t);
          }), this);
        },
        undestroy: function undestroy() {
          this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
        }
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(7).Buffer,
          i = n.isEncoding || function (t) {
        switch ((t = "" + t) && t.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;

          default:
            return !1;
        }
      };

      function o(t) {
        var e;

        switch (this.encoding = function (t) {
          var e = function (t) {
            if (!t) return "utf8";

            for (var e;;) {
              switch (t) {
                case "utf8":
                case "utf-8":
                  return "utf8";

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return "utf16le";

                case "latin1":
                case "binary":
                  return "latin1";

                case "base64":
                case "ascii":
                case "hex":
                  return t;

                default:
                  if (e) return;
                  t = ("" + t).toLowerCase(), e = !0;
              }
            }
          }(t);

          if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
          return e || t;
        }(t), this.encoding) {
          case "utf16le":
            this.text = f, this.end = u, e = 4;
            break;

          case "utf8":
            this.fillLast = s, e = 4;
            break;

          case "base64":
            this.text = c, this.end = h, e = 3;
            break;

          default:
            return this.write = l, void (this.end = d);
        }

        this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
      }

      function a(t) {
        return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
      }

      function s(t) {
        var e = this.lastTotal - this.lastNeed,
            r = function (t, e, r) {
          if (128 != (192 & e[0])) return t.lastNeed = 0, "�";

          if (t.lastNeed > 1 && e.length > 1) {
            if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
            if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�";
          }
        }(this, t);

        return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
      }

      function f(t, e) {
        if ((t.length - e) % 2 == 0) {
          var r = t.toString("utf16le", e);

          if (r) {
            var n = r.charCodeAt(r.length - 1);
            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
          }

          return r;
        }

        return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
      }

      function u(t) {
        var e = t && t.length ? this.write(t) : "";

        if (this.lastNeed) {
          var r = this.lastTotal - this.lastNeed;
          return e + this.lastChar.toString("utf16le", 0, r);
        }

        return e;
      }

      function c(t, e) {
        var r = (t.length - e) % 3;
        return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
      }

      function h(t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
      }

      function l(t) {
        return t.toString(this.encoding);
      }

      function d(t) {
        return t && t.length ? this.write(t) : "";
      }

      e.StringDecoder = o, o.prototype.write = function (t) {
        if (0 === t.length) return "";
        var e, r;

        if (this.lastNeed) {
          if (void 0 === (e = this.fillLast(t))) return "";
          r = this.lastNeed, this.lastNeed = 0;
        } else r = 0;

        return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
      }, o.prototype.end = function (t) {
        var e = t && t.length ? this.write(t) : "";
        return this.lastNeed ? e + "�" : e;
      }, o.prototype.text = function (t, e) {
        var r = function (t, e, r) {
          var n = e.length - 1;
          if (n < r) return 0;
          var i = a(e[n]);
          return i >= 0 ? (i > 0 && (t.lastNeed = i - 1), i) : --n < r || -2 === i ? 0 : (i = a(e[n])) >= 0 ? (i > 0 && (t.lastNeed = i - 2), i) : --n < r || -2 === i ? 0 : (i = a(e[n])) >= 0 ? (i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i) : 0;
        }(this, t, e);

        if (!this.lastNeed) return t.toString("utf8", e);
        this.lastTotal = r;
        var n = t.length - (r - this.lastNeed);
        return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
      }, o.prototype.fillLast = function (t) {
        if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
        t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = a;
      var n = r(4),
          i = r(5);

      function o(t, e) {
        var r = this._transformState;
        r.transforming = !1;
        var n = r.writecb;
        if (!n) return this.emit("error", new Error("write callback called multiple times"));
        r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
        var i = this._readableState;
        i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }

      function a(t) {
        if (!(this instanceof a)) return new a(t);
        n.call(this, t), this._transformState = {
          afterTransform: o.bind(this),
          needTransform: !1,
          transforming: !1,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", s);
      }

      function s() {
        var t = this;
        "function" == typeof this._flush ? this._flush(function (e, r) {
          f(t, e, r);
        }) : f(this, null, null);
      }

      function f(t, e, r) {
        if (e) return t.emit("error", e);
        if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
        if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
        return t.push(null);
      }

      i.inherits = r(3), i.inherits(a, n), a.prototype.push = function (t, e) {
        return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e);
      }, a.prototype._transform = function (t, e, r) {
        throw new Error("_transform() is not implemented");
      }, a.prototype._write = function (t, e, r) {
        var n = this._transformState;

        if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
          var i = this._readableState;
          (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
        }
      }, a.prototype._read = function (t) {
        var e = this._transformState;
        null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
      }, a.prototype._destroy = function (t, e) {
        var r = this;

        n.prototype._destroy.call(this, t, function (t) {
          e(t), r.emit("close");
        });
      };
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
         * @license  MIT
         */
        function n(t, e) {
          if (t === e) return 0;

          for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
            if (t[i] !== e[i]) {
              r = t[i], n = e[i];
              break;
            }
          }

          return r < n ? -1 : n < r ? 1 : 0;
        }

        function i(t) {
          return e.Buffer && "function" == typeof e.Buffer.isBuffer ? e.Buffer.isBuffer(t) : !(null == t || !t._isBuffer);
        }

        var o = r(20),
            a = Object.prototype.hasOwnProperty,
            s = Array.prototype.slice,
            f = "foo" === function () {}.name;

        function u(t) {
          return Object.prototype.toString.call(t);
        }

        function c(t) {
          return !i(t) && "function" == typeof e.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : !!t && (t instanceof DataView || !!(t.buffer && t.buffer instanceof ArrayBuffer)));
        }

        var h = t.exports = b,
            l = /\s*function\s+([^\(\s]*)\s*/;

        function d(t) {
          if (o.isFunction(t)) {
            if (f) return t.name;
            var e = t.toString().match(l);
            return e && e[1];
          }
        }

        function p(t, e) {
          return "string" == typeof t ? t.length < e ? t : t.slice(0, e) : t;
        }

        function g(t) {
          if (f || !o.isFunction(t)) return o.inspect(t);
          var e = d(t);
          return "[Function" + (e ? ": " + e : "") + "]";
        }

        function A(t, e, r, n, i) {
          throw new h.AssertionError({
            message: r,
            actual: t,
            expected: e,
            operator: n,
            stackStartFunction: i
          });
        }

        function b(t, e) {
          t || A(t, !0, e, "==", h.ok);
        }

        function v(t, e, r, a) {
          if (t === e) return !0;
          if (i(t) && i(e)) return 0 === n(t, e);
          if (o.isDate(t) && o.isDate(e)) return t.getTime() === e.getTime();
          if (o.isRegExp(t) && o.isRegExp(e)) return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;

          if (null !== t && "object" == typeof t || null !== e && "object" == typeof e) {
            if (c(t) && c(e) && u(t) === u(e) && !(t instanceof Float32Array || t instanceof Float64Array)) return 0 === n(new Uint8Array(t.buffer), new Uint8Array(e.buffer));
            if (i(t) !== i(e)) return !1;
            var f = (a = a || {
              actual: [],
              expected: []
            }).actual.indexOf(t);
            return -1 !== f && f === a.expected.indexOf(e) || (a.actual.push(t), a.expected.push(e), function (t, e, r, n) {
              if (null == t || null == e) return !1;
              if (o.isPrimitive(t) || o.isPrimitive(e)) return t === e;
              if (r && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e)) return !1;
              var i = y(t),
                  a = y(e);
              if (i && !a || !i && a) return !1;
              if (i) return t = s.call(t), e = s.call(e), v(t, e, r);

              var f,
                  u,
                  c = _(t),
                  h = _(e);

              if (c.length !== h.length) return !1;

              for (c.sort(), h.sort(), u = c.length - 1; u >= 0; u--) {
                if (c[u] !== h[u]) return !1;
              }

              for (u = c.length - 1; u >= 0; u--) {
                if (f = c[u], !v(t[f], e[f], r, n)) return !1;
              }

              return !0;
            }(t, e, r, a));
          }

          return r ? t === e : t == e;
        }

        function y(t) {
          return "[object Arguments]" == Object.prototype.toString.call(t);
        }

        function w(t, e) {
          if (!t || !e) return !1;
          if ("[object RegExp]" == Object.prototype.toString.call(e)) return e.test(t);

          try {
            if (t instanceof e) return !0;
          } catch (t) {}

          return !Error.isPrototypeOf(e) && !0 === e.call({}, t);
        }

        function m(t, e, r, n) {
          var i;
          if ("function" != typeof e) throw new TypeError('"block" argument must be a function');
          "string" == typeof r && (n = r, r = null), i = function (t) {
            var e;

            try {
              t();
            } catch (t) {
              e = t;
            }

            return e;
          }(e), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t && !i && A(i, r, "Missing expected exception" + n);
          var a = "string" == typeof n,
              s = !t && i && !r;
          if ((!t && o.isError(i) && a && w(i, r) || s) && A(i, r, "Got unwanted exception" + n), t && i && r && !w(i, r) || !t && i) throw i;
        }

        h.AssertionError = function (t) {
          this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = p(g(this.actual), 128) + " " + this.operator + " " + p(g(this.expected), 128), this.generatedMessage = !0);
          var e = t.stackStartFunction || A;
          if (Error.captureStackTrace) Error.captureStackTrace(this, e);else {
            var r = new Error();

            if (r.stack) {
              var n = r.stack,
                  i = d(e),
                  o = n.indexOf("\n" + i);

              if (o >= 0) {
                var a = n.indexOf("\n", o + 1);
                n = n.substring(a + 1);
              }

              this.stack = n;
            }
          }
        }, o.inherits(h.AssertionError, Error), h.fail = A, h.ok = b, h.equal = function (t, e, r) {
          t != e && A(t, e, r, "==", h.equal);
        }, h.notEqual = function (t, e, r) {
          t == e && A(t, e, r, "!=", h.notEqual);
        }, h.deepEqual = function (t, e, r) {
          v(t, e, !1) || A(t, e, r, "deepEqual", h.deepEqual);
        }, h.deepStrictEqual = function (t, e, r) {
          v(t, e, !0) || A(t, e, r, "deepStrictEqual", h.deepStrictEqual);
        }, h.notDeepEqual = function (t, e, r) {
          v(t, e, !1) && A(t, e, r, "notDeepEqual", h.notDeepEqual);
        }, h.notDeepStrictEqual = function t(e, r, n) {
          v(e, r, !0) && A(e, r, n, "notDeepStrictEqual", t);
        }, h.strictEqual = function (t, e, r) {
          t !== e && A(t, e, r, "===", h.strictEqual);
        }, h.notStrictEqual = function (t, e, r) {
          t === e && A(t, e, r, "!==", h.notStrictEqual);
        }, h.throws = function (t, e, r) {
          m(!0, t, e, r);
        }, h.doesNotThrow = function (t, e, r) {
          m(!1, t, e, r);
        }, h.ifError = function (t) {
          if (t) throw t;
        };

        var _ = Object.keys || function (t) {
          var e = [];

          for (var r in t) {
            a.call(t, r) && e.push(r);
          }

          return e;
        };
      }).call(this, r(2));
    }, function (t, e, r) {
      (function (t) {
        var n = Object.getOwnPropertyDescriptors || function (t) {
          for (var e = Object.keys(t), r = {}, n = 0; n < e.length; n++) {
            r[e[n]] = Object.getOwnPropertyDescriptor(t, e[n]);
          }

          return r;
        },
            i = /%[sdj%]/g;

        e.format = function (t) {
          if (!b(t)) {
            for (var e = [], r = 0; r < arguments.length; r++) {
              e.push(s(arguments[r]));
            }

            return e.join(" ");
          }

          r = 1;

          for (var n = arguments, o = n.length, a = String(t).replace(i, function (t) {
            if ("%%" === t) return "%";
            if (r >= o) return t;

            switch (t) {
              case "%s":
                return String(n[r++]);

              case "%d":
                return Number(n[r++]);

              case "%j":
                try {
                  return JSON.stringify(n[r++]);
                } catch (t) {
                  return "[Circular]";
                }

              default:
                return t;
            }
          }), f = n[r]; r < o; f = n[++r]) {
            g(f) || !w(f) ? a += " " + f : a += " " + s(f);
          }

          return a;
        }, e.deprecate = function (r, n) {
          if (void 0 !== t && !0 === t.noDeprecation) return r;
          if (void 0 === t) return function () {
            return e.deprecate(r, n).apply(this, arguments);
          };
          var i = !1;
          return function () {
            if (!i) {
              if (t.throwDeprecation) throw new Error(n);
              t.traceDeprecation ? console.trace(n) : console.error(n), i = !0;
            }

            return r.apply(this, arguments);
          };
        };
        var o,
            a = {};

        function s(t, r) {
          var n = {
            seen: [],
            stylize: u
          };
          return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(r) ? n.showHidden = r : r && e._extend(n, r), v(n.showHidden) && (n.showHidden = !1), v(n.depth) && (n.depth = 2), v(n.colors) && (n.colors = !1), v(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = f), c(n, t, n.depth);
        }

        function f(t, e) {
          var r = s.styles[e];
          return r ? "[" + s.colors[r][0] + "m" + t + "[" + s.colors[r][1] + "m" : t;
        }

        function u(t, e) {
          return t;
        }

        function c(t, r, n) {
          if (t.customInspect && r && I(r.inspect) && r.inspect !== e.inspect && (!r.constructor || r.constructor.prototype !== r)) {
            var i = r.inspect(n, t);
            return b(i) || (i = c(t, i, n)), i;
          }

          var o = function (t, e) {
            if (v(e)) return t.stylize("undefined", "undefined");

            if (b(e)) {
              var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
              return t.stylize(r, "string");
            }

            return A(e) ? t.stylize("" + e, "number") : p(e) ? t.stylize("" + e, "boolean") : g(e) ? t.stylize("null", "null") : void 0;
          }(t, r);

          if (o) return o;

          var a = Object.keys(r),
              s = function (t) {
            var e = {};
            return t.forEach(function (t, r) {
              e[t] = !0;
            }), e;
          }(a);

          if (t.showHidden && (a = Object.getOwnPropertyNames(r)), _(r) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return h(r);

          if (0 === a.length) {
            if (I(r)) {
              var f = r.name ? ": " + r.name : "";
              return t.stylize("[Function" + f + "]", "special");
            }

            if (y(r)) return t.stylize(RegExp.prototype.toString.call(r), "regexp");
            if (m(r)) return t.stylize(Date.prototype.toString.call(r), "date");
            if (_(r)) return h(r);
          }

          var u,
              w = "",
              E = !1,
              P = ["{", "}"];
          return d(r) && (E = !0, P = ["[", "]"]), I(r) && (w = " [Function" + (r.name ? ": " + r.name : "") + "]"), y(r) && (w = " " + RegExp.prototype.toString.call(r)), m(r) && (w = " " + Date.prototype.toUTCString.call(r)), _(r) && (w = " " + h(r)), 0 !== a.length || E && 0 != r.length ? n < 0 ? y(r) ? t.stylize(RegExp.prototype.toString.call(r), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(r), u = E ? function (t, e, r, n, i) {
            for (var o = [], a = 0, s = e.length; a < s; ++a) {
              x(e, String(a)) ? o.push(l(t, e, r, n, String(a), !0)) : o.push("");
            }

            return i.forEach(function (i) {
              i.match(/^\d+$/) || o.push(l(t, e, r, n, i, !0));
            }), o;
          }(t, r, n, s, a) : a.map(function (e) {
            return l(t, r, n, s, e, E);
          }), t.seen.pop(), function (t, e, r) {
            return t.reduce(function (t, e) {
              return e.indexOf("\n"), t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
            }, 0) > 60 ? r[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + r[1] : r[0] + e + " " + t.join(", ") + " " + r[1];
          }(u, w, P)) : P[0] + w + P[1];
        }

        function h(t) {
          return "[" + Error.prototype.toString.call(t) + "]";
        }

        function l(t, e, r, n, i, o) {
          var a, s, f;

          if ((f = Object.getOwnPropertyDescriptor(e, i) || {
            value: e[i]
          }).get ? s = f.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : f.set && (s = t.stylize("[Setter]", "special")), x(n, i) || (a = "[" + i + "]"), s || (t.seen.indexOf(f.value) < 0 ? (s = g(r) ? c(t, f.value, null) : c(t, f.value, r - 1)).indexOf("\n") > -1 && (s = o ? s.split("\n").map(function (t) {
            return "  " + t;
          }).join("\n").substr(2) : "\n" + s.split("\n").map(function (t) {
            return "   " + t;
          }).join("\n")) : s = t.stylize("[Circular]", "special")), v(a)) {
            if (o && i.match(/^\d+$/)) return s;
            (a = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = t.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = t.stylize(a, "string"));
          }

          return a + ": " + s;
        }

        function d(t) {
          return Array.isArray(t);
        }

        function p(t) {
          return "boolean" == typeof t;
        }

        function g(t) {
          return null === t;
        }

        function A(t) {
          return "number" == typeof t;
        }

        function b(t) {
          return "string" == typeof t;
        }

        function v(t) {
          return void 0 === t;
        }

        function y(t) {
          return w(t) && "[object RegExp]" === E(t);
        }

        function w(t) {
          return "object" == typeof t && null !== t;
        }

        function m(t) {
          return w(t) && "[object Date]" === E(t);
        }

        function _(t) {
          return w(t) && ("[object Error]" === E(t) || t instanceof Error);
        }

        function I(t) {
          return "function" == typeof t;
        }

        function E(t) {
          return Object.prototype.toString.call(t);
        }

        function P(t) {
          return t < 10 ? "0" + t.toString(10) : t.toString(10);
        }

        e.debuglog = function (r) {
          if (v(o) && (o = t.env.NODE_DEBUG || ""), r = r.toUpperCase(), !a[r]) if (new RegExp("\\b" + r + "\\b", "i").test(o)) {
            var n = t.pid;

            a[r] = function () {
              var t = e.format.apply(e, arguments);
              console.error("%s %d: %s", r, n, t);
            };
          } else a[r] = function () {};
          return a[r];
        }, e.inspect = s, s.colors = {
          bold: [1, 22],
          italic: [3, 23],
          underline: [4, 24],
          inverse: [7, 27],
          white: [37, 39],
          grey: [90, 39],
          black: [30, 39],
          blue: [34, 39],
          cyan: [36, 39],
          green: [32, 39],
          magenta: [35, 39],
          red: [31, 39],
          yellow: [33, 39]
        }, s.styles = {
          special: "cyan",
          number: "yellow",
          boolean: "yellow",
          undefined: "grey",
          null: "bold",
          string: "green",
          date: "magenta",
          regexp: "red"
        }, e.isArray = d, e.isBoolean = p, e.isNull = g, e.isNullOrUndefined = function (t) {
          return null == t;
        }, e.isNumber = A, e.isString = b, e.isSymbol = function (t) {
          return "symbol" == typeof t;
        }, e.isUndefined = v, e.isRegExp = y, e.isObject = w, e.isDate = m, e.isError = _, e.isFunction = I, e.isPrimitive = function (t) {
          return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
        }, e.isBuffer = r(46);
        var S = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        function x(t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }

        e.log = function () {
          var t, r;
          console.log("%s - %s", (t = new Date(), r = [P(t.getHours()), P(t.getMinutes()), P(t.getSeconds())].join(":"), [t.getDate(), S[t.getMonth()], r].join(" ")), e.format.apply(e, arguments));
        }, e.inherits = r(3), e._extend = function (t, e) {
          if (!e || !w(e)) return t;

          for (var r = Object.keys(e), n = r.length; n--;) {
            t[r[n]] = e[r[n]];
          }

          return t;
        };
        var C = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

        function M(t, e) {
          if (!t) {
            var r = new Error("Promise was rejected with a falsy value");
            r.reason = t, t = r;
          }

          return e(t);
        }

        e.promisify = function (t) {
          if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');

          if (C && t[C]) {
            var e;
            if ("function" != typeof (e = t[C])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return Object.defineProperty(e, C, {
              value: e,
              enumerable: !1,
              writable: !1,
              configurable: !0
            }), e;
          }

          function e() {
            for (var e, r, n = new Promise(function (t, n) {
              e = t, r = n;
            }), i = [], o = 0; o < arguments.length; o++) {
              i.push(arguments[o]);
            }

            i.push(function (t, n) {
              t ? r(t) : e(n);
            });

            try {
              t.apply(this, i);
            } catch (t) {
              r(t);
            }

            return n;
          }

          return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), C && Object.defineProperty(e, C, {
            value: e,
            enumerable: !1,
            writable: !1,
            configurable: !0
          }), Object.defineProperties(e, n(t));
        }, e.promisify.custom = C, e.callbackify = function (e) {
          if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

          function r() {
            for (var r = [], n = 0; n < arguments.length; n++) {
              r.push(arguments[n]);
            }

            var i = r.pop();
            if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");

            var o = this,
                a = function a() {
              return i.apply(o, arguments);
            };

            e.apply(this, r).then(function (e) {
              t.nextTick(a, null, e);
            }, function (e) {
              t.nextTick(M, e, a);
            });
          }

          return Object.setPrototypeOf(r, Object.getPrototypeOf(e)), Object.defineProperties(r, n(e)), r;
        };
      }).call(this, r(1));
    }, function (t, e, r) {
      "use strict";

      t.exports = function (t, e, r, n) {
        for (var i = 65535 & t | 0, o = t >>> 16 & 65535 | 0, a = 0; 0 !== r;) {
          r -= a = r > 2e3 ? 2e3 : r;

          do {
            o = o + (i = i + e[n++] | 0) | 0;
          } while (--a);

          i %= 65521, o %= 65521;
        }

        return i | o << 16 | 0;
      };
    }, function (t, e, r) {
      "use strict";

      var n = function () {
        for (var t, e = [], r = 0; r < 256; r++) {
          t = r;

          for (var n = 0; n < 8; n++) {
            t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
          }

          e[r] = t;
        }

        return e;
      }();

      t.exports = function (t, e, r, i) {
        var o = n,
            a = i + r;
        t ^= -1;

        for (var s = i; s < a; s++) {
          t = t >>> 8 ^ o[255 & (t ^ e[s])];
        }

        return -1 ^ t;
      };
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var n,
          i = r(24),
          o = i.__importStar(r(25)),
          a = i.__importDefault(r(58)),
          s = i.__importDefault(r(59));

      function f() {
        var t = n.getElementById("walletconnect-qrcode-modal");
        t && (t.className = t.className.replace("fadeIn", "fadeOut"), setTimeout(function () {
          var t = n.getElementById("walletconnect-wrapper");
          t && n.body.removeChild(t);
        }, a.default.animationDuration));
      }

      "undefined" != typeof window && void 0 !== window.document && (n = window.document), e.default = {
        close: f,
        open: function open(t, e) {
          var r = n.createElement("div");
          r.setAttribute("id", "walletconnect-wrapper");
          var i,
              u,
              c,
              h = (i = t, u = "", "string" == typeof (c = o.imageSync(i, {
            type: "svg"
          })) && (u = c.replace("<svg", '<svg style="' + a.default.qrcode.image + '"')), u);
          r.innerHTML = function (t) {
            return '\n    <div\n      id="walletconnect-qrcode-modal"\n      style="' + a.default.qrcode.base + '"\n      class="animated fadeIn"\n    >\n      <div style="' + a.default.modal.base + '">\n        <div style="' + a.default.modal.header + '">\n          <img src="' + s.default.logo + '" style="' + a.default.modal.headerLogo + '" />\n          <div style="' + a.default.modal.close.wrapper + '">\n            <div\n              id="walletconnect-qrcode-close"\n              style="' + a.default.modal.close.icon + '"\n            >\n              <div style="' + a.default.modal.close.line1 + '"></div>\n              <div style="' + a.default.modal.close.line2 + '"></div>\n            </div>\n          </div>\n        </div>\n        <div>\n          <div>\n            <p id="walletconnect-qrcode-text" style="' + a.default.qrcode.text + '">\n              Scan QR code with a WalletConnect-compatible wallet\n            </p>\n            ' + t + "\n          </div>\n        </div>\n      </div>\n      " + a.default.animation + "\n    </div>\n";
          }(h), n.body.appendChild(r);
          var l = n.getElementById("walletconnect-qrcode-close");
          l && l.addEventListener("click", function () {
            f(), e && e();
          });
        }
      };
    }, function (t, e, r) {
      "use strict";

      r.r(e), r.d(e, "__extends", function () {
        return i;
      }), r.d(e, "__assign", function () {
        return _o;
      }), r.d(e, "__rest", function () {
        return a;
      }), r.d(e, "__decorate", function () {
        return s;
      }), r.d(e, "__param", function () {
        return f;
      }), r.d(e, "__metadata", function () {
        return u;
      }), r.d(e, "__awaiter", function () {
        return c;
      }), r.d(e, "__generator", function () {
        return h;
      }), r.d(e, "__exportStar", function () {
        return l;
      }), r.d(e, "__values", function () {
        return d;
      }), r.d(e, "__read", function () {
        return p;
      }), r.d(e, "__spread", function () {
        return g;
      }), r.d(e, "__await", function () {
        return A;
      }), r.d(e, "__asyncGenerator", function () {
        return b;
      }), r.d(e, "__asyncDelegator", function () {
        return v;
      }), r.d(e, "__asyncValues", function () {
        return y;
      }), r.d(e, "__makeTemplateObject", function () {
        return w;
      }), r.d(e, "__importStar", function () {
        return m;
      }), r.d(e, "__importDefault", function () {
        return _;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _n = function n(t, e) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            e.hasOwnProperty(r) && (t[r] = e[r]);
          }
        })(t, e);
      };

      function i(t, e) {
        function r() {
          this.constructor = t;
        }

        _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }

      var _o = function o() {
        return (_o = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var i in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            }
          }

          return t;
        }).apply(this, arguments);
      };

      function a(t, e) {
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var i = 0;

          for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
            e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
          }
        }

        return r;
      }

      function s(t, e, r, n) {
        var i,
            o = arguments.length,
            a = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, e, r, n);else for (var s = t.length - 1; s >= 0; s--) {
          (i = t[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(e, r, a) : i(e, r)) || a);
        }
        return o > 3 && a && Object.defineProperty(e, r, a), a;
      }

      function f(t, e) {
        return function (r, n) {
          e(r, n, t);
        };
      }

      function u(t, e) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
      }

      function c(t, e, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function a(t) {
            try {
              f(n.next(t));
            } catch (t) {
              o(t);
            }
          }

          function s(t) {
            try {
              f(n.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function f(t) {
            t.done ? i(t.value) : new r(function (e) {
              e(t.value);
            }).then(a, s);
          }

          f((n = n.apply(t, e || [])).next());
        });
      }

      function h(t, e) {
        var r,
            n,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                  switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, n = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = e.call(t, a);
                } catch (t) {
                  o = [6, t], n = 0;
                } finally {
                  r = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      }

      function l(t, e) {
        for (var r in t) {
          e.hasOwnProperty(r) || (e[r] = t[r]);
        }
      }

      function d(t) {
        var e = "function" == typeof Symbol && t[Symbol.iterator],
            r = 0;
        return e ? e.call(t) : {
          next: function next() {
            return t && r >= t.length && (t = void 0), {
              value: t && t[r++],
              done: !t
            };
          }
        };
      }

      function p(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            i,
            o = r.call(t),
            a = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
            a.push(n.value);
          }
        } catch (t) {
          i = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = o.return) && r.call(o);
          } finally {
            if (i) throw i.error;
          }
        }

        return a;
      }

      function g() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t = t.concat(p(arguments[e]));
        }

        return t;
      }

      function A(t) {
        return this instanceof A ? (this.v = t, this) : new A(t);
      }

      function b(t, e, r) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var n,
            i = r.apply(t, e || []),
            o = [];
        return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function () {
          return this;
        }, n;

        function a(t) {
          i[t] && (n[t] = function (e) {
            return new Promise(function (r, n) {
              o.push([t, e, r, n]) > 1 || s(t, e);
            });
          });
        }

        function s(t, e) {
          try {
            (r = i[t](e)).value instanceof A ? Promise.resolve(r.value.v).then(f, u) : c(o[0][2], r);
          } catch (t) {
            c(o[0][3], t);
          }

          var r;
        }

        function f(t) {
          s("next", t);
        }

        function u(t) {
          s("throw", t);
        }

        function c(t, e) {
          t(e), o.shift(), o.length && s(o[0][0], o[0][1]);
        }
      }

      function v(t) {
        var e, r;
        return e = {}, n("next"), n("throw", function (t) {
          throw t;
        }), n("return"), e[Symbol.iterator] = function () {
          return this;
        }, e;

        function n(n, i) {
          e[n] = t[n] ? function (e) {
            return (r = !r) ? {
              value: A(t[n](e)),
              done: "return" === n
            } : i ? i(e) : e;
          } : i;
        }
      }

      function y(t) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var e,
            r = t[Symbol.asyncIterator];
        return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
          return this;
        }, e);

        function n(r) {
          e[r] = t[r] && function (e) {
            return new Promise(function (n, i) {
              !function (t, e, r, n) {
                Promise.resolve(n).then(function (e) {
                  t({
                    value: e,
                    done: r
                  });
                }, e);
              }(n, i, (e = t[r](e)).done, e.value);
            });
          };
        }
      }

      function w(t, e) {
        return Object.defineProperty ? Object.defineProperty(t, "raw", {
          value: e
        }) : t.raw = e, t;
      }

      function m(t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var r in t) {
          Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e.default = t, e;
      }

      function _(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
    }, function (t, e, r) {
      "use strict";

      (function (e, n) {
        var i = r(13).Readable,
            o = r(39).QR,
            a = r(43),
            s = r(57),
            f = function f() {},
            u = {
          parse_url: !1,
          ec_level: "M",
          size: 5,
          margin: 4,
          customize: null
        },
            c = {
          parse_url: !1,
          ec_level: "M",
          margin: 1,
          size: 0
        };

        function h(t, e) {
          t = "string" == typeof t ? {
            ec_level: t
          } : t || {};
          var r = {
            type: String(e || t.type || "png").toLowerCase()
          },
              n = "png" == r.type ? u : c;

          for (var i in n) {
            r[i] = i in t ? t[i] : n[i];
          }

          return r;
        }

        t.exports = {
          matrix: o,
          image: function image(t, r) {
            r = h(r);
            var n = o(t, r.ec_level, r.parse_url),
                u = new i();

            switch (u._read = f, r.type) {
              case "svg":
              case "pdf":
              case "eps":
                e.nextTick(function () {
                  s[r.type](n, u, r.margin, r.size);
                });
                break;

              case "svgpath":
                e.nextTick(function () {
                  var t = s.svg_object(n, r.margin, r.size);
                  u.push(t.path), u.push(null);
                });
                break;

              case "png":
              default:
                e.nextTick(function () {
                  var t = a.bitmap(n, r.size, r.margin);
                  r.customize && r.customize(t), a.png(t, u);
                });
            }

            return u;
          },
          imageSync: function imageSync(t, e) {
            e = h(e);
            var r,
                i = o(t, e.ec_level, e.parse_url),
                f = [];

            switch (e.type) {
              case "svg":
              case "pdf":
              case "eps":
                s[e.type](i, f, e.margin, e.size), r = f.filter(Boolean).join("");
                break;

              case "png":
              default:
                var u = a.bitmap(i, e.size, e.margin);
                e.customize && e.customize(u), a.png(u, f), r = n.concat(f.filter(Boolean));
            }

            return r;
          },
          svgObject: function svgObject(t, e) {
            e = h(e, "svg");
            var r = o(t, e.ec_level);
            return s.svg_object(r, e.margin);
          }
        };
      }).call(this, r(1), r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      e.byteLength = function (t) {
        var e = u(t),
            r = e[0],
            n = e[1];
        return 3 * (r + n) / 4 - n;
      }, e.toByteArray = function (t) {
        for (var e, r = u(t), n = r[0], a = r[1], s = new o(NaN), f = 0, c = a > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
          e = i[t.charCodeAt(h)] << 18 | i[t.charCodeAt(h + 1)] << 12 | i[t.charCodeAt(h + 2)] << 6 | i[t.charCodeAt(h + 3)], s[f++] = e >> 16 & 255, s[f++] = e >> 8 & 255, s[f++] = 255 & e;
        }

        return 2 === a && (e = i[t.charCodeAt(h)] << 2 | i[t.charCodeAt(h + 1)] >> 4, s[f++] = 255 & e), 1 === a && (e = i[t.charCodeAt(h)] << 10 | i[t.charCodeAt(h + 1)] << 4 | i[t.charCodeAt(h + 2)] >> 2, s[f++] = e >> 8 & 255, s[f++] = 255 & e), s;
      }, e.fromByteArray = function (t) {
        for (var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
          o.push(c(t, a, a + 16383 > s ? s : a + 16383));
        }

        return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
      };

      for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) {
        n[s] = a[s], i[a.charCodeAt(s)] = s;
      }

      function u(t) {
        var e = t.length;
        if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var r = t.indexOf("=");
        return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
      }

      function c(t, e, r) {
        for (var i, o, a = [], s = e; s < r; s += 3) {
          i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
        }

        return a.join("");
      }

      i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
    }, function (t, e) {
      e.read = function (t, e, r, n, i) {
        var o,
            a,
            s = 8 * i - n - 1,
            f = (1 << s) - 1,
            u = f >> 1,
            c = -7,
            h = r ? i - 1 : 0,
            l = r ? -1 : 1,
            d = t[e + h];

        for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += s; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
          ;
        }

        for (a = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; a = 256 * a + t[e + h], h += l, c -= 8) {
          ;
        }

        if (0 === o) o = 1 - u;else {
          if (o === f) return a ? NaN : 1 / 0 * (d ? -1 : 1);
          a += Math.pow(2, n), o -= u;
        }
        return (d ? -1 : 1) * a * Math.pow(2, o - n);
      }, e.write = function (t, e, r, n, i, o) {
        var a,
            s,
            f,
            u = 8 * o - i - 1,
            c = (1 << u) - 1,
            h = c >> 1,
            l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
            d = n ? 0 : o - 1,
            p = n ? 1 : -1,
            g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

        for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (e += a + h >= 1 ? l / f : l * Math.pow(2, 1 - h)) * f >= 2 && (a++, f /= 2), a + h >= c ? (s = 0, a = c) : a + h >= 1 ? (s = (e * f - 1) * Math.pow(2, i), a += h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + d] = 255 & s, d += p, s /= 256, i -= 8) {
          ;
        }

        for (a = a << i | s, u += i; u > 0; t[r + d] = 255 & a, d += p, a /= 256, u -= 8) {
          ;
        }

        t[r + d - p] |= 128 * g;
      };
    }, function (t, e) {}, function (t, e, r) {
      "use strict";

      var n = r(7).Buffer,
          i = r(30);
      t.exports = function () {
        function t() {
          !function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, t), this.head = null, this.tail = null, this.length = 0;
        }

        return t.prototype.push = function (t) {
          var e = {
            data: t,
            next: null
          };
          this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
        }, t.prototype.unshift = function (t) {
          var e = {
            data: t,
            next: this.head
          };
          0 === this.length && (this.tail = e), this.head = e, ++this.length;
        }, t.prototype.shift = function () {
          if (0 !== this.length) {
            var t = this.head.data;
            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
          }
        }, t.prototype.clear = function () {
          this.head = this.tail = null, this.length = 0;
        }, t.prototype.join = function (t) {
          if (0 === this.length) return "";

          for (var e = this.head, r = "" + e.data; e = e.next;) {
            r += t + e.data;
          }

          return r;
        }, t.prototype.concat = function (t) {
          if (0 === this.length) return n.alloc(0);
          if (1 === this.length) return this.head.data;

          for (var e, r, i, o = n.allocUnsafe(t >>> 0), a = this.head, s = 0; a;) {
            e = a.data, r = o, i = s, e.copy(r, i), s += a.data.length, a = a.next;
          }

          return o;
        }, t;
      }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function () {
        var t = i.inspect({
          length: this.length
        });
        return this.constructor.name + " " + t;
      });
    }, function (t, e) {}, function (t, e, r) {
      (function (t) {
        var n = void 0 !== t && t || "undefined" != typeof self && self || window,
            i = Function.prototype.apply;

        function o(t, e) {
          this._id = t, this._clearFn = e;
        }

        e.setTimeout = function () {
          return new o(i.call(setTimeout, n, arguments), clearTimeout);
        }, e.setInterval = function () {
          return new o(i.call(setInterval, n, arguments), clearInterval);
        }, e.clearTimeout = e.clearInterval = function (t) {
          t && t.close();
        }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
          this._clearFn.call(n, this._id);
        }, e.enroll = function (t, e) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
        }, e.unenroll = function (t) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
        }, e._unrefActive = e.active = function (t) {
          clearTimeout(t._idleTimeoutId);
          var e = t._idleTimeout;
          e >= 0 && (t._idleTimeoutId = setTimeout(function () {
            t._onTimeout && t._onTimeout();
          }, e));
        }, r(32), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
      }).call(this, r(2));
    }, function (t, e, r) {
      (function (t, e) {
        !function (t, r) {
          "use strict";

          if (!t.setImmediate) {
            var n,
                i,
                o,
                a,
                s,
                f = 1,
                u = {},
                c = !1,
                h = t.document,
                l = Object.getPrototypeOf && Object.getPrototypeOf(t);
            l = l && l.setTimeout ? l : t, "[object process]" === {}.toString.call(t.process) ? n = function n(t) {
              e.nextTick(function () {
                p(t);
              });
            } : function () {
              if (t.postMessage && !t.importScripts) {
                var e = !0,
                    r = t.onmessage;
                return t.onmessage = function () {
                  e = !1;
                }, t.postMessage("", "*"), t.onmessage = r, e;
              }
            }() ? (a = "setImmediate$" + Math.random() + "$", s = function s(e) {
              e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length));
            }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), n = function n(e) {
              t.postMessage(a + e, "*");
            }) : t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
              p(t.data);
            }, n = function n(t) {
              o.port2.postMessage(t);
            }) : h && "onreadystatechange" in h.createElement("script") ? (i = h.documentElement, n = function n(t) {
              var e = h.createElement("script");
              e.onreadystatechange = function () {
                p(t), e.onreadystatechange = null, i.removeChild(e), e = null;
              }, i.appendChild(e);
            }) : n = function n(t) {
              setTimeout(p, 0, t);
            }, l.setImmediate = function (t) {
              "function" != typeof t && (t = new Function("" + t));

              for (var e = new Array(arguments.length - 1), r = 0; r < e.length; r++) {
                e[r] = arguments[r + 1];
              }

              var i = {
                callback: t,
                args: e
              };
              return u[f] = i, n(f), f++;
            }, l.clearImmediate = d;
          }

          function d(t) {
            delete u[t];
          }

          function p(t) {
            if (c) setTimeout(p, 0, t);else {
              var e = u[t];

              if (e) {
                c = !0;

                try {
                  !function (t) {
                    var e = t.callback,
                        n = t.args;

                    switch (n.length) {
                      case 0:
                        e();
                        break;

                      case 1:
                        e(n[0]);
                        break;

                      case 2:
                        e(n[0], n[1]);
                        break;

                      case 3:
                        e(n[0], n[1], n[2]);
                        break;

                      default:
                        e.apply(r, n);
                    }
                  }(e);
                } finally {
                  d(t), c = !1;
                }
              }
            }
          }
        }("undefined" == typeof self ? void 0 === t ? this : t : self);
      }).call(this, r(2), r(1));
    }, function (t, e, r) {
      (function (e) {
        function r(t) {
          try {
            if (!e.localStorage) return !1;
          } catch (t) {
            return !1;
          }

          var r = e.localStorage[t];
          return null != r && "true" === String(r).toLowerCase();
        }

        t.exports = function (t, e) {
          if (r("noDeprecation")) return t;
          var n = !1;
          return function () {
            if (!n) {
              if (r("throwDeprecation")) throw new Error(e);
              r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
            }

            return t.apply(this, arguments);
          };
        };
      }).call(this, r(2));
    }, function (t, e, r) {
      "use strict";

      t.exports = o;
      var n = r(18),
          i = r(5);

      function o(t) {
        if (!(this instanceof o)) return new o(t);
        n.call(this, t);
      }

      i.inherits = r(3), i.inherits(o, n), o.prototype._transform = function (t, e, r) {
        r(null, t);
      };
    }, function (t, e, r) {
      t.exports = r(11);
    }, function (t, e, r) {
      t.exports = r(4);
    }, function (t, e, r) {
      t.exports = r(10).Transform;
    }, function (t, e, r) {
      t.exports = r(10).PassThrough;
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        var n = r(40),
            i = r(41),
            o = r(42);

        function a(t) {
          return JSON.parse(JSON.stringify(t));
        }

        var s = ["L", "M", "Q", "H"],
            f = [[], [26, 7, 1, 10, 1, 13, 1, 17, 1], [44, 10, 1, 16, 1, 22, 1, 28, 1], [70, 15, 1, 26, 1, 36, 2, 44, 2], [100, 20, 1, 36, 2, 52, 2, 64, 4], [134, 26, 1, 48, 2, 72, 4, 88, 4], [172, 36, 2, 64, 4, 96, 4, 112, 4], [196, 40, 2, 72, 4, 108, 6, 130, 5], [242, 48, 2, 88, 4, 132, 6, 156, 6], [292, 60, 2, 110, 5, 160, 8, 192, 8], [346, 72, 4, 130, 5, 192, 8, 224, 8], [404, 80, 4, 150, 5, 224, 8, 264, 11], [466, 96, 4, 176, 8, 260, 10, 308, 11], [532, 104, 4, 198, 9, 288, 12, 352, 16], [581, 120, 4, 216, 9, 320, 16, 384, 16], [655, 132, 6, 240, 10, 360, 12, 432, 18], [733, 144, 6, 280, 10, 408, 17, 480, 16], [815, 168, 6, 308, 11, 448, 16, 532, 19], [901, 180, 6, 338, 13, 504, 18, 588, 21], [991, 196, 7, 364, 14, 546, 21, 650, 25], [1085, 224, 8, 416, 16, 600, 20, 700, 25], [1156, 224, 8, 442, 17, 644, 23, 750, 25], [1258, 252, 9, 476, 17, 690, 23, 816, 34], [1364, 270, 9, 504, 18, 750, 25, 900, 30], [1474, 300, 10, 560, 20, 810, 27, 960, 32], [1588, 312, 12, 588, 21, 870, 29, 1050, 35], [1706, 336, 12, 644, 23, 952, 34, 1110, 37], [1828, 360, 12, 700, 25, 1020, 34, 1200, 40], [1921, 390, 13, 728, 26, 1050, 35, 1260, 42], [2051, 420, 14, 784, 28, 1140, 38, 1350, 45], [2185, 450, 15, 812, 29, 1200, 40, 1440, 48], [2323, 480, 16, 868, 31, 1290, 43, 1530, 51], [2465, 510, 17, 924, 33, 1350, 45, 1620, 54], [2611, 540, 18, 980, 35, 1440, 48, 1710, 57], [2761, 570, 19, 1036, 37, 1530, 51, 1800, 60], [2876, 570, 19, 1064, 38, 1590, 53, 1890, 63], [3034, 600, 20, 1120, 40, 1680, 56, 1980, 66], [3196, 630, 21, 1204, 43, 1770, 59, 2100, 70], [3362, 660, 22, 1260, 45, 1860, 62, 2220, 74], [3532, 720, 24, 1316, 47, 1950, 65, 2310, 77], [3706, 750, 25, 1372, 49, 2040, 68, 2430, 81]];

        function u(t, e) {
          var r,
              n = 1;

          for (t.data1 ? r = Math.ceil(t.data1.length / 8) : n = 10; n < 10; n++) {
            if ((i = f[n][e]).data_len >= r) return a(i);
          }

          for (t.data10 ? r = Math.ceil(t.data10.length / 8) : n = 27; n < 27; n++) {
            if ((i = f[n][e]).data_len >= r) return a(i);
          }

          for (r = Math.ceil(t.data27.length / 8); n < 41; n++) {
            var i;
            if ((i = f[n][e]).data_len >= r) return a(i);
          }

          throw new Error("Too much data");
        }

        function c(t, r) {
          var n = new e(r.data_len);
          n.fill(0);

          for (var o = (t = r.version < 10 ? t.data1 : r.version < 27 ? t.data10 : t.data27).length, a = 0; a < o; a += 8) {
            for (var s = 0, f = 0; f < 8; f++) {
              s = s << 1 | (t[a + f] ? 1 : 0);
            }

            n[a / 8] = s;
          }

          var u = 236;

          for (a = Math.ceil((o + 4) / 8); a < n.length; a++) {
            n[a] = u, u = 236 == u ? 17 : 236;
          }

          var c = 0;
          return r.blocks = r.blocks.map(function (t) {
            var e = n.slice(c, c + t);
            return c += t, r.ec.push(i(e, r.ec_len)), e;
          }), r;
        }

        f = f.map(function (t, e) {
          if (!e) return {};

          for (var r = {}, n = 1; n < 8; n += 2) {
            for (var i = t[0] - t[n], o = t[n + 1], a = s[n / 2 | 0], f = {
              version: e,
              ec_level: a,
              data_len: i,
              ec_len: t[n] / o,
              blocks: [],
              ec: []
            }, u = o, c = i; u > 0; u--) {
              var h = c / u | 0;
              f.blocks.push(h), c -= h;
            }

            r[a] = f;
          }

          return r;
        }), t.exports = {
          QR: function QR(t, e, r) {
            e = s.indexOf(e) > -1 ? e : "M";
            var i = n(t, r),
                a = c(i, u(i, e));
            return o.getMatrix(a);
          },
          getTemplate: u,
          fillTemplate: c
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        function r(t, e, r) {
          for (var n = 1 << e - 1; n; n >>>= 1) {
            t.push(n & r ? 1 : 0);
          }
        }

        var n = function (t) {
          for (var e = {}, r = 0; r < t.length; r++) {
            e[t[r]] = r;
          }

          return e;
        }("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:");

        t.exports = function t(i, o) {
          var a,
              s = typeof i;
          if ("string" == s || "number" == s) i = new e(a = "" + i);else if (e.isBuffer(i)) a = i.toString();else {
            if (!Array.isArray(i)) throw new Error("Bad data");
            a = (i = new e(i)).toString();
          }

          if (/^[0-9]+$/.test(a)) {
            if (i.length > 7089) throw new Error("Too much data");
            return function (t) {
              for (var e = t.length, n = [], i = 0; i < e; i += 3) {
                var o = t.substr(i, 3);
                r(n, Math.ceil(10 * o.length / 3), parseInt(o, 10));
              }

              var a,
                  s = {};
              return r(a = [0, 0, 0, 1], 14, e), s.data27 = a.concat(n), e < 4096 && (r(a = [0, 0, 0, 1], 12, e), s.data10 = a.concat(n)), e < 1024 && (r(a = [0, 0, 0, 1], 10, e), s.data1 = a.concat(n)), s;
            }(a);
          }

          if (/^[0-9A-Z \$%\*\+\.\/\:\-]+$/.test(a)) {
            if (i.length > 4296) throw new Error("Too much data");
            return function (t) {
              for (var e = t.length, i = [], o = 0; o < e; o += 2) {
                var a = 6,
                    s = n[t[o]];
                t[o + 1] && (a = 11, s = 45 * s + n[t[o + 1]]), r(i, a, s);
              }

              var f,
                  u = {};
              return r(f = [0, 0, 1, 0], 13, e), u.data27 = f.concat(i), e < 2048 && (r(f = [0, 0, 1, 0], 11, e), u.data10 = f.concat(i)), e < 512 && (r(f = [0, 0, 1, 0], 9, e), u.data1 = f.concat(i)), u;
            }(a);
          }

          if (o && /^https?:/i.test(a)) return function (e) {
            var r = e.indexOf("/", 8) + 1 || e.length,
                n = t(e.slice(0, r).toUpperCase(), !1);
            if (r >= e.length) return n;
            var i = t(e.slice(r), !1);
            return n.data27 = n.data27.concat(i.data27), n.data10 && i.data10 && (n.data10 = n.data10.concat(i.data10)), n.data1 && i.data1 && (n.data1 = n.data1.concat(i.data1)), n;
          }(a);
          if (i.length > 2953) throw new Error("Too much data");
          return function (t) {
            for (var e = t.length, n = [], i = 0; i < e; i++) {
              r(n, 8, t[i]);
            }

            var o,
                a = {};
            return r(o = [0, 1, 0, 0], 16, e), a.data10 = a.data27 = o.concat(n), e < 256 && (r(o = [0, 1, 0, 0], 8, e), a.data1 = o.concat(n)), a;
          }(i);
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        for (var r = [1], n = [], i = 1; i < 256; i++) {
          var o = r[i - 1] << 1;
          o > 255 && (o ^= 285), r[i] = o;
        }

        for (i = 0; i < 255; i++) {
          n[r[i]] = i;
        }

        function a(t) {
          for (; t < 0;) {
            t += 255;
          }

          for (; t > 255;) {
            t -= 255;
          }

          return r[t];
        }

        function s(t) {
          if (t < 1 || t > 255) throw Error("Bad log(" + t + ")");
          return n[t];
        }

        var f = [[0], [0, 0], [0, 25, 1]];

        t.exports = function (t, r) {
          t = [].slice.call(t);

          for (var n = function t(e) {
            if (f[e]) return f[e];
            var r = t(e - 1),
                n = [];
            n[0] = r[0];

            for (var i = 1; i <= e; i++) {
              n[i] = s(a(r[i]) ^ a(r[i - 1] + e - 1));
            }

            return f[e] = n, n;
          }(r), i = 0; i < r; i++) {
            t.push(0);
          }

          for (; t.length > r;) {
            if (t[0]) {
              var o = s(t[0]);

              for (i = 0; i <= r; i++) {
                t[i] = t[i] ^ a(n[i] + o);
              }

              t.shift();
            } else t.shift();
          }

          return new e(t);
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        function r(t) {
          var r = 4 * t + 17,
              n = [],
              i = new e(r);
          i.fill(0), i = [].slice.call(i);

          for (var o = 0; o < r; o++) {
            n[o] = i.slice();
          }

          return n;
        }

        function n(t) {
          for (var e = t.length, r = -3; r <= 3; r++) {
            for (var n = -3; n <= 3; n++) {
              var i = Math.max(r, n),
                  o = Math.min(r, n),
                  a = 2 == i && o >= -2 || -2 == o && i <= 2 ? 128 : 129;
              t[3 + r][3 + n] = a, t[3 + r][e - 4 + n] = a, t[e - 4 + r][3 + n] = a;
            }
          }

          for (r = 0; r < 8; r++) {
            t[7][r] = t[r][7] = t[7][e - r - 1] = t[r][e - 8] = t[e - 8][r] = t[e - 1 - r][7] = 128;
          }
        }

        function i(t) {
          var e = t.length;

          if (e > 21) {
            var r = e - 13,
                n = Math.round(r / Math.ceil(r / 28));
            n % 2 && n++;

            for (var i = [], o = r + 6; o > 10; o -= n) {
              i.unshift(o);
            }

            i.unshift(6);

            for (var a = 0; a < i.length; a++) {
              for (var s = 0; s < i.length; s++) {
                var f = i[a],
                    u = i[s];
                if (!t[f][u]) for (var c = -2; c <= 2; c++) {
                  for (var h = -2; h <= 2; h++) {
                    var l = Math.max(c, h),
                        d = Math.min(c, h),
                        p = 1 == l && d >= -1 || -1 == d && l <= 1 ? 128 : 129;
                    t[f + c][u + h] = p;
                  }
                }
              }
            }
          }

          for (a = 8; a < e - 8; a++) {
            t[6][a] = t[a][6] = a % 2 ? 128 : 129;
          }
        }

        function o(t) {
          for (var e = t.length, r = 0; r < 8; r++) {
            6 != r && (t[8][r] = t[r][8] = 128), t[8][e - 1 - r] = 128, t[e - 1 - r][8] = 128;
          }

          if (t[8][8] = 128, t[e - 8][8] = 129, !(e < 45)) for (r = e - 11; r < e - 8; r++) {
            for (var n = 0; n < 6; n++) {
              t[r][n] = t[n][r] = 128;
            }
          }
        }

        var a,
            s = function () {
          for (var t = Array(32), e = Array(40), r = 0; r < 32; r++) {
            for (var n = r << 10, i = 5; i > 0; i--) {
              n >>> 9 + i && (n ^= 1335 << i - 1);
            }

            t[r] = 21522 ^ (n | r << 10);
          }

          for (var o = 7; o <= 40; o++) {
            for (n = o << 12, i = 6; i > 0; i--) {
              n >>> 11 + i && (n ^= 7973 << i - 1);
            }

            e[o] = n | o << 12;
          }

          var a = {
            L: 1,
            M: 0,
            Q: 3,
            H: 2
          };
          return function (r, n, i) {
            var o = r.length,
                s = t[a[n] << 3 | i];

            function f(t) {
              return s >> t & 1 ? 129 : 128;
            }

            for (var u = 0; u < 8; u++) {
              r[8][o - 1 - u] = f(u), u < 6 && (r[u][8] = f(u));
            }

            for (u = 8; u < 15; u++) {
              r[o - 15 + u][8] = f(u), u > 8 && (r[8][14 - u] = f(u));
            }

            r[7][8] = f(6), r[8][8] = f(7), r[8][7] = f(8);
            var c = e[(o - 17) / 4];
            if (c) for (u = 0; u < 6; u++) {
              for (var h = 0; h < 3; h++) {
                r[o - 11 + h][u] = r[u][o - 11 + h] = c >> 3 * u + h & 1 ? 129 : 128;
              }
            }
          };
        }(),
            f = (a = [function (t, e) {
          return (t + e) % 2 == 0;
        }, function (t, e) {
          return t % 2 == 0;
        }, function (t, e) {
          return e % 3 == 0;
        }, function (t, e) {
          return (t + e) % 3 == 0;
        }, function (t, e) {
          return (Math.floor(t / 2) + Math.floor(e / 3)) % 2 == 0;
        }, function (t, e) {
          return t * e % 2 + t * e % 3 == 0;
        }, function (t, e) {
          return (t * e % 2 + t * e % 3) % 2 == 0;
        }, function (t, e) {
          return (t * e % 3 + (t + e) % 2) % 2 == 0;
        }], function (t, e, r) {
          var n,
              i,
              o = t.length,
              s = -1;
          n = i = o - 1;

          for (var f = a[r], u = e.blocks[e.blocks.length - 1].length, c = 0; c < u; c++) {
            for (var h = 0; h < e.blocks.length; h++) {
              e.blocks[h].length <= c || l(e.blocks[h][c]);
            }
          }

          for (u = e.ec_len, c = 0; c < u; c++) {
            for (h = 0; h < e.ec.length; h++) {
              l(e.ec[h][c]);
            }
          }

          if (i > -1) do {
            t[n][i] = f(n, i) ? 1 : 0;
          } while (d());

          function l(e) {
            for (var r = 128; r; r >>= 1) {
              var o = !!(r & e);
              f(n, i) && (o = !o), t[n][i] = o ? 1 : 0, d();
            }
          }

          function d() {
            do {
              if (i % 2 ^ i < 6 ? s < 0 && 0 == n || s > 0 && n == o - 1 ? (i--, s = -s) : (i++, n += s) : i--, 6 == i && i--, i < 0) return !1;
            } while (240 & t[n][i]);

            return !0;
          }
        });

        function u(t) {
          for (var e = t.length, r = 0, n = 0; n < e; n++) {
            for (var i = 1 & t[n][0], o = 1, a = 1; a < e; a++) {
              (s = 1 & t[n][a]) != i ? (o >= 5 && (r += o - 2), i = s, o = 1) : o++;
            }

            o >= 5 && (r += o - 2);
          }

          for (a = 0; a < e; a++) {
            for (i = 1 & t[0][a], o = 1, n = 1; n < e; n++) {
              var s;
              (s = 1 & t[n][a]) != i ? (o >= 5 && (r += o - 2), i = s, o = 1) : o++;
            }

            o >= 5 && (r += o - 2);
          }

          for (n = 0; n < e - 1; n++) {
            for (a = 0; a < e - 1; a++) {
              var f = t[n][a] + t[n][a + 1] + t[n + 1][a] + t[n + 1][a + 1] & 7;
              0 != f && 4 != f || (r += 3);
            }
          }

          function u(e) {
            return 1 & t[n][a + e];
          }

          function c(e) {
            return 1 & t[n + e][a];
          }

          for (n = 0; n < e; n++) {
            for (a = 0; a < e; a++) {
              a < e - 6 && u(0) && !u(1) && u(2) && u(3) && u(4) && !u(5) && u(6) && (a >= 4 && !(u(-4) || u(-3) || u(-2) || u(-1)) && (r += 40), a < e - 10 && !(u(7) || u(8) || u(9) || u(10)) && (r += 40)), n < e - 6 && c(0) && !c(1) && c(2) && c(3) && c(4) && !c(5) && c(6) && (n >= 4 && !(c(-4) || c(-3) || c(-2) || c(-1)) && (r += 40), n < e - 10 && !(c(7) || c(8) || c(9) || c(10)) && (r += 40));
            }
          }

          var h = 0;

          for (n = 0; n < e; n++) {
            for (a = 0; a < e; a++) {
              1 & t[n][a] && h++;
            }
          }

          return r += 10 * Math.floor(Math.abs(10 - 20 * h / (e * e)));
        }

        t.exports = {
          getMatrix: function getMatrix(t) {
            var e = r(t.version);
            n(e), i(e), o(e);

            for (var a = 1 / 0, c = 0, h = 0; h < 8; h++) {
              f(e, t, h), s(e, t.ec_level, h);
              var l = u(e);
              l < a && (a = l, c = h);
            }

            return f(e, t, c), s(e, t.ec_level, c), e.map(function (t) {
              return t.map(function (t) {
                return 1 & t;
              });
            });
          },
          init: r,
          fillFinders: n,
          fillAlignAndTiming: i,
          fillStub: o,
          fillReserved: s,
          fillData: f,
          calculatePenalty: u
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        var n = r(44),
            i = r(55),
            o = new e([137, 80, 78, 71, 13, 10, 26, 10]),
            a = new e([0, 0, 0, 13, 73, 72, 68, 82, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0]),
            s = new e([0, 0, 0, 0, 73, 68, 65, 84]),
            f = new e([0, 0, 0, 0, 73, 69, 78, 68, 174, 66, 96, 130]);
        t.exports = {
          bitmap: function bitmap(t, r, n) {
            var i = t.length,
                o = (i + 2 * n) * r,
                a = new e((o + 1) * o);
            a.fill(255);

            for (var s = 0; s < o; s++) {
              a[s * (o + 1)] = 0;
            }

            for (s = 0; s < i; s++) {
              for (var f = 0; f < i; f++) {
                if (t[s][f]) {
                  var u = ((n + s) * (o + 1) + (n + f)) * r + 1;
                  a.fill(0, u, u + r);

                  for (var c = 1; c < r; c++) {
                    a.copy(a, u + c * (o + 1), u, u + r);
                  }
                }
              }
            }

            return {
              data: a,
              size: o
            };
          },
          png: function png(t, r) {
            r.push(o);
            var u = e.concat([a]);
            u.writeUInt32BE(t.size, 8), u.writeUInt32BE(t.size, 12), u.writeUInt32BE(i(u.slice(4, -4)), 21), r.push(u);
            var c = e.concat([s, n.deflateSync(t.data, {
              level: 9
            }), new e(4)]);
            c.writeUInt32BE(c.length - 12, 0), c.writeUInt32BE(i(c.slice(4, -4)), c.length - 4), r.push(c), r.push(f), r.push(null);
          }
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (t) {
        var n = r(0).Buffer,
            i = r(13).Transform,
            o = r(45),
            a = r(20),
            s = r(19).ok,
            f = r(0).kMaxLength,
            u = "Cannot create final Buffer. It would be larger than 0x" + f.toString(16) + " bytes";
        o.Z_MIN_WINDOWBITS = 8, o.Z_MAX_WINDOWBITS = 15, o.Z_DEFAULT_WINDOWBITS = 15, o.Z_MIN_CHUNK = 64, o.Z_MAX_CHUNK = 1 / 0, o.Z_DEFAULT_CHUNK = 16384, o.Z_MIN_MEMLEVEL = 1, o.Z_MAX_MEMLEVEL = 9, o.Z_DEFAULT_MEMLEVEL = 8, o.Z_MIN_LEVEL = -1, o.Z_MAX_LEVEL = 9, o.Z_DEFAULT_LEVEL = o.Z_DEFAULT_COMPRESSION;

        for (var c = Object.keys(o), h = 0; h < c.length; h++) {
          var l = c[h];
          l.match(/^Z/) && Object.defineProperty(e, l, {
            enumerable: !0,
            value: o[l],
            writable: !1
          });
        }

        for (var d = {
          Z_OK: o.Z_OK,
          Z_STREAM_END: o.Z_STREAM_END,
          Z_NEED_DICT: o.Z_NEED_DICT,
          Z_ERRNO: o.Z_ERRNO,
          Z_STREAM_ERROR: o.Z_STREAM_ERROR,
          Z_DATA_ERROR: o.Z_DATA_ERROR,
          Z_MEM_ERROR: o.Z_MEM_ERROR,
          Z_BUF_ERROR: o.Z_BUF_ERROR,
          Z_VERSION_ERROR: o.Z_VERSION_ERROR
        }, p = Object.keys(d), g = 0; g < p.length; g++) {
          var A = p[g];
          d[d[A]] = A;
        }

        function b(t, e, r) {
          var i = [],
              o = 0;

          function a() {
            for (var e; null !== (e = t.read());) {
              i.push(e), o += e.length;
            }

            t.once("readable", a);
          }

          function s() {
            var e,
                a = null;
            o >= f ? a = new RangeError(u) : e = n.concat(i, o), i = [], t.close(), r(a, e);
          }

          t.on("error", function (e) {
            t.removeListener("end", s), t.removeListener("readable", a), r(e);
          }), t.on("end", s), t.end(e), a();
        }

        function v(t, e) {
          if ("string" == typeof e && (e = n.from(e)), !n.isBuffer(e)) throw new TypeError("Not a string or buffer");
          var r = t._finishFlushFlag;
          return t._processChunk(e, r);
        }

        function y(t) {
          if (!(this instanceof y)) return new y(t);
          x.call(this, t, o.DEFLATE);
        }

        function w(t) {
          if (!(this instanceof w)) return new w(t);
          x.call(this, t, o.INFLATE);
        }

        function m(t) {
          if (!(this instanceof m)) return new m(t);
          x.call(this, t, o.GZIP);
        }

        function _(t) {
          if (!(this instanceof _)) return new _(t);
          x.call(this, t, o.GUNZIP);
        }

        function I(t) {
          if (!(this instanceof I)) return new I(t);
          x.call(this, t, o.DEFLATERAW);
        }

        function E(t) {
          if (!(this instanceof E)) return new E(t);
          x.call(this, t, o.INFLATERAW);
        }

        function P(t) {
          if (!(this instanceof P)) return new P(t);
          x.call(this, t, o.UNZIP);
        }

        function S(t) {
          return t === o.Z_NO_FLUSH || t === o.Z_PARTIAL_FLUSH || t === o.Z_SYNC_FLUSH || t === o.Z_FULL_FLUSH || t === o.Z_FINISH || t === o.Z_BLOCK;
        }

        function x(t, r) {
          var a = this;
          if (this._opts = t = t || {}, this._chunkSize = t.chunkSize || e.Z_DEFAULT_CHUNK, i.call(this, t), t.flush && !S(t.flush)) throw new Error("Invalid flush flag: " + t.flush);
          if (t.finishFlush && !S(t.finishFlush)) throw new Error("Invalid flush flag: " + t.finishFlush);
          if (this._flushFlag = t.flush || o.Z_NO_FLUSH, this._finishFlushFlag = void 0 !== t.finishFlush ? t.finishFlush : o.Z_FINISH, t.chunkSize && (t.chunkSize < e.Z_MIN_CHUNK || t.chunkSize > e.Z_MAX_CHUNK)) throw new Error("Invalid chunk size: " + t.chunkSize);
          if (t.windowBits && (t.windowBits < e.Z_MIN_WINDOWBITS || t.windowBits > e.Z_MAX_WINDOWBITS)) throw new Error("Invalid windowBits: " + t.windowBits);
          if (t.level && (t.level < e.Z_MIN_LEVEL || t.level > e.Z_MAX_LEVEL)) throw new Error("Invalid compression level: " + t.level);
          if (t.memLevel && (t.memLevel < e.Z_MIN_MEMLEVEL || t.memLevel > e.Z_MAX_MEMLEVEL)) throw new Error("Invalid memLevel: " + t.memLevel);
          if (t.strategy && t.strategy != e.Z_FILTERED && t.strategy != e.Z_HUFFMAN_ONLY && t.strategy != e.Z_RLE && t.strategy != e.Z_FIXED && t.strategy != e.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + t.strategy);
          if (t.dictionary && !n.isBuffer(t.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
          this._handle = new o.Zlib(r);
          var s = this;
          this._hadError = !1, this._handle.onerror = function (t, r) {
            C(s), s._hadError = !0;
            var n = new Error(t);
            n.errno = r, n.code = e.codes[r], s.emit("error", n);
          };
          var f = e.Z_DEFAULT_COMPRESSION;
          "number" == typeof t.level && (f = t.level);
          var u = e.Z_DEFAULT_STRATEGY;
          "number" == typeof t.strategy && (u = t.strategy), this._handle.init(t.windowBits || e.Z_DEFAULT_WINDOWBITS, f, t.memLevel || e.Z_DEFAULT_MEMLEVEL, u, t.dictionary), this._buffer = n.allocUnsafe(this._chunkSize), this._offset = 0, this._level = f, this._strategy = u, this.once("end", this.close), Object.defineProperty(this, "_closed", {
            get: function get() {
              return !a._handle;
            },
            configurable: !0,
            enumerable: !0
          });
        }

        function C(e, r) {
          r && t.nextTick(r), e._handle && (e._handle.close(), e._handle = null);
        }

        function M(t) {
          t.emit("close");
        }

        Object.defineProperty(e, "codes", {
          enumerable: !0,
          value: Object.freeze(d),
          writable: !1
        }), e.Deflate = y, e.Inflate = w, e.Gzip = m, e.Gunzip = _, e.DeflateRaw = I, e.InflateRaw = E, e.Unzip = P, e.createDeflate = function (t) {
          return new y(t);
        }, e.createInflate = function (t) {
          return new w(t);
        }, e.createDeflateRaw = function (t) {
          return new I(t);
        }, e.createInflateRaw = function (t) {
          return new E(t);
        }, e.createGzip = function (t) {
          return new m(t);
        }, e.createGunzip = function (t) {
          return new _(t);
        }, e.createUnzip = function (t) {
          return new P(t);
        }, e.deflate = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new y(e), t, r);
        }, e.deflateSync = function (t, e) {
          return v(new y(e), t);
        }, e.gzip = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new m(e), t, r);
        }, e.gzipSync = function (t, e) {
          return v(new m(e), t);
        }, e.deflateRaw = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new I(e), t, r);
        }, e.deflateRawSync = function (t, e) {
          return v(new I(e), t);
        }, e.unzip = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new P(e), t, r);
        }, e.unzipSync = function (t, e) {
          return v(new P(e), t);
        }, e.inflate = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new w(e), t, r);
        }, e.inflateSync = function (t, e) {
          return v(new w(e), t);
        }, e.gunzip = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new _(e), t, r);
        }, e.gunzipSync = function (t, e) {
          return v(new _(e), t);
        }, e.inflateRaw = function (t, e, r) {
          return "function" == typeof e && (r = e, e = {}), b(new E(e), t, r);
        }, e.inflateRawSync = function (t, e) {
          return v(new E(e), t);
        }, a.inherits(x, i), x.prototype.params = function (r, n, i) {
          if (r < e.Z_MIN_LEVEL || r > e.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + r);
          if (n != e.Z_FILTERED && n != e.Z_HUFFMAN_ONLY && n != e.Z_RLE && n != e.Z_FIXED && n != e.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + n);

          if (this._level !== r || this._strategy !== n) {
            var a = this;
            this.flush(o.Z_SYNC_FLUSH, function () {
              s(a._handle, "zlib binding closed"), a._handle.params(r, n), a._hadError || (a._level = r, a._strategy = n, i && i());
            });
          } else t.nextTick(i);
        }, x.prototype.reset = function () {
          return s(this._handle, "zlib binding closed"), this._handle.reset();
        }, x.prototype._flush = function (t) {
          this._transform(n.alloc(0), "", t);
        }, x.prototype.flush = function (e, r) {
          var i = this,
              a = this._writableState;
          ("function" == typeof e || void 0 === e && !r) && (r = e, e = o.Z_FULL_FLUSH), a.ended ? r && t.nextTick(r) : a.ending ? r && this.once("end", r) : a.needDrain ? r && this.once("drain", function () {
            return i.flush(e, r);
          }) : (this._flushFlag = e, this.write(n.alloc(0), "", r));
        }, x.prototype.close = function (e) {
          C(this, e), t.nextTick(M, this);
        }, x.prototype._transform = function (t, e, r) {
          var i,
              a = this._writableState,
              s = (a.ending || a.ended) && (!t || a.length === t.length);
          return null === t || n.isBuffer(t) ? this._handle ? (s ? i = this._finishFlushFlag : (i = this._flushFlag, t.length >= a.length && (this._flushFlag = this._opts.flush || o.Z_NO_FLUSH)), void this._processChunk(t, i, r)) : r(new Error("zlib binding closed")) : r(new Error("invalid input"));
        }, x.prototype._processChunk = function (t, e, r) {
          var i = t && t.length,
              o = this._chunkSize - this._offset,
              a = 0,
              c = this,
              h = "function" == typeof r;

          if (!h) {
            var l,
                d = [],
                p = 0;
            this.on("error", function (t) {
              l = t;
            }), s(this._handle, "zlib binding closed");

            do {
              var g = this._handle.writeSync(e, t, a, i, this._buffer, this._offset, o);
            } while (!this._hadError && v(g[0], g[1]));

            if (this._hadError) throw l;
            if (p >= f) throw C(this), new RangeError(u);
            var A = n.concat(d, p);
            return C(this), A;
          }

          s(this._handle, "zlib binding closed");

          var b = this._handle.write(e, t, a, i, this._buffer, this._offset, o);

          function v(f, u) {
            if (this && (this.buffer = null, this.callback = null), !c._hadError) {
              var l = o - u;

              if (s(l >= 0, "have should not go down"), l > 0) {
                var g = c._buffer.slice(c._offset, c._offset + l);

                c._offset += l, h ? c.push(g) : (d.push(g), p += g.length);
              }

              if ((0 === u || c._offset >= c._chunkSize) && (o = c._chunkSize, c._offset = 0, c._buffer = n.allocUnsafe(c._chunkSize)), 0 === u) {
                if (a += i - f, i = f, !h) return !0;

                var A = c._handle.write(e, t, a, i, c._buffer, c._offset, c._chunkSize);

                return A.callback = v, void (A.buffer = t);
              }

              if (!h) return !1;
              r();
            }
          }

          b.buffer = t, b.callback = v;
        }, a.inherits(y, x), a.inherits(w, x), a.inherits(m, x), a.inherits(_, x), a.inherits(I, x), a.inherits(E, x), a.inherits(P, x);
      }).call(this, r(1));
    }, function (t, e, r) {
      "use strict";

      (function (t, n) {
        var i = r(19),
            o = r(47),
            a = r(48),
            s = r(51),
            f = r(54);

        for (var u in f) {
          e[u] = f[u];
        }

        function c(t) {
          if ("number" != typeof t || t < e.DEFLATE || t > e.UNZIP) throw new TypeError("Bad argument");
          this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = t, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
        }

        e.NONE = 0, e.DEFLATE = 1, e.INFLATE = 2, e.GZIP = 3, e.GUNZIP = 4, e.DEFLATERAW = 5, e.INFLATERAW = 6, e.UNZIP = 7, c.prototype.close = function () {
          this.write_in_progress ? this.pending_close = !0 : (this.pending_close = !1, i(this.init_done, "close before init"), i(this.mode <= e.UNZIP), this.mode === e.DEFLATE || this.mode === e.GZIP || this.mode === e.DEFLATERAW ? a.deflateEnd(this.strm) : this.mode !== e.INFLATE && this.mode !== e.GUNZIP && this.mode !== e.INFLATERAW && this.mode !== e.UNZIP || s.inflateEnd(this.strm), this.mode = e.NONE, this.dictionary = null);
        }, c.prototype.write = function (t, e, r, n, i, o, a) {
          return this._write(!0, t, e, r, n, i, o, a);
        }, c.prototype.writeSync = function (t, e, r, n, i, o, a) {
          return this._write(!1, t, e, r, n, i, o, a);
        }, c.prototype._write = function (r, o, a, s, f, u, c, h) {
          if (i.equal(arguments.length, 8), i(this.init_done, "write before init"), i(this.mode !== e.NONE, "already finalized"), i.equal(!1, this.write_in_progress, "write already in progress"), i.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, i.equal(!1, void 0 === o, "must provide flush value"), this.write_in_progress = !0, o !== e.Z_NO_FLUSH && o !== e.Z_PARTIAL_FLUSH && o !== e.Z_SYNC_FLUSH && o !== e.Z_FULL_FLUSH && o !== e.Z_FINISH && o !== e.Z_BLOCK) throw new Error("Invalid flush value");
          if (null == a && (a = t.alloc(0), f = 0, s = 0), this.strm.avail_in = f, this.strm.input = a, this.strm.next_in = s, this.strm.avail_out = h, this.strm.output = u, this.strm.next_out = c, this.flush = o, !r) return this._process(), this._checkError() ? this._afterSync() : void 0;
          var l = this;
          return n.nextTick(function () {
            l._process(), l._after();
          }), this;
        }, c.prototype._afterSync = function () {
          var t = this.strm.avail_out,
              e = this.strm.avail_in;
          return this.write_in_progress = !1, [e, t];
        }, c.prototype._process = function () {
          var t = null;

          switch (this.mode) {
            case e.DEFLATE:
            case e.GZIP:
            case e.DEFLATERAW:
              this.err = a.deflate(this.strm, this.flush);
              break;

            case e.UNZIP:
              switch (this.strm.avail_in > 0 && (t = this.strm.next_in), this.gzip_id_bytes_read) {
                case 0:
                  if (null === t) break;

                  if (31 !== this.strm.input[t]) {
                    this.mode = e.INFLATE;
                    break;
                  }

                  if (this.gzip_id_bytes_read = 1, t++, 1 === this.strm.avail_in) break;

                case 1:
                  if (null === t) break;
                  139 === this.strm.input[t] ? (this.gzip_id_bytes_read = 2, this.mode = e.GUNZIP) : this.mode = e.INFLATE;
                  break;

                default:
                  throw new Error("invalid number of gzip magic number bytes read");
              }

            case e.INFLATE:
            case e.GUNZIP:
            case e.INFLATERAW:
              for (this.err = s.inflate(this.strm, this.flush), this.err === e.Z_NEED_DICT && this.dictionary && (this.err = s.inflateSetDictionary(this.strm, this.dictionary), this.err === e.Z_OK ? this.err = s.inflate(this.strm, this.flush) : this.err === e.Z_DATA_ERROR && (this.err = e.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === e.GUNZIP && this.err === e.Z_STREAM_END && 0 !== this.strm.next_in[0];) {
                this.reset(), this.err = s.inflate(this.strm, this.flush);
              }

              break;

            default:
              throw new Error("Unknown mode " + this.mode);
          }
        }, c.prototype._checkError = function () {
          switch (this.err) {
            case e.Z_OK:
            case e.Z_BUF_ERROR:
              if (0 !== this.strm.avail_out && this.flush === e.Z_FINISH) return this._error("unexpected end of file"), !1;
              break;

            case e.Z_STREAM_END:
              break;

            case e.Z_NEED_DICT:
              return null == this.dictionary ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;

            default:
              return this._error("Zlib error"), !1;
          }

          return !0;
        }, c.prototype._after = function () {
          if (this._checkError()) {
            var t = this.strm.avail_out,
                e = this.strm.avail_in;
            this.write_in_progress = !1, this.callback(e, t), this.pending_close && this.close();
          }
        }, c.prototype._error = function (t) {
          this.strm.msg && (t = this.strm.msg), this.onerror(t, this.err), this.write_in_progress = !1, this.pending_close && this.close();
        }, c.prototype.init = function (t, r, n, o, a) {
          i(4 === arguments.length || 5 === arguments.length, "init(windowBits, level, memLevel, strategy, [dictionary])"), i(t >= 8 && t <= 15, "invalid windowBits"), i(r >= -1 && r <= 9, "invalid compression level"), i(n >= 1 && n <= 9, "invalid memlevel"), i(o === e.Z_FILTERED || o === e.Z_HUFFMAN_ONLY || o === e.Z_RLE || o === e.Z_FIXED || o === e.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(r, t, n, o, a), this._setDictionary();
        }, c.prototype.params = function () {
          throw new Error("deflateParams Not supported");
        }, c.prototype.reset = function () {
          this._reset(), this._setDictionary();
        }, c.prototype._init = function (t, r, n, i, f) {
          switch (this.level = t, this.windowBits = r, this.memLevel = n, this.strategy = i, this.flush = e.Z_NO_FLUSH, this.err = e.Z_OK, this.mode !== e.GZIP && this.mode !== e.GUNZIP || (this.windowBits += 16), this.mode === e.UNZIP && (this.windowBits += 32), this.mode !== e.DEFLATERAW && this.mode !== e.INFLATERAW || (this.windowBits = -1 * this.windowBits), this.strm = new o(), this.mode) {
            case e.DEFLATE:
            case e.GZIP:
            case e.DEFLATERAW:
              this.err = a.deflateInit2(this.strm, this.level, e.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
              break;

            case e.INFLATE:
            case e.GUNZIP:
            case e.INFLATERAW:
            case e.UNZIP:
              this.err = s.inflateInit2(this.strm, this.windowBits);
              break;

            default:
              throw new Error("Unknown mode " + this.mode);
          }

          this.err !== e.Z_OK && this._error("Init error"), this.dictionary = f, this.write_in_progress = !1, this.init_done = !0;
        }, c.prototype._setDictionary = function () {
          if (null != this.dictionary) {
            switch (this.err = e.Z_OK, this.mode) {
              case e.DEFLATE:
              case e.DEFLATERAW:
                this.err = a.deflateSetDictionary(this.strm, this.dictionary);
            }

            this.err !== e.Z_OK && this._error("Failed to set dictionary");
          }
        }, c.prototype._reset = function () {
          switch (this.err = e.Z_OK, this.mode) {
            case e.DEFLATE:
            case e.DEFLATERAW:
            case e.GZIP:
              this.err = a.deflateReset(this.strm);
              break;

            case e.INFLATE:
            case e.INFLATERAW:
            case e.GUNZIP:
              this.err = s.inflateReset(this.strm);
          }

          this.err !== e.Z_OK && this._error("Failed to reset stream");
        }, e.Zlib = c;
      }).call(this, r(0).Buffer, r(1));
    }, function (t, e) {
      t.exports = function (t) {
        return t && "object" == typeof t && "function" == typeof t.copy && "function" == typeof t.fill && "function" == typeof t.readUInt8;
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = function () {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, function (t, e, r) {
      "use strict";

      var n,
          i = r(8),
          o = r(49),
          a = r(21),
          s = r(22),
          f = r(50),
          u = 0,
          c = 4,
          h = 0,
          l = -2,
          d = -1,
          p = 1,
          g = 4,
          A = 2,
          b = 8,
          v = 9,
          y = 286,
          w = 30,
          m = 19,
          _ = 2 * y + 1,
          I = 15,
          E = 3,
          P = 258,
          S = P + E + 1,
          x = 42,
          C = 103,
          M = 113,
          T = 666,
          k = 1,
          R = 2,
          B = 3,
          L = 4;

      function O(t, e) {
        return t.msg = f[e], e;
      }

      function j(t) {
        return (t << 1) - (t > 4 ? 9 : 0);
      }

      function D(t) {
        for (var e = t.length; --e >= 0;) {
          t[e] = 0;
        }
      }

      function H(t) {
        var e = t.state,
            r = e.pending;
        r > t.avail_out && (r = t.avail_out), 0 !== r && (i.arraySet(t.output, e.pending_buf, e.pending_out, r, t.next_out), t.next_out += r, e.pending_out += r, t.total_out += r, t.avail_out -= r, e.pending -= r, 0 === e.pending && (e.pending_out = 0));
      }

      function z(t, e) {
        o._tr_flush_block(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, H(t.strm);
      }

      function N(t, e) {
        t.pending_buf[t.pending++] = e;
      }

      function q(t, e) {
        t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = 255 & e;
      }

      function U(t, e) {
        var r,
            n,
            i = t.max_chain_length,
            o = t.strstart,
            a = t.prev_length,
            s = t.nice_match,
            f = t.strstart > t.w_size - S ? t.strstart - (t.w_size - S) : 0,
            u = t.window,
            c = t.w_mask,
            h = t.prev,
            l = t.strstart + P,
            d = u[o + a - 1],
            p = u[o + a];
        t.prev_length >= t.good_match && (i >>= 2), s > t.lookahead && (s = t.lookahead);

        do {
          if (u[(r = e) + a] === p && u[r + a - 1] === d && u[r] === u[o] && u[++r] === u[o + 1]) {
            o += 2, r++;

            do {} while (u[++o] === u[++r] && u[++o] === u[++r] && u[++o] === u[++r] && u[++o] === u[++r] && u[++o] === u[++r] && u[++o] === u[++r] && u[++o] === u[++r] && u[++o] === u[++r] && o < l);

            if (n = P - (l - o), o = l - P, n > a) {
              if (t.match_start = e, a = n, n >= s) break;
              d = u[o + a - 1], p = u[o + a];
            }
          }
        } while ((e = h[e & c]) > f && 0 != --i);

        return a <= t.lookahead ? a : t.lookahead;
      }

      function V(t) {
        var e,
            r,
            n,
            o,
            f,
            u,
            c,
            h,
            l,
            d,
            p = t.w_size;

        do {
          if (o = t.window_size - t.lookahead - t.strstart, t.strstart >= p + (p - S)) {
            i.arraySet(t.window, t.window, p, p, 0), t.match_start -= p, t.strstart -= p, t.block_start -= p, e = r = t.hash_size;

            do {
              n = t.head[--e], t.head[e] = n >= p ? n - p : 0;
            } while (--r);

            e = r = p;

            do {
              n = t.prev[--e], t.prev[e] = n >= p ? n - p : 0;
            } while (--r);

            o += p;
          }

          if (0 === t.strm.avail_in) break;
          if (u = t.strm, c = t.window, h = t.strstart + t.lookahead, l = o, d = void 0, (d = u.avail_in) > l && (d = l), r = 0 === d ? 0 : (u.avail_in -= d, i.arraySet(c, u.input, u.next_in, d, h), 1 === u.state.wrap ? u.adler = a(u.adler, c, d, h) : 2 === u.state.wrap && (u.adler = s(u.adler, c, d, h)), u.next_in += d, u.total_in += d, d), t.lookahead += r, t.lookahead + t.insert >= E) for (f = t.strstart - t.insert, t.ins_h = t.window[f], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[f + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[f + E - 1]) & t.hash_mask, t.prev[f & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = f, f++, t.insert--, !(t.lookahead + t.insert < E));) {
            ;
          }
        } while (t.lookahead < S && 0 !== t.strm.avail_in);
      }

      function W(t, e) {
        for (var r, n;;) {
          if (t.lookahead < S) {
            if (V(t), t.lookahead < S && e === u) return k;
            if (0 === t.lookahead) break;
          }

          if (r = 0, t.lookahead >= E && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + E - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 !== r && t.strstart - r <= t.w_size - S && (t.match_length = U(t, r)), t.match_length >= E) {
            if (n = o._tr_tally(t, t.strstart - t.match_start, t.match_length - E), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= E) {
              t.match_length--;

              do {
                t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + E - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart;
              } while (0 != --t.match_length);

              t.strstart++;
            } else t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
          } else n = o._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
          if (n && (z(t, !1), 0 === t.strm.avail_out)) return k;
        }

        return t.insert = t.strstart < E - 1 ? t.strstart : E - 1, e === c ? (z(t, !0), 0 === t.strm.avail_out ? B : L) : t.last_lit && (z(t, !1), 0 === t.strm.avail_out) ? k : R;
      }

      function Y(t, e) {
        for (var r, n, i;;) {
          if (t.lookahead < S) {
            if (V(t), t.lookahead < S && e === u) return k;
            if (0 === t.lookahead) break;
          }

          if (r = 0, t.lookahead >= E && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + E - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = E - 1, 0 !== r && t.prev_length < t.max_lazy_match && t.strstart - r <= t.w_size - S && (t.match_length = U(t, r), t.match_length <= 5 && (t.strategy === p || t.match_length === E && t.strstart - t.match_start > 4096) && (t.match_length = E - 1)), t.prev_length >= E && t.match_length <= t.prev_length) {
            i = t.strstart + t.lookahead - E, n = o._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - E), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;

            do {
              ++t.strstart <= i && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + E - 1]) & t.hash_mask, r = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart);
            } while (0 != --t.prev_length);

            if (t.match_available = 0, t.match_length = E - 1, t.strstart++, n && (z(t, !1), 0 === t.strm.avail_out)) return k;
          } else if (t.match_available) {
            if ((n = o._tr_tally(t, 0, t.window[t.strstart - 1])) && z(t, !1), t.strstart++, t.lookahead--, 0 === t.strm.avail_out) return k;
          } else t.match_available = 1, t.strstart++, t.lookahead--;
        }

        return t.match_available && (n = o._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < E - 1 ? t.strstart : E - 1, e === c ? (z(t, !0), 0 === t.strm.avail_out ? B : L) : t.last_lit && (z(t, !1), 0 === t.strm.avail_out) ? k : R;
      }

      function F(t, e, r, n, i) {
        this.good_length = t, this.max_lazy = e, this.nice_length = r, this.max_chain = n, this.func = i;
      }

      function Z() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = b, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(2 * _), this.dyn_dtree = new i.Buf16(2 * (2 * w + 1)), this.bl_tree = new i.Buf16(2 * (2 * m + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(I + 1), this.heap = new i.Buf16(2 * y + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(2 * y + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }

      function X(t) {
        var e;
        return t && t.state ? (t.total_in = t.total_out = 0, t.data_type = A, (e = t.state).pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? x : M, t.adler = 2 === e.wrap ? 0 : 1, e.last_flush = u, o._tr_init(e), h) : O(t, l);
      }

      function K(t) {
        var e,
            r = X(t);
        return r === h && ((e = t.state).window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = E - 1, e.match_available = 0, e.ins_h = 0), r;
      }

      function J(t, e, r, n, o, a) {
        if (!t) return l;
        var s = 1;
        if (e === d && (e = 6), n < 0 ? (s = 0, n = -n) : n > 15 && (s = 2, n -= 16), o < 1 || o > v || r !== b || n < 8 || n > 15 || e < 0 || e > 9 || a < 0 || a > g) return O(t, l);
        8 === n && (n = 9);
        var f = new Z();
        return t.state = f, f.strm = t, f.wrap = s, f.gzhead = null, f.w_bits = n, f.w_size = 1 << f.w_bits, f.w_mask = f.w_size - 1, f.hash_bits = o + 7, f.hash_size = 1 << f.hash_bits, f.hash_mask = f.hash_size - 1, f.hash_shift = ~~((f.hash_bits + E - 1) / E), f.window = new i.Buf8(2 * f.w_size), f.head = new i.Buf16(f.hash_size), f.prev = new i.Buf16(f.w_size), f.lit_bufsize = 1 << o + 6, f.pending_buf_size = 4 * f.lit_bufsize, f.pending_buf = new i.Buf8(f.pending_buf_size), f.d_buf = 1 * f.lit_bufsize, f.l_buf = 3 * f.lit_bufsize, f.level = e, f.strategy = a, f.method = r, K(t);
      }

      n = [new F(0, 0, 0, 0, function (t, e) {
        var r = 65535;

        for (r > t.pending_buf_size - 5 && (r = t.pending_buf_size - 5);;) {
          if (t.lookahead <= 1) {
            if (V(t), 0 === t.lookahead && e === u) return k;
            if (0 === t.lookahead) break;
          }

          t.strstart += t.lookahead, t.lookahead = 0;
          var n = t.block_start + r;
          if ((0 === t.strstart || t.strstart >= n) && (t.lookahead = t.strstart - n, t.strstart = n, z(t, !1), 0 === t.strm.avail_out)) return k;
          if (t.strstart - t.block_start >= t.w_size - S && (z(t, !1), 0 === t.strm.avail_out)) return k;
        }

        return t.insert = 0, e === c ? (z(t, !0), 0 === t.strm.avail_out ? B : L) : (t.strstart > t.block_start && (z(t, !1), t.strm.avail_out), k);
      }), new F(4, 4, 8, 4, W), new F(4, 5, 16, 8, W), new F(4, 6, 32, 32, W), new F(4, 4, 16, 16, Y), new F(8, 16, 32, 32, Y), new F(8, 16, 128, 128, Y), new F(8, 32, 128, 256, Y), new F(32, 128, 258, 1024, Y), new F(32, 258, 258, 4096, Y)], e.deflateInit = function (t, e) {
        return J(t, e, b, 15, 8, 0);
      }, e.deflateInit2 = J, e.deflateReset = K, e.deflateResetKeep = X, e.deflateSetHeader = function (t, e) {
        return t && t.state ? 2 !== t.state.wrap ? l : (t.state.gzhead = e, h) : l;
      }, e.deflate = function (t, e) {
        var r, i, a, f;
        if (!t || !t.state || e > 5 || e < 0) return t ? O(t, l) : l;
        if (i = t.state, !t.output || !t.input && 0 !== t.avail_in || i.status === T && e !== c) return O(t, 0 === t.avail_out ? -5 : l);
        if (i.strm = t, r = i.last_flush, i.last_flush = e, i.status === x) if (2 === i.wrap) t.adler = 0, N(i, 31), N(i, 139), N(i, 8), i.gzhead ? (N(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), N(i, 255 & i.gzhead.time), N(i, i.gzhead.time >> 8 & 255), N(i, i.gzhead.time >> 16 & 255), N(i, i.gzhead.time >> 24 & 255), N(i, 9 === i.level ? 2 : i.strategy >= 2 || i.level < 2 ? 4 : 0), N(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (N(i, 255 & i.gzhead.extra.length), N(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (t.adler = s(t.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (N(i, 0), N(i, 0), N(i, 0), N(i, 0), N(i, 0), N(i, 9 === i.level ? 2 : i.strategy >= 2 || i.level < 2 ? 4 : 0), N(i, 3), i.status = M);else {
          var d = b + (i.w_bits - 8 << 4) << 8;
          d |= (i.strategy >= 2 || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (d |= 32), d += 31 - d % 31, i.status = M, q(i, d), 0 !== i.strstart && (q(i, t.adler >>> 16), q(i, 65535 & t.adler)), t.adler = 1;
        }
        if (69 === i.status) if (i.gzhead.extra) {
          for (a = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > a && (t.adler = s(t.adler, i.pending_buf, i.pending - a, a)), H(t), a = i.pending, i.pending !== i.pending_buf_size));) {
            N(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
          }

          i.gzhead.hcrc && i.pending > a && (t.adler = s(t.adler, i.pending_buf, i.pending - a, a)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
        } else i.status = 73;
        if (73 === i.status) if (i.gzhead.name) {
          a = i.pending;

          do {
            if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (t.adler = s(t.adler, i.pending_buf, i.pending - a, a)), H(t), a = i.pending, i.pending === i.pending_buf_size)) {
              f = 1;
              break;
            }

            f = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, N(i, f);
          } while (0 !== f);

          i.gzhead.hcrc && i.pending > a && (t.adler = s(t.adler, i.pending_buf, i.pending - a, a)), 0 === f && (i.gzindex = 0, i.status = 91);
        } else i.status = 91;
        if (91 === i.status) if (i.gzhead.comment) {
          a = i.pending;

          do {
            if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > a && (t.adler = s(t.adler, i.pending_buf, i.pending - a, a)), H(t), a = i.pending, i.pending === i.pending_buf_size)) {
              f = 1;
              break;
            }

            f = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, N(i, f);
          } while (0 !== f);

          i.gzhead.hcrc && i.pending > a && (t.adler = s(t.adler, i.pending_buf, i.pending - a, a)), 0 === f && (i.status = C);
        } else i.status = C;

        if (i.status === C && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && H(t), i.pending + 2 <= i.pending_buf_size && (N(i, 255 & t.adler), N(i, t.adler >> 8 & 255), t.adler = 0, i.status = M)) : i.status = M), 0 !== i.pending) {
          if (H(t), 0 === t.avail_out) return i.last_flush = -1, h;
        } else if (0 === t.avail_in && j(e) <= j(r) && e !== c) return O(t, -5);

        if (i.status === T && 0 !== t.avail_in) return O(t, -5);

        if (0 !== t.avail_in || 0 !== i.lookahead || e !== u && i.status !== T) {
          var p = 2 === i.strategy ? function (t, e) {
            for (var r;;) {
              if (0 === t.lookahead && (V(t), 0 === t.lookahead)) {
                if (e === u) return k;
                break;
              }

              if (t.match_length = 0, r = o._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, r && (z(t, !1), 0 === t.strm.avail_out)) return k;
            }

            return t.insert = 0, e === c ? (z(t, !0), 0 === t.strm.avail_out ? B : L) : t.last_lit && (z(t, !1), 0 === t.strm.avail_out) ? k : R;
          }(i, e) : 3 === i.strategy ? function (t, e) {
            for (var r, n, i, a, s = t.window;;) {
              if (t.lookahead <= P) {
                if (V(t), t.lookahead <= P && e === u) return k;
                if (0 === t.lookahead) break;
              }

              if (t.match_length = 0, t.lookahead >= E && t.strstart > 0 && (n = s[i = t.strstart - 1]) === s[++i] && n === s[++i] && n === s[++i]) {
                a = t.strstart + P;

                do {} while (n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && n === s[++i] && i < a);

                t.match_length = P - (a - i), t.match_length > t.lookahead && (t.match_length = t.lookahead);
              }

              if (t.match_length >= E ? (r = o._tr_tally(t, 1, t.match_length - E), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (r = o._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), r && (z(t, !1), 0 === t.strm.avail_out)) return k;
            }

            return t.insert = 0, e === c ? (z(t, !0), 0 === t.strm.avail_out ? B : L) : t.last_lit && (z(t, !1), 0 === t.strm.avail_out) ? k : R;
          }(i, e) : n[i.level].func(i, e);
          if (p !== B && p !== L || (i.status = T), p === k || p === B) return 0 === t.avail_out && (i.last_flush = -1), h;
          if (p === R && (1 === e ? o._tr_align(i) : 5 !== e && (o._tr_stored_block(i, 0, 0, !1), 3 === e && (D(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), H(t), 0 === t.avail_out)) return i.last_flush = -1, h;
        }

        return e !== c ? h : i.wrap <= 0 ? 1 : (2 === i.wrap ? (N(i, 255 & t.adler), N(i, t.adler >> 8 & 255), N(i, t.adler >> 16 & 255), N(i, t.adler >> 24 & 255), N(i, 255 & t.total_in), N(i, t.total_in >> 8 & 255), N(i, t.total_in >> 16 & 255), N(i, t.total_in >> 24 & 255)) : (q(i, t.adler >>> 16), q(i, 65535 & t.adler)), H(t), i.wrap > 0 && (i.wrap = -i.wrap), 0 !== i.pending ? h : 1);
      }, e.deflateEnd = function (t) {
        var e;
        return t && t.state ? (e = t.state.status) !== x && 69 !== e && 73 !== e && 91 !== e && e !== C && e !== M && e !== T ? O(t, l) : (t.state = null, e === M ? O(t, -3) : h) : l;
      }, e.deflateSetDictionary = function (t, e) {
        var r,
            n,
            o,
            s,
            f,
            u,
            c,
            d,
            p = e.length;
        if (!t || !t.state) return l;
        if (2 === (s = (r = t.state).wrap) || 1 === s && r.status !== x || r.lookahead) return l;

        for (1 === s && (t.adler = a(t.adler, e, p, 0)), r.wrap = 0, p >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), d = new i.Buf8(r.w_size), i.arraySet(d, e, p - r.w_size, r.w_size, 0), e = d, p = r.w_size), f = t.avail_in, u = t.next_in, c = t.input, t.avail_in = p, t.next_in = 0, t.input = e, V(r); r.lookahead >= E;) {
          n = r.strstart, o = r.lookahead - (E - 1);

          do {
            r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + E - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++;
          } while (--o);

          r.strstart = n, r.lookahead = E - 1, V(r);
        }

        return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = E - 1, r.match_available = 0, t.next_in = u, t.input = c, t.avail_in = f, r.wrap = s, h;
      }, e.deflateInfo = "pako deflate (from Nodeca project)";
    }, function (t, e, r) {
      "use strict";

      var n = r(8);

      function i(t) {
        for (var e = t.length; --e >= 0;) {
          t[e] = 0;
        }
      }

      var o = 0,
          a = 256,
          s = a + 1 + 29,
          f = 30,
          u = 19,
          c = 2 * s + 1,
          h = 15,
          l = 16,
          d = 256,
          p = 16,
          g = 17,
          A = 18,
          b = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
          v = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
          y = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
          w = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
          m = new Array(2 * (s + 2));
      i(m);

      var _ = new Array(2 * f);

      i(_);
      var I = new Array(512);
      i(I);
      var E = new Array(256);
      i(E);
      var P = new Array(29);
      i(P);
      var S,
          x,
          C,
          M = new Array(f);

      function T(t, e, r, n, i) {
        this.static_tree = t, this.extra_bits = e, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = t && t.length;
      }

      function k(t, e) {
        this.dyn_tree = t, this.max_code = 0, this.stat_desc = e;
      }

      function R(t) {
        return t < 256 ? I[t] : I[256 + (t >>> 7)];
      }

      function B(t, e) {
        t.pending_buf[t.pending++] = 255 & e, t.pending_buf[t.pending++] = e >>> 8 & 255;
      }

      function L(t, e, r) {
        t.bi_valid > l - r ? (t.bi_buf |= e << t.bi_valid & 65535, B(t, t.bi_buf), t.bi_buf = e >> l - t.bi_valid, t.bi_valid += r - l) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += r);
      }

      function O(t, e, r) {
        L(t, r[2 * e], r[2 * e + 1]);
      }

      function j(t, e) {
        var r = 0;

        do {
          r |= 1 & t, t >>>= 1, r <<= 1;
        } while (--e > 0);

        return r >>> 1;
      }

      function D(t, e, r) {
        var n,
            i,
            o = new Array(h + 1),
            a = 0;

        for (n = 1; n <= h; n++) {
          o[n] = a = a + r[n - 1] << 1;
        }

        for (i = 0; i <= e; i++) {
          var s = t[2 * i + 1];
          0 !== s && (t[2 * i] = j(o[s]++, s));
        }
      }

      function H(t) {
        var e;

        for (e = 0; e < s; e++) {
          t.dyn_ltree[2 * e] = 0;
        }

        for (e = 0; e < f; e++) {
          t.dyn_dtree[2 * e] = 0;
        }

        for (e = 0; e < u; e++) {
          t.bl_tree[2 * e] = 0;
        }

        t.dyn_ltree[2 * d] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0;
      }

      function z(t) {
        t.bi_valid > 8 ? B(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0;
      }

      function N(t, e, r, n) {
        var i = 2 * e,
            o = 2 * r;
        return t[i] < t[o] || t[i] === t[o] && n[e] <= n[r];
      }

      function q(t, e, r) {
        for (var n = t.heap[r], i = r << 1; i <= t.heap_len && (i < t.heap_len && N(e, t.heap[i + 1], t.heap[i], t.depth) && i++, !N(e, n, t.heap[i], t.depth));) {
          t.heap[r] = t.heap[i], r = i, i <<= 1;
        }

        t.heap[r] = n;
      }

      function U(t, e, r) {
        var n,
            i,
            o,
            s,
            f = 0;
        if (0 !== t.last_lit) do {
          n = t.pending_buf[t.d_buf + 2 * f] << 8 | t.pending_buf[t.d_buf + 2 * f + 1], i = t.pending_buf[t.l_buf + f], f++, 0 === n ? O(t, i, e) : (O(t, (o = E[i]) + a + 1, e), 0 !== (s = b[o]) && L(t, i -= P[o], s), O(t, o = R(--n), r), 0 !== (s = v[o]) && L(t, n -= M[o], s));
        } while (f < t.last_lit);
        O(t, d, e);
      }

      function V(t, e) {
        var r,
            n,
            i,
            o = e.dyn_tree,
            a = e.stat_desc.static_tree,
            s = e.stat_desc.has_stree,
            f = e.stat_desc.elems,
            u = -1;

        for (t.heap_len = 0, t.heap_max = c, r = 0; r < f; r++) {
          0 !== o[2 * r] ? (t.heap[++t.heap_len] = u = r, t.depth[r] = 0) : o[2 * r + 1] = 0;
        }

        for (; t.heap_len < 2;) {
          o[2 * (i = t.heap[++t.heap_len] = u < 2 ? ++u : 0)] = 1, t.depth[i] = 0, t.opt_len--, s && (t.static_len -= a[2 * i + 1]);
        }

        for (e.max_code = u, r = t.heap_len >> 1; r >= 1; r--) {
          q(t, o, r);
        }

        i = f;

        do {
          r = t.heap[1], t.heap[1] = t.heap[t.heap_len--], q(t, o, 1), n = t.heap[1], t.heap[--t.heap_max] = r, t.heap[--t.heap_max] = n, o[2 * i] = o[2 * r] + o[2 * n], t.depth[i] = (t.depth[r] >= t.depth[n] ? t.depth[r] : t.depth[n]) + 1, o[2 * r + 1] = o[2 * n + 1] = i, t.heap[1] = i++, q(t, o, 1);
        } while (t.heap_len >= 2);

        t.heap[--t.heap_max] = t.heap[1], function (t, e) {
          var r,
              n,
              i,
              o,
              a,
              s,
              f = e.dyn_tree,
              u = e.max_code,
              l = e.stat_desc.static_tree,
              d = e.stat_desc.has_stree,
              p = e.stat_desc.extra_bits,
              g = e.stat_desc.extra_base,
              A = e.stat_desc.max_length,
              b = 0;

          for (o = 0; o <= h; o++) {
            t.bl_count[o] = 0;
          }

          for (f[2 * t.heap[t.heap_max] + 1] = 0, r = t.heap_max + 1; r < c; r++) {
            (o = f[2 * f[2 * (n = t.heap[r]) + 1] + 1] + 1) > A && (o = A, b++), f[2 * n + 1] = o, n > u || (t.bl_count[o]++, a = 0, n >= g && (a = p[n - g]), s = f[2 * n], t.opt_len += s * (o + a), d && (t.static_len += s * (l[2 * n + 1] + a)));
          }

          if (0 !== b) {
            do {
              for (o = A - 1; 0 === t.bl_count[o];) {
                o--;
              }

              t.bl_count[o]--, t.bl_count[o + 1] += 2, t.bl_count[A]--, b -= 2;
            } while (b > 0);

            for (o = A; 0 !== o; o--) {
              for (n = t.bl_count[o]; 0 !== n;) {
                (i = t.heap[--r]) > u || (f[2 * i + 1] !== o && (t.opt_len += (o - f[2 * i + 1]) * f[2 * i], f[2 * i + 1] = o), n--);
              }
            }
          }
        }(t, e), D(o, u, t.bl_count);
      }

      function W(t, e, r) {
        var n,
            i,
            o = -1,
            a = e[1],
            s = 0,
            f = 7,
            u = 4;

        for (0 === a && (f = 138, u = 3), e[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++) {
          i = a, a = e[2 * (n + 1) + 1], ++s < f && i === a || (s < u ? t.bl_tree[2 * i] += s : 0 !== i ? (i !== o && t.bl_tree[2 * i]++, t.bl_tree[2 * p]++) : s <= 10 ? t.bl_tree[2 * g]++ : t.bl_tree[2 * A]++, s = 0, o = i, 0 === a ? (f = 138, u = 3) : i === a ? (f = 6, u = 3) : (f = 7, u = 4));
        }
      }

      function Y(t, e, r) {
        var n,
            i,
            o = -1,
            a = e[1],
            s = 0,
            f = 7,
            u = 4;

        for (0 === a && (f = 138, u = 3), n = 0; n <= r; n++) {
          if (i = a, a = e[2 * (n + 1) + 1], !(++s < f && i === a)) {
            if (s < u) do {
              O(t, i, t.bl_tree);
            } while (0 != --s);else 0 !== i ? (i !== o && (O(t, i, t.bl_tree), s--), O(t, p, t.bl_tree), L(t, s - 3, 2)) : s <= 10 ? (O(t, g, t.bl_tree), L(t, s - 3, 3)) : (O(t, A, t.bl_tree), L(t, s - 11, 7));
            s = 0, o = i, 0 === a ? (f = 138, u = 3) : i === a ? (f = 6, u = 3) : (f = 7, u = 4);
          }
        }
      }

      i(M);
      var F = !1;

      function Z(t, e, r, i) {
        L(t, (o << 1) + (i ? 1 : 0), 3), function (t, e, r, i) {
          z(t), B(t, r), B(t, ~r), n.arraySet(t.pending_buf, t.window, e, r, t.pending), t.pending += r;
        }(t, e, r);
      }

      e._tr_init = function (t) {
        F || (function () {
          var t,
              e,
              r,
              n,
              i,
              o = new Array(h + 1);

          for (r = 0, n = 0; n < 28; n++) {
            for (P[n] = r, t = 0; t < 1 << b[n]; t++) {
              E[r++] = n;
            }
          }

          for (E[r - 1] = n, i = 0, n = 0; n < 16; n++) {
            for (M[n] = i, t = 0; t < 1 << v[n]; t++) {
              I[i++] = n;
            }
          }

          for (i >>= 7; n < f; n++) {
            for (M[n] = i << 7, t = 0; t < 1 << v[n] - 7; t++) {
              I[256 + i++] = n;
            }
          }

          for (e = 0; e <= h; e++) {
            o[e] = 0;
          }

          for (t = 0; t <= 143;) {
            m[2 * t + 1] = 8, t++, o[8]++;
          }

          for (; t <= 255;) {
            m[2 * t + 1] = 9, t++, o[9]++;
          }

          for (; t <= 279;) {
            m[2 * t + 1] = 7, t++, o[7]++;
          }

          for (; t <= 287;) {
            m[2 * t + 1] = 8, t++, o[8]++;
          }

          for (D(m, s + 1, o), t = 0; t < f; t++) {
            _[2 * t + 1] = 5, _[2 * t] = j(t, 5);
          }

          S = new T(m, b, a + 1, s, h), x = new T(_, v, 0, f, h), C = new T(new Array(0), y, 0, u, 7);
        }(), F = !0), t.l_desc = new k(t.dyn_ltree, S), t.d_desc = new k(t.dyn_dtree, x), t.bl_desc = new k(t.bl_tree, C), t.bi_buf = 0, t.bi_valid = 0, H(t);
      }, e._tr_stored_block = Z, e._tr_flush_block = function (t, e, r, n) {
        var i,
            o,
            s = 0;
        t.level > 0 ? (2 === t.strm.data_type && (t.strm.data_type = function (t) {
          var e,
              r = 4093624447;

          for (e = 0; e <= 31; e++, r >>>= 1) {
            if (1 & r && 0 !== t.dyn_ltree[2 * e]) return 0;
          }

          if (0 !== t.dyn_ltree[18] || 0 !== t.dyn_ltree[20] || 0 !== t.dyn_ltree[26]) return 1;

          for (e = 32; e < a; e++) {
            if (0 !== t.dyn_ltree[2 * e]) return 1;
          }

          return 0;
        }(t)), V(t, t.l_desc), V(t, t.d_desc), s = function (t) {
          var e;

          for (W(t, t.dyn_ltree, t.l_desc.max_code), W(t, t.dyn_dtree, t.d_desc.max_code), V(t, t.bl_desc), e = u - 1; e >= 3 && 0 === t.bl_tree[2 * w[e] + 1]; e--) {
            ;
          }

          return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e;
        }(t), i = t.opt_len + 3 + 7 >>> 3, (o = t.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== e ? Z(t, e, r, n) : 4 === t.strategy || o === i ? (L(t, 2 + (n ? 1 : 0), 3), U(t, m, _)) : (L(t, 4 + (n ? 1 : 0), 3), function (t, e, r, n) {
          var i;

          for (L(t, e - 257, 5), L(t, r - 1, 5), L(t, n - 4, 4), i = 0; i < n; i++) {
            L(t, t.bl_tree[2 * w[i] + 1], 3);
          }

          Y(t, t.dyn_ltree, e - 1), Y(t, t.dyn_dtree, r - 1);
        }(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, s + 1), U(t, t.dyn_ltree, t.dyn_dtree)), H(t), n && z(t);
      }, e._tr_tally = function (t, e, r) {
        return t.pending_buf[t.d_buf + 2 * t.last_lit] = e >>> 8 & 255, t.pending_buf[t.d_buf + 2 * t.last_lit + 1] = 255 & e, t.pending_buf[t.l_buf + t.last_lit] = 255 & r, t.last_lit++, 0 === e ? t.dyn_ltree[2 * r]++ : (t.matches++, e--, t.dyn_ltree[2 * (E[r] + a + 1)]++, t.dyn_dtree[2 * R(e)]++), t.last_lit === t.lit_bufsize - 1;
      }, e._tr_align = function (t) {
        L(t, 2, 3), O(t, d, m), function (t) {
          16 === t.bi_valid ? (B(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8);
        }(t);
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(8),
          i = r(21),
          o = r(22),
          a = r(52),
          s = r(53),
          f = 1,
          u = 2,
          c = 0,
          h = -2,
          l = 1,
          d = 12,
          p = 30,
          g = 852,
          A = 592;

      function b(t) {
        return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24);
      }

      function v() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }

      function y(t) {
        var e;
        return t && t.state ? (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = 1 & e.wrap), e.mode = l, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new n.Buf32(g), e.distcode = e.distdyn = new n.Buf32(A), e.sane = 1, e.back = -1, c) : h;
      }

      function w(t) {
        var e;
        return t && t.state ? ((e = t.state).wsize = 0, e.whave = 0, e.wnext = 0, y(t)) : h;
      }

      function m(t, e) {
        var r, n;
        return t && t.state ? (n = t.state, e < 0 ? (r = 0, e = -e) : (r = 1 + (e >> 4), e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? h : (null !== n.window && n.wbits !== e && (n.window = null), n.wrap = r, n.wbits = e, w(t))) : h;
      }

      function _(t, e) {
        var r, n;
        return t ? (n = new v(), t.state = n, n.window = null, (r = m(t, e)) !== c && (t.state = null), r) : h;
      }

      var I,
          E,
          P = !0;

      function S(t) {
        if (P) {
          var e;

          for (I = new n.Buf32(512), E = new n.Buf32(32), e = 0; e < 144;) {
            t.lens[e++] = 8;
          }

          for (; e < 256;) {
            t.lens[e++] = 9;
          }

          for (; e < 280;) {
            t.lens[e++] = 7;
          }

          for (; e < 288;) {
            t.lens[e++] = 8;
          }

          for (s(f, t.lens, 0, 288, I, 0, t.work, {
            bits: 9
          }), e = 0; e < 32;) {
            t.lens[e++] = 5;
          }

          s(u, t.lens, 0, 32, E, 0, t.work, {
            bits: 5
          }), P = !1;
        }

        t.lencode = I, t.lenbits = 9, t.distcode = E, t.distbits = 5;
      }

      function x(t, e, r, i) {
        var o,
            a = t.state;
        return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new n.Buf8(a.wsize)), i >= a.wsize ? (n.arraySet(a.window, e, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : ((o = a.wsize - a.wnext) > i && (o = i), n.arraySet(a.window, e, r - i, o, a.wnext), (i -= o) ? (n.arraySet(a.window, e, r - i, i, 0), a.wnext = i, a.whave = a.wsize) : (a.wnext += o, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += o))), 0;
      }

      e.inflateReset = w, e.inflateReset2 = m, e.inflateResetKeep = y, e.inflateInit = function (t) {
        return _(t, 15);
      }, e.inflateInit2 = _, e.inflate = function (t, e) {
        var r,
            g,
            A,
            v,
            y,
            w,
            m,
            _,
            I,
            E,
            P,
            C,
            M,
            T,
            k,
            R,
            B,
            L,
            O,
            j,
            D,
            H,
            z,
            N,
            q = 0,
            U = new n.Buf8(4),
            V = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

        if (!t || !t.state || !t.output || !t.input && 0 !== t.avail_in) return h;
        (r = t.state).mode === d && (r.mode = 13), y = t.next_out, A = t.output, m = t.avail_out, v = t.next_in, g = t.input, w = t.avail_in, _ = r.hold, I = r.bits, E = w, P = m, H = c;

        t: for (;;) {
          switch (r.mode) {
            case l:
              if (0 === r.wrap) {
                r.mode = 13;
                break;
              }

              for (; I < 16;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              if (2 & r.wrap && 35615 === _) {
                r.check = 0, U[0] = 255 & _, U[1] = _ >>> 8 & 255, r.check = o(r.check, U, 2, 0), _ = 0, I = 0, r.mode = 2;
                break;
              }

              if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & _) << 8) + (_ >> 8)) % 31) {
                t.msg = "incorrect header check", r.mode = p;
                break;
              }

              if (8 != (15 & _)) {
                t.msg = "unknown compression method", r.mode = p;
                break;
              }

              if (I -= 4, D = 8 + (15 & (_ >>>= 4)), 0 === r.wbits) r.wbits = D;else if (D > r.wbits) {
                t.msg = "invalid window size", r.mode = p;
                break;
              }
              r.dmax = 1 << D, t.adler = r.check = 1, r.mode = 512 & _ ? 10 : d, _ = 0, I = 0;
              break;

            case 2:
              for (; I < 16;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              if (r.flags = _, 8 != (255 & r.flags)) {
                t.msg = "unknown compression method", r.mode = p;
                break;
              }

              if (57344 & r.flags) {
                t.msg = "unknown header flags set", r.mode = p;
                break;
              }

              r.head && (r.head.text = _ >> 8 & 1), 512 & r.flags && (U[0] = 255 & _, U[1] = _ >>> 8 & 255, r.check = o(r.check, U, 2, 0)), _ = 0, I = 0, r.mode = 3;

            case 3:
              for (; I < 32;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              r.head && (r.head.time = _), 512 & r.flags && (U[0] = 255 & _, U[1] = _ >>> 8 & 255, U[2] = _ >>> 16 & 255, U[3] = _ >>> 24 & 255, r.check = o(r.check, U, 4, 0)), _ = 0, I = 0, r.mode = 4;

            case 4:
              for (; I < 16;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              r.head && (r.head.xflags = 255 & _, r.head.os = _ >> 8), 512 & r.flags && (U[0] = 255 & _, U[1] = _ >>> 8 & 255, r.check = o(r.check, U, 2, 0)), _ = 0, I = 0, r.mode = 5;

            case 5:
              if (1024 & r.flags) {
                for (; I < 16;) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                r.length = _, r.head && (r.head.extra_len = _), 512 & r.flags && (U[0] = 255 & _, U[1] = _ >>> 8 & 255, r.check = o(r.check, U, 2, 0)), _ = 0, I = 0;
              } else r.head && (r.head.extra = null);

              r.mode = 6;

            case 6:
              if (1024 & r.flags && ((C = r.length) > w && (C = w), C && (r.head && (D = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, g, v, C, D)), 512 & r.flags && (r.check = o(r.check, g, C, v)), w -= C, v += C, r.length -= C), r.length)) break t;
              r.length = 0, r.mode = 7;

            case 7:
              if (2048 & r.flags) {
                if (0 === w) break t;
                C = 0;

                do {
                  D = g[v + C++], r.head && D && r.length < 65536 && (r.head.name += String.fromCharCode(D));
                } while (D && C < w);

                if (512 & r.flags && (r.check = o(r.check, g, C, v)), w -= C, v += C, D) break t;
              } else r.head && (r.head.name = null);

              r.length = 0, r.mode = 8;

            case 8:
              if (4096 & r.flags) {
                if (0 === w) break t;
                C = 0;

                do {
                  D = g[v + C++], r.head && D && r.length < 65536 && (r.head.comment += String.fromCharCode(D));
                } while (D && C < w);

                if (512 & r.flags && (r.check = o(r.check, g, C, v)), w -= C, v += C, D) break t;
              } else r.head && (r.head.comment = null);

              r.mode = 9;

            case 9:
              if (512 & r.flags) {
                for (; I < 16;) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                if (_ !== (65535 & r.check)) {
                  t.msg = "header crc mismatch", r.mode = p;
                  break;
                }

                _ = 0, I = 0;
              }

              r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), t.adler = r.check = 0, r.mode = d;
              break;

            case 10:
              for (; I < 32;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              t.adler = r.check = b(_), _ = 0, I = 0, r.mode = 11;

            case 11:
              if (0 === r.havedict) return t.next_out = y, t.avail_out = m, t.next_in = v, t.avail_in = w, r.hold = _, r.bits = I, 2;
              t.adler = r.check = 1, r.mode = d;

            case d:
              if (5 === e || 6 === e) break t;

            case 13:
              if (r.last) {
                _ >>>= 7 & I, I -= 7 & I, r.mode = 27;
                break;
              }

              for (; I < 3;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              switch (r.last = 1 & _, I -= 1, 3 & (_ >>>= 1)) {
                case 0:
                  r.mode = 14;
                  break;

                case 1:
                  if (S(r), r.mode = 20, 6 === e) {
                    _ >>>= 2, I -= 2;
                    break t;
                  }

                  break;

                case 2:
                  r.mode = 17;
                  break;

                case 3:
                  t.msg = "invalid block type", r.mode = p;
              }

              _ >>>= 2, I -= 2;
              break;

            case 14:
              for (_ >>>= 7 & I, I -= 7 & I; I < 32;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              if ((65535 & _) != (_ >>> 16 ^ 65535)) {
                t.msg = "invalid stored block lengths", r.mode = p;
                break;
              }

              if (r.length = 65535 & _, _ = 0, I = 0, r.mode = 15, 6 === e) break t;

            case 15:
              r.mode = 16;

            case 16:
              if (C = r.length) {
                if (C > w && (C = w), C > m && (C = m), 0 === C) break t;
                n.arraySet(A, g, v, C, y), w -= C, v += C, m -= C, y += C, r.length -= C;
                break;
              }

              r.mode = d;
              break;

            case 17:
              for (; I < 14;) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              if (r.nlen = 257 + (31 & _), _ >>>= 5, I -= 5, r.ndist = 1 + (31 & _), _ >>>= 5, I -= 5, r.ncode = 4 + (15 & _), _ >>>= 4, I -= 4, r.nlen > 286 || r.ndist > 30) {
                t.msg = "too many length or distance symbols", r.mode = p;
                break;
              }

              r.have = 0, r.mode = 18;

            case 18:
              for (; r.have < r.ncode;) {
                for (; I < 3;) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                r.lens[V[r.have++]] = 7 & _, _ >>>= 3, I -= 3;
              }

              for (; r.have < 19;) {
                r.lens[V[r.have++]] = 0;
              }

              if (r.lencode = r.lendyn, r.lenbits = 7, z = {
                bits: r.lenbits
              }, H = s(0, r.lens, 0, 19, r.lencode, 0, r.work, z), r.lenbits = z.bits, H) {
                t.msg = "invalid code lengths set", r.mode = p;
                break;
              }

              r.have = 0, r.mode = 19;

            case 19:
              for (; r.have < r.nlen + r.ndist;) {
                for (; R = (q = r.lencode[_ & (1 << r.lenbits) - 1]) >>> 16 & 255, B = 65535 & q, !((k = q >>> 24) <= I);) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                if (B < 16) _ >>>= k, I -= k, r.lens[r.have++] = B;else {
                  if (16 === B) {
                    for (N = k + 2; I < N;) {
                      if (0 === w) break t;
                      w--, _ += g[v++] << I, I += 8;
                    }

                    if (_ >>>= k, I -= k, 0 === r.have) {
                      t.msg = "invalid bit length repeat", r.mode = p;
                      break;
                    }

                    D = r.lens[r.have - 1], C = 3 + (3 & _), _ >>>= 2, I -= 2;
                  } else if (17 === B) {
                    for (N = k + 3; I < N;) {
                      if (0 === w) break t;
                      w--, _ += g[v++] << I, I += 8;
                    }

                    I -= k, D = 0, C = 3 + (7 & (_ >>>= k)), _ >>>= 3, I -= 3;
                  } else {
                    for (N = k + 7; I < N;) {
                      if (0 === w) break t;
                      w--, _ += g[v++] << I, I += 8;
                    }

                    I -= k, D = 0, C = 11 + (127 & (_ >>>= k)), _ >>>= 7, I -= 7;
                  }

                  if (r.have + C > r.nlen + r.ndist) {
                    t.msg = "invalid bit length repeat", r.mode = p;
                    break;
                  }

                  for (; C--;) {
                    r.lens[r.have++] = D;
                  }
                }
              }

              if (r.mode === p) break;

              if (0 === r.lens[256]) {
                t.msg = "invalid code -- missing end-of-block", r.mode = p;
                break;
              }

              if (r.lenbits = 9, z = {
                bits: r.lenbits
              }, H = s(f, r.lens, 0, r.nlen, r.lencode, 0, r.work, z), r.lenbits = z.bits, H) {
                t.msg = "invalid literal/lengths set", r.mode = p;
                break;
              }

              if (r.distbits = 6, r.distcode = r.distdyn, z = {
                bits: r.distbits
              }, H = s(u, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, z), r.distbits = z.bits, H) {
                t.msg = "invalid distances set", r.mode = p;
                break;
              }

              if (r.mode = 20, 6 === e) break t;

            case 20:
              r.mode = 21;

            case 21:
              if (w >= 6 && m >= 258) {
                t.next_out = y, t.avail_out = m, t.next_in = v, t.avail_in = w, r.hold = _, r.bits = I, a(t, P), y = t.next_out, A = t.output, m = t.avail_out, v = t.next_in, g = t.input, w = t.avail_in, _ = r.hold, I = r.bits, r.mode === d && (r.back = -1);
                break;
              }

              for (r.back = 0; R = (q = r.lencode[_ & (1 << r.lenbits) - 1]) >>> 16 & 255, B = 65535 & q, !((k = q >>> 24) <= I);) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              if (R && 0 == (240 & R)) {
                for (L = k, O = R, j = B; R = (q = r.lencode[j + ((_ & (1 << L + O) - 1) >> L)]) >>> 16 & 255, B = 65535 & q, !(L + (k = q >>> 24) <= I);) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                _ >>>= L, I -= L, r.back += L;
              }

              if (_ >>>= k, I -= k, r.back += k, r.length = B, 0 === R) {
                r.mode = 26;
                break;
              }

              if (32 & R) {
                r.back = -1, r.mode = d;
                break;
              }

              if (64 & R) {
                t.msg = "invalid literal/length code", r.mode = p;
                break;
              }

              r.extra = 15 & R, r.mode = 22;

            case 22:
              if (r.extra) {
                for (N = r.extra; I < N;) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                r.length += _ & (1 << r.extra) - 1, _ >>>= r.extra, I -= r.extra, r.back += r.extra;
              }

              r.was = r.length, r.mode = 23;

            case 23:
              for (; R = (q = r.distcode[_ & (1 << r.distbits) - 1]) >>> 16 & 255, B = 65535 & q, !((k = q >>> 24) <= I);) {
                if (0 === w) break t;
                w--, _ += g[v++] << I, I += 8;
              }

              if (0 == (240 & R)) {
                for (L = k, O = R, j = B; R = (q = r.distcode[j + ((_ & (1 << L + O) - 1) >> L)]) >>> 16 & 255, B = 65535 & q, !(L + (k = q >>> 24) <= I);) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                _ >>>= L, I -= L, r.back += L;
              }

              if (_ >>>= k, I -= k, r.back += k, 64 & R) {
                t.msg = "invalid distance code", r.mode = p;
                break;
              }

              r.offset = B, r.extra = 15 & R, r.mode = 24;

            case 24:
              if (r.extra) {
                for (N = r.extra; I < N;) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                r.offset += _ & (1 << r.extra) - 1, _ >>>= r.extra, I -= r.extra, r.back += r.extra;
              }

              if (r.offset > r.dmax) {
                t.msg = "invalid distance too far back", r.mode = p;
                break;
              }

              r.mode = 25;

            case 25:
              if (0 === m) break t;

              if (C = P - m, r.offset > C) {
                if ((C = r.offset - C) > r.whave && r.sane) {
                  t.msg = "invalid distance too far back", r.mode = p;
                  break;
                }

                C > r.wnext ? (C -= r.wnext, M = r.wsize - C) : M = r.wnext - C, C > r.length && (C = r.length), T = r.window;
              } else T = A, M = y - r.offset, C = r.length;

              C > m && (C = m), m -= C, r.length -= C;

              do {
                A[y++] = T[M++];
              } while (--C);

              0 === r.length && (r.mode = 21);
              break;

            case 26:
              if (0 === m) break t;
              A[y++] = r.length, m--, r.mode = 21;
              break;

            case 27:
              if (r.wrap) {
                for (; I < 32;) {
                  if (0 === w) break t;
                  w--, _ |= g[v++] << I, I += 8;
                }

                if (P -= m, t.total_out += P, r.total += P, P && (t.adler = r.check = r.flags ? o(r.check, A, P, y - P) : i(r.check, A, P, y - P)), P = m, (r.flags ? _ : b(_)) !== r.check) {
                  t.msg = "incorrect data check", r.mode = p;
                  break;
                }

                _ = 0, I = 0;
              }

              r.mode = 28;

            case 28:
              if (r.wrap && r.flags) {
                for (; I < 32;) {
                  if (0 === w) break t;
                  w--, _ += g[v++] << I, I += 8;
                }

                if (_ !== (4294967295 & r.total)) {
                  t.msg = "incorrect length check", r.mode = p;
                  break;
                }

                _ = 0, I = 0;
              }

              r.mode = 29;

            case 29:
              H = 1;
              break t;

            case p:
              H = -3;
              break t;

            case 31:
              return -4;

            case 32:
            default:
              return h;
          }
        }

        return t.next_out = y, t.avail_out = m, t.next_in = v, t.avail_in = w, r.hold = _, r.bits = I, (r.wsize || P !== t.avail_out && r.mode < p && (r.mode < 27 || 4 !== e)) && x(t, t.output, t.next_out, P - t.avail_out) ? (r.mode = 31, -4) : (E -= t.avail_in, P -= t.avail_out, t.total_in += E, t.total_out += P, r.total += P, r.wrap && P && (t.adler = r.check = r.flags ? o(r.check, A, P, t.next_out - P) : i(r.check, A, P, t.next_out - P)), t.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === d ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 === E && 0 === P || 4 === e) && H === c && (H = -5), H);
      }, e.inflateEnd = function (t) {
        if (!t || !t.state) return h;
        var e = t.state;
        return e.window && (e.window = null), t.state = null, c;
      }, e.inflateGetHeader = function (t, e) {
        var r;
        return t && t.state ? 0 == (2 & (r = t.state).wrap) ? h : (r.head = e, e.done = !1, c) : h;
      }, e.inflateSetDictionary = function (t, e) {
        var r,
            n = e.length;
        return t && t.state ? 0 !== (r = t.state).wrap && 11 !== r.mode ? h : 11 === r.mode && i(1, e, n, 0) !== r.check ? -3 : x(t, e, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, c) : h;
      }, e.inflateInfo = "pako inflate (from Nodeca project)";
    }, function (t, e, r) {
      "use strict";

      t.exports = function (t, e) {
        var r, n, i, o, a, s, f, u, c, h, l, d, p, g, A, b, v, y, w, m, _, I, E, P, S;

        r = t.state, n = t.next_in, P = t.input, i = n + (t.avail_in - 5), o = t.next_out, S = t.output, a = o - (e - t.avail_out), s = o + (t.avail_out - 257), f = r.dmax, u = r.wsize, c = r.whave, h = r.wnext, l = r.window, d = r.hold, p = r.bits, g = r.lencode, A = r.distcode, b = (1 << r.lenbits) - 1, v = (1 << r.distbits) - 1;

        t: do {
          p < 15 && (d += P[n++] << p, p += 8, d += P[n++] << p, p += 8), y = g[d & b];

          e: for (;;) {
            if (d >>>= w = y >>> 24, p -= w, 0 == (w = y >>> 16 & 255)) S[o++] = 65535 & y;else {
              if (!(16 & w)) {
                if (0 == (64 & w)) {
                  y = g[(65535 & y) + (d & (1 << w) - 1)];
                  continue e;
                }

                if (32 & w) {
                  r.mode = 12;
                  break t;
                }

                t.msg = "invalid literal/length code", r.mode = 30;
                break t;
              }

              m = 65535 & y, (w &= 15) && (p < w && (d += P[n++] << p, p += 8), m += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += P[n++] << p, p += 8, d += P[n++] << p, p += 8), y = A[d & v];

              r: for (;;) {
                if (d >>>= w = y >>> 24, p -= w, !(16 & (w = y >>> 16 & 255))) {
                  if (0 == (64 & w)) {
                    y = A[(65535 & y) + (d & (1 << w) - 1)];
                    continue r;
                  }

                  t.msg = "invalid distance code", r.mode = 30;
                  break t;
                }

                if (_ = 65535 & y, p < (w &= 15) && (d += P[n++] << p, (p += 8) < w && (d += P[n++] << p, p += 8)), (_ += d & (1 << w) - 1) > f) {
                  t.msg = "invalid distance too far back", r.mode = 30;
                  break t;
                }

                if (d >>>= w, p -= w, _ > (w = o - a)) {
                  if ((w = _ - w) > c && r.sane) {
                    t.msg = "invalid distance too far back", r.mode = 30;
                    break t;
                  }

                  if (I = 0, E = l, 0 === h) {
                    if (I += u - w, w < m) {
                      m -= w;

                      do {
                        S[o++] = l[I++];
                      } while (--w);

                      I = o - _, E = S;
                    }
                  } else if (h < w) {
                    if (I += u + h - w, (w -= h) < m) {
                      m -= w;

                      do {
                        S[o++] = l[I++];
                      } while (--w);

                      if (I = 0, h < m) {
                        m -= w = h;

                        do {
                          S[o++] = l[I++];
                        } while (--w);

                        I = o - _, E = S;
                      }
                    }
                  } else if (I += h - w, w < m) {
                    m -= w;

                    do {
                      S[o++] = l[I++];
                    } while (--w);

                    I = o - _, E = S;
                  }

                  for (; m > 2;) {
                    S[o++] = E[I++], S[o++] = E[I++], S[o++] = E[I++], m -= 3;
                  }

                  m && (S[o++] = E[I++], m > 1 && (S[o++] = E[I++]));
                } else {
                  I = o - _;

                  do {
                    S[o++] = S[I++], S[o++] = S[I++], S[o++] = S[I++], m -= 3;
                  } while (m > 2);

                  m && (S[o++] = S[I++], m > 1 && (S[o++] = S[I++]));
                }

                break;
              }
            }
            break;
          }
        } while (n < i && o < s);

        n -= m = p >> 3, d &= (1 << (p -= m << 3)) - 1, t.next_in = n, t.next_out = o, t.avail_in = n < i ? i - n + 5 : 5 - (n - i), t.avail_out = o < s ? s - o + 257 : 257 - (o - s), r.hold = d, r.bits = p;
      };
    }, function (t, e, r) {
      "use strict";

      var n = r(8),
          i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
          o = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
          a = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
          s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];

      t.exports = function (t, e, r, f, u, c, h, l) {
        var d,
            p,
            g,
            A,
            b,
            v,
            y,
            w,
            m,
            _ = l.bits,
            I = 0,
            E = 0,
            P = 0,
            S = 0,
            x = 0,
            C = 0,
            M = 0,
            T = 0,
            k = 0,
            R = 0,
            B = null,
            L = 0,
            O = new n.Buf16(16),
            j = new n.Buf16(16),
            D = null,
            H = 0;

        for (I = 0; I <= 15; I++) {
          O[I] = 0;
        }

        for (E = 0; E < f; E++) {
          O[e[r + E]]++;
        }

        for (x = _, S = 15; S >= 1 && 0 === O[S]; S--) {
          ;
        }

        if (x > S && (x = S), 0 === S) return u[c++] = 20971520, u[c++] = 20971520, l.bits = 1, 0;

        for (P = 1; P < S && 0 === O[P]; P++) {
          ;
        }

        for (x < P && (x = P), T = 1, I = 1; I <= 15; I++) {
          if (T <<= 1, (T -= O[I]) < 0) return -1;
        }

        if (T > 0 && (0 === t || 1 !== S)) return -1;

        for (j[1] = 0, I = 1; I < 15; I++) {
          j[I + 1] = j[I] + O[I];
        }

        for (E = 0; E < f; E++) {
          0 !== e[r + E] && (h[j[e[r + E]]++] = E);
        }

        if (0 === t ? (B = D = h, v = 19) : 1 === t ? (B = i, L -= 257, D = o, H -= 257, v = 256) : (B = a, D = s, v = -1), R = 0, E = 0, I = P, b = c, C = x, M = 0, g = -1, A = (k = 1 << x) - 1, 1 === t && k > 852 || 2 === t && k > 592) return 1;

        for (;;) {
          y = I - M, h[E] < v ? (w = 0, m = h[E]) : h[E] > v ? (w = D[H + h[E]], m = B[L + h[E]]) : (w = 96, m = 0), d = 1 << I - M, P = p = 1 << C;

          do {
            u[b + (R >> M) + (p -= d)] = y << 24 | w << 16 | m | 0;
          } while (0 !== p);

          for (d = 1 << I - 1; R & d;) {
            d >>= 1;
          }

          if (0 !== d ? (R &= d - 1, R += d) : R = 0, E++, 0 == --O[I]) {
            if (I === S) break;
            I = e[r + h[E]];
          }

          if (I > x && (R & A) !== g) {
            for (0 === M && (M = x), b += P, T = 1 << (C = I - M); C + M < S && !((T -= O[C + M]) <= 0);) {
              C++, T <<= 1;
            }

            if (k += 1 << C, 1 === t && k > 852 || 2 === t && k > 592) return 1;
            u[g = R & A] = x << 24 | C << 16 | b - c | 0;
          }
        }

        return 0 !== R && (u[b + R] = I - M << 24 | 64 << 16 | 0), l.bits = x, 0;
      };
    }, function (t, e, r) {
      "use strict";

      t.exports = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
      };
    }, function (t, e, r) {
      "use strict";

      (function (e, n) {
        !function () {
          if ("arm" !== e.arch) {
            var i = [];
            !function () {
              for (var t = 0; t < 256; t++) {
                for (var e = t, r = 0; r < 8; r++) {
                  1 & e ? e = 3988292384 ^ e >>> 1 : e >>>= 1;
                }

                i[t] = e >>> 0;
              }
            }(), t.exports = function () {
              for (var t = arguments.length, e = -1, r = 0; r < t; r++) {
                e = o(e, new n(arguments[r]));
              }

              return e = (-1 ^ e) >>> 0;
            };
          } else t.exports = r(56);

          function o(t, e) {
            for (var r = e.length, n = 0; n < r; n++) {
              t = i[255 & (t ^ e[n])] ^ t >>> 8;
            }

            return t;
          }
        }();
      }).call(this, r(1), r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      (function (e) {
        for (var r = [], n = 0; n < 256; n++) {
          var i = r[n] = new e(4);
          i.writeUInt32BE(n, 0);

          for (var o = 0; o < 8; o++) {
            var a = 1 & i[0],
                s = 1 & i[1],
                f = 1 & i[2],
                u = 1 & i[3];
            i[0] = i[0] >> 1 ^ (u ? 237 : 0), i[1] = i[1] >> 1 ^ (u ? 184 : 0) ^ (a ? 128 : 0), i[2] = i[2] >> 1 ^ (u ? 131 : 0) ^ (s ? 128 : 0), i[3] = i[3] >> 1 ^ (u ? 32 : 0) ^ (f ? 128 : 0);
          }
        }

        function c(t, e) {
          for (var n = e.length, i = 0; i < n; i++) {
            var o = r[t[3] ^ e[i]];
            t[3] = o[3] ^ t[2], t[2] = o[2] ^ t[1], t[1] = o[1] ^ t[0], t[0] = o[0];
          }
        }

        t.exports = function () {
          var t = arguments.length,
              r = new e(4);
          r.fill(255);

          for (var n = 0; n < t; n++) {
            c(r, new e(arguments[n]));
          }

          return r[0] = 255 ^ r[0], r[1] = 255 ^ r[1], r[2] = 255 ^ r[2], r[3] = 255 ^ r[3], r.readUInt32BE(0);
        };
      }).call(this, r(0).Buffer);
    }, function (t, e, r) {
      "use strict";

      function n(t) {
        for (var e = t.length, r = [], n = -1; n <= e; n++) {
          r[n] = [];
        }

        var i = [];

        for (n = 0; n < e; n++) {
          for (var o = 0; o < e; o++) {
            r[n][o] || (r[n][o] = 1, a(n, o) ? a(n - 1, o) || i.push(s(n, o, "right")) : a(n, o - 1) && i.push(s(n, o, "down")));
          }
        }

        return i;

        function a(r, n) {
          return !(r < 0 || n < 0 || r >= e || n >= e || !t[r][n]);
        }

        function s(t, e, n) {
          r[t][e] = 1;
          var i = [];
          i.push(["M", e, t]);
          var o = t,
              s = e,
              f = 0;

          do {
            switch (n) {
              case "right":
                r[o][s] = 1, a(o, s) ? (r[o - 1][s] = 1, a(o - 1, s) ? (i.push(["h", f]), f = 0, n = "up") : (f++, s++)) : (i.push(["h", f]), f = 0, n = "down");
                break;

              case "left":
                r[o - 1][s - 1] = 1, a(o - 1, s - 1) ? (r[o][s - 1] = 1, a(o, s - 1) ? (i.push(["h", -f]), f = 0, n = "down") : (f++, s--)) : (i.push(["h", -f]), f = 0, n = "up");
                break;

              case "down":
                r[o][s - 1] = 1, a(o, s - 1) ? (r[o][s] = 1, a(o, s) ? (i.push(["v", f]), f = 0, n = "right") : (f++, o++)) : (i.push(["v", f]), f = 0, n = "left");
                break;

              case "up":
                r[o - 1][s] = 1, a(o - 1, s) ? (r[o - 1][s - 1] = 1, a(o - 1, s - 1) ? (i.push(["v", -f]), f = 0, n = "left") : (f++, o--)) : (i.push(["v", -f]), f = 0, n = "right");
            }
          } while (o != t || s != e);

          return i;
        }
      }

      function i(t, e, r) {
        n(t).forEach(function (t) {
          for (var n = "", i = 0; i < t.length; i++) {
            var o = t[i];

            switch (o[0]) {
              case "M":
                n += "M" + (o[1] + r) + " " + (o[2] + r);
                break;

              default:
                n += o.join("");
            }
          }

          n += "z", e.push(n);
        });
      }

      t.exports = {
        svg: function svg(t, e, r, n) {
          var o = t.length + 2 * r;

          if (e.push('<svg xmlns="http://www.w3.org/2000/svg" '), n > 0) {
            var a = o * n;
            e.push('width="' + a + '" height="' + a + '" ');
          }

          e.push('viewBox="0 0 ' + o + " " + o + '">'), e.push('<path d="'), i(t, e, r), e.push('"/></svg>'), e.push(null);
        },
        eps: function eps(t, e, r) {
          var i = t.length,
              o = 9 * (i + 2 * r);
          e.push(["%!PS-Adobe-3.0 EPSF-3.0", "%%BoundingBox: 0 0 " + o + " " + o, "/h { 0 rlineto } bind def", "/v { 0 exch neg rlineto } bind def", "/M { neg " + (i + r) + " add moveto } bind def", "/z { closepath } bind def", "9 9 scale", ""].join("\n")), n(t).forEach(function (t) {
            for (var n = "", i = 0; i < t.length; i++) {
              var o = t[i];

              switch (o[0]) {
                case "M":
                  n += o[1] + r + " " + o[2] + " M ";
                  break;

                default:
                  n += o[1] + " " + o[0] + " ";
              }
            }

            n += "z\n", e.push(n);
          }), e.push("fill\n%%EOF\n"), e.push(null);
        },
        pdf: function pdf(t, e, r) {
          var i = t.length,
              o = 9 * (i + 2 * r),
              a = ["%PDF-1.0\n\n", "1 0 obj << /Type /Catalog /Pages 2 0 R >> endobj\n", "2 0 obj << /Type /Pages /Count 1 /Kids [ 3 0 R ] >> endobj\n"];
          a.push("3 0 obj << /Type /Page /Parent 2 0 R /Resources <<>> /Contents 4 0 R /MediaBox [ 0 0 " + o + " " + o + " ] >> endobj\n");
          var s = "9 0 0 9 0 0 cm\n";
          s += n(t).map(function (t) {
            for (var e, n, o = "", a = 0; a < t.length; a++) {
              var s = t[a];

              switch (s[0]) {
                case "M":
                  o += (e = s[1] + r) + " " + (n = i - s[2] + r) + " m ";
                  break;

                case "h":
                  o += (e += s[1]) + " " + n + " l ";
                  break;

                case "v":
                  o += e + " " + (n -= s[1]) + " l ";
              }
            }

            return o += "h";
          }).join("\n"), s += "\nf\n", a.push("4 0 obj << /Length " + s.length + " >> stream\n" + s + "endstream\nendobj\n");

          for (var f = "xref\n0 5\n0000000000 65535 f \n", u = 1, c = a[0].length; u < 5; u++) {
            f += ("0000000000" + c).substr(-10) + " 00000 n \n", c += a[u].length;
          }

          a.push(f, "trailer << /Root 1 0 R /Size 5 >>\n", "startxref\n" + c + "\n%%EOF\n"), e.push(a.join("")), e.push(null);
        },
        svg_object: function svg_object(t, e) {
          var r = [];
          return i(t, r, e), {
            size: t.length + 2 * e,
            path: r.filter(Boolean).join("")
          };
        }
      };
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = {
        animationDuration: 300,
        animation: "\n  <style>\n    @keyframes fadeIn {\n      from { opacity: 0; }\n      to { opacity: 1; }\n    }\n    @keyframes fadeOut {\n      from { opacity: 1; }\n      to { opacity: 0; }\n    }\n    .animated {\n      animation-duration: 300ms;\n      animation-fill-mode: both;\n    }\n    .fadeIn {\n      animation-name: fadeIn;\n    }\n    .fadeOut {\n      animation-name: fadeOut;\n    }\n  </style>\n  ",
        modal: {
          base: "\n        position:relative;\n        top:50%;\n        display:inline-block;\n        z-index:101;\n        background:#fff;\n        transform:translateY(-50%);\n        margin:0 auto;\n        border-radius: 8px;\n        overflow: hidden;\n        box-shadow: 0 12px 24px 0 rgba(0,0,0,0.1);\n        width: 100%;\n        max-width: 500px;\n      ",
          header: "\n        position: relative;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      ",
          headerLogo: "\n      width: 100%;\n      max-width: 320px;\n      margin: 20px auto;\n      height: 100%;\n    ",
          close: {
            wrapper: "\n        position: absolute;\n        top: 15px;\n        right: 15px;\n        z-index: 10000;\n      ",
            icon: "\n        width: 25px;\n        height: 25px;\n        position: relative;\n        top: 0;\n        right: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transform: rotate(45deg);\n      ",
            line1: "\n        position: absolute;\n        width: 90%;\n        border: 1px solid #7C828B;\n      ",
            line2: "\n        position: absolute;\n        width: 90%;\n        border: 1px solid #7C828B;\n        transform: rotate(90deg);\n      "
          }
        },
        qrcode: {
          base: "\n      position:fixed;\n      top: 0;\n      width:100%;\n      height:100%;\n      z-index:100;\n      background-color:rgba(0,0,0,0.5);\n      text-align:center;\n    ",
          text: "\n      color: #7C828B;\n      font-family: Avenir;\n      font-size: 18px;\n      text-align: center;\n      margin: 0 auto;\n      padding: 0 30px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    ",
          image: "\n      width: 100%;\n      padding: 30px;\n      box-sizing: border-box;\n    "
        }
      };
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = {
        logo: "data:image/jpeg;base64,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\n  "
      };
    }]);
  }, function (t, e) {
    var r = Array.isArray;
    t.exports = r;
  }, function (t, e) {
    t.exports = function (t) {
      var e = typeof t;
      return null != t && ("object" == e || "function" == e);
    };
  }, function (t, e, r) {
    (function (t) {
      var n = void 0 !== t && t || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(t, e) {
        this._id = t, this._clearFn = e;
      }

      e.setTimeout = function () {
        return new o(i.call(setTimeout, n, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new o(i.call(setInterval, n, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(n, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, r(69), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, r(5));
  }, function (t, e, r) {
    var n = r(36).Symbol;
    t.exports = n;
  }, function (t, e, r) {
    var n = r(37),
        i = "object" == typeof self && self && self.Object === Object && self,
        o = n || i || Function("return this")();
    t.exports = o;
  }, function (t, e, r) {
    (function (e) {
      var r = "object" == typeof e && e && e.Object === Object && e;
      t.exports = r;
    }).call(this, r(5));
  }, function (t, e) {
    var r = 9007199254740991;

    t.exports = function (t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= r;
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = {}, t.exports = e.default;
  }, function (t, e, r) {
    (function (t) {
      var n = Object.getOwnPropertyDescriptors || function (t) {
        for (var e = Object.keys(t), r = {}, n = 0; n < e.length; n++) {
          r[e[n]] = Object.getOwnPropertyDescriptor(t, e[n]);
        }

        return r;
      },
          i = /%[sdj%]/g;

      e.format = function (t) {
        if (!b(t)) {
          for (var e = [], r = 0; r < arguments.length; r++) {
            e.push(s(arguments[r]));
          }

          return e.join(" ");
        }

        r = 1;

        for (var n = arguments, o = n.length, a = String(t).replace(i, function (t) {
          if ("%%" === t) return "%";
          if (r >= o) return t;

          switch (t) {
            case "%s":
              return String(n[r++]);

            case "%d":
              return Number(n[r++]);

            case "%j":
              try {
                return JSON.stringify(n[r++]);
              } catch (t) {
                return "[Circular]";
              }

            default:
              return t;
          }
        }), f = n[r]; r < o; f = n[++r]) {
          g(f) || !w(f) ? a += " " + f : a += " " + s(f);
        }

        return a;
      }, e.deprecate = function (r, n) {
        if (void 0 !== t && !0 === t.noDeprecation) return r;
        if (void 0 === t) return function () {
          return e.deprecate(r, n).apply(this, arguments);
        };
        var i = !1;
        return function () {
          if (!i) {
            if (t.throwDeprecation) throw new Error(n);
            t.traceDeprecation ? console.trace(n) : console.error(n), i = !0;
          }

          return r.apply(this, arguments);
        };
      };
      var o,
          a = {};

      function s(t, r) {
        var n = {
          seen: [],
          stylize: u
        };
        return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(r) ? n.showHidden = r : r && e._extend(n, r), v(n.showHidden) && (n.showHidden = !1), v(n.depth) && (n.depth = 2), v(n.colors) && (n.colors = !1), v(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = f), c(n, t, n.depth);
      }

      function f(t, e) {
        var r = s.styles[e];
        return r ? "[" + s.colors[r][0] + "m" + t + "[" + s.colors[r][1] + "m" : t;
      }

      function u(t, e) {
        return t;
      }

      function c(t, r, n) {
        if (t.customInspect && r && I(r.inspect) && r.inspect !== e.inspect && (!r.constructor || r.constructor.prototype !== r)) {
          var i = r.inspect(n, t);
          return b(i) || (i = c(t, i, n)), i;
        }

        var o = function (t, e) {
          if (v(e)) return t.stylize("undefined", "undefined");

          if (b(e)) {
            var r = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return t.stylize(r, "string");
          }

          if (A(e)) return t.stylize("" + e, "number");
          if (p(e)) return t.stylize("" + e, "boolean");
          if (g(e)) return t.stylize("null", "null");
        }(t, r);

        if (o) return o;

        var a = Object.keys(r),
            s = function (t) {
          var e = {};
          return t.forEach(function (t, r) {
            e[t] = !0;
          }), e;
        }(a);

        if (t.showHidden && (a = Object.getOwnPropertyNames(r)), _(r) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return h(r);

        if (0 === a.length) {
          if (I(r)) {
            var f = r.name ? ": " + r.name : "";
            return t.stylize("[Function" + f + "]", "special");
          }

          if (y(r)) return t.stylize(RegExp.prototype.toString.call(r), "regexp");
          if (m(r)) return t.stylize(Date.prototype.toString.call(r), "date");
          if (_(r)) return h(r);
        }

        var u,
            w = "",
            E = !1,
            P = ["{", "}"];
        (d(r) && (E = !0, P = ["[", "]"]), I(r)) && (w = " [Function" + (r.name ? ": " + r.name : "") + "]");
        return y(r) && (w = " " + RegExp.prototype.toString.call(r)), m(r) && (w = " " + Date.prototype.toUTCString.call(r)), _(r) && (w = " " + h(r)), 0 !== a.length || E && 0 != r.length ? n < 0 ? y(r) ? t.stylize(RegExp.prototype.toString.call(r), "regexp") : t.stylize("[Object]", "special") : (t.seen.push(r), u = E ? function (t, e, r, n, i) {
          for (var o = [], a = 0, s = e.length; a < s; ++a) {
            x(e, String(a)) ? o.push(l(t, e, r, n, String(a), !0)) : o.push("");
          }

          return i.forEach(function (i) {
            i.match(/^\d+$/) || o.push(l(t, e, r, n, i, !0));
          }), o;
        }(t, r, n, s, a) : a.map(function (e) {
          return l(t, r, n, s, e, E);
        }), t.seen.pop(), function (t, e, r) {
          if (t.reduce(function (t, e) {
            return 0, e.indexOf("\n") >= 0 && 0, t + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
          }, 0) > 60) return r[0] + ("" === e ? "" : e + "\n ") + " " + t.join(",\n  ") + " " + r[1];
          return r[0] + e + " " + t.join(", ") + " " + r[1];
        }(u, w, P)) : P[0] + w + P[1];
      }

      function h(t) {
        return "[" + Error.prototype.toString.call(t) + "]";
      }

      function l(t, e, r, n, i, o) {
        var a, s, f;

        if ((f = Object.getOwnPropertyDescriptor(e, i) || {
          value: e[i]
        }).get ? s = f.set ? t.stylize("[Getter/Setter]", "special") : t.stylize("[Getter]", "special") : f.set && (s = t.stylize("[Setter]", "special")), x(n, i) || (a = "[" + i + "]"), s || (t.seen.indexOf(f.value) < 0 ? (s = g(r) ? c(t, f.value, null) : c(t, f.value, r - 1)).indexOf("\n") > -1 && (s = o ? s.split("\n").map(function (t) {
          return "  " + t;
        }).join("\n").substr(2) : "\n" + s.split("\n").map(function (t) {
          return "   " + t;
        }).join("\n")) : s = t.stylize("[Circular]", "special")), v(a)) {
          if (o && i.match(/^\d+$/)) return s;
          (a = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = t.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = t.stylize(a, "string"));
        }

        return a + ": " + s;
      }

      function d(t) {
        return Array.isArray(t);
      }

      function p(t) {
        return "boolean" == typeof t;
      }

      function g(t) {
        return null === t;
      }

      function A(t) {
        return "number" == typeof t;
      }

      function b(t) {
        return "string" == typeof t;
      }

      function v(t) {
        return void 0 === t;
      }

      function y(t) {
        return w(t) && "[object RegExp]" === E(t);
      }

      function w(t) {
        return "object" == typeof t && null !== t;
      }

      function m(t) {
        return w(t) && "[object Date]" === E(t);
      }

      function _(t) {
        return w(t) && ("[object Error]" === E(t) || t instanceof Error);
      }

      function I(t) {
        return "function" == typeof t;
      }

      function E(t) {
        return Object.prototype.toString.call(t);
      }

      function P(t) {
        return t < 10 ? "0" + t.toString(10) : t.toString(10);
      }

      e.debuglog = function (r) {
        if (v(o) && (o = t.env.NODE_DEBUG || ""), r = r.toUpperCase(), !a[r]) if (new RegExp("\\b" + r + "\\b", "i").test(o)) {
          var n = t.pid;

          a[r] = function () {
            var t = e.format.apply(e, arguments);
            console.error("%s %d: %s", r, n, t);
          };
        } else a[r] = function () {};
        return a[r];
      }, e.inspect = s, s.colors = {
        bold: [1, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        white: [37, 39],
        grey: [90, 39],
        black: [30, 39],
        blue: [34, 39],
        cyan: [36, 39],
        green: [32, 39],
        magenta: [35, 39],
        red: [31, 39],
        yellow: [33, 39]
      }, s.styles = {
        special: "cyan",
        number: "yellow",
        boolean: "yellow",
        undefined: "grey",
        null: "bold",
        string: "green",
        date: "magenta",
        regexp: "red"
      }, e.isArray = d, e.isBoolean = p, e.isNull = g, e.isNullOrUndefined = function (t) {
        return null == t;
      }, e.isNumber = A, e.isString = b, e.isSymbol = function (t) {
        return "symbol" == typeof t;
      }, e.isUndefined = v, e.isRegExp = y, e.isObject = w, e.isDate = m, e.isError = _, e.isFunction = I, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }, e.isBuffer = r(97);
      var S = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      function x(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }

      e.log = function () {
        var t, r;
        console.log("%s - %s", (t = new Date(), r = [P(t.getHours()), P(t.getMinutes()), P(t.getSeconds())].join(":"), [t.getDate(), S[t.getMonth()], r].join(" ")), e.format.apply(e, arguments));
      }, e.inherits = r(0), e._extend = function (t, e) {
        if (!e || !w(e)) return t;

        for (var r = Object.keys(e), n = r.length; n--;) {
          t[r[n]] = e[r[n]];
        }

        return t;
      };
      var C = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;

      function M(t, e) {
        if (!t) {
          var r = new Error("Promise was rejected with a falsy value");
          r.reason = t, t = r;
        }

        return e(t);
      }

      e.promisify = function (t) {
        if ("function" != typeof t) throw new TypeError('The "original" argument must be of type Function');

        if (C && t[C]) {
          var e;
          if ("function" != typeof (e = t[C])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
          return Object.defineProperty(e, C, {
            value: e,
            enumerable: !1,
            writable: !1,
            configurable: !0
          }), e;
        }

        function e() {
          for (var e, r, n = new Promise(function (t, n) {
            e = t, r = n;
          }), i = [], o = 0; o < arguments.length; o++) {
            i.push(arguments[o]);
          }

          i.push(function (t, n) {
            t ? r(t) : e(n);
          });

          try {
            t.apply(this, i);
          } catch (t) {
            r(t);
          }

          return n;
        }

        return Object.setPrototypeOf(e, Object.getPrototypeOf(t)), C && Object.defineProperty(e, C, {
          value: e,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), Object.defineProperties(e, n(t));
      }, e.promisify.custom = C, e.callbackify = function (e) {
        if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');

        function r() {
          for (var r = [], n = 0; n < arguments.length; n++) {
            r.push(arguments[n]);
          }

          var i = r.pop();
          if ("function" != typeof i) throw new TypeError("The last argument must be of type Function");

          var o = this,
              a = function a() {
            return i.apply(o, arguments);
          };

          e.apply(this, r).then(function (e) {
            t.nextTick(a, null, e);
          }, function (e) {
            t.nextTick(M, e, a);
          });
        }

        return Object.setPrototypeOf(r, Object.getPrototypeOf(e)), Object.defineProperties(r, n(e)), r;
      };
    }).call(this, r(6));
  }, function (t, e, r) {
    "use strict";

    var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    },
        i = r(42),
        o = r(47),
        a = r(56),
        s = r(57),
        f = r(2),
        u = r(29),
        c = r(1).Buffer;
    Object.assign(e, r(58)), e.MAX_INTEGER = new f("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), e.TWO_POW256 = new f("10000000000000000000000000000000000000000000000000000000000000000", 16), e.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", e.SHA3_NULL_S = e.KECCAK256_NULL_S, e.KECCAK256_NULL = c.from(e.KECCAK256_NULL_S, "hex"), e.SHA3_NULL = e.KECCAK256_NULL, e.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", e.SHA3_RLP_ARRAY_S = e.KECCAK256_RLP_ARRAY_S, e.KECCAK256_RLP_ARRAY = c.from(e.KECCAK256_RLP_ARRAY_S, "hex"), e.SHA3_RLP_ARRAY = e.KECCAK256_RLP_ARRAY, e.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", e.SHA3_RLP_S = e.KECCAK256_RLP_S, e.KECCAK256_RLP = c.from(e.KECCAK256_RLP_S, "hex"), e.SHA3_RLP = e.KECCAK256_RLP, e.BN = f, e.rlp = s, e.secp256k1 = o, e.zeros = function (t) {
      return c.allocUnsafe(t).fill(0);
    }, e.zeroAddress = function () {
      var t = e.zeros(20);
      return e.bufferToHex(t);
    }, e.setLengthLeft = e.setLength = function (t, r, n) {
      var i = e.zeros(r);
      return t = e.toBuffer(t), n ? t.length < r ? (t.copy(i), i) : t.slice(0, r) : t.length < r ? (t.copy(i, r - t.length), i) : t.slice(-r);
    }, e.setLengthRight = function (t, r) {
      return e.setLength(t, r, !0);
    }, e.unpad = e.stripZeros = function (t) {
      for (var r = (t = e.stripHexPrefix(t))[0]; t.length > 0 && "0" === r.toString();) {
        r = (t = t.slice(1))[0];
      }

      return t;
    }, e.toBuffer = function (t) {
      if (!c.isBuffer(t)) if (Array.isArray(t)) t = c.from(t);else if ("string" == typeof t) t = e.isHexString(t) ? c.from(e.padToEven(e.stripHexPrefix(t)), "hex") : c.from(t);else if ("number" == typeof t) t = e.intToBuffer(t);else if (null == t) t = c.allocUnsafe(0);else if (f.isBN(t)) t = t.toArrayLike(c);else {
        if (!t.toArray) throw new Error("invalid type");
        t = c.from(t.toArray());
      }
      return t;
    }, e.bufferToInt = function (t) {
      return new f(e.toBuffer(t)).toNumber();
    }, e.bufferToHex = function (t) {
      return "0x" + (t = e.toBuffer(t)).toString("hex");
    }, e.fromSigned = function (t) {
      return new f(t).fromTwos(256);
    }, e.toUnsigned = function (t) {
      return c.from(t.toTwos(256).toArray());
    }, e.keccak = function (t, r) {
      return t = e.toBuffer(t), r || (r = 256), i("keccak" + r).update(t).digest();
    }, e.keccak256 = function (t) {
      return e.keccak(t);
    }, e.sha3 = e.keccak, e.sha256 = function (t) {
      return t = e.toBuffer(t), u("sha256").update(t).digest();
    }, e.ripemd160 = function (t, r) {
      t = e.toBuffer(t);
      var n = u("rmd160").update(t).digest();
      return !0 === r ? e.setLength(n, 32) : n;
    }, e.rlphash = function (t) {
      return e.keccak(s.encode(t));
    }, e.isValidPrivate = function (t) {
      return o.privateKeyVerify(t);
    }, e.isValidPublic = function (t, e) {
      return 64 === t.length ? o.publicKeyVerify(c.concat([c.from([4]), t])) : !!e && o.publicKeyVerify(t);
    }, e.pubToAddress = e.publicToAddress = function (t, r) {
      return t = e.toBuffer(t), r && 64 !== t.length && (t = o.publicKeyConvert(t, !1).slice(1)), a(64 === t.length), e.keccak(t).slice(-20);
    };

    var h = e.privateToPublic = function (t) {
      return t = e.toBuffer(t), o.publicKeyCreate(t, !1).slice(1);
    };

    e.importPublic = function (t) {
      return 64 !== (t = e.toBuffer(t)).length && (t = o.publicKeyConvert(t, !1).slice(1)), t;
    }, e.ecsign = function (t, e) {
      var r = o.sign(t, e),
          n = {};
      return n.r = r.signature.slice(0, 32), n.s = r.signature.slice(32, 64), n.v = r.recovery + 27, n;
    }, e.hashPersonalMessage = function (t) {
      var r = e.toBuffer("Ethereum Signed Message:\n" + t.length.toString());
      return e.keccak(c.concat([r, t]));
    }, e.ecrecover = function (t, r, n, i) {
      var a = c.concat([e.setLength(n, 32), e.setLength(i, 32)], 64),
          s = r - 27;
      if (0 !== s && 1 !== s) throw new Error("Invalid signature v value");
      var f = o.recover(t, a, s);
      return o.publicKeyConvert(f, !1).slice(1);
    }, e.toRpcSig = function (t, r, n) {
      if (27 !== t && 28 !== t) throw new Error("Invalid recovery id");
      return e.bufferToHex(c.concat([e.setLengthLeft(r, 32), e.setLengthLeft(n, 32), e.toBuffer(t - 27)]));
    }, e.fromRpcSig = function (t) {
      if (65 !== (t = e.toBuffer(t)).length) throw new Error("Invalid signature length");
      var r = t[64];
      return r < 27 && (r += 27), {
        v: r,
        r: t.slice(0, 32),
        s: t.slice(32, 64)
      };
    }, e.privateToAddress = function (t) {
      return e.publicToAddress(h(t));
    }, e.isValidAddress = function (t) {
      return /^0x[0-9a-fA-F]{40}$/.test(t);
    }, e.isZeroAddress = function (t) {
      return e.zeroAddress() === e.addHexPrefix(t);
    }, e.toChecksumAddress = function (t) {
      t = e.stripHexPrefix(t).toLowerCase();

      for (var r = e.keccak(t).toString("hex"), n = "0x", i = 0; i < t.length; i++) {
        parseInt(r[i], 16) >= 8 ? n += t[i].toUpperCase() : n += t[i];
      }

      return n;
    }, e.isValidChecksumAddress = function (t) {
      return e.isValidAddress(t) && e.toChecksumAddress(t) === t;
    }, e.generateAddress = function (t, r) {
      return t = e.toBuffer(t), r = (r = new f(r)).isZero() ? null : c.from(r.toArray()), e.rlphash([t, r]).slice(-20);
    }, e.isPrecompiled = function (t) {
      var r = e.unpad(t);
      return 1 === r.length && r[0] >= 1 && r[0] <= 8;
    }, e.addHexPrefix = function (t) {
      return "string" != typeof t ? t : e.isHexPrefixed(t) ? t : "0x" + t;
    }, e.isValidSignature = function (t, e, r, n) {
      var i = new f("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
          o = new f("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
      return 32 === e.length && 32 === r.length && (27 === t || 28 === t) && (e = new f(e), r = new f(r), !(e.isZero() || e.gt(o) || r.isZero() || r.gt(o)) && (!1 !== n || 1 !== new f(r).cmp(i)));
    }, e.baToJSON = function (t) {
      if (c.isBuffer(t)) return "0x" + t.toString("hex");

      if (t instanceof Array) {
        for (var r = [], n = 0; n < t.length; n++) {
          r.push(e.baToJSON(t[n]));
        }

        return r;
      }
    }, e.defineProperties = function (t, r, i) {
      if (t.raw = [], t._fields = [], t.toJSON = function (r) {
        if (r) {
          var n = {};
          return t._fields.forEach(function (e) {
            n[e] = "0x" + t[e].toString("hex");
          }), n;
        }

        return e.baToJSON(this.raw);
      }, t.serialize = function () {
        return s.encode(t.raw);
      }, r.forEach(function (r, n) {
        function i() {
          return t.raw[n];
        }

        function o(i) {
          "00" !== (i = e.toBuffer(i)).toString("hex") || r.allowZero || (i = c.allocUnsafe(0)), r.allowLess && r.length ? (i = e.stripZeros(i), a(r.length >= i.length, "The field " + r.name + " must not have more " + r.length + " bytes")) : r.allowZero && 0 === i.length || !r.length || a(r.length === i.length, "The field " + r.name + " must have byte length of " + r.length), t.raw[n] = i;
        }

        t._fields.push(r.name), Object.defineProperty(t, r.name, {
          enumerable: !0,
          configurable: !0,
          get: i,
          set: o
        }), r.default && (t[r.name] = r.default), r.alias && Object.defineProperty(t, r.alias, {
          enumerable: !1,
          configurable: !0,
          set: o,
          get: i
        });
      }), i) if ("string" == typeof i && (i = c.from(e.stripHexPrefix(i), "hex")), c.isBuffer(i) && (i = s.decode(i)), Array.isArray(i)) {
        if (i.length > t._fields.length) throw new Error("wrong number of fields in data");
        i.forEach(function (r, n) {
          t[t._fields[n]] = e.toBuffer(r);
        });
      } else {
        if ("object" !== (void 0 === i ? "undefined" : n(i))) throw new Error("invalid data");
        var o = Object.keys(i);
        r.forEach(function (e) {
          -1 !== o.indexOf(e.name) && (t[e.name] = i[e.name]), -1 !== o.indexOf(e.alias) && (t[e.alias] = i[e.alias]);
        });
      }
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = r(98)(r(114));
  }, function (t, e, r) {
    "use strict";

    (function (e, n) {
      var i = r(18);
      t.exports = y;
      var o,
          a = r(103);
      y.ReadableState = v;
      r(25).EventEmitter;

      var s = function s(t, e) {
        return t.listeners(e).length;
      },
          f = r(44),
          u = r(1).Buffer,
          c = e.Uint8Array || function () {};

      var h = r(11);
      h.inherits = r(0);
      var l = r(104),
          d = void 0;
      d = l && l.debuglog ? l.debuglog("stream") : function () {};
      var p,
          g = r(105),
          A = r(45);
      h.inherits(y, f);
      var b = ["error", "close", "destroy", "pause", "resume"];

      function v(t, e) {
        t = t || {};
        var n = e instanceof (o = o || r(8));
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
        var i = t.highWaterMark,
            a = t.readableHighWaterMark,
            s = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : s, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new g(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = r(28).StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
      }

      function y(t) {
        if (o = o || r(8), !(this instanceof y)) return new y(t);
        this._readableState = new v(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), f.call(this);
      }

      function w(t, e, r, n, i) {
        var o,
            a = t._readableState;
        null === e ? (a.reading = !1, function (t, e) {
          if (e.ended) return;

          if (e.decoder) {
            var r = e.decoder.end();
            r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
          }

          e.ended = !0, E(t);
        }(t, a)) : (i || (o = function (t, e) {
          var r;
          n = e, u.isBuffer(n) || n instanceof c || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
          var n;
          return r;
        }(a, e)), o ? t.emit("error", o) : a.objectMode || e && e.length > 0 ? ("string" == typeof e || a.objectMode || Object.getPrototypeOf(e) === u.prototype || (e = function (t) {
          return u.from(t);
        }(e)), n ? a.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : m(t, a, e, !0) : a.ended ? t.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !r ? (e = a.decoder.write(e), a.objectMode || 0 !== e.length ? m(t, a, e, !1) : S(t, a)) : m(t, a, e, !1))) : n || (a.reading = !1));
        return function (t) {
          return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
        }(a);
      }

      function m(t, e, r, n) {
        e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && E(t)), S(t, e);
      }

      Object.defineProperty(y.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(t) {
          this._readableState && (this._readableState.destroyed = t);
        }
      }), y.prototype.destroy = A.destroy, y.prototype._undestroy = A.undestroy, y.prototype._destroy = function (t, e) {
        this.push(null), e(t);
      }, y.prototype.push = function (t, e) {
        var r,
            n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = u.from(t, e), e = ""), r = !0), w(this, t, e, !1, r);
      }, y.prototype.unshift = function (t) {
        return w(this, t, null, !0, !1);
      }, y.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, y.prototype.setEncoding = function (t) {
        return p || (p = r(28).StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
      };
      var _ = 8388608;

      function I(t, e) {
        return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
          return t >= _ ? t = _ : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
        }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
      }

      function E(t) {
        var e = t._readableState;
        e.needReadable = !1, e.emittedReadable || (d("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(P, t) : P(t));
      }

      function P(t) {
        d("emit readable"), t.emit("readable"), T(t);
      }

      function S(t, e) {
        e.readingMore || (e.readingMore = !0, i.nextTick(x, t, e));
      }

      function x(t, e) {
        for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (d("maybeReadMore read 0"), t.read(0), r !== e.length);) {
          r = e.length;
        }

        e.readingMore = !1;
      }

      function C(t) {
        d("readable nexttick read 0"), t.read(0);
      }

      function M(t, e) {
        e.reading || (d("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), T(t), e.flowing && !e.reading && t.read(0);
      }

      function T(t) {
        var e = t._readableState;

        for (d("flow", e.flowing); e.flowing && null !== t.read();) {
          ;
        }
      }

      function k(t, e) {
        return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function (t, e, r) {
          var n;
          t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function (t, e) {
            var r = e.head,
                n = 1,
                i = r.data;
            t -= i.length;

            for (; r = r.next;) {
              var o = r.data,
                  a = t > o.length ? o.length : t;

              if (a === o.length ? i += o : i += o.slice(0, t), 0 === (t -= a)) {
                a === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(a));
                break;
              }

              ++n;
            }

            return e.length -= n, i;
          }(t, e) : function (t, e) {
            var r = u.allocUnsafe(t),
                n = e.head,
                i = 1;
            n.data.copy(r), t -= n.data.length;

            for (; n = n.next;) {
              var o = n.data,
                  a = t > o.length ? o.length : t;

              if (o.copy(r, r.length - t, 0, a), 0 === (t -= a)) {
                a === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(a));
                break;
              }

              ++i;
            }

            return e.length -= i, r;
          }(t, e);
          return n;
        }(t, e.buffer, e.decoder), r);
        var r;
      }

      function R(t) {
        var e = t._readableState;
        if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        e.endEmitted || (e.ended = !0, i.nextTick(B, e, t));
      }

      function B(t, e) {
        t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
      }

      function L(t, e) {
        for (var r = 0, n = t.length; r < n; r++) {
          if (t[r] === e) return r;
        }

        return -1;
      }

      y.prototype.read = function (t) {
        d("read", t), t = parseInt(t, 10);
        var e = this._readableState,
            r = t;
        if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return d("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? R(this) : E(this), null;
        if (0 === (t = I(t, e)) && e.ended) return 0 === e.length && R(this), null;
        var n,
            i = e.needReadable;
        return d("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && d("length less than watermark", i = !0), e.ended || e.reading ? d("reading or ended", i = !1) : i && (d("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = I(r, e))), null === (n = t > 0 ? k(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && R(this)), null !== n && this.emit("data", n), n;
      }, y.prototype._read = function (t) {
        this.emit("error", new Error("_read() is not implemented"));
      }, y.prototype.pipe = function (t, e) {
        var r = this,
            o = this._readableState;

        switch (o.pipesCount) {
          case 0:
            o.pipes = t;
            break;

          case 1:
            o.pipes = [o.pipes, t];
            break;

          default:
            o.pipes.push(t);
        }

        o.pipesCount += 1, d("pipe count=%d opts=%j", o.pipesCount, e);
        var f = (!e || !1 !== e.end) && t !== n.stdout && t !== n.stderr ? c : y;

        function u(e, n) {
          d("onunpipe"), e === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, d("cleanup"), t.removeListener("close", b), t.removeListener("finish", v), t.removeListener("drain", h), t.removeListener("error", A), t.removeListener("unpipe", u), r.removeListener("end", c), r.removeListener("end", y), r.removeListener("data", g), l = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || h());
        }

        function c() {
          d("onend"), t.end();
        }

        o.endEmitted ? i.nextTick(f) : r.once("end", f), t.on("unpipe", u);

        var h = function (t) {
          return function () {
            var e = t._readableState;
            d("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && s(t, "data") && (e.flowing = !0, T(t));
          };
        }(r);

        t.on("drain", h);
        var l = !1;
        var p = !1;

        function g(e) {
          d("ondata"), p = !1, !1 !== t.write(e) || p || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== L(o.pipes, t)) && !l && (d("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, p = !0), r.pause());
        }

        function A(e) {
          d("onerror", e), y(), t.removeListener("error", A), 0 === s(t, "error") && t.emit("error", e);
        }

        function b() {
          t.removeListener("finish", v), y();
        }

        function v() {
          d("onfinish"), t.removeListener("close", b), y();
        }

        function y() {
          d("unpipe"), r.unpipe(t);
        }

        return r.on("data", g), function (t, e, r) {
          if ("function" == typeof t.prependListener) return t.prependListener(e, r);
          t._events && t._events[e] ? a(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r);
        }(t, "error", A), t.once("close", b), t.once("finish", v), t.emit("pipe", r), o.flowing || (d("pipe resume"), r.resume()), t;
      }, y.prototype.unpipe = function (t) {
        var e = this._readableState,
            r = {
          hasUnpiped: !1
        };
        if (0 === e.pipesCount) return this;
        if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r), this);

        if (!t) {
          var n = e.pipes,
              i = e.pipesCount;
          e.pipes = null, e.pipesCount = 0, e.flowing = !1;

          for (var o = 0; o < i; o++) {
            n[o].emit("unpipe", this, r);
          }

          return this;
        }

        var a = L(e.pipes, t);
        return -1 === a ? this : (e.pipes.splice(a, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r), this);
      }, y.prototype.on = function (t, e) {
        var r = f.prototype.on.call(this, t, e);
        if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
          var n = this._readableState;
          n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && E(this) : i.nextTick(C, this));
        }
        return r;
      }, y.prototype.addListener = y.prototype.on, y.prototype.resume = function () {
        var t = this._readableState;
        return t.flowing || (d("resume"), t.flowing = !0, function (t, e) {
          e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(M, t, e));
        }(this, t)), this;
      }, y.prototype.pause = function () {
        return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, y.prototype.wrap = function (t) {
        var e = this,
            r = this._readableState,
            n = !1;

        for (var i in t.on("end", function () {
          if (d("wrapped end"), r.decoder && !r.ended) {
            var t = r.decoder.end();
            t && t.length && e.push(t);
          }

          e.push(null);
        }), t.on("data", function (i) {
          (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
        }), t) {
          void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
            return function () {
              return t[e].apply(t, arguments);
            };
          }(i));
        }

        for (var o = 0; o < b.length; o++) {
          t.on(b[o], this.emit.bind(this, b[o]));
        }

        return this._read = function (e) {
          d("wrapped _read", e), n && (n = !1, t.resume());
        }, this;
      }, Object.defineProperty(y.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), y._fromList = k;
    }).call(this, r(5), r(6));
  }, function (t, e, r) {
    t.exports = r(25).EventEmitter;
  }, function (t, e, r) {
    "use strict";

    var n = r(18);

    function i(t, e) {
      t.emit("error", e);
    }

    t.exports = {
      destroy: function destroy(t, e) {
        var r = this,
            o = this._readableState && this._readableState.destroyed,
            a = this._writableState && this._writableState.destroyed;
        return o || a ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
          !e && t ? (n.nextTick(i, r, t), r._writableState && (r._writableState.errorEmitted = !0)) : e && e(t);
        }), this);
      },
      undestroy: function undestroy() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = a;
    var n = r(8),
        i = r(11);

    function o(t, e) {
      var r = this._transformState;
      r.transforming = !1;
      var n = r.writecb;
      if (!n) return this.emit("error", new Error("write callback called multiple times"));
      r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }

    function a(t) {
      if (!(this instanceof a)) return new a(t);
      n.call(this, t), this._transformState = {
        afterTransform: o.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", s);
    }

    function s() {
      var t = this;
      "function" == typeof this._flush ? this._flush(function (e, r) {
        f(t, e, r);
      }) : f(this, null, null);
    }

    function f(t, e, r) {
      if (e) return t.emit("error", e);
      if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return t.push(null);
    }

    i.inherits = r(0), i.inherits(a, n), a.prototype.push = function (t, e) {
      return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e);
    }, a.prototype._transform = function (t, e, r) {
      throw new Error("_transform() is not implemented");
    }, a.prototype._write = function (t, e, r) {
      var n = this._transformState;

      if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
        var i = this._readableState;
        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, a.prototype._read = function (t) {
      var e = this._transformState;
      null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
    }, a.prototype._destroy = function (t, e) {
      var r = this;

      n.prototype._destroy.call(this, t, function (t) {
        e(t), r.emit("close");
      });
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = r(116)(r(120));
  }, function (t) {
    t.exports = {
      COMPRESSED_TYPE_INVALID: "compressed should be a boolean",
      EC_PRIVATE_KEY_TYPE_INVALID: "private key should be a Buffer",
      EC_PRIVATE_KEY_LENGTH_INVALID: "private key length is invalid",
      EC_PRIVATE_KEY_RANGE_INVALID: "private key range is invalid",
      EC_PRIVATE_KEY_TWEAK_ADD_FAIL: "tweak out of range or resulting private key is invalid",
      EC_PRIVATE_KEY_TWEAK_MUL_FAIL: "tweak out of range",
      EC_PRIVATE_KEY_EXPORT_DER_FAIL: "couldn't export to DER format",
      EC_PRIVATE_KEY_IMPORT_DER_FAIL: "couldn't import from DER format",
      EC_PUBLIC_KEYS_TYPE_INVALID: "public keys should be an Array",
      EC_PUBLIC_KEYS_LENGTH_INVALID: "public keys Array should have at least 1 element",
      EC_PUBLIC_KEY_TYPE_INVALID: "public key should be a Buffer",
      EC_PUBLIC_KEY_LENGTH_INVALID: "public key length is invalid",
      EC_PUBLIC_KEY_PARSE_FAIL: "the public key could not be parsed or is invalid",
      EC_PUBLIC_KEY_CREATE_FAIL: "private was invalid, try again",
      EC_PUBLIC_KEY_TWEAK_ADD_FAIL: "tweak out of range or resulting public key is invalid",
      EC_PUBLIC_KEY_TWEAK_MUL_FAIL: "tweak out of range",
      EC_PUBLIC_KEY_COMBINE_FAIL: "the sum of the public keys is not valid",
      ECDH_FAIL: "scalar was invalid (zero or overflow)",
      ECDSA_SIGNATURE_TYPE_INVALID: "signature should be a Buffer",
      ECDSA_SIGNATURE_LENGTH_INVALID: "signature length is invalid",
      ECDSA_SIGNATURE_PARSE_FAIL: "couldn't parse signature",
      ECDSA_SIGNATURE_PARSE_DER_FAIL: "couldn't parse DER signature",
      ECDSA_SIGNATURE_SERIALIZE_DER_FAIL: "couldn't serialize signature to DER format",
      ECDSA_SIGN_FAIL: "nonce generation function failed or private key is invalid",
      ECDSA_RECOVER_FAIL: "couldn't recover public key from signature",
      MSG32_TYPE_INVALID: "message should be a Buffer",
      MSG32_LENGTH_INVALID: "message length is invalid",
      OPTIONS_TYPE_INVALID: "options should be an Object",
      OPTIONS_DATA_TYPE_INVALID: "options.data should be a Buffer",
      OPTIONS_DATA_LENGTH_INVALID: "options.data length is invalid",
      OPTIONS_NONCEFN_TYPE_INVALID: "options.noncefn should be a Function",
      RECOVERY_ID_TYPE_INVALID: "recovery should be a Number",
      RECOVERY_ID_VALUE_INVALID: "recovery should have value between -1 and 4",
      TWEAK_TYPE_INVALID: "tweak should be a Buffer",
      TWEAK_LENGTH_INVALID: "tweak length is invalid"
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(17).Transform;

    function o(t) {
      i.call(this), this._block = n.allocUnsafe(t), this._blockSize = t, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
    }

    r(0)(o, i), o.prototype._transform = function (t, e, r) {
      var n = null;

      try {
        this.update(t, e);
      } catch (t) {
        n = t;
      }

      r(n);
    }, o.prototype._flush = function (t) {
      var e = null;

      try {
        this.push(this.digest());
      } catch (t) {
        e = t;
      }

      t(e);
    }, o.prototype.update = function (t, e) {
      if (function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError(e + " must be a string or a buffer");
      }(t, "Data"), this._finalized) throw new Error("Digest already called");
      n.isBuffer(t) || (t = n.from(t, e));

      for (var r = this._block, i = 0; this._blockOffset + t.length - i >= this._blockSize;) {
        for (var o = this._blockOffset; o < this._blockSize;) {
          r[o++] = t[i++];
        }

        this._update(), this._blockOffset = 0;
      }

      for (; i < t.length;) {
        r[this._blockOffset++] = t[i++];
      }

      for (var a = 0, s = 8 * t.length; s > 0; ++a) {
        this._length[a] += s, (s = this._length[a] / 4294967296 | 0) > 0 && (this._length[a] -= 4294967296 * s);
      }

      return this;
    }, o.prototype._update = function () {
      throw new Error("_update is not implemented");
    }, o.prototype.digest = function (t) {
      if (this._finalized) throw new Error("Digest already called");
      this._finalized = !0;

      var e = this._digest();

      void 0 !== t && (e = e.toString(t)), this._block.fill(0), this._blockOffset = 0;

      for (var r = 0; r < 4; ++r) {
        this._length[r] = 0;
      }

      return e;
    }, o.prototype._digest = function () {
      throw new Error("_digest is not implemented");
    }, t.exports = o;
  }, function (t, e, r) {
    var n = r(0),
        i = r(10),
        o = r(1).Buffer,
        a = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
        s = new Array(64);

    function f() {
      this.init(), this._w = s, i.call(this, 64, 56);
    }

    function u(t, e, r) {
      return r ^ t & (e ^ r);
    }

    function c(t, e, r) {
      return t & e | r & (t | e);
    }

    function h(t) {
      return (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10);
    }

    function l(t) {
      return (t >>> 6 | t << 26) ^ (t >>> 11 | t << 21) ^ (t >>> 25 | t << 7);
    }

    function d(t) {
      return (t >>> 7 | t << 25) ^ (t >>> 18 | t << 14) ^ t >>> 3;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
    }, f.prototype._update = function (t) {
      for (var e, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, p = 0 | this._f, g = 0 | this._g, A = 0 | this._h, b = 0; b < 16; ++b) {
        r[b] = t.readInt32BE(4 * b);
      }

      for (; b < 64; ++b) {
        r[b] = 0 | (((e = r[b - 2]) >>> 17 | e << 15) ^ (e >>> 19 | e << 13) ^ e >>> 10) + r[b - 7] + d(r[b - 15]) + r[b - 16];
      }

      for (var v = 0; v < 64; ++v) {
        var y = A + l(f) + u(f, p, g) + a[v] + r[v] | 0,
            w = h(n) + c(n, i, o) | 0;
        A = g, g = p, p = f, f = s + y | 0, s = o, o = i, i = n, n = y + w | 0;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0, this._f = p + this._f | 0, this._g = g + this._g | 0, this._h = A + this._h | 0;
    }, f.prototype._hash = function () {
      var t = o.allocUnsafe(32);
      return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t.writeInt32BE(this._h, 28), t;
    }, t.exports = f;
  }, function (t, e, r) {
    var n = r(0),
        i = r(10),
        o = r(1).Buffer,
        a = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591],
        s = new Array(160);

    function f() {
      this.init(), this._w = s, i.call(this, 128, 112);
    }

    function u(t, e, r) {
      return r ^ t & (e ^ r);
    }

    function c(t, e, r) {
      return t & e | r & (t | e);
    }

    function h(t, e) {
      return (t >>> 28 | e << 4) ^ (e >>> 2 | t << 30) ^ (e >>> 7 | t << 25);
    }

    function l(t, e) {
      return (t >>> 14 | e << 18) ^ (t >>> 18 | e << 14) ^ (e >>> 9 | t << 23);
    }

    function d(t, e) {
      return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ t >>> 7;
    }

    function p(t, e) {
      return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ (t >>> 7 | e << 25);
    }

    function g(t, e) {
      return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ t >>> 6;
    }

    function A(t, e) {
      return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ (t >>> 6 | e << 26);
    }

    function b(t, e) {
      return t >>> 0 < e >>> 0 ? 1 : 0;
    }

    n(f, i), f.prototype.init = function () {
      return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
    }, f.prototype._update = function (t) {
      for (var e = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, o = 0 | this._dh, s = 0 | this._eh, f = 0 | this._fh, v = 0 | this._gh, y = 0 | this._hh, w = 0 | this._al, m = 0 | this._bl, _ = 0 | this._cl, I = 0 | this._dl, E = 0 | this._el, P = 0 | this._fl, S = 0 | this._gl, x = 0 | this._hl, C = 0; C < 32; C += 2) {
        e[C] = t.readInt32BE(4 * C), e[C + 1] = t.readInt32BE(4 * C + 4);
      }

      for (; C < 160; C += 2) {
        var M = e[C - 30],
            T = e[C - 30 + 1],
            k = d(M, T),
            R = p(T, M),
            B = g(M = e[C - 4], T = e[C - 4 + 1]),
            L = A(T, M),
            O = e[C - 14],
            j = e[C - 14 + 1],
            D = e[C - 32],
            H = e[C - 32 + 1],
            z = R + j | 0,
            N = k + O + b(z, R) | 0;
        N = (N = N + B + b(z = z + L | 0, L) | 0) + D + b(z = z + H | 0, H) | 0, e[C] = N, e[C + 1] = z;
      }

      for (var q = 0; q < 160; q += 2) {
        N = e[q], z = e[q + 1];
        var U = c(r, n, i),
            V = c(w, m, _),
            W = h(r, w),
            Y = h(w, r),
            F = l(s, E),
            Z = l(E, s),
            X = a[q],
            K = a[q + 1],
            J = u(s, f, v),
            G = u(E, P, S),
            Q = x + Z | 0,
            $ = y + F + b(Q, x) | 0;
        $ = ($ = ($ = $ + J + b(Q = Q + G | 0, G) | 0) + X + b(Q = Q + K | 0, K) | 0) + N + b(Q = Q + z | 0, z) | 0;
        var tt = Y + V | 0,
            et = W + U + b(tt, Y) | 0;
        y = v, x = S, v = f, S = P, f = s, P = E, s = o + $ + b(E = I + Q | 0, I) | 0, o = i, I = _, i = n, _ = m, n = r, m = w, r = $ + et + b(w = Q + tt | 0, Q) | 0;
      }

      this._al = this._al + w | 0, this._bl = this._bl + m | 0, this._cl = this._cl + _ | 0, this._dl = this._dl + I | 0, this._el = this._el + E | 0, this._fl = this._fl + P | 0, this._gl = this._gl + S | 0, this._hl = this._hl + x | 0, this._ah = this._ah + r + b(this._al, w) | 0, this._bh = this._bh + n + b(this._bl, m) | 0, this._ch = this._ch + i + b(this._cl, _) | 0, this._dh = this._dh + o + b(this._dl, I) | 0, this._eh = this._eh + s + b(this._el, E) | 0, this._fh = this._fh + f + b(this._fl, P) | 0, this._gh = this._gh + v + b(this._gl, S) | 0, this._hh = this._hh + y + b(this._hl, x) | 0;
    }, f.prototype._hash = function () {
      var t = o.allocUnsafe(64);

      function e(e, r, n) {
        t.writeInt32BE(e, n), t.writeInt32BE(r, n + 4);
      }

      return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), e(this._gh, this._gl, 48), e(this._hh, this._hl, 56), t;
    }, t.exports = f;
  }, function (t, e, r) {
    "use strict";

    var n = e;

    function i(t) {
      return 1 === t.length ? "0" + t : t;
    }

    function o(t) {
      for (var e = "", r = 0; r < t.length; r++) {
        e += i(t[r].toString(16));
      }

      return e;
    }

    n.toArray = function (t, e) {
      if (Array.isArray(t)) return t.slice();
      if (!t) return [];
      var r = [];

      if ("string" != typeof t) {
        for (var n = 0; n < t.length; n++) {
          r[n] = 0 | t[n];
        }

        return r;
      }

      if ("hex" === e) for ((t = t.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (t = "0" + t), n = 0; n < t.length; n += 2) {
        r.push(parseInt(t[n] + t[n + 1], 16));
      } else for (n = 0; n < t.length; n++) {
        var i = t.charCodeAt(n),
            o = i >> 8,
            a = 255 & i;
        o ? r.push(o, a) : r.push(a);
      }
      return r;
    }, n.zero2 = i, n.toHex = o, n.encode = function (t, e) {
      return "hex" === e ? o(t) : t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4).rotr32;

    function i(t, e, r) {
      return t & e ^ ~t & r;
    }

    function o(t, e, r) {
      return t & e ^ t & r ^ e & r;
    }

    function a(t, e, r) {
      return t ^ e ^ r;
    }

    e.ft_1 = function (t, e, r, n) {
      return 0 === t ? i(e, r, n) : 1 === t || 3 === t ? a(e, r, n) : 2 === t ? o(e, r, n) : void 0;
    }, e.ch32 = i, e.maj32 = o, e.p32 = a, e.s0_256 = function (t) {
      return n(t, 2) ^ n(t, 13) ^ n(t, 22);
    }, e.s1_256 = function (t) {
      return n(t, 6) ^ n(t, 11) ^ n(t, 25);
    }, e.g0_256 = function (t) {
      return n(t, 7) ^ n(t, 18) ^ t >>> 3;
    }, e.g1_256 = function (t) {
      return n(t, 17) ^ n(t, 19) ^ t >>> 10;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(12),
        o = r(53),
        a = r(9),
        s = n.sum32,
        f = n.sum32_4,
        u = n.sum32_5,
        c = o.ch32,
        h = o.maj32,
        l = o.s0_256,
        d = o.s1_256,
        p = o.g0_256,
        g = o.g1_256,
        A = i.BlockHash,
        b = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

    function v() {
      if (!(this instanceof v)) return new v();
      A.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = b, this.W = new Array(64);
    }

    n.inherits(v, A), t.exports = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function (t, e) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n++) {
        r[n] = f(g(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
      }

      var i = this.h[0],
          o = this.h[1],
          A = this.h[2],
          b = this.h[3],
          v = this.h[4],
          y = this.h[5],
          w = this.h[6],
          m = this.h[7];

      for (a(this.k.length === r.length), n = 0; n < r.length; n++) {
        var _ = u(m, d(v), c(v, y, w), this.k[n], r[n]),
            I = s(l(i), h(i, o, A));

        m = w, w = y, y = v, v = s(b, _), b = A, A = o, o = i, i = s(_, I);
      }

      this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], A), this.h[3] = s(this.h[3], b), this.h[4] = s(this.h[4], v), this.h[5] = s(this.h[5], y), this.h[6] = s(this.h[6], w), this.h[7] = s(this.h[7], m);
    }, v.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(12),
        o = r(9),
        a = n.rotr64_hi,
        s = n.rotr64_lo,
        f = n.shr64_hi,
        u = n.shr64_lo,
        c = n.sum64,
        h = n.sum64_hi,
        l = n.sum64_lo,
        d = n.sum64_4_hi,
        p = n.sum64_4_lo,
        g = n.sum64_5_hi,
        A = n.sum64_5_lo,
        b = i.BlockHash,
        v = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

    function y() {
      if (!(this instanceof y)) return new y();
      b.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = v, this.W = new Array(160);
    }

    function w(t, e, r, n, i) {
      var o = t & r ^ ~t & i;
      return o < 0 && (o += 4294967296), o;
    }

    function m(t, e, r, n, i, o) {
      var a = e & n ^ ~e & o;
      return a < 0 && (a += 4294967296), a;
    }

    function _(t, e, r, n, i) {
      var o = t & r ^ t & i ^ r & i;
      return o < 0 && (o += 4294967296), o;
    }

    function I(t, e, r, n, i, o) {
      var a = e & n ^ e & o ^ n & o;
      return a < 0 && (a += 4294967296), a;
    }

    function E(t, e) {
      var r = a(t, e, 28) ^ a(e, t, 2) ^ a(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function P(t, e) {
      var r = s(t, e, 28) ^ s(e, t, 2) ^ s(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function S(t, e) {
      var r = a(t, e, 14) ^ a(t, e, 18) ^ a(e, t, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function x(t, e) {
      var r = s(t, e, 14) ^ s(t, e, 18) ^ s(e, t, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function C(t, e) {
      var r = a(t, e, 1) ^ a(t, e, 8) ^ f(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function M(t, e) {
      var r = s(t, e, 1) ^ s(t, e, 8) ^ u(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function T(t, e) {
      var r = a(t, e, 19) ^ a(e, t, 29) ^ f(t, e, 6);
      return r < 0 && (r += 4294967296), r;
    }

    function k(t, e) {
      var r = s(t, e, 19) ^ s(e, t, 29) ^ u(t, e, 6);
      return r < 0 && (r += 4294967296), r;
    }

    n.inherits(y, b), t.exports = y, y.blockSize = 1024, y.outSize = 512, y.hmacStrength = 192, y.padLength = 128, y.prototype._prepareBlock = function (t, e) {
      for (var r = this.W, n = 0; n < 32; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n += 2) {
        var i = T(r[n - 4], r[n - 3]),
            o = k(r[n - 4], r[n - 3]),
            a = r[n - 14],
            s = r[n - 13],
            f = C(r[n - 30], r[n - 29]),
            u = M(r[n - 30], r[n - 29]),
            c = r[n - 32],
            h = r[n - 31];
        r[n] = d(i, o, a, s, f, u, c, h), r[n + 1] = p(i, o, a, s, f, u, c, h);
      }
    }, y.prototype._update = function (t, e) {
      this._prepareBlock(t, e);

      var r = this.W,
          n = this.h[0],
          i = this.h[1],
          a = this.h[2],
          s = this.h[3],
          f = this.h[4],
          u = this.h[5],
          d = this.h[6],
          p = this.h[7],
          b = this.h[8],
          v = this.h[9],
          y = this.h[10],
          C = this.h[11],
          M = this.h[12],
          T = this.h[13],
          k = this.h[14],
          R = this.h[15];
      o(this.k.length === r.length);

      for (var B = 0; B < r.length; B += 2) {
        var L = k,
            O = R,
            j = S(b, v),
            D = x(b, v),
            H = w(b, v, y, C, M),
            z = m(b, v, y, C, M, T),
            N = this.k[B],
            q = this.k[B + 1],
            U = r[B],
            V = r[B + 1],
            W = g(L, O, j, D, H, z, N, q, U, V),
            Y = A(L, O, j, D, H, z, N, q, U, V);
        L = E(n, i), O = P(n, i), j = _(n, i, a, s, f), D = I(n, i, a, s, f, u);
        var F = h(L, O, j, D),
            Z = l(L, O, j, D);
        k = M, R = T, M = y, T = C, y = b, C = v, b = h(d, p, W, Y), v = l(p, p, W, Y), d = f, p = u, f = a, u = s, a = n, s = i, n = h(W, Y, F, Z), i = l(W, Y, F, Z);
      }

      c(this.h, 0, n, i), c(this.h, 2, a, s), c(this.h, 4, f, u), c(this.h, 6, d, p), c(this.h, 8, b, v), c(this.h, 10, y, C), c(this.h, 12, M, T), c(this.h, 14, k, R);
    }, y.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */
      function n(t, e) {
        if (t === e) return 0;

        for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (t[i] !== e[i]) {
            r = t[i], n = e[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }

      function i(t) {
        return e.Buffer && "function" == typeof e.Buffer.isBuffer ? e.Buffer.isBuffer(t) : !(null == t || !t._isBuffer);
      }

      var o = r(40),
          a = Object.prototype.hasOwnProperty,
          s = Array.prototype.slice,
          f = "foo" === function () {}.name;

      function u(t) {
        return Object.prototype.toString.call(t);
      }

      function c(t) {
        return !i(t) && "function" == typeof e.ArrayBuffer && ("function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : !!t && (t instanceof DataView || !!(t.buffer && t.buffer instanceof ArrayBuffer)));
      }

      var h = t.exports = b,
          l = /\s*function\s+([^\(\s]*)\s*/;

      function d(t) {
        if (o.isFunction(t)) {
          if (f) return t.name;
          var e = t.toString().match(l);
          return e && e[1];
        }
      }

      function p(t, e) {
        return "string" == typeof t ? t.length < e ? t : t.slice(0, e) : t;
      }

      function g(t) {
        if (f || !o.isFunction(t)) return o.inspect(t);
        var e = d(t);
        return "[Function" + (e ? ": " + e : "") + "]";
      }

      function A(t, e, r, n, i) {
        throw new h.AssertionError({
          message: r,
          actual: t,
          expected: e,
          operator: n,
          stackStartFunction: i
        });
      }

      function b(t, e) {
        t || A(t, !0, e, "==", h.ok);
      }

      function v(t, e, r, a) {
        if (t === e) return !0;
        if (i(t) && i(e)) return 0 === n(t, e);
        if (o.isDate(t) && o.isDate(e)) return t.getTime() === e.getTime();
        if (o.isRegExp(t) && o.isRegExp(e)) return t.source === e.source && t.global === e.global && t.multiline === e.multiline && t.lastIndex === e.lastIndex && t.ignoreCase === e.ignoreCase;

        if (null !== t && "object" == typeof t || null !== e && "object" == typeof e) {
          if (c(t) && c(e) && u(t) === u(e) && !(t instanceof Float32Array || t instanceof Float64Array)) return 0 === n(new Uint8Array(t.buffer), new Uint8Array(e.buffer));
          if (i(t) !== i(e)) return !1;
          var f = (a = a || {
            actual: [],
            expected: []
          }).actual.indexOf(t);
          return -1 !== f && f === a.expected.indexOf(e) || (a.actual.push(t), a.expected.push(e), function (t, e, r, n) {
            if (null == t || null == e) return !1;
            if (o.isPrimitive(t) || o.isPrimitive(e)) return t === e;
            if (r && Object.getPrototypeOf(t) !== Object.getPrototypeOf(e)) return !1;
            var i = y(t),
                a = y(e);
            if (i && !a || !i && a) return !1;
            if (i) return t = s.call(t), e = s.call(e), v(t, e, r);

            var f,
                u,
                c = _(t),
                h = _(e);

            if (c.length !== h.length) return !1;

            for (c.sort(), h.sort(), u = c.length - 1; u >= 0; u--) {
              if (c[u] !== h[u]) return !1;
            }

            for (u = c.length - 1; u >= 0; u--) {
              if (f = c[u], !v(t[f], e[f], r, n)) return !1;
            }

            return !0;
          }(t, e, r, a));
        }

        return r ? t === e : t == e;
      }

      function y(t) {
        return "[object Arguments]" == Object.prototype.toString.call(t);
      }

      function w(t, e) {
        if (!t || !e) return !1;
        if ("[object RegExp]" == Object.prototype.toString.call(e)) return e.test(t);

        try {
          if (t instanceof e) return !0;
        } catch (t) {}

        return !Error.isPrototypeOf(e) && !0 === e.call({}, t);
      }

      function m(t, e, r, n) {
        var i;
        if ("function" != typeof e) throw new TypeError('"block" argument must be a function');
        "string" == typeof r && (n = r, r = null), i = function (t) {
          var e;

          try {
            t();
          } catch (t) {
            e = t;
          }

          return e;
        }(e), n = (r && r.name ? " (" + r.name + ")." : ".") + (n ? " " + n : "."), t && !i && A(i, r, "Missing expected exception" + n);
        var a = "string" == typeof n,
            s = !t && i && !r;
        if ((!t && o.isError(i) && a && w(i, r) || s) && A(i, r, "Got unwanted exception" + n), t && i && r && !w(i, r) || !t && i) throw i;
      }

      h.AssertionError = function (t) {
        var e;
        this.name = "AssertionError", this.actual = t.actual, this.expected = t.expected, this.operator = t.operator, t.message ? (this.message = t.message, this.generatedMessage = !1) : (this.message = p(g((e = this).actual), 128) + " " + e.operator + " " + p(g(e.expected), 128), this.generatedMessage = !0);
        var r = t.stackStartFunction || A;
        if (Error.captureStackTrace) Error.captureStackTrace(this, r);else {
          var n = new Error();

          if (n.stack) {
            var i = n.stack,
                o = d(r),
                a = i.indexOf("\n" + o);

            if (a >= 0) {
              var s = i.indexOf("\n", a + 1);
              i = i.substring(s + 1);
            }

            this.stack = i;
          }
        }
      }, o.inherits(h.AssertionError, Error), h.fail = A, h.ok = b, h.equal = function (t, e, r) {
        t != e && A(t, e, r, "==", h.equal);
      }, h.notEqual = function (t, e, r) {
        t == e && A(t, e, r, "!=", h.notEqual);
      }, h.deepEqual = function (t, e, r) {
        v(t, e, !1) || A(t, e, r, "deepEqual", h.deepEqual);
      }, h.deepStrictEqual = function (t, e, r) {
        v(t, e, !0) || A(t, e, r, "deepStrictEqual", h.deepStrictEqual);
      }, h.notDeepEqual = function (t, e, r) {
        v(t, e, !1) && A(t, e, r, "notDeepEqual", h.notDeepEqual);
      }, h.notDeepStrictEqual = function t(e, r, n) {
        v(e, r, !0) && A(e, r, n, "notDeepStrictEqual", t);
      }, h.strictEqual = function (t, e, r) {
        t !== e && A(t, e, r, "===", h.strictEqual);
      }, h.notStrictEqual = function (t, e, r) {
        t === e && A(t, e, r, "!==", h.notStrictEqual);
      }, h.throws = function (t, e, r) {
        m(!0, t, e, r);
      }, h.doesNotThrow = function (t, e, r) {
        m(!1, t, e, r);
      }, h.ifError = function (t) {
        if (t) throw t;
      };

      var _ = Object.keys || function (t) {
        var e = [];

        for (var r in t) {
          a.call(t, r) && e.push(r);
        }

        return e;
      };
    }).call(this, r(5));
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(2);

      function i(t, e) {
        if ("00" === t.slice(0, 2)) throw new Error("invalid RLP: extra zeros");
        return parseInt(t, e);
      }

      function o(e, r) {
        if (e < 56) return t.from([e + r]);
        var n = s(e),
            i = s(r + 55 + n.length / 2);
        return t.from(i + n, "hex");
      }

      function a(t) {
        return "0x" === t.slice(0, 2);
      }

      function s(t) {
        if (t < 0) throw new Error("Invalid integer as argument, must be unsigned!");
        var e = t.toString(16);
        return e.length % 2 ? "0" + e : e;
      }

      function f(e) {
        if (!t.isBuffer(e)) {
          if ("string" == typeof e) return a(e) ? t.from((i = "string" != typeof (o = e) ? o : a(o) ? o.slice(2) : o).length % 2 ? "0" + i : i, "hex") : t.from(e);
          if ("number" == typeof e) return e ? (r = s(e), t.from(r, "hex")) : t.from([]);
          if (null == e) return t.from([]);
          if (e instanceof Uint8Array) return t.from(e);
          if (n.isBN(e)) return t.from(e.toArray());
          throw new Error("invalid type");
        }

        var r, i, o;
        return e;
      }

      e.encode = function e(r) {
        if (Array.isArray(r)) {
          for (var n = [], i = 0; i < r.length; i++) {
            n.push(e(r[i]));
          }

          var a = t.concat(n);
          return t.concat([o(a.length, 192), a]);
        }

        var s = f(r);
        return 1 === s.length && s[0] < 128 ? s : t.concat([o(s.length, 128), s]);
      }, e.decode = function (e, r) {
        if (void 0 === r && (r = !1), !e || 0 === e.length) return t.from([]);

        var n = function e(r) {
          var n,
              o,
              a,
              s,
              f,
              u = [],
              c = r[0];
          if (c <= 127) return {
            data: r.slice(0, 1),
            remainder: r.slice(1)
          };

          if (c <= 183) {
            if (n = c - 127, a = 128 === c ? t.from([]) : r.slice(1, n), 2 === n && a[0] < 128) throw new Error("invalid rlp encoding: byte must be less 0x80");
            return {
              data: a,
              remainder: r.slice(n)
            };
          }

          if (c <= 191) {
            if (o = c - 182, n = i(r.slice(1, o).toString("hex"), 16), (a = r.slice(o, n + o)).length < n) throw new Error("invalid RLP");
            return {
              data: a,
              remainder: r.slice(n + o)
            };
          }

          if (c <= 247) {
            for (n = c - 191, s = r.slice(1, n); s.length;) {
              f = e(s), u.push(f.data), s = f.remainder;
            }

            return {
              data: u,
              remainder: r.slice(n)
            };
          }

          o = c - 246, n = i(r.slice(1, o).toString("hex"), 16);
          var h = o + n;
          if (h > r.length) throw new Error("invalid rlp: total length is larger than the data");
          if (0 === (s = r.slice(o, h)).length) throw new Error("invalid rlp, List has a invalid length");

          for (; s.length;) {
            f = e(s), u.push(f.data), s = f.remainder;
          }

          return {
            data: u,
            remainder: r.slice(h)
          };
        }(f(e));

        if (r) return n;
        if (0 !== n.remainder.length) throw new Error("invalid remainder");
        return n.data;
      }, e.getLength = function (e) {
        if (!e || 0 === e.length) return t.from([]);
        var r = f(e),
            n = r[0];
        if (n <= 127) return r.length;
        if (n <= 183) return n - 127;
        if (n <= 191) return n - 182;
        if (n <= 247) return n - 191;
        var o = n - 246;
        return o + i(r.slice(1, o).toString("hex"), 16);
      };
    }).call(this, r(7).Buffer);
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(59),
          i = r(153);

      function o(t) {
        var e = t;
        if ("string" != typeof e) throw new Error("[ethjs-util] while padding to even, value must be string, is currently " + typeof e + ", while padToEven.");
        return e.length % 2 && (e = "0" + e), e;
      }

      function a(t) {
        return "0x" + t.toString(16);
      }

      t.exports = {
        arrayContainsArray: function arrayContainsArray(t, e, r) {
          if (!0 !== Array.isArray(t)) throw new Error("[ethjs-util] method arrayContainsArray requires input 'superset' to be an array got type '" + typeof t + "'");
          if (!0 !== Array.isArray(e)) throw new Error("[ethjs-util] method arrayContainsArray requires input 'subset' to be an array got type '" + typeof e + "'");
          return e[Boolean(r) ? "some" : "every"](function (e) {
            return t.indexOf(e) >= 0;
          });
        },
        intToBuffer: function intToBuffer(t) {
          var r = a(t);
          return new e(o(r.slice(2)), "hex");
        },
        getBinarySize: function getBinarySize(t) {
          if ("string" != typeof t) throw new Error("[ethjs-util] while getting binary size, method getBinarySize requires input 'str' to be type String, got '" + typeof t + "'.");
          return e.byteLength(t, "utf8");
        },
        isHexPrefixed: n,
        stripHexPrefix: i,
        padToEven: o,
        intToHex: a,
        fromAscii: function fromAscii(t) {
          for (var e = "", r = 0; r < t.length; r++) {
            var n = t.charCodeAt(r).toString(16);
            e += n.length < 2 ? "0" + n : n;
          }

          return "0x" + e;
        },
        fromUtf8: function fromUtf8(t) {
          return "0x" + o(new e(t, "utf8").toString("hex")).replace(/^0+|0+$/g, "");
        },
        toAscii: function toAscii(t) {
          var e = "",
              r = 0,
              n = t.length;

          for ("0x" === t.substring(0, 2) && (r = 2); r < n; r += 2) {
            var i = parseInt(t.substr(r, 2), 16);
            e += String.fromCharCode(i);
          }

          return e;
        },
        toUtf8: function toUtf8(t) {
          return new e(o(i(t).replace(/^0+|0+$/g, "")), "hex").toString("utf8");
        },
        getKeys: function getKeys(t, e, r) {
          if (!Array.isArray(t)) throw new Error("[ethjs-util] method getKeys expecting type Array as 'params' input, got '" + typeof t + "'");
          if ("string" != typeof e) throw new Error("[ethjs-util] method getKeys expecting type String for input 'key' got '" + typeof e + "'.");

          for (var n = [], i = 0; i < t.length; i++) {
            var o = t[i][e];
            if (r && !o) o = "";else if ("string" != typeof o) throw new Error("invalid abi");
            n.push(o);
          }

          return n;
        },
        isHexString: function isHexString(t, e) {
          return !("string" != typeof t || !t.match(/^0x[0-9A-Fa-f]*$/) || e && t.length !== 2 + 2 * e);
        }
      };
    }).call(this, r(7).Buffer);
  }, function (t, e) {
    t.exports = function (t) {
      if ("string" != typeof t) throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof t + ", while checking isHexPrefixed.");
      return "0x" === t.slice(0, 2);
    };
  }, function (t, e) {
    t.exports = function () {
      for (var t = {}, e = 0; e < arguments.length; e++) {
        var n = arguments[e];

        for (var i in n) {
          r.call(n, i) && (t[i] = n[i]);
        }
      }

      return t;
    };

    var r = Object.prototype.hasOwnProperty;
  }, function (t, e, r) {
    var n = r(160),
        i = r(60);

    t.exports = function (t) {
      return i({
        id: n(),
        jsonrpc: "2.0",
        params: []
      }, t);
    };
  }, function (t, e, r) {
    t.exports = function (t) {
      var e = {};

      function r(n) {
        if (e[n]) return e[n].exports;
        var i = e[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
      }

      return r.m = t, r.c = e, r.d = function (t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: n
        });
      }, r.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, r.t = function (t, e) {
        if (1 & e && (t = r(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) {
          r.d(n, i, function (e) {
            return t[e];
          }.bind(null, i));
        }
        return n;
      }, r.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return r.d(e, "a", e), e;
      }, r.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, r.p = "", r(r.s = 1);
    }([function (t, e, r) {
      "use strict";

      r.r(e), r.d(e, "__extends", function () {
        return i;
      }), r.d(e, "__assign", function () {
        return _o2;
      }), r.d(e, "__rest", function () {
        return a;
      }), r.d(e, "__decorate", function () {
        return s;
      }), r.d(e, "__param", function () {
        return f;
      }), r.d(e, "__metadata", function () {
        return u;
      }), r.d(e, "__awaiter", function () {
        return c;
      }), r.d(e, "__generator", function () {
        return h;
      }), r.d(e, "__exportStar", function () {
        return l;
      }), r.d(e, "__values", function () {
        return d;
      }), r.d(e, "__read", function () {
        return p;
      }), r.d(e, "__spread", function () {
        return g;
      }), r.d(e, "__await", function () {
        return A;
      }), r.d(e, "__asyncGenerator", function () {
        return b;
      }), r.d(e, "__asyncDelegator", function () {
        return v;
      }), r.d(e, "__asyncValues", function () {
        return y;
      }), r.d(e, "__makeTemplateObject", function () {
        return w;
      }), r.d(e, "__importStar", function () {
        return m;
      }), r.d(e, "__importDefault", function () {
        return _;
      });
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */

      var _n2 = function n(t, e) {
        return (_n2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            e.hasOwnProperty(r) && (t[r] = e[r]);
          }
        })(t, e);
      };

      function i(t, e) {
        function r() {
          this.constructor = t;
        }

        _n2(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }

      var _o2 = function o() {
        return (_o2 = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var i in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            }
          }

          return t;
        }).apply(this, arguments);
      };

      function a(t, e) {
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var i = 0;

          for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
            e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
          }
        }

        return r;
      }

      function s(t, e, r, n) {
        var i,
            o = arguments.length,
            a = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, e, r, n);else for (var s = t.length - 1; s >= 0; s--) {
          (i = t[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(e, r, a) : i(e, r)) || a);
        }
        return o > 3 && a && Object.defineProperty(e, r, a), a;
      }

      function f(t, e) {
        return function (r, n) {
          e(r, n, t);
        };
      }

      function u(t, e) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
      }

      function c(t, e, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function a(t) {
            try {
              f(n.next(t));
            } catch (t) {
              o(t);
            }
          }

          function s(t) {
            try {
              f(n.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function f(t) {
            t.done ? i(t.value) : new r(function (e) {
              e(t.value);
            }).then(a, s);
          }

          f((n = n.apply(t, e || [])).next());
        });
      }

      function h(t, e) {
        var r,
            n,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                  switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, n = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = e.call(t, a);
                } catch (t) {
                  o = [6, t], n = 0;
                } finally {
                  r = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      }

      function l(t, e) {
        for (var r in t) {
          e.hasOwnProperty(r) || (e[r] = t[r]);
        }
      }

      function d(t) {
        var e = "function" == typeof Symbol && t[Symbol.iterator],
            r = 0;
        return e ? e.call(t) : {
          next: function next() {
            return t && r >= t.length && (t = void 0), {
              value: t && t[r++],
              done: !t
            };
          }
        };
      }

      function p(t, e) {
        var r = "function" == typeof Symbol && t[Symbol.iterator];
        if (!r) return t;
        var n,
            i,
            o = r.call(t),
            a = [];

        try {
          for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
            a.push(n.value);
          }
        } catch (t) {
          i = {
            error: t
          };
        } finally {
          try {
            n && !n.done && (r = o.return) && r.call(o);
          } finally {
            if (i) throw i.error;
          }
        }

        return a;
      }

      function g() {
        for (var t = [], e = 0; e < arguments.length; e++) {
          t = t.concat(p(arguments[e]));
        }

        return t;
      }

      function A(t) {
        return this instanceof A ? (this.v = t, this) : new A(t);
      }

      function b(t, e, r) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var n,
            i = r.apply(t, e || []),
            o = [];
        return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function () {
          return this;
        }, n;

        function a(t) {
          i[t] && (n[t] = function (e) {
            return new Promise(function (r, n) {
              o.push([t, e, r, n]) > 1 || s(t, e);
            });
          });
        }

        function s(t, e) {
          try {
            (r = i[t](e)).value instanceof A ? Promise.resolve(r.value.v).then(f, u) : c(o[0][2], r);
          } catch (t) {
            c(o[0][3], t);
          }

          var r;
        }

        function f(t) {
          s("next", t);
        }

        function u(t) {
          s("throw", t);
        }

        function c(t, e) {
          t(e), o.shift(), o.length && s(o[0][0], o[0][1]);
        }
      }

      function v(t) {
        var e, r;
        return e = {}, n("next"), n("throw", function (t) {
          throw t;
        }), n("return"), e[Symbol.iterator] = function () {
          return this;
        }, e;

        function n(n, i) {
          e[n] = t[n] ? function (e) {
            return (r = !r) ? {
              value: A(t[n](e)),
              done: "return" === n
            } : i ? i(e) : e;
          } : i;
        }
      }

      function y(t) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var e,
            r = t[Symbol.asyncIterator];
        return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
          return this;
        }, e);

        function n(r) {
          e[r] = t[r] && function (e) {
            return new Promise(function (n, i) {
              !function (t, e, r, n) {
                Promise.resolve(n).then(function (e) {
                  t({
                    value: e,
                    done: r
                  });
                }, e);
              }(n, i, (e = t[r](e)).done, e.value);
            });
          };
        }
      }

      function w(t, e) {
        return Object.defineProperty ? Object.defineProperty(t, "raw", {
          value: e
        }) : t.raw = e, t;
      }

      function m(t) {
        if (t && t.__esModule) return t;
        var e = {};
        if (null != t) for (var r in t) {
          Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e.default = t, e;
      }

      function _(t) {
        return t && t.__esModule ? t : {
          default: t
        };
      }
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var n = r(0),
          i = n.__importDefault(r(2)),
          o = n.__importStar(r(3)),
          a = function (t) {
        function e(e) {
          return t.call(this, o, e, !0) || this;
        }

        return n.__extends(e, t), e;
      }(i.default);

      e.default = a;
    }, function (t, e, r) {
      t.exports = function (t) {
        var e = {};

        function r(n) {
          if (e[n]) return e[n].exports;
          var i = e[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }

        return r.m = t, r.c = e, r.d = function (t, e, n) {
          r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
          });
        }, r.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, r.t = function (t, e) {
          if (1 & e && (t = r(t)), 8 & e) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var i in t) {
            r.d(n, i, function (e) {
              return t[e];
            }.bind(null, i));
          }
          return n;
        }, r.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(e, "a", e), e;
        }, r.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 0);
      }([function (t, e, r) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var n = r(1),
            i = r(2);

        function o(t) {
          return "result" in t;
        }

        function a(t) {
          return "error" in t;
        }

        var s = null;
        "undefined" != typeof window && void 0 !== window.localStorage && (s = window.localStorage);

        var f = function () {
          function t(t, e, r, n) {
            if (this.cryptoLib = t, this.protocol = "wc", this.version = 1, this._bridge = "", this._key = null, this._nextKey = null, this._clientId = "", this._clientMeta = null, this._peerId = "", this._peerMeta = null, this._handshakeId = 0, this._handshakeTopic = "", this._accounts = [], this._chainId = 0, this._socket = null, this._queue = [], this._eventEmitters = [], this._connected = !1, this._browser = r, this._pingInterval = null, r && "https:" !== window.location.protocol && "localhost" !== window.location.hostname) throw new Error("HTTPS is required for non-localhost origins");
            if (n && (this.clientMeta = n), !e.bridge && !e.uri && !e.session) throw new Error("Missing one of two required parameters: bridge / uri / session");
            e.bridge && (this.bridge = e.bridge), e.uri && (this.uri = e.uri, this._subscribeToSessionRequest());

            var i = e.session || this._getStorageSession();

            i && (this.session = i, this._browser && this._exchangeKey()), this.handshakeId && this._subscribeToSessionResponse(this.handshakeId, "Session request rejected"), this._subscribeToInternalEvents(), this._socketOpen();
          }

          return Object.defineProperty(t.prototype, "bridge", {
            get: function get() {
              return this._bridge;
            },
            set: function set(t) {
              t && (this._bridge = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "key", {
            get: function get() {
              return this._key ? i.convertArrayBufferToHex(this._key) : "";
            },
            set: function set(t) {
              if (t) {
                var e = i.convertHexToArrayBuffer(t);
                this._key = e;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "nextKey", {
            get: function get() {
              return this._nextKey ? i.convertArrayBufferToHex(this._nextKey) : "";
            },
            set: function set(t) {
              if (t) {
                var e = i.convertHexToArrayBuffer(t);
                this._nextKey = e;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "clientId", {
            get: function get() {
              var t = this._clientId;
              return t || (t = this._clientId = i.uuid()), this._clientId;
            },
            set: function set(t) {
              t && (this._clientId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "peerId", {
            get: function get() {
              return this._peerId;
            },
            set: function set(t) {
              t && (this._peerId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "clientMeta", {
            get: function get() {
              var t = this._clientMeta;
              return t || (t = this._clientMeta = i.getMeta()), t;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "peerMeta", {
            get: function get() {
              return this._peerMeta;
            },
            set: function set(t) {
              this._peerMeta = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "handshakeTopic", {
            get: function get() {
              return this._handshakeTopic;
            },
            set: function set(t) {
              t && (this._handshakeTopic = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "handshakeId", {
            get: function get() {
              return this._handshakeId;
            },
            set: function set(t) {
              t && (this._handshakeId = t);
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "uri", {
            get: function get() {
              return this._formatUri();
            },
            set: function set(t) {
              if (t) {
                var e = this._parseUri(t),
                    r = e.handshakeTopic,
                    n = e.bridge,
                    i = e.key;

                this.handshakeTopic = r, this.bridge = n, this.key = i;
              }
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "chainId", {
            get: function get() {
              return this._chainId;
            },
            set: function set(t) {
              this._chainId = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "accounts", {
            get: function get() {
              return this._accounts;
            },
            set: function set(t) {
              this._accounts = t;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "connected", {
            get: function get() {
              return this._connected;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "pending", {
            get: function get() {
              return !!this._handshakeTopic;
            },
            set: function set(t) {},
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t.prototype, "session", {
            get: function get() {
              return {
                connected: this.connected,
                accounts: this.accounts,
                chainId: this.chainId,
                bridge: this.bridge,
                key: this.key,
                clientId: this.clientId,
                clientMeta: this.clientMeta,
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                handshakeId: this.handshakeId,
                handshakeTopic: this.handshakeTopic
              };
            },
            set: function set(t) {
              t && (this._connected = t.connected, this.accounts = t.accounts, this.chainId = t.chainId, this.bridge = t.bridge, this.key = t.key, this.clientId = t.clientId, this.clientMeta = t.clientMeta, this.peerId = t.peerId, this.peerMeta = t.peerMeta, this.handshakeId = t.handshakeId, this.handshakeTopic = t.handshakeTopic);
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.on = function (t, e) {
            var r = {
              event: t,
              callback: e
            };

            this._eventEmitters.push(r);
          }, t.prototype.createSession = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (this._connected) throw new Error("Session currently connected");
                    return this.pending ? [2] : (e = this, [4, this._generateKey()]);

                  case 1:
                    return e._key = n.sent(), r = this._formatRequest({
                      method: "wc_sessionRequest",
                      params: [{
                        peerId: this.clientId,
                        peerMeta: this.clientMeta,
                        chainId: t && t.chainId ? t.chainId : null
                      }]
                    }), this.handshakeId = r.id, this.handshakeTopic = i.uuid(), this._sendSessionRequest(r, "Session update rejected", this.handshakeTopic), [2];
                }
              });
            });
          }, t.prototype.approveSession = function (t) {
            if (this._connected) throw new Error("Session currently connected");
            this.chainId = t.chainId, this.accounts = t.accounts;
            var e = {
              approved: !0,
              chainId: this.chainId,
              accounts: this.accounts,
              peerId: this.clientId,
              peerMeta: this.clientMeta
            },
                r = {
              id: this.handshakeId,
              jsonrpc: "2.0",
              result: e
            };
            this._sendResponse(r), this._connected = !0, this._triggerEvents({
              event: "connect",
              params: [{
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                chainId: this.chainId,
                accounts: this.accounts
              }]
            }), this._connected && this._setStorageSession();
          }, t.prototype.rejectSession = function (t) {
            if (this._connected) throw new Error("Session currently connected");

            var e = t && t.message ? t.message : "Session Rejected",
                r = this._formatResponse({
              id: this.handshakeId,
              error: {
                message: e
              }
            });

            this._sendResponse(r), this._connected = !1, this._triggerEvents({
              event: "disconnect",
              params: [{
                message: e
              }]
            }), this._removeStorageSession();
          }, t.prototype.updateSession = function (t) {
            if (!this._connected) throw new Error("Session currently disconnected");
            this.chainId = t.chainId, this.accounts = t.accounts;

            var e = {
              approved: !0,
              chainId: this.chainId,
              accounts: this.accounts
            },
                r = this._formatRequest({
              method: "wc_sessionUpdate",
              params: [e]
            });

            this._sendSessionRequest(r, "Session update rejected"), this._triggerEvents({
              event: "session_update",
              params: [{
                chainId: this.chainId,
                accounts: this.accounts
              }]
            }), this._connected ? this._setStorageSession() : this._removeStorageSession();
          }, t.prototype.killSession = function (t) {
            var e = t ? t.message : "Session Disconnected",
                r = this._formatRequest({
              method: "wc_sessionUpdate",
              params: [{
                approved: !1,
                chainId: null,
                accounts: null
              }]
            });

            this._sendSessionRequest(r, "Failed to kill Session"), this._handleSessionDisconnect(e);
          }, t.prototype.sendTransaction = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "eth_sendTransaction",
                      params: [t]
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signTransaction = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "eth_signTransaction",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signMessage = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "eth_sign",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signPersonalMessage = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    i.isHexStrict(t[1]) || (t[1] = i.convertUtf8ToHex(t[1])), e = this._formatRequest({
                      method: "personal_sign",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.signTypedData = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest({
                      method: "eth_signTypedData",
                      params: t
                    }), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.sendCustomRequest = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (!this._connected) throw new Error("Session currently disconnected");
                    e = this._formatRequest(t), r.label = 1;

                  case 1:
                    return r.trys.push([1, 3,, 4]), [4, this._sendCallRequest(e)];

                  case 2:
                    return [2, r.sent()];

                  case 3:
                    throw r.sent();

                  case 4:
                    return [2];
                }
              });
            });
          }, t.prototype.approveRequest = function (t) {
            if (!o(t)) throw new Error('JSON-RPC success response must include "result" field');

            var e = this._formatResponse(t);

            this._sendResponse(e);
          }, t.prototype.rejectRequest = function (t) {
            if (!a(t)) throw new Error('JSON-RPC error response must include "error" field');

            var e = this._formatResponse(t);

            this._sendResponse(e);
          }, t.prototype._sendRequest = function (t, e) {
            return n.__awaiter(this, void 0, void 0, function () {
              var r, i, o, a, s;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return r = this._formatRequest(t), [4, this._encrypt(r)];

                  case 1:
                    return i = n.sent(), o = e || this.peerId, a = JSON.stringify(i), s = {
                      topic: o,
                      type: "pub",
                      payload: a
                    }, this._socket && 1 === this._socket.readyState ? this._socketSend(s) : this._setToQueue(s), [2];
                }
              });
            });
          }, t.prototype._sendResponse = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, i, o;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return [4, this._encrypt(t)];

                  case 1:
                    return e = n.sent(), r = this.peerId, i = JSON.stringify(e), o = {
                      topic: r,
                      type: "pub",
                      payload: i
                    }, this._socket && 1 === this._socket.readyState ? this._socketSend(o) : this._setToQueue(o), [2];
                }
              });
            });
          }, t.prototype._sendSessionRequest = function (t, e, r) {
            return n.__awaiter(this, void 0, void 0, function () {
              return n.__generator(this, function (n) {
                return this._sendRequest(t, r), this._subscribeToSessionResponse(t.id, e), [2];
              });
            });
          }, t.prototype._sendCallRequest = function (t) {
            return this._sendRequest(t), this._subscribeToCallResponse(t.id);
          }, t.prototype._formatRequest = function (t) {
            return n.__assign({
              id: i.payloadId(),
              jsonrpc: "2.0"
            }, t);
          }, t.prototype._formatResponse = function (t) {
            if (a(t)) {
              var e = i.formatRpcError(t.error);
              return n.__assign({
                jsonrpc: "2.0"
              }, t, {
                error: e
              });
            }

            return n.__assign({
              jsonrpc: "2.0",
              result: null
            }, t);
          }, t.prototype._handleSessionDisconnect = function (t) {
            var e = t || "Session Disconnected";
            this._connected && (this._connected = !1, this._triggerEvents({
              event: "disconnect",
              params: [{
                message: e
              }]
            })), this._removeStorageSession(), this._toggleSocketPing();
          }, t.prototype._handleSessionResponse = function (t, e) {
            e && e.approved ? (this._connected ? (e.chainId && (this.chainId = e.chainId), e.accounts && (this.accounts = e.accounts), this._triggerEvents({
              event: "session_update",
              params: [{
                chainId: this.chainId,
                accounts: this.accounts
              }]
            })) : (this._connected = !0, e.chainId && (this.chainId = e.chainId), e.accounts && (this.accounts = e.accounts), e.peerId && !this.peerId && (this.peerId = e.peerId), e.peerMeta && !this.peerMeta && (this.peerMeta = e.peerMeta), this._triggerEvents({
              event: "connect",
              params: [{
                peerId: this.peerId,
                peerMeta: this.peerMeta,
                chainId: this.chainId,
                accounts: this.accounts
              }]
            })), this._connected ? this._setStorageSession() : this._removeStorageSession()) : this._handleSessionDisconnect(t);
          }, t.prototype._subscribeToSessionRequest = function () {
            this._setToQueue({
              topic: "" + this.handshakeTopic,
              type: "sub",
              payload: ""
            });
          }, t.prototype._subscribeToSessionResponse = function (t, e) {
            var r = this;
            this.on("response:" + t, function (t, n) {
              t && r._handleSessionResponse(t.message), n.result ? r._handleSessionResponse(e, n.result) : n.error && n.error.message ? r._handleSessionResponse(n.error.message) : r._handleSessionResponse(e);
            });
          }, t.prototype._subscribeToCallResponse = function (t) {
            var e = this;
            return new Promise(function (r, n) {
              e.on("response:" + t, function (t, e) {
                t ? n(t) : e.result ? r(e.result) : e.error && e.error.message ? n(new Error(e.error.message)) : n(new Error("Invalid JSON RPC response format received"));
              });
            });
          }, t.prototype._subscribeToInternalEvents = function () {
            var t = this;
            this.on("wc_sessionRequest", function (e, r) {
              e && t._triggerEvents({
                event: "error",
                params: [{
                  code: "SESSION_REQUEST_ERROR",
                  message: e.toString()
                }]
              }), t.handshakeId = r.id, t.peerId = r.params[0].peerId, t.peerMeta = r.params[0].peerMeta, t._exchangeKey();

              var i = n.__assign({}, r, {
                method: "session_request"
              });

              t._triggerEvents(i);
            }), this.on("wc_sessionUpdate", function (e, r) {
              e && t._handleSessionResponse(e.message), t._handleSessionResponse("Session disconnected", r.params[0]);
            }), this.on("wc_exchangeKey", function (e, r) {
              e && t._triggerEvents({
                event: "error",
                params: [{
                  code: "EXCHANGE_KEY_ERROR",
                  message: e.toString()
                }]
              }), t._handleExchangeKeyRequest(r);
            });
          }, t.prototype._triggerEvents = function (t) {
            var e,
                r = [];
            (e = "method" in t ? t.method : o(t) || a(t) ? "response:" + t.id : function (t) {
              return "event" in t;
            }(t) ? t.event : "") && (r = this._eventEmitters.filter(function (t) {
              return t.event === e;
            })), r && r.length || ["wc_sessionRequest", "wc_sessionUpdate", "wc_exchangeKey", "session_request", "session_update", "exchange_key", "connect", "disconnect"].includes(e) || (r = this._eventEmitters.filter(function (t) {
              return "call_request" === t.event;
            })), r.forEach(function (e) {
              if (a(t)) {
                var r = new Error(t.error.message);
                e.callback(r, null);
              } else e.callback(null, t);
            });
          }, t.prototype._exchangeKey = function () {
            return n.__awaiter(this, void 0, void 0, function () {
              var t, e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return t = this, [4, this._generateKey()];

                  case 1:
                    t._nextKey = r.sent(), e = this._formatRequest({
                      method: "wc_exchangeKey",
                      params: [{
                        peerId: this.clientId,
                        peerMeta: this.clientMeta,
                        nextKey: this.nextKey
                      }]
                    }), r.label = 2;

                  case 2:
                    return r.trys.push([2, 4,, 5]), [4, this._sendCallRequest(e)];

                  case 3:
                    return r.sent(), this._swapKey(), [3, 5];

                  case 4:
                    throw r.sent();

                  case 5:
                    return [2];
                }
              });
            });
          }, t.prototype._handleExchangeKeyRequest = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, i, o, a;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    return e = t.params[0], r = e.peerId, i = e.peerMeta, o = e.nextKey, this.peerId = r, this.peerMeta = i, this.nextKey = o, a = {
                      id: t.id,
                      jsonrpc: "2.0",
                      result: !0
                    }, [4, this._sendResponse(a)];

                  case 1:
                    return n.sent(), this._swapKey(), [2];
                }
              });
            });
          }, t.prototype._swapKey = function () {
            this._key = this._nextKey, this._nextKey = null, this._connected && this._setStorageSession();
          }, t.prototype._socketOpen = function () {
            var t = this,
                e = this.bridge,
                r = e.startsWith("https") ? e.replace("https", "wss") : e.startsWith("http") ? e.replace("http", "ws") : e,
                n = new WebSocket(r);
            n.onmessage = function (e) {
              return t._socketReceive(e);
            }, n.onopen = function () {
              t._socket = n, t._setToQueue({
                topic: "" + t.clientId,
                type: "sub",
                payload: ""
              }), t._dispatchQueue(), t._toggleSocketPing();
            };
          }, t.prototype._toggleSocketPing = function () {
            var t = this;
            this._socket && 1 === this._socket.readyState ? this._pingInterval = setInterval(function () {
              t._socket && t._socket.send("ping");
            }, 1e4) : clearInterval(this._pingInterval);
          }, t.prototype._socketSend = function (t) {
            if (!this._socket) throw new Error("Missing socket: required for sending message");
            var e = JSON.stringify(t);
            this._socket && 1 === this._socket.readyState ? this._socket.send(e) : this._connected && (this._setToQueue(t), this._socketOpen());
          }, t.prototype._socketReceive = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e, r, i;
              return n.__generator(this, function (n) {
                switch (n.label) {
                  case 0:
                    try {
                      e = JSON.parse(t.data);
                    } catch (t) {
                      throw t;
                    }

                    if (![this.clientId, this.handshakeTopic].includes(e.topic)) return [2];

                    try {
                      r = JSON.parse(e.payload);
                    } catch (t) {
                      throw t;
                    }

                    return [4, this._decrypt(r)];

                  case 1:
                    return (i = n.sent()) && this._triggerEvents(i), [2];
                }
              });
            });
          }, t.prototype._setToQueue = function (t) {
            this._queue.push(t);
          }, t.prototype._dispatchQueue = function () {
            var t = this;
            this._queue.forEach(function (e) {
              return t._socketSend(e);
            }), this._queue = [];
          }, t.prototype._formatUri = function () {
            return this.protocol + ":" + this.handshakeTopic + "@" + this.version + "?bridge=" + encodeURIComponent(this.bridge) + "&key=" + this.key;
          }, t.prototype._parseUri = function (t) {
            var e = i.parseWalletConnectUri(t);

            if (e.protocol === this.protocol) {
              if (!e.handshakeTopic) throw Error("Invalid or missing handshakeTopic parameter value");
              var r = e.handshakeTopic;
              if (!e.bridge) throw Error("Invalid or missing bridge url parameter value");
              var n = decodeURIComponent(e.bridge);
              if (!e.key) throw Error("Invalid or missing kkey parameter value");
              return {
                handshakeTopic: r,
                bridge: n,
                key: e.key
              };
            }

            throw new Error("URI format doesn't follow Connector protocol");
          }, t.prototype._generateKey = function () {
            return n.__awaiter(this, void 0, void 0, function () {
              return n.__generator(this, function (t) {
                switch (t.label) {
                  case 0:
                    return this.cryptoLib ? [4, this.cryptoLib.generateKey()] : [3, 2];

                  case 1:
                    return [2, t.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._encrypt = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this._key, this.cryptoLib && e ? [4, this.cryptoLib.encrypt(t, e)] : [3, 2];

                  case 1:
                    return [2, r.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._decrypt = function (t) {
            return n.__awaiter(this, void 0, void 0, function () {
              var e;
              return n.__generator(this, function (r) {
                switch (r.label) {
                  case 0:
                    return e = this._key, this.cryptoLib && e ? [4, this.cryptoLib.decrypt(t, e)] : [3, 2];

                  case 1:
                    return [2, r.sent()];

                  case 2:
                    return [2, null];
                }
              });
            });
          }, t.prototype._getStorageSession = function () {
            var t = null,
                e = null;
            if (s && (e = s.getItem("walletconnect")), e && "string" == typeof e) try {
              var r = JSON.parse(e);
              "bridge" in r && (t = r);
            } catch (t) {
              throw t;
            }
            return t;
          }, t.prototype._setStorageSession = function () {
            var t = this.session,
                e = JSON.stringify(t);
            return s && s.setItem("walletconnect", e), t;
          }, t.prototype._removeStorageSession = function () {
            s && s.removeItem("walletconnect");
          }, t;
        }();

        e.default = f;
      }, function (t, e, r) {
        "use strict";

        r.r(e), r.d(e, "__extends", function () {
          return i;
        }), r.d(e, "__assign", function () {
          return _o3;
        }), r.d(e, "__rest", function () {
          return a;
        }), r.d(e, "__decorate", function () {
          return s;
        }), r.d(e, "__param", function () {
          return f;
        }), r.d(e, "__metadata", function () {
          return u;
        }), r.d(e, "__awaiter", function () {
          return c;
        }), r.d(e, "__generator", function () {
          return h;
        }), r.d(e, "__exportStar", function () {
          return l;
        }), r.d(e, "__values", function () {
          return d;
        }), r.d(e, "__read", function () {
          return p;
        }), r.d(e, "__spread", function () {
          return g;
        }), r.d(e, "__await", function () {
          return A;
        }), r.d(e, "__asyncGenerator", function () {
          return b;
        }), r.d(e, "__asyncDelegator", function () {
          return v;
        }), r.d(e, "__asyncValues", function () {
          return y;
        }), r.d(e, "__makeTemplateObject", function () {
          return w;
        }), r.d(e, "__importStar", function () {
          return m;
        }), r.d(e, "__importDefault", function () {
          return _;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        var _n3 = function n(t, e) {
          return (_n3 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) {
              e.hasOwnProperty(r) && (t[r] = e[r]);
            }
          })(t, e);
        };

        function i(t, e) {
          function r() {
            this.constructor = t;
          }

          _n3(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }

        var _o3 = function o() {
          return (_o3 = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              for (var i in e = arguments[r]) {
                Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
              }
            }

            return t;
          }).apply(this, arguments);
        };

        function a(t, e) {
          var r = {};

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          }

          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var i = 0;

            for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
              e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
            }
          }

          return r;
        }

        function s(t, e, r, n) {
          var i,
              o = arguments.length,
              a = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, e, r, n);else for (var s = t.length - 1; s >= 0; s--) {
            (i = t[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(e, r, a) : i(e, r)) || a);
          }
          return o > 3 && a && Object.defineProperty(e, r, a), a;
        }

        function f(t, e) {
          return function (r, n) {
            e(r, n, t);
          };
        }

        function u(t, e) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }

        function c(t, e, r, n) {
          return new (r || (r = Promise))(function (i, o) {
            function a(t) {
              try {
                f(n.next(t));
              } catch (t) {
                o(t);
              }
            }

            function s(t) {
              try {
                f(n.throw(t));
              } catch (t) {
                o(t);
              }
            }

            function f(t) {
              t.done ? i(t.value) : new r(function (e) {
                e(t.value);
              }).then(a, s);
            }

            f((n = n.apply(t, e || [])).next());
          });
        }

        function h(t, e) {
          var r,
              n,
              i,
              o,
              a = {
            label: 0,
            sent: function sent() {
              if (1 & i[0]) throw i[1];
              return i[1];
            },
            trys: [],
            ops: []
          };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;

          function s(o) {
            return function (s) {
              return function (o) {
                if (r) throw new TypeError("Generator is already executing.");

                for (; a;) {
                  try {
                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                    switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                      case 0:
                      case 1:
                        i = o;
                        break;

                      case 4:
                        return a.label++, {
                          value: o[1],
                          done: !1
                        };

                      case 5:
                        a.label++, n = o[1], o = [0];
                        continue;

                      case 7:
                        o = a.ops.pop(), a.trys.pop();
                        continue;

                      default:
                        if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                          a = 0;
                          continue;
                        }

                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                          a.label = o[1];
                          break;
                        }

                        if (6 === o[0] && a.label < i[1]) {
                          a.label = i[1], i = o;
                          break;
                        }

                        if (i && a.label < i[2]) {
                          a.label = i[2], a.ops.push(o);
                          break;
                        }

                        i[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }

                    o = e.call(t, a);
                  } catch (t) {
                    o = [6, t], n = 0;
                  } finally {
                    r = i = 0;
                  }
                }

                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        }

        function l(t, e) {
          for (var r in t) {
            e.hasOwnProperty(r) || (e[r] = t[r]);
          }
        }

        function d(t) {
          var e = "function" == typeof Symbol && t[Symbol.iterator],
              r = 0;
          return e ? e.call(t) : {
            next: function next() {
              return t && r >= t.length && (t = void 0), {
                value: t && t[r++],
                done: !t
              };
            }
          };
        }

        function p(t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
              i,
              o = r.call(t),
              a = [];

          try {
            for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
              a.push(n.value);
            }
          } catch (t) {
            i = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = o.return) && r.call(o);
            } finally {
              if (i) throw i.error;
            }
          }

          return a;
        }

        function g() {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t = t.concat(p(arguments[e]));
          }

          return t;
        }

        function A(t) {
          return this instanceof A ? (this.v = t, this) : new A(t);
        }

        function b(t, e, r) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var n,
              i = r.apply(t, e || []),
              o = [];
          return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function () {
            return this;
          }, n;

          function a(t) {
            i[t] && (n[t] = function (e) {
              return new Promise(function (r, n) {
                o.push([t, e, r, n]) > 1 || s(t, e);
              });
            });
          }

          function s(t, e) {
            try {
              (r = i[t](e)).value instanceof A ? Promise.resolve(r.value.v).then(f, u) : c(o[0][2], r);
            } catch (t) {
              c(o[0][3], t);
            }

            var r;
          }

          function f(t) {
            s("next", t);
          }

          function u(t) {
            s("throw", t);
          }

          function c(t, e) {
            t(e), o.shift(), o.length && s(o[0][0], o[0][1]);
          }
        }

        function v(t) {
          var e, r;
          return e = {}, n("next"), n("throw", function (t) {
            throw t;
          }), n("return"), e[Symbol.iterator] = function () {
            return this;
          }, e;

          function n(n, i) {
            e[n] = t[n] ? function (e) {
              return (r = !r) ? {
                value: A(t[n](e)),
                done: "return" === n
              } : i ? i(e) : e;
            } : i;
          }
        }

        function y(t) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var e,
              r = t[Symbol.asyncIterator];
          return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
            return this;
          }, e);

          function n(r) {
            e[r] = t[r] && function (e) {
              return new Promise(function (n, i) {
                !function (t, e, r, n) {
                  Promise.resolve(n).then(function (e) {
                    t({
                      value: e,
                      done: r
                    });
                  }, e);
                }(n, i, (e = t[r](e)).done, e.value);
              });
            };
          }
        }

        function w(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, "raw", {
            value: e
          }) : t.raw = e, t;
        }

        function m(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var r in t) {
            Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
          return e.default = t, e;
        }

        function _(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
      }, function (t, e, r) {
        t.exports = function (t) {
          var e = {};

          function r(n) {
            if (e[n]) return e[n].exports;
            var i = e[n] = {
              i: n,
              l: !1,
              exports: {}
            };
            return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
          }

          return r.m = t, r.c = e, r.d = function (t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
              enumerable: !0,
              get: n
            });
          }, r.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(t, "__esModule", {
              value: !0
            });
          }, r.t = function (t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
              enumerable: !0,
              value: t
            }), 2 & e && "string" != typeof t) for (var i in t) {
              r.d(n, i, function (e) {
                return t[e];
              }.bind(null, i));
            }
            return n;
          }, r.n = function (t) {
            var e = t && t.__esModule ? function () {
              return t.default;
            } : function () {
              return t;
            };
            return r.d(e, "a", e), e;
          }, r.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }, r.p = "", r(r.s = 0);
        }([function (t, e, r) {
          "use strict";

          (function (t) {
            Object.defineProperty(e, "__esModule", {
              value: !0
            });

            var n = r(6),
                i = n.__importDefault(r(7));

            function o(t) {
              return t.toString("hex");
            }

            function a(e) {
              return new t(e, "hex");
            }

            function s(t) {
              for (var e = new Uint8Array(t), r = [], n = 0; n < e.length;) {
                var i = e[n];
                i < 128 ? (r.push(String.fromCharCode(i)), n++) : i > 191 && i < 224 ? (r.push(String.fromCharCode((31 & i) << 6 | 63 & e[n + 1])), n += 2) : (r.push(String.fromCharCode((15 & i) << 12 | (63 & e[n + 1]) << 6 | 63 & e[n + 2])), n += 3);
              }

              return r.join("");
            }

            function f(t) {
              var e = [],
                  r = 0;

              for (t = encodeURI(t); r < t.length;) {
                var n = t.charCodeAt(r++);
                37 === n ? (e.push(parseInt(t.substr(r, 2), 16)), r += 2) : e.push(n);
              }

              return new Uint8Array(e).buffer;
            }

            function u(t) {
              for (var e = new Uint8Array(t), r = [], n = 0; n < e.length; n++) {
                var i = e[n];
                r.push("0123456789abcdef"[(240 & i) >> 4] + "0123456789abcdef"[15 & i]);
              }

              return r.join("");
            }

            function c(t) {
              for (var e = [], r = 0; r < t.length; r += 2) {
                e.push(parseInt(t.substr(r, 2), 16));
              }

              return new Uint8Array(e).buffer;
            }

            e.convertArrayBufferToBuffer = function (t) {
              return a(u(t));
            }, e.convertBufferToArrayBuffer = function (t) {
              return c(o(t));
            }, e.convertUtf8ToBuffer = function (e) {
              return new t(e, "utf8");
            }, e.convertBufferToUtf8 = function (t) {
              return t.toString("utf8");
            }, e.convertBufferToHex = o, e.convertHexToBuffer = a, e.concatBuffers = function () {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              return a(t.map(function (t) {
                return o(t);
              }).join(""));
            }, e.concatArrayBuffers = function () {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              return c(t.map(function (t) {
                return u(t);
              }).join(""));
            }, e.convertArrayBufferToUtf8 = s, e.convertUtf8ToArrayBuffer = f, e.convertArrayBufferToHex = u, e.convertHexToArrayBuffer = c, e.convertUtf8ToHex = function (t) {
              return u(f(t));
            }, e.convertHexToUtf8 = function (t) {
              return s(c(t));
            }, e.payloadId = function () {
              return new Date().getTime() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3));
            }, e.uuid = function () {
              return function (t, e) {
                for (e = t = ""; t++ < 36; e += 51 * t & 52 ? (15 ^ t ? 8 ^ Math.random() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
                  ;
                }

                return e;
              }();
            }, e.isHexStrict = function (t) {
              return ("string" == typeof t || i.default(t)) && /^(-)?0x[0-9a-f]*$/i.test(t);
            }, e.getMeta = function () {
              if ("undefined" == typeof window || "undefined" == typeof document || void 0 === window.location) return null;

              function t() {
                for (var t = [], e = 0; e < arguments.length; e++) {
                  t[e] = arguments[e];
                }

                for (var r = document.getElementsByTagName("meta"), n = function n(e) {
                  var n = r[e],
                      i = ["itemprop", "property", "name"].map(function (t) {
                    return n.getAttribute(t);
                  }).filter(function (e) {
                    e && t.includes(e);
                  });

                  if (i.length && i) {
                    var o = n.getAttribute("content");
                    if (o) return {
                      value: o
                    };
                  }
                }, i = 0; i < r.length; i++) {
                  var o = n(i);
                  if ("object" == typeof o) return o.value;
                }

                return "";
              }

              var e = function () {
                var e = t("name", "og:site_name", "og:title", "twitter:title");
                return e || (e = document.title), e;
              }();

              return {
                description: t("description", "og:description", "twitter:description", "keywords"),
                url: window.location.origin,
                icons: function () {
                  for (var t = document.getElementsByTagName("link"), e = [], r = 0; r < t.length; r++) {
                    var n = t[r],
                        i = n.getAttribute("rel");

                    if (i && i.toLowerCase().indexOf("icon") > -1) {
                      var o = n.getAttribute("href");
                      if (o) if (-1 === o.toLowerCase().indexOf("https:") && -1 === o.toLowerCase().indexOf("http:") && 0 !== o.indexOf("//")) {
                        var a = window.location.protocol + "//" + window.location.host;
                        if (0 === o.indexOf("/")) a += o;else {
                          var s = window.location.pathname.split("/");
                          s.pop(), a += s.join("/") + "/" + o;
                        }
                        e.push(a);
                      } else if (0 === o.indexOf("//")) {
                        var f = window.location.protocol + o;
                        e.push(f);
                      } else e.push(o);
                    }
                  }

                  return e;
                }(),
                name: e
              };
            }, e.parseWalletConnectUri = function (t) {
              var e = t.indexOf(":"),
                  r = -1 !== t.indexOf("?") ? t.indexOf("?") : void 0,
                  i = t.substring(0, e),
                  o = function (t) {
                var e = t.split("@");
                return {
                  handshakeTopic: e[0],
                  version: parseInt(e[1], 10)
                };
              }(t.substring(e + 1, r)),
                  a = function (t) {
                for (var e = {}, r = ("?" === t[0] ? t.substr(1) : t).split("&"), n = 0; n < r.length; n++) {
                  var i = r[n].match(/\w+(?==)/i) || [],
                      o = r[n].match(/=.+/i) || [];
                  i[0] && (e[decodeURIComponent(i[0])] = decodeURIComponent(o[0].substr(1)));
                }

                return {
                  key: e.key || "",
                  bridge: e.bridge || ""
                };
              }(void 0 !== r ? t.substr(r) : "");

              return n.__assign({
                protocol: i
              }, o, a);
            }, e.sanitizeHex = function (t) {
              return "" === (t = "0x" === t.substring(0, 2) ? t.substring(2) : t) ? "" : "0x" + (t = t.length % 2 != 0 ? "0" + t : t);
            }, e.removeHexPrefix = function (t) {
              return t.toLowerCase().replace("0x", "");
            }, e.promisify = function (t, e) {
              var r = this;
              return function () {
                for (var i = [], o = 0; o < arguments.length; o++) {
                  i[o] = arguments[o];
                }

                return n.__awaiter(r, void 0, void 0, function () {
                  return n.__generator(this, function (r) {
                    return [2, new Promise(function (r, o) {
                      t.apply(e, n.__spread(i, [function (t, e) {
                        null == t && o(t), r(e);
                      }]));
                    })];
                  });
                });
              };
            }, e.formatRpcError = function (t) {
              var e = t.message || "Failed or Rejected Request",
                  r = -32e3;
              if (t && !t.code) switch (e) {
                case "Parse error":
                  r = -32700;
                  break;

                case "Invalid request":
                  r = -32600;
                  break;

                case "Method not found":
                  r = -32601;
                  break;

                case "Invalid params":
                  r = -32602;
                  break;

                case "Internal error":
                  r = -32603;
                  break;

                default:
                  r = -32e3;
              }
              return {
                code: r,
                message: e
              };
            };
          }).call(this, r(1).Buffer);
        }, function (t, e, r) {
          "use strict";

          (function (t) {
            /*!
             * The buffer module from node.js, for the browser.
             *
             * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
             * @license  MIT
             */
            var n = r(3),
                i = r(4),
                o = r(5);

            function a() {
              return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
            }

            function s(t, e) {
              if (a() < e) throw new RangeError("Invalid typed array length");
              return f.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = f.prototype : (null === t && (t = new f(e)), t.length = e), t;
            }

            function f(t, e, r) {
              if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(t, e, r);

              if ("number" == typeof t) {
                if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
                return h(this, t);
              }

              return u(this, t, e, r);
            }

            function u(t, e, r, n) {
              if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
              return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
                if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
                if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
                return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), f.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = f.prototype : t = l(t, e), t;
              }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
                if ("string" == typeof r && "" !== r || (r = "utf8"), !f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
                var n = 0 | p(e, r),
                    i = (t = s(t, n)).write(e, r);
                return i !== n && (t = t.slice(0, i)), t;
              }(t, e, r) : function (t, e) {
                if (f.isBuffer(e)) {
                  var r = 0 | d(e.length);
                  return 0 === (t = s(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
                }

                if (e) {
                  if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? s(t, 0) : l(t, e);
                  if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
                }

                var n;
                throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
              }(t, e);
            }

            function c(t) {
              if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
              if (t < 0) throw new RangeError('"size" argument must not be negative');
            }

            function h(t, e) {
              if (c(e), t = s(t, e < 0 ? 0 : 0 | d(e)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
                t[r] = 0;
              }
              return t;
            }

            function l(t, e) {
              var r = e.length < 0 ? 0 : 0 | d(e.length);
              t = s(t, r);

              for (var n = 0; n < r; n += 1) {
                t[n] = 255 & e[n];
              }

              return t;
            }

            function d(t) {
              if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
              return 0 | t;
            }

            function p(t, e) {
              if (f.isBuffer(t)) return t.length;
              if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
              "string" != typeof t && (t = "" + t);
              var r = t.length;
              if (0 === r) return 0;

              for (var n = !1;;) {
                switch (e) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return r;

                  case "utf8":
                  case "utf-8":
                  case void 0:
                    return N(t).length;

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return 2 * r;

                  case "hex":
                    return r >>> 1;

                  case "base64":
                    return q(t).length;

                  default:
                    if (n) return N(t).length;
                    e = ("" + e).toLowerCase(), n = !0;
                }
              }
            }

            function g(t, e, r) {
              var n = t[e];
              t[e] = t[r], t[r] = n;
            }

            function A(t, e, r, n, i) {
              if (0 === t.length) return -1;

              if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
                if (i) return -1;
                r = t.length - 1;
              } else if (r < 0) {
                if (!i) return -1;
                r = 0;
              }

              if ("string" == typeof e && (e = f.from(e, n)), f.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, r, n, i);
              if ("number" == typeof e) return e &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : b(t, [e], r, n, i);
              throw new TypeError("val must be string, number or Buffer");
            }

            function b(t, e, r, n, i) {
              var o,
                  a = 1,
                  s = t.length,
                  f = e.length;

              if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                if (t.length < 2 || e.length < 2) return -1;
                a = 2, s /= 2, f /= 2, r /= 2;
              }

              function u(t, e) {
                return 1 === a ? t[e] : t.readUInt16BE(e * a);
              }

              if (i) {
                var c = -1;

                for (o = r; o < s; o++) {
                  if (u(t, o) === u(e, -1 === c ? 0 : o - c)) {
                    if (-1 === c && (c = o), o - c + 1 === f) return c * a;
                  } else -1 !== c && (o -= o - c), c = -1;
                }
              } else for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
                for (var h = !0, l = 0; l < f; l++) {
                  if (u(t, o + l) !== u(e, l)) {
                    h = !1;
                    break;
                  }
                }

                if (h) return o;
              }

              return -1;
            }

            function v(t, e, r, n) {
              r = Number(r) || 0;
              var i = t.length - r;
              n ? (n = Number(n)) > i && (n = i) : n = i;
              var o = e.length;
              if (o % 2 != 0) throw new TypeError("Invalid hex string");
              n > o / 2 && (n = o / 2);

              for (var a = 0; a < n; ++a) {
                var s = parseInt(e.substr(2 * a, 2), 16);
                if (isNaN(s)) return a;
                t[r + a] = s;
              }

              return a;
            }

            function y(t, e, r, n) {
              return U(N(e, t.length - r), t, r, n);
            }

            function w(t, e, r, n) {
              return U(function (t) {
                for (var e = [], r = 0; r < t.length; ++r) {
                  e.push(255 & t.charCodeAt(r));
                }

                return e;
              }(e), t, r, n);
            }

            function m(t, e, r, n) {
              return w(t, e, r, n);
            }

            function _(t, e, r, n) {
              return U(q(e), t, r, n);
            }

            function I(t, e, r, n) {
              return U(function (t, e) {
                for (var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) {
                  r = t.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
                }

                return o;
              }(e, t.length - r), t, r, n);
            }

            function E(t, e, r) {
              return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
            }

            function P(t, e, r) {
              r = Math.min(t.length, r);

              for (var n = [], i = e; i < r;) {
                var o,
                    a,
                    s,
                    f,
                    u = t[i],
                    c = null,
                    h = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
                if (i + h <= r) switch (h) {
                  case 1:
                    u < 128 && (c = u);
                    break;

                  case 2:
                    128 == (192 & (o = t[i + 1])) && (f = (31 & u) << 6 | 63 & o) > 127 && (c = f);
                    break;

                  case 3:
                    o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (c = f);
                    break;

                  case 4:
                    o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (c = f);
                }
                null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
              }

              return function (t) {
                var e = t.length;
                if (e <= S) return String.fromCharCode.apply(String, t);

                for (var r = "", n = 0; n < e;) {
                  r += String.fromCharCode.apply(String, t.slice(n, n += S));
                }

                return r;
              }(n);
            }

            e.Buffer = f, e.SlowBuffer = function (t) {
              return +t != t && (t = 0), f.alloc(+t);
            }, e.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
              try {
                var t = new Uint8Array(1);
                return t.__proto__ = {
                  __proto__: Uint8Array.prototype,
                  foo: function foo() {
                    return 42;
                  }
                }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
              } catch (t) {
                return !1;
              }
            }(), e.kMaxLength = a(), f.poolSize = 8192, f._augment = function (t) {
              return t.__proto__ = f.prototype, t;
            }, f.from = function (t, e, r) {
              return u(null, t, e, r);
            }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
              value: null,
              configurable: !0
            })), f.alloc = function (t, e, r) {
              return function (t, e, r, n) {
                return c(e), e <= 0 ? s(t, e) : void 0 !== r ? "string" == typeof n ? s(t, e).fill(r, n) : s(t, e).fill(r) : s(t, e);
              }(null, t, e, r);
            }, f.allocUnsafe = function (t) {
              return h(null, t);
            }, f.allocUnsafeSlow = function (t) {
              return h(null, t);
            }, f.isBuffer = function (t) {
              return !(null == t || !t._isBuffer);
            }, f.compare = function (t, e) {
              if (!f.isBuffer(t) || !f.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
              if (t === e) return 0;

              for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
                if (t[i] !== e[i]) {
                  r = t[i], n = e[i];
                  break;
                }
              }

              return r < n ? -1 : n < r ? 1 : 0;
            }, f.isEncoding = function (t) {
              switch (String(t).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;

                default:
                  return !1;
              }
            }, f.concat = function (t, e) {
              if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
              if (0 === t.length) return f.alloc(0);
              var r;
              if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
                e += t[r].length;
              }
              var n = f.allocUnsafe(e),
                  i = 0;

              for (r = 0; r < t.length; ++r) {
                var a = t[r];
                if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
                a.copy(n, i), i += a.length;
              }

              return n;
            }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
              var t = this.length;
              if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

              for (var e = 0; e < t; e += 2) {
                g(this, e, e + 1);
              }

              return this;
            }, f.prototype.swap32 = function () {
              var t = this.length;
              if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

              for (var e = 0; e < t; e += 4) {
                g(this, e, e + 3), g(this, e + 1, e + 2);
              }

              return this;
            }, f.prototype.swap64 = function () {
              var t = this.length;
              if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

              for (var e = 0; e < t; e += 8) {
                g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
              }

              return this;
            }, f.prototype.toString = function () {
              var t = 0 | this.length;
              return 0 === t ? "" : 0 === arguments.length ? P(this, 0, t) : function (t, e, r) {
                var n = !1;
                if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
                if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                if ((r >>>= 0) <= (e >>>= 0)) return "";

                for (t || (t = "utf8");;) {
                  switch (t) {
                    case "hex":
                      return M(this, e, r);

                    case "utf8":
                    case "utf-8":
                      return P(this, e, r);

                    case "ascii":
                      return x(this, e, r);

                    case "latin1":
                    case "binary":
                      return C(this, e, r);

                    case "base64":
                      return E(this, e, r);

                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return T(this, e, r);

                    default:
                      if (n) throw new TypeError("Unknown encoding: " + t);
                      t = (t + "").toLowerCase(), n = !0;
                  }
                }
              }.apply(this, arguments);
            }, f.prototype.equals = function (t) {
              if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
              return this === t || 0 === f.compare(this, t);
            }, f.prototype.inspect = function () {
              var t = "",
                  r = e.INSPECT_MAX_BYTES;
              return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
            }, f.prototype.compare = function (t, e, r, n, i) {
              if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
              if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
              if (n >= i && e >= r) return 0;
              if (n >= i) return -1;
              if (e >= r) return 1;
              if (this === t) return 0;

              for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), u = this.slice(n, i), c = t.slice(e, r), h = 0; h < s; ++h) {
                if (u[h] !== c[h]) {
                  o = u[h], a = c[h];
                  break;
                }
              }

              return o < a ? -1 : a < o ? 1 : 0;
            }, f.prototype.includes = function (t, e, r) {
              return -1 !== this.indexOf(t, e, r);
            }, f.prototype.indexOf = function (t, e, r) {
              return A(this, t, e, r, !0);
            }, f.prototype.lastIndexOf = function (t, e, r) {
              return A(this, t, e, r, !1);
            }, f.prototype.write = function (t, e, r, n) {
              if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
                if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
              }
              var i = this.length - e;
              if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
              n || (n = "utf8");

              for (var o = !1;;) {
                switch (n) {
                  case "hex":
                    return v(this, t, e, r);

                  case "utf8":
                  case "utf-8":
                    return y(this, t, e, r);

                  case "ascii":
                    return w(this, t, e, r);

                  case "latin1":
                  case "binary":
                    return m(this, t, e, r);

                  case "base64":
                    return _(this, t, e, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return I(this, t, e, r);

                  default:
                    if (o) throw new TypeError("Unknown encoding: " + n);
                    n = ("" + n).toLowerCase(), o = !0;
                }
              }
            }, f.prototype.toJSON = function () {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            };
            var S = 4096;

            function x(t, e, r) {
              var n = "";
              r = Math.min(t.length, r);

              for (var i = e; i < r; ++i) {
                n += String.fromCharCode(127 & t[i]);
              }

              return n;
            }

            function C(t, e, r) {
              var n = "";
              r = Math.min(t.length, r);

              for (var i = e; i < r; ++i) {
                n += String.fromCharCode(t[i]);
              }

              return n;
            }

            function M(t, e, r) {
              var n = t.length;
              (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

              for (var i = "", o = e; o < r; ++o) {
                i += z(t[o]);
              }

              return i;
            }

            function T(t, e, r) {
              for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
                i += String.fromCharCode(n[o] + 256 * n[o + 1]);
              }

              return i;
            }

            function k(t, e, r) {
              if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
              if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
            }

            function R(t, e, r, n, i, o) {
              if (!f.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
              if (r + n > t.length) throw new RangeError("Index out of range");
            }

            function B(t, e, r, n) {
              e < 0 && (e = 65535 + e + 1);

              for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
                t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
              }
            }

            function L(t, e, r, n) {
              e < 0 && (e = 4294967295 + e + 1);

              for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
                t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
              }
            }

            function O(t, e, r, n, i, o) {
              if (r + n > t.length) throw new RangeError("Index out of range");
              if (r < 0) throw new RangeError("Index out of range");
            }

            function j(t, e, r, n, o) {
              return o || O(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
            }

            function D(t, e, r, n, o) {
              return o || O(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
            }

            f.prototype.slice = function (t, e) {
              var r,
                  n = this.length;
              if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = f.prototype;else {
                var i = e - t;
                r = new f(i, void 0);

                for (var o = 0; o < i; ++o) {
                  r[o] = this[o + t];
                }
              }
              return r;
            }, f.prototype.readUIntLE = function (t, e, r) {
              t |= 0, e |= 0, r || k(t, e, this.length);

              for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
                n += this[t + o] * i;
              }

              return n;
            }, f.prototype.readUIntBE = function (t, e, r) {
              t |= 0, e |= 0, r || k(t, e, this.length);

              for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
                n += this[t + --e] * i;
              }

              return n;
            }, f.prototype.readUInt8 = function (t, e) {
              return e || k(t, 1, this.length), this[t];
            }, f.prototype.readUInt16LE = function (t, e) {
              return e || k(t, 2, this.length), this[t] | this[t + 1] << 8;
            }, f.prototype.readUInt16BE = function (t, e) {
              return e || k(t, 2, this.length), this[t] << 8 | this[t + 1];
            }, f.prototype.readUInt32LE = function (t, e) {
              return e || k(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
            }, f.prototype.readUInt32BE = function (t, e) {
              return e || k(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
            }, f.prototype.readIntLE = function (t, e, r) {
              t |= 0, e |= 0, r || k(t, e, this.length);

              for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
                n += this[t + o] * i;
              }

              return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
            }, f.prototype.readIntBE = function (t, e, r) {
              t |= 0, e |= 0, r || k(t, e, this.length);

              for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
                o += this[t + --n] * i;
              }

              return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
            }, f.prototype.readInt8 = function (t, e) {
              return e || k(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
            }, f.prototype.readInt16LE = function (t, e) {
              e || k(t, 2, this.length);
              var r = this[t] | this[t + 1] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, f.prototype.readInt16BE = function (t, e) {
              e || k(t, 2, this.length);
              var r = this[t + 1] | this[t] << 8;
              return 32768 & r ? 4294901760 | r : r;
            }, f.prototype.readInt32LE = function (t, e) {
              return e || k(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
            }, f.prototype.readInt32BE = function (t, e) {
              return e || k(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
            }, f.prototype.readFloatLE = function (t, e) {
              return e || k(t, 4, this.length), i.read(this, t, !0, 23, 4);
            }, f.prototype.readFloatBE = function (t, e) {
              return e || k(t, 4, this.length), i.read(this, t, !1, 23, 4);
            }, f.prototype.readDoubleLE = function (t, e) {
              return e || k(t, 8, this.length), i.read(this, t, !0, 52, 8);
            }, f.prototype.readDoubleBE = function (t, e) {
              return e || k(t, 8, this.length), i.read(this, t, !1, 52, 8);
            }, f.prototype.writeUIntLE = function (t, e, r, n) {
              t = +t, e |= 0, r |= 0, n || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
              var i = 1,
                  o = 0;

              for (this[e] = 255 & t; ++o < r && (i *= 256);) {
                this[e + o] = t / i & 255;
              }

              return e + r;
            }, f.prototype.writeUIntBE = function (t, e, r, n) {
              t = +t, e |= 0, r |= 0, n || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
              var i = r - 1,
                  o = 1;

              for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
                this[e + i] = t / o & 255;
              }

              return e + r;
            }, f.prototype.writeUInt8 = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
            }, f.prototype.writeUInt16LE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
            }, f.prototype.writeUInt16BE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
            }, f.prototype.writeUInt32LE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : L(this, t, e, !0), e + 4;
            }, f.prototype.writeUInt32BE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
            }, f.prototype.writeIntLE = function (t, e, r, n) {
              if (t = +t, e |= 0, !n) {
                var i = Math.pow(2, 8 * r - 1);
                R(this, t, e, r, i - 1, -i);
              }

              var o = 0,
                  a = 1,
                  s = 0;

              for (this[e] = 255 & t; ++o < r && (a *= 256);) {
                t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
              }

              return e + r;
            }, f.prototype.writeIntBE = function (t, e, r, n) {
              if (t = +t, e |= 0, !n) {
                var i = Math.pow(2, 8 * r - 1);
                R(this, t, e, r, i - 1, -i);
              }

              var o = r - 1,
                  a = 1,
                  s = 0;

              for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
                t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
              }

              return e + r;
            }, f.prototype.writeInt8 = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
            }, f.prototype.writeInt16LE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
            }, f.prototype.writeInt16BE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
            }, f.prototype.writeInt32LE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : L(this, t, e, !0), e + 4;
            }, f.prototype.writeInt32BE = function (t, e, r) {
              return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
            }, f.prototype.writeFloatLE = function (t, e, r) {
              return j(this, t, e, !0, r);
            }, f.prototype.writeFloatBE = function (t, e, r) {
              return j(this, t, e, !1, r);
            }, f.prototype.writeDoubleLE = function (t, e, r) {
              return D(this, t, e, !0, r);
            }, f.prototype.writeDoubleBE = function (t, e, r) {
              return D(this, t, e, !1, r);
            }, f.prototype.copy = function (t, e, r, n) {
              if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
              if (0 === t.length || 0 === this.length) return 0;
              if (e < 0) throw new RangeError("targetStart out of bounds");
              if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
              if (n < 0) throw new RangeError("sourceEnd out of bounds");
              n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
              var i,
                  o = n - r;
              if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
                t[i + e] = this[i + r];
              } else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
                t[i + e] = this[i + r];
              } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
              return o;
            }, f.prototype.fill = function (t, e, r, n) {
              if ("string" == typeof t) {
                if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                  var i = t.charCodeAt(0);
                  i < 256 && (t = i);
                }

                if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
              } else "number" == typeof t && (t &= 255);

              if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
              if (r <= e) return this;
              var o;
              if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
                this[o] = t;
              } else {
                var a = f.isBuffer(t) ? t : N(new f(t, n).toString()),
                    s = a.length;

                for (o = 0; o < r - e; ++o) {
                  this[o + e] = a[o % s];
                }
              }
              return this;
            };
            var H = /[^+\/0-9A-Za-z-_]/g;

            function z(t) {
              return t < 16 ? "0" + t.toString(16) : t.toString(16);
            }

            function N(t, e) {
              var r;
              e = e || 1 / 0;

              for (var n = t.length, i = null, o = [], a = 0; a < n; ++a) {
                if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
                  if (!i) {
                    if (r > 56319) {
                      (e -= 3) > -1 && o.push(239, 191, 189);
                      continue;
                    }

                    if (a + 1 === n) {
                      (e -= 3) > -1 && o.push(239, 191, 189);
                      continue;
                    }

                    i = r;
                    continue;
                  }

                  if (r < 56320) {
                    (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                    continue;
                  }

                  r = 65536 + (i - 55296 << 10 | r - 56320);
                } else i && (e -= 3) > -1 && o.push(239, 191, 189);

                if (i = null, r < 128) {
                  if ((e -= 1) < 0) break;
                  o.push(r);
                } else if (r < 2048) {
                  if ((e -= 2) < 0) break;
                  o.push(r >> 6 | 192, 63 & r | 128);
                } else if (r < 65536) {
                  if ((e -= 3) < 0) break;
                  o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                } else {
                  if (!(r < 1114112)) throw new Error("Invalid code point");
                  if ((e -= 4) < 0) break;
                  o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                }
              }

              return o;
            }

            function q(t) {
              return n.toByteArray(function (t) {
                if ((t = function (t) {
                  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
                }(t).replace(H, "")).length < 2) return "";

                for (; t.length % 4 != 0;) {
                  t += "=";
                }

                return t;
              }(t));
            }

            function U(t, e, r, n) {
              for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
                e[i + r] = t[i];
              }

              return i;
            }
          }).call(this, r(2));
        }, function (t, e) {
          var r;

          r = function () {
            return this;
          }();

          try {
            r = r || new Function("return this")();
          } catch (t) {
            "object" == typeof window && (r = window);
          }

          t.exports = r;
        }, function (t, e, r) {
          "use strict";

          e.byteLength = function (t) {
            var e = u(t),
                r = e[0],
                n = e[1];
            return 3 * (r + n) / 4 - n;
          }, e.toByteArray = function (t) {
            for (var e, r = u(t), n = r[0], a = r[1], s = new o(NaN), f = 0, c = a > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
              e = i[t.charCodeAt(h)] << 18 | i[t.charCodeAt(h + 1)] << 12 | i[t.charCodeAt(h + 2)] << 6 | i[t.charCodeAt(h + 3)], s[f++] = e >> 16 & 255, s[f++] = e >> 8 & 255, s[f++] = 255 & e;
            }

            return 2 === a && (e = i[t.charCodeAt(h)] << 2 | i[t.charCodeAt(h + 1)] >> 4, s[f++] = 255 & e), 1 === a && (e = i[t.charCodeAt(h)] << 10 | i[t.charCodeAt(h + 1)] << 4 | i[t.charCodeAt(h + 2)] >> 2, s[f++] = e >> 8 & 255, s[f++] = 255 & e), s;
          }, e.fromByteArray = function (t) {
            for (var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
              o.push(c(t, a, a + 16383 > s ? s : a + 16383));
            }

            return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
          };

          for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) {
            n[s] = a[s], i[a.charCodeAt(s)] = s;
          }

          function u(t) {
            var e = t.length;
            if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
            var r = t.indexOf("=");
            return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
          }

          function c(t, e, r) {
            for (var i, o, a = [], s = e; s < r; s += 3) {
              i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
            }

            return a.join("");
          }

          i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
        }, function (t, e) {
          e.read = function (t, e, r, n, i) {
            var o,
                a,
                s = 8 * i - n - 1,
                f = (1 << s) - 1,
                u = f >> 1,
                c = -7,
                h = r ? i - 1 : 0,
                l = r ? -1 : 1,
                d = t[e + h];

            for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += s; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
              ;
            }

            for (a = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; a = 256 * a + t[e + h], h += l, c -= 8) {
              ;
            }

            if (0 === o) o = 1 - u;else {
              if (o === f) return a ? NaN : 1 / 0 * (d ? -1 : 1);
              a += Math.pow(2, n), o -= u;
            }
            return (d ? -1 : 1) * a * Math.pow(2, o - n);
          }, e.write = function (t, e, r, n, i, o) {
            var a,
                s,
                f,
                u = 8 * o - i - 1,
                c = (1 << u) - 1,
                h = c >> 1,
                l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
                d = n ? 0 : o - 1,
                p = n ? 1 : -1,
                g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

            for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (e += a + h >= 1 ? l / f : l * Math.pow(2, 1 - h)) * f >= 2 && (a++, f /= 2), a + h >= c ? (s = 0, a = c) : a + h >= 1 ? (s = (e * f - 1) * Math.pow(2, i), a += h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + d] = 255 & s, d += p, s /= 256, i -= 8) {
              ;
            }

            for (a = a << i | s, u += i; u > 0; t[r + d] = 255 & a, d += p, a /= 256, u -= 8) {
              ;
            }

            t[r + d - p] |= 128 * g;
          };
        }, function (t, e) {
          var r = {}.toString;

          t.exports = Array.isArray || function (t) {
            return "[object Array]" == r.call(t);
          };
        }, function (t, e, r) {
          "use strict";

          r.r(e), r.d(e, "__extends", function () {
            return i;
          }), r.d(e, "__assign", function () {
            return _o4;
          }), r.d(e, "__rest", function () {
            return a;
          }), r.d(e, "__decorate", function () {
            return s;
          }), r.d(e, "__param", function () {
            return f;
          }), r.d(e, "__metadata", function () {
            return u;
          }), r.d(e, "__awaiter", function () {
            return c;
          }), r.d(e, "__generator", function () {
            return h;
          }), r.d(e, "__exportStar", function () {
            return l;
          }), r.d(e, "__values", function () {
            return d;
          }), r.d(e, "__read", function () {
            return p;
          }), r.d(e, "__spread", function () {
            return g;
          }), r.d(e, "__await", function () {
            return A;
          }), r.d(e, "__asyncGenerator", function () {
            return b;
          }), r.d(e, "__asyncDelegator", function () {
            return v;
          }), r.d(e, "__asyncValues", function () {
            return y;
          }), r.d(e, "__makeTemplateObject", function () {
            return w;
          }), r.d(e, "__importStar", function () {
            return m;
          }), r.d(e, "__importDefault", function () {
            return _;
          });
          /*! *****************************************************************************
          Copyright (c) Microsoft Corporation. All rights reserved.
          Licensed under the Apache License, Version 2.0 (the "License"); you may not use
          this file except in compliance with the License. You may obtain a copy of the
          License at http://www.apache.org/licenses/LICENSE-2.0
          
          THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
          KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
          WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
          MERCHANTABLITY OR NON-INFRINGEMENT.
          
          See the Apache Version 2.0 License for specific language governing permissions
          and limitations under the License.
          ***************************************************************************** */

          var _n4 = function n(t, e) {
            return (_n4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var r in e) {
                e.hasOwnProperty(r) && (t[r] = e[r]);
              }
            })(t, e);
          };

          function i(t, e) {
            function r() {
              this.constructor = t;
            }

            _n4(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
          }

          var _o4 = function o() {
            return (_o4 = Object.assign || function (t) {
              for (var e, r = 1, n = arguments.length; r < n; r++) {
                for (var i in e = arguments[r]) {
                  Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
                }
              }

              return t;
            }).apply(this, arguments);
          };

          function a(t, e) {
            var r = {};

            for (var n in t) {
              Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
            }

            if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
              var i = 0;

              for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
                e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
              }
            }

            return r;
          }

          function s(t, e, r, n) {
            var i,
                o = arguments.length,
                a = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
            if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, e, r, n);else for (var s = t.length - 1; s >= 0; s--) {
              (i = t[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(e, r, a) : i(e, r)) || a);
            }
            return o > 3 && a && Object.defineProperty(e, r, a), a;
          }

          function f(t, e) {
            return function (r, n) {
              e(r, n, t);
            };
          }

          function u(t, e) {
            if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
          }

          function c(t, e, r, n) {
            return new (r || (r = Promise))(function (i, o) {
              function a(t) {
                try {
                  f(n.next(t));
                } catch (t) {
                  o(t);
                }
              }

              function s(t) {
                try {
                  f(n.throw(t));
                } catch (t) {
                  o(t);
                }
              }

              function f(t) {
                t.done ? i(t.value) : new r(function (e) {
                  e(t.value);
                }).then(a, s);
              }

              f((n = n.apply(t, e || [])).next());
            });
          }

          function h(t, e) {
            var r,
                n,
                i,
                o,
                a = {
              label: 0,
              sent: function sent() {
                if (1 & i[0]) throw i[1];
                return i[1];
              },
              trys: [],
              ops: []
            };
            return o = {
              next: s(0),
              throw: s(1),
              return: s(2)
            }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
              return this;
            }), o;

            function s(o) {
              return function (s) {
                return function (o) {
                  if (r) throw new TypeError("Generator is already executing.");

                  for (; a;) {
                    try {
                      if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                      switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                          i = o;
                          break;

                        case 4:
                          return a.label++, {
                            value: o[1],
                            done: !1
                          };

                        case 5:
                          a.label++, n = o[1], o = [0];
                          continue;

                        case 7:
                          o = a.ops.pop(), a.trys.pop();
                          continue;

                        default:
                          if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                            a = 0;
                            continue;
                          }

                          if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                            a.label = o[1];
                            break;
                          }

                          if (6 === o[0] && a.label < i[1]) {
                            a.label = i[1], i = o;
                            break;
                          }

                          if (i && a.label < i[2]) {
                            a.label = i[2], a.ops.push(o);
                            break;
                          }

                          i[2] && a.ops.pop(), a.trys.pop();
                          continue;
                      }

                      o = e.call(t, a);
                    } catch (t) {
                      o = [6, t], n = 0;
                    } finally {
                      r = i = 0;
                    }
                  }

                  if (5 & o[0]) throw o[1];
                  return {
                    value: o[0] ? o[1] : void 0,
                    done: !0
                  };
                }([o, s]);
              };
            }
          }

          function l(t, e) {
            for (var r in t) {
              e.hasOwnProperty(r) || (e[r] = t[r]);
            }
          }

          function d(t) {
            var e = "function" == typeof Symbol && t[Symbol.iterator],
                r = 0;
            return e ? e.call(t) : {
              next: function next() {
                return t && r >= t.length && (t = void 0), {
                  value: t && t[r++],
                  done: !t
                };
              }
            };
          }

          function p(t, e) {
            var r = "function" == typeof Symbol && t[Symbol.iterator];
            if (!r) return t;
            var n,
                i,
                o = r.call(t),
                a = [];

            try {
              for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
                a.push(n.value);
              }
            } catch (t) {
              i = {
                error: t
              };
            } finally {
              try {
                n && !n.done && (r = o.return) && r.call(o);
              } finally {
                if (i) throw i.error;
              }
            }

            return a;
          }

          function g() {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t = t.concat(p(arguments[e]));
            }

            return t;
          }

          function A(t) {
            return this instanceof A ? (this.v = t, this) : new A(t);
          }

          function b(t, e, r) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var n,
                i = r.apply(t, e || []),
                o = [];
            return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function () {
              return this;
            }, n;

            function a(t) {
              i[t] && (n[t] = function (e) {
                return new Promise(function (r, n) {
                  o.push([t, e, r, n]) > 1 || s(t, e);
                });
              });
            }

            function s(t, e) {
              try {
                (r = i[t](e)).value instanceof A ? Promise.resolve(r.value.v).then(f, u) : c(o[0][2], r);
              } catch (t) {
                c(o[0][3], t);
              }

              var r;
            }

            function f(t) {
              s("next", t);
            }

            function u(t) {
              s("throw", t);
            }

            function c(t, e) {
              t(e), o.shift(), o.length && s(o[0][0], o[0][1]);
            }
          }

          function v(t) {
            var e, r;
            return e = {}, n("next"), n("throw", function (t) {
              throw t;
            }), n("return"), e[Symbol.iterator] = function () {
              return this;
            }, e;

            function n(n, i) {
              e[n] = t[n] ? function (e) {
                return (r = !r) ? {
                  value: A(t[n](e)),
                  done: "return" === n
                } : i ? i(e) : e;
              } : i;
            }
          }

          function y(t) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var e,
                r = t[Symbol.asyncIterator];
            return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
              return this;
            }, e);

            function n(r) {
              e[r] = t[r] && function (e) {
                return new Promise(function (n, i) {
                  !function (t, e, r, n) {
                    Promise.resolve(n).then(function (e) {
                      t({
                        value: e,
                        done: r
                      });
                    }, e);
                  }(n, i, (e = t[r](e)).done, e.value);
                });
              };
            }
          }

          function w(t, e) {
            return Object.defineProperty ? Object.defineProperty(t, "raw", {
              value: e
            }) : t.raw = e, t;
          }

          function m(t) {
            if (t && t.__esModule) return t;
            var e = {};
            if (null != t) for (var r in t) {
              Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }
            return e.default = t, e;
          }

          function _(t) {
            return t && t.__esModule ? t : {
              default: t
            };
          }
        }, function (t, e) {
          var r = Object.prototype.toString;

          t.exports = function (t) {
            return "number" == typeof t || function (t) {
              return !!t && "object" == typeof t;
            }(t) && "[object Number]" == r.call(t);
          };
        }]);
      }]);
    }, function (t, e, r) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var n = r(0),
          i = r(4),
          o = "AES-CBC",
          a = 256,
          s = "SHA-256";

      function f(t) {
        return n.__awaiter(this, void 0, void 0, function () {
          return n.__generator(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, window.crypto.subtle.exportKey("raw", t)];

              case 1:
                return [2, e.sent()];
            }
          });
        });
      }

      function u(t, e) {
        return void 0 === e && (e = o), n.__awaiter(this, void 0, void 0, function () {
          var r, i;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return r = e === o ? {
                  length: a,
                  name: o
                } : {
                  hash: {
                    name: s
                  },
                  name: "HMAC"
                }, i = e === o ? ["encrypt", "decrypt"] : ["sign", "verify"], [4, window.crypto.subtle.importKey("raw", t, r, !0, i)];

              case 1:
                return [2, n.sent()];
            }
          });
        });
      }

      function c(t) {
        return n.__awaiter(this, void 0, void 0, function () {
          var e;
          return n.__generator(this, function (r) {
            switch (r.label) {
              case 0:
                return e = t || 256, [4, window.crypto.subtle.generateKey({
                  length: e,
                  name: o
                }, !0, ["encrypt", "decrypt"])];

              case 1:
                return [4, f(r.sent())];

              case 2:
                return [2, r.sent()];
            }
          });
        });
      }

      function h(t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, u(e, "HMAC")];

              case 1:
                return r = n.sent(), [4, window.crypto.subtle.sign({
                  length: 256,
                  name: "HMAC"
                }, r, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      function l(t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, o, a, s, f, u;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return r = i.convertHexToArrayBuffer(t.data), o = i.convertHexToArrayBuffer(t.iv), a = i.convertHexToArrayBuffer(t.hmac), s = i.convertArrayBufferToHex(a), [4, h(i.concatArrayBuffers(r, o), e)];

              case 1:
                return f = n.sent(), u = i.convertArrayBufferToHex(f), s === u ? [2, !0] : [2, !1];
            }
          });
        });
      }

      function d(t, e, r) {
        return n.__awaiter(this, void 0, void 0, function () {
          var i;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, u(e, o)];

              case 1:
                return i = n.sent(), [4, window.crypto.subtle.encrypt({
                  iv: r,
                  name: o
                }, i, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      function p(t, e, r) {
        return n.__awaiter(this, void 0, void 0, function () {
          var i;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, u(e, o)];

              case 1:
                return i = n.sent(), [4, window.crypto.subtle.decrypt({
                  iv: r,
                  name: o
                }, i, t)];

              case 2:
                return [2, n.sent()];
            }
          });
        });
      }

      e.exportKey = f, e.importKey = u, e.generateKey = c, e.createHmac = h, e.verifyHmac = l, e.aesCbcEncrypt = d, e.aesCbcDecrypt = p, e.encrypt = function (t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, o, a, s, f, u, l;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if (!e) throw new Error("Missing key: required for encryption");
                return [4, c(128)];

              case 1:
                return r = n.sent(), o = i.convertArrayBufferToHex(r), a = JSON.stringify(t), [4, d(i.convertUtf8ToArrayBuffer(a), e, r)];

              case 2:
                return s = n.sent(), f = i.convertArrayBufferToHex(s), [4, h(i.concatArrayBuffers(s, r), e)];

              case 3:
                return u = n.sent(), l = i.convertArrayBufferToHex(u), [2, {
                  data: f,
                  hmac: l,
                  iv: o
                }];
            }
          });
        });
      }, e.decrypt = function (t, e) {
        return n.__awaiter(this, void 0, void 0, function () {
          var r, o, a, s, f;
          return n.__generator(this, function (n) {
            switch (n.label) {
              case 0:
                if (!e) throw new Error("Missing key: required for decryption");
                return [4, l(t, e)];

              case 1:
                return n.sent() ? (r = i.convertHexToArrayBuffer(t.data), o = i.convertHexToArrayBuffer(t.iv), [4, p(r, e, o)]) : [2, null];

              case 2:
                a = n.sent(), s = i.convertArrayBufferToUtf8(a);

                try {
                  f = JSON.parse(s);
                } catch (t) {
                  throw t;
                }

                return [2, f];
            }
          });
        });
      };
    }, function (t, e, r) {
      t.exports = function (t) {
        var e = {};

        function r(n) {
          if (e[n]) return e[n].exports;
          var i = e[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }

        return r.m = t, r.c = e, r.d = function (t, e, n) {
          r.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
          });
        }, r.r = function (t) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, r.t = function (t, e) {
          if (1 & e && (t = r(t)), 8 & e) return t;
          if (4 & e && "object" == typeof t && t && t.__esModule) return t;
          var n = Object.create(null);
          if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var i in t) {
            r.d(n, i, function (e) {
              return t[e];
            }.bind(null, i));
          }
          return n;
        }, r.n = function (t) {
          var e = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(e, "a", e), e;
        }, r.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 0);
      }([function (t, e, r) {
        "use strict";

        (function (t) {
          Object.defineProperty(e, "__esModule", {
            value: !0
          });

          var n = r(6),
              i = n.__importDefault(r(7));

          function o(t) {
            return t.toString("hex");
          }

          function a(e) {
            return new t(e, "hex");
          }

          function s(t) {
            for (var e = new Uint8Array(t), r = [], n = 0; n < e.length;) {
              var i = e[n];
              i < 128 ? (r.push(String.fromCharCode(i)), n++) : i > 191 && i < 224 ? (r.push(String.fromCharCode((31 & i) << 6 | 63 & e[n + 1])), n += 2) : (r.push(String.fromCharCode((15 & i) << 12 | (63 & e[n + 1]) << 6 | 63 & e[n + 2])), n += 3);
            }

            return r.join("");
          }

          function f(t) {
            var e = [],
                r = 0;

            for (t = encodeURI(t); r < t.length;) {
              var n = t.charCodeAt(r++);
              37 === n ? (e.push(parseInt(t.substr(r, 2), 16)), r += 2) : e.push(n);
            }

            return new Uint8Array(e).buffer;
          }

          function u(t) {
            for (var e = new Uint8Array(t), r = [], n = 0; n < e.length; n++) {
              var i = e[n];
              r.push("0123456789abcdef"[(240 & i) >> 4] + "0123456789abcdef"[15 & i]);
            }

            return r.join("");
          }

          function c(t) {
            for (var e = [], r = 0; r < t.length; r += 2) {
              e.push(parseInt(t.substr(r, 2), 16));
            }

            return new Uint8Array(e).buffer;
          }

          e.convertArrayBufferToBuffer = function (t) {
            return a(u(t));
          }, e.convertBufferToArrayBuffer = function (t) {
            return c(o(t));
          }, e.convertUtf8ToBuffer = function (e) {
            return new t(e, "utf8");
          }, e.convertBufferToUtf8 = function (t) {
            return t.toString("utf8");
          }, e.convertBufferToHex = o, e.convertHexToBuffer = a, e.concatBuffers = function () {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t[e] = arguments[e];
            }

            return a(t.map(function (t) {
              return o(t);
            }).join(""));
          }, e.concatArrayBuffers = function () {
            for (var t = [], e = 0; e < arguments.length; e++) {
              t[e] = arguments[e];
            }

            return c(t.map(function (t) {
              return u(t);
            }).join(""));
          }, e.convertArrayBufferToUtf8 = s, e.convertUtf8ToArrayBuffer = f, e.convertArrayBufferToHex = u, e.convertHexToArrayBuffer = c, e.convertUtf8ToHex = function (t) {
            return u(f(t));
          }, e.convertHexToUtf8 = function (t) {
            return s(c(t));
          }, e.payloadId = function () {
            return new Date().getTime() * Math.pow(10, 3) + Math.floor(Math.random() * Math.pow(10, 3));
          }, e.uuid = function () {
            return function (t, e) {
              for (e = t = ""; t++ < 36; e += 51 * t & 52 ? (15 ^ t ? 8 ^ Math.random() * (20 ^ t ? 16 : 4) : 4).toString(16) : "-") {
                ;
              }

              return e;
            }();
          }, e.isHexStrict = function (t) {
            return ("string" == typeof t || i.default(t)) && /^(-)?0x[0-9a-f]*$/i.test(t);
          }, e.getMeta = function () {
            if ("undefined" == typeof window || "undefined" == typeof document || void 0 === window.location) return null;

            function t() {
              for (var t = [], e = 0; e < arguments.length; e++) {
                t[e] = arguments[e];
              }

              for (var r = document.getElementsByTagName("meta"), n = function n(e) {
                var n = r[e],
                    i = ["itemprop", "property", "name"].map(function (t) {
                  return n.getAttribute(t);
                }).filter(function (e) {
                  e && t.includes(e);
                });

                if (i.length && i) {
                  var o = n.getAttribute("content");
                  if (o) return {
                    value: o
                  };
                }
              }, i = 0; i < r.length; i++) {
                var o = n(i);
                if ("object" == typeof o) return o.value;
              }

              return "";
            }

            var e = function () {
              var e = t("name", "og:site_name", "og:title", "twitter:title");
              return e || (e = document.title), e;
            }();

            return {
              description: t("description", "og:description", "twitter:description", "keywords"),
              url: window.location.origin,
              icons: function () {
                for (var t = document.getElementsByTagName("link"), e = [], r = 0; r < t.length; r++) {
                  var n = t[r],
                      i = n.getAttribute("rel");

                  if (i && i.toLowerCase().indexOf("icon") > -1) {
                    var o = n.getAttribute("href");
                    if (o) if (-1 === o.toLowerCase().indexOf("https:") && -1 === o.toLowerCase().indexOf("http:") && 0 !== o.indexOf("//")) {
                      var a = window.location.protocol + "//" + window.location.host;
                      if (0 === o.indexOf("/")) a += o;else {
                        var s = window.location.pathname.split("/");
                        s.pop(), a += s.join("/") + "/" + o;
                      }
                      e.push(a);
                    } else if (0 === o.indexOf("//")) {
                      var f = window.location.protocol + o;
                      e.push(f);
                    } else e.push(o);
                  }
                }

                return e;
              }(),
              name: e
            };
          }, e.parseWalletConnectUri = function (t) {
            var e = t.indexOf(":"),
                r = -1 !== t.indexOf("?") ? t.indexOf("?") : void 0,
                i = t.substring(0, e),
                o = function (t) {
              var e = t.split("@");
              return {
                handshakeTopic: e[0],
                version: parseInt(e[1], 10)
              };
            }(t.substring(e + 1, r)),
                a = function (t) {
              for (var e = {}, r = ("?" === t[0] ? t.substr(1) : t).split("&"), n = 0; n < r.length; n++) {
                var i = r[n].match(/\w+(?==)/i) || [],
                    o = r[n].match(/=.+/i) || [];
                i[0] && (e[decodeURIComponent(i[0])] = decodeURIComponent(o[0].substr(1)));
              }

              return {
                key: e.key || "",
                bridge: e.bridge || ""
              };
            }(void 0 !== r ? t.substr(r) : "");

            return n.__assign({
              protocol: i
            }, o, a);
          }, e.sanitizeHex = function (t) {
            return "" === (t = "0x" === t.substring(0, 2) ? t.substring(2) : t) ? "" : "0x" + (t = t.length % 2 != 0 ? "0" + t : t);
          }, e.removeHexPrefix = function (t) {
            return t.toLowerCase().replace("0x", "");
          }, e.promisify = function (t, e) {
            var r = this;
            return function () {
              for (var i = [], o = 0; o < arguments.length; o++) {
                i[o] = arguments[o];
              }

              return n.__awaiter(r, void 0, void 0, function () {
                return n.__generator(this, function (r) {
                  return [2, new Promise(function (r, o) {
                    t.apply(e, n.__spread(i, [function (t, e) {
                      null == t && o(t), r(e);
                    }]));
                  })];
                });
              });
            };
          }, e.formatRpcError = function (t) {
            var e = t.message || "Failed or Rejected Request",
                r = -32e3;
            if (t && !t.code) switch (e) {
              case "Parse error":
                r = -32700;
                break;

              case "Invalid request":
                r = -32600;
                break;

              case "Method not found":
                r = -32601;
                break;

              case "Invalid params":
                r = -32602;
                break;

              case "Internal error":
                r = -32603;
                break;

              default:
                r = -32e3;
            }
            return {
              code: r,
              message: e
            };
          };
        }).call(this, r(1).Buffer);
      }, function (t, e, r) {
        "use strict";

        (function (t) {
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
           * @license  MIT
           */
          var n = r(3),
              i = r(4),
              o = r(5);

          function a() {
            return f.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }

          function s(t, e) {
            if (a() < e) throw new RangeError("Invalid typed array length");
            return f.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = f.prototype : (null === t && (t = new f(e)), t.length = e), t;
          }

          function f(t, e, r) {
            if (!(f.TYPED_ARRAY_SUPPORT || this instanceof f)) return new f(t, e, r);

            if ("number" == typeof t) {
              if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
              return h(this, t);
            }

            return u(this, t, e, r);
          }

          function u(t, e, r, n) {
            if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
            return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
              if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
              if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
              return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), f.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = f.prototype : t = l(t, e), t;
            }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
              if ("string" == typeof r && "" !== r || (r = "utf8"), !f.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
              var n = 0 | p(e, r),
                  i = (t = s(t, n)).write(e, r);
              return i !== n && (t = t.slice(0, i)), t;
            }(t, e, r) : function (t, e) {
              if (f.isBuffer(e)) {
                var r = 0 | d(e.length);
                return 0 === (t = s(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
              }

              if (e) {
                if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? s(t, 0) : l(t, e);
                if ("Buffer" === e.type && o(e.data)) return l(t, e.data);
              }

              var n;
              throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }(t, e);
          }

          function c(t) {
            if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
            if (t < 0) throw new RangeError('"size" argument must not be negative');
          }

          function h(t, e) {
            if (c(e), t = s(t, e < 0 ? 0 : 0 | d(e)), !f.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
              t[r] = 0;
            }
            return t;
          }

          function l(t, e) {
            var r = e.length < 0 ? 0 : 0 | d(e.length);
            t = s(t, r);

            for (var n = 0; n < r; n += 1) {
              t[n] = 255 & e[n];
            }

            return t;
          }

          function d(t) {
            if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
            return 0 | t;
          }

          function p(t, e) {
            if (f.isBuffer(t)) return t.length;
            if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
            "string" != typeof t && (t = "" + t);
            var r = t.length;
            if (0 === r) return 0;

            for (var n = !1;;) {
              switch (e) {
                case "ascii":
                case "latin1":
                case "binary":
                  return r;

                case "utf8":
                case "utf-8":
                case void 0:
                  return N(t).length;

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return 2 * r;

                case "hex":
                  return r >>> 1;

                case "base64":
                  return q(t).length;

                default:
                  if (n) return N(t).length;
                  e = ("" + e).toLowerCase(), n = !0;
              }
            }
          }

          function g(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          function A(t, e, r, n, i) {
            if (0 === t.length) return -1;

            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
              if (i) return -1;
              r = t.length - 1;
            } else if (r < 0) {
              if (!i) return -1;
              r = 0;
            }

            if ("string" == typeof e && (e = f.from(e, n)), f.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, r, n, i);
            if ("number" == typeof e) return e &= 255, f.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : b(t, [e], r, n, i);
            throw new TypeError("val must be string, number or Buffer");
          }

          function b(t, e, r, n, i) {
            var o,
                a = 1,
                s = t.length,
                f = e.length;

            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
              if (t.length < 2 || e.length < 2) return -1;
              a = 2, s /= 2, f /= 2, r /= 2;
            }

            function u(t, e) {
              return 1 === a ? t[e] : t.readUInt16BE(e * a);
            }

            if (i) {
              var c = -1;

              for (o = r; o < s; o++) {
                if (u(t, o) === u(e, -1 === c ? 0 : o - c)) {
                  if (-1 === c && (c = o), o - c + 1 === f) return c * a;
                } else -1 !== c && (o -= o - c), c = -1;
              }
            } else for (r + f > s && (r = s - f), o = r; o >= 0; o--) {
              for (var h = !0, l = 0; l < f; l++) {
                if (u(t, o + l) !== u(e, l)) {
                  h = !1;
                  break;
                }
              }

              if (h) return o;
            }

            return -1;
          }

          function v(t, e, r, n) {
            r = Number(r) || 0;
            var i = t.length - r;
            n ? (n = Number(n)) > i && (n = i) : n = i;
            var o = e.length;
            if (o % 2 != 0) throw new TypeError("Invalid hex string");
            n > o / 2 && (n = o / 2);

            for (var a = 0; a < n; ++a) {
              var s = parseInt(e.substr(2 * a, 2), 16);
              if (isNaN(s)) return a;
              t[r + a] = s;
            }

            return a;
          }

          function y(t, e, r, n) {
            return U(N(e, t.length - r), t, r, n);
          }

          function w(t, e, r, n) {
            return U(function (t) {
              for (var e = [], r = 0; r < t.length; ++r) {
                e.push(255 & t.charCodeAt(r));
              }

              return e;
            }(e), t, r, n);
          }

          function m(t, e, r, n) {
            return w(t, e, r, n);
          }

          function _(t, e, r, n) {
            return U(q(e), t, r, n);
          }

          function I(t, e, r, n) {
            return U(function (t, e) {
              for (var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) {
                r = t.charCodeAt(a), n = r >> 8, i = r % 256, o.push(i), o.push(n);
              }

              return o;
            }(e, t.length - r), t, r, n);
          }

          function E(t, e, r) {
            return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
          }

          function P(t, e, r) {
            r = Math.min(t.length, r);

            for (var n = [], i = e; i < r;) {
              var o,
                  a,
                  s,
                  f,
                  u = t[i],
                  c = null,
                  h = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
              if (i + h <= r) switch (h) {
                case 1:
                  u < 128 && (c = u);
                  break;

                case 2:
                  128 == (192 & (o = t[i + 1])) && (f = (31 & u) << 6 | 63 & o) > 127 && (c = f);
                  break;

                case 3:
                  o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (f = (15 & u) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (f < 55296 || f > 57343) && (c = f);
                  break;

                case 4:
                  o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (f = (15 & u) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && f < 1114112 && (c = f);
              }
              null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, n.push(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), n.push(c), i += h;
            }

            return function (t) {
              var e = t.length;
              if (e <= S) return String.fromCharCode.apply(String, t);

              for (var r = "", n = 0; n < e;) {
                r += String.fromCharCode.apply(String, t.slice(n, n += S));
              }

              return r;
            }(n);
          }

          e.Buffer = f, e.SlowBuffer = function (t) {
            return +t != t && (t = 0), f.alloc(+t);
          }, e.INSPECT_MAX_BYTES = 50, f.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
            try {
              var t = new Uint8Array(1);
              return t.__proto__ = {
                __proto__: Uint8Array.prototype,
                foo: function foo() {
                  return 42;
                }
              }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
            } catch (t) {
              return !1;
            }
          }(), e.kMaxLength = a(), f.poolSize = 8192, f._augment = function (t) {
            return t.__proto__ = f.prototype, t;
          }, f.from = function (t, e, r) {
            return u(null, t, e, r);
          }, f.TYPED_ARRAY_SUPPORT && (f.prototype.__proto__ = Uint8Array.prototype, f.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && f[Symbol.species] === f && Object.defineProperty(f, Symbol.species, {
            value: null,
            configurable: !0
          })), f.alloc = function (t, e, r) {
            return function (t, e, r, n) {
              return c(e), e <= 0 ? s(t, e) : void 0 !== r ? "string" == typeof n ? s(t, e).fill(r, n) : s(t, e).fill(r) : s(t, e);
            }(null, t, e, r);
          }, f.allocUnsafe = function (t) {
            return h(null, t);
          }, f.allocUnsafeSlow = function (t) {
            return h(null, t);
          }, f.isBuffer = function (t) {
            return !(null == t || !t._isBuffer);
          }, f.compare = function (t, e) {
            if (!f.isBuffer(t) || !f.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
            if (t === e) return 0;

            for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
              if (t[i] !== e[i]) {
                r = t[i], n = e[i];
                break;
              }
            }

            return r < n ? -1 : n < r ? 1 : 0;
          }, f.isEncoding = function (t) {
            switch (String(t).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;

              default:
                return !1;
            }
          }, f.concat = function (t, e) {
            if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === t.length) return f.alloc(0);
            var r;
            if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
              e += t[r].length;
            }
            var n = f.allocUnsafe(e),
                i = 0;

            for (r = 0; r < t.length; ++r) {
              var a = t[r];
              if (!f.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
              a.copy(n, i), i += a.length;
            }

            return n;
          }, f.byteLength = p, f.prototype._isBuffer = !0, f.prototype.swap16 = function () {
            var t = this.length;
            if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

            for (var e = 0; e < t; e += 2) {
              g(this, e, e + 1);
            }

            return this;
          }, f.prototype.swap32 = function () {
            var t = this.length;
            if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

            for (var e = 0; e < t; e += 4) {
              g(this, e, e + 3), g(this, e + 1, e + 2);
            }

            return this;
          }, f.prototype.swap64 = function () {
            var t = this.length;
            if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

            for (var e = 0; e < t; e += 8) {
              g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
            }

            return this;
          }, f.prototype.toString = function () {
            var t = 0 | this.length;
            return 0 === t ? "" : 0 === arguments.length ? P(this, 0, t) : function (t, e, r) {
              var n = !1;
              if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
              if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
              if ((r >>>= 0) <= (e >>>= 0)) return "";

              for (t || (t = "utf8");;) {
                switch (t) {
                  case "hex":
                    return M(this, e, r);

                  case "utf8":
                  case "utf-8":
                    return P(this, e, r);

                  case "ascii":
                    return x(this, e, r);

                  case "latin1":
                  case "binary":
                    return C(this, e, r);

                  case "base64":
                    return E(this, e, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return T(this, e, r);

                  default:
                    if (n) throw new TypeError("Unknown encoding: " + t);
                    t = (t + "").toLowerCase(), n = !0;
                }
              }
            }.apply(this, arguments);
          }, f.prototype.equals = function (t) {
            if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            return this === t || 0 === f.compare(this, t);
          }, f.prototype.inspect = function () {
            var t = "",
                r = e.INSPECT_MAX_BYTES;
            return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
          }, f.prototype.compare = function (t, e, r, n, i) {
            if (!f.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
            if (n >= i && e >= r) return 0;
            if (n >= i) return -1;
            if (e >= r) return 1;
            if (this === t) return 0;

            for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), u = this.slice(n, i), c = t.slice(e, r), h = 0; h < s; ++h) {
              if (u[h] !== c[h]) {
                o = u[h], a = c[h];
                break;
              }
            }

            return o < a ? -1 : a < o ? 1 : 0;
          }, f.prototype.includes = function (t, e, r) {
            return -1 !== this.indexOf(t, e, r);
          }, f.prototype.indexOf = function (t, e, r) {
            return A(this, t, e, r, !0);
          }, f.prototype.lastIndexOf = function (t, e, r) {
            return A(this, t, e, r, !1);
          }, f.prototype.write = function (t, e, r, n) {
            if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
              if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
            }
            var i = this.length - e;
            if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            n || (n = "utf8");

            for (var o = !1;;) {
              switch (n) {
                case "hex":
                  return v(this, t, e, r);

                case "utf8":
                case "utf-8":
                  return y(this, t, e, r);

                case "ascii":
                  return w(this, t, e, r);

                case "latin1":
                case "binary":
                  return m(this, t, e, r);

                case "base64":
                  return _(this, t, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return I(this, t, e, r);

                default:
                  if (o) throw new TypeError("Unknown encoding: " + n);
                  n = ("" + n).toLowerCase(), o = !0;
              }
            }
          }, f.prototype.toJSON = function () {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          var S = 4096;

          function x(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(127 & t[i]);
            }

            return n;
          }

          function C(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(t[i]);
            }

            return n;
          }

          function M(t, e, r) {
            var n = t.length;
            (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

            for (var i = "", o = e; o < r; ++o) {
              i += z(t[o]);
            }

            return i;
          }

          function T(t, e, r) {
            for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
              i += String.fromCharCode(n[o] + 256 * n[o + 1]);
            }

            return i;
          }

          function k(t, e, r) {
            if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
            if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
          }

          function R(t, e, r, n, i, o) {
            if (!f.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
            if (r + n > t.length) throw new RangeError("Index out of range");
          }

          function B(t, e, r, n) {
            e < 0 && (e = 65535 + e + 1);

            for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
              t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
            }
          }

          function L(t, e, r, n) {
            e < 0 && (e = 4294967295 + e + 1);

            for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
              t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
            }
          }

          function O(t, e, r, n, i, o) {
            if (r + n > t.length) throw new RangeError("Index out of range");
            if (r < 0) throw new RangeError("Index out of range");
          }

          function j(t, e, r, n, o) {
            return o || O(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
          }

          function D(t, e, r, n, o) {
            return o || O(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
          }

          f.prototype.slice = function (t, e) {
            var r,
                n = this.length;
            if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), f.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = f.prototype;else {
              var i = e - t;
              r = new f(i, void 0);

              for (var o = 0; o < i; ++o) {
                r[o] = this[o + t];
              }
            }
            return r;
          }, f.prototype.readUIntLE = function (t, e, r) {
            t |= 0, e |= 0, r || k(t, e, this.length);

            for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
              n += this[t + o] * i;
            }

            return n;
          }, f.prototype.readUIntBE = function (t, e, r) {
            t |= 0, e |= 0, r || k(t, e, this.length);

            for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
              n += this[t + --e] * i;
            }

            return n;
          }, f.prototype.readUInt8 = function (t, e) {
            return e || k(t, 1, this.length), this[t];
          }, f.prototype.readUInt16LE = function (t, e) {
            return e || k(t, 2, this.length), this[t] | this[t + 1] << 8;
          }, f.prototype.readUInt16BE = function (t, e) {
            return e || k(t, 2, this.length), this[t] << 8 | this[t + 1];
          }, f.prototype.readUInt32LE = function (t, e) {
            return e || k(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
          }, f.prototype.readUInt32BE = function (t, e) {
            return e || k(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
          }, f.prototype.readIntLE = function (t, e, r) {
            t |= 0, e |= 0, r || k(t, e, this.length);

            for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
              n += this[t + o] * i;
            }

            return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
          }, f.prototype.readIntBE = function (t, e, r) {
            t |= 0, e |= 0, r || k(t, e, this.length);

            for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
              o += this[t + --n] * i;
            }

            return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
          }, f.prototype.readInt8 = function (t, e) {
            return e || k(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
          }, f.prototype.readInt16LE = function (t, e) {
            e || k(t, 2, this.length);
            var r = this[t] | this[t + 1] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, f.prototype.readInt16BE = function (t, e) {
            e || k(t, 2, this.length);
            var r = this[t + 1] | this[t] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, f.prototype.readInt32LE = function (t, e) {
            return e || k(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
          }, f.prototype.readInt32BE = function (t, e) {
            return e || k(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
          }, f.prototype.readFloatLE = function (t, e) {
            return e || k(t, 4, this.length), i.read(this, t, !0, 23, 4);
          }, f.prototype.readFloatBE = function (t, e) {
            return e || k(t, 4, this.length), i.read(this, t, !1, 23, 4);
          }, f.prototype.readDoubleLE = function (t, e) {
            return e || k(t, 8, this.length), i.read(this, t, !0, 52, 8);
          }, f.prototype.readDoubleBE = function (t, e) {
            return e || k(t, 8, this.length), i.read(this, t, !1, 52, 8);
          }, f.prototype.writeUIntLE = function (t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = 1,
                o = 0;

            for (this[e] = 255 & t; ++o < r && (i *= 256);) {
              this[e + o] = t / i & 255;
            }

            return e + r;
          }, f.prototype.writeUIntBE = function (t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || R(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = r - 1,
                o = 1;

            for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
              this[e + i] = t / o & 255;
            }

            return e + r;
          }, f.prototype.writeUInt8 = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 1, 255, 0), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
          }, f.prototype.writeUInt16LE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
          }, f.prototype.writeUInt16BE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 2, 65535, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
          }, f.prototype.writeUInt32LE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : L(this, t, e, !0), e + 4;
          }, f.prototype.writeUInt32BE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 4, 4294967295, 0), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
          }, f.prototype.writeIntLE = function (t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              R(this, t, e, r, i - 1, -i);
            }

            var o = 0,
                a = 1,
                s = 0;

            for (this[e] = 255 & t; ++o < r && (a *= 256);) {
              t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
            }

            return e + r;
          }, f.prototype.writeIntBE = function (t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              R(this, t, e, r, i - 1, -i);
            }

            var o = r - 1,
                a = 1,
                s = 0;

            for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
              t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
            }

            return e + r;
          }, f.prototype.writeInt8 = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 1, 127, -128), f.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
          }, f.prototype.writeInt16LE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
          }, f.prototype.writeInt16BE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 2, 32767, -32768), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
          }, f.prototype.writeInt32LE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), f.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : L(this, t, e, !0), e + 4;
          }, f.prototype.writeInt32BE = function (t, e, r) {
            return t = +t, e |= 0, r || R(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), f.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : L(this, t, e, !1), e + 4;
          }, f.prototype.writeFloatLE = function (t, e, r) {
            return j(this, t, e, !0, r);
          }, f.prototype.writeFloatBE = function (t, e, r) {
            return j(this, t, e, !1, r);
          }, f.prototype.writeDoubleLE = function (t, e, r) {
            return D(this, t, e, !0, r);
          }, f.prototype.writeDoubleBE = function (t, e, r) {
            return D(this, t, e, !1, r);
          }, f.prototype.copy = function (t, e, r, n) {
            if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
            if (0 === t.length || 0 === this.length) return 0;
            if (e < 0) throw new RangeError("targetStart out of bounds");
            if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
            if (n < 0) throw new RangeError("sourceEnd out of bounds");
            n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
            var i,
                o = n - r;
            if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
              t[i + e] = this[i + r];
            } else if (o < 1e3 || !f.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
              t[i + e] = this[i + r];
            } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
            return o;
          }, f.prototype.fill = function (t, e, r, n) {
            if ("string" == typeof t) {
              if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
                var i = t.charCodeAt(0);
                i < 256 && (t = i);
              }

              if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
              if ("string" == typeof n && !f.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
            } else "number" == typeof t && (t &= 255);

            if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
            if (r <= e) return this;
            var o;
            if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
              this[o] = t;
            } else {
              var a = f.isBuffer(t) ? t : N(new f(t, n).toString()),
                  s = a.length;

              for (o = 0; o < r - e; ++o) {
                this[o + e] = a[o % s];
              }
            }
            return this;
          };
          var H = /[^+\/0-9A-Za-z-_]/g;

          function z(t) {
            return t < 16 ? "0" + t.toString(16) : t.toString(16);
          }

          function N(t, e) {
            var r;
            e = e || 1 / 0;

            for (var n = t.length, i = null, o = [], a = 0; a < n; ++a) {
              if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
                if (!i) {
                  if (r > 56319) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                  }

                  if (a + 1 === n) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                  }

                  i = r;
                  continue;
                }

                if (r < 56320) {
                  (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                  continue;
                }

                r = 65536 + (i - 55296 << 10 | r - 56320);
              } else i && (e -= 3) > -1 && o.push(239, 191, 189);

              if (i = null, r < 128) {
                if ((e -= 1) < 0) break;
                o.push(r);
              } else if (r < 2048) {
                if ((e -= 2) < 0) break;
                o.push(r >> 6 | 192, 63 & r | 128);
              } else if (r < 65536) {
                if ((e -= 3) < 0) break;
                o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
              } else {
                if (!(r < 1114112)) throw new Error("Invalid code point");
                if ((e -= 4) < 0) break;
                o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
              }
            }

            return o;
          }

          function q(t) {
            return n.toByteArray(function (t) {
              if ((t = function (t) {
                return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
              }(t).replace(H, "")).length < 2) return "";

              for (; t.length % 4 != 0;) {
                t += "=";
              }

              return t;
            }(t));
          }

          function U(t, e, r, n) {
            for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
              e[i + r] = t[i];
            }

            return i;
          }
        }).call(this, r(2));
      }, function (t, e) {
        var r;

        r = function () {
          return this;
        }();

        try {
          r = r || new Function("return this")();
        } catch (t) {
          "object" == typeof window && (r = window);
        }

        t.exports = r;
      }, function (t, e, r) {
        "use strict";

        e.byteLength = function (t) {
          var e = u(t),
              r = e[0],
              n = e[1];
          return 3 * (r + n) / 4 - n;
        }, e.toByteArray = function (t) {
          for (var e, r = u(t), n = r[0], a = r[1], s = new o(NaN), f = 0, c = a > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
            e = i[t.charCodeAt(h)] << 18 | i[t.charCodeAt(h + 1)] << 12 | i[t.charCodeAt(h + 2)] << 6 | i[t.charCodeAt(h + 3)], s[f++] = e >> 16 & 255, s[f++] = e >> 8 & 255, s[f++] = 255 & e;
          }

          return 2 === a && (e = i[t.charCodeAt(h)] << 2 | i[t.charCodeAt(h + 1)] >> 4, s[f++] = 255 & e), 1 === a && (e = i[t.charCodeAt(h)] << 10 | i[t.charCodeAt(h + 1)] << 4 | i[t.charCodeAt(h + 2)] >> 2, s[f++] = e >> 8 & 255, s[f++] = 255 & e), s;
        }, e.fromByteArray = function (t) {
          for (var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
            o.push(c(t, a, a + 16383 > s ? s : a + 16383));
          }

          return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
        };

        for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) {
          n[s] = a[s], i[a.charCodeAt(s)] = s;
        }

        function u(t) {
          var e = t.length;
          if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var r = t.indexOf("=");
          return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
        }

        function c(t, e, r) {
          for (var i, o, a = [], s = e; s < r; s += 3) {
            i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
          }

          return a.join("");
        }

        i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
      }, function (t, e) {
        e.read = function (t, e, r, n, i) {
          var o,
              a,
              s = 8 * i - n - 1,
              f = (1 << s) - 1,
              u = f >> 1,
              c = -7,
              h = r ? i - 1 : 0,
              l = r ? -1 : 1,
              d = t[e + h];

          for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += s; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
            ;
          }

          for (a = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; a = 256 * a + t[e + h], h += l, c -= 8) {
            ;
          }

          if (0 === o) o = 1 - u;else {
            if (o === f) return a ? NaN : 1 / 0 * (d ? -1 : 1);
            a += Math.pow(2, n), o -= u;
          }
          return (d ? -1 : 1) * a * Math.pow(2, o - n);
        }, e.write = function (t, e, r, n, i, o) {
          var a,
              s,
              f,
              u = 8 * o - i - 1,
              c = (1 << u) - 1,
              h = c >> 1,
              l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              d = n ? 0 : o - 1,
              p = n ? 1 : -1,
              g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

          for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (e += a + h >= 1 ? l / f : l * Math.pow(2, 1 - h)) * f >= 2 && (a++, f /= 2), a + h >= c ? (s = 0, a = c) : a + h >= 1 ? (s = (e * f - 1) * Math.pow(2, i), a += h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + d] = 255 & s, d += p, s /= 256, i -= 8) {
            ;
          }

          for (a = a << i | s, u += i; u > 0; t[r + d] = 255 & a, d += p, a /= 256, u -= 8) {
            ;
          }

          t[r + d - p] |= 128 * g;
        };
      }, function (t, e) {
        var r = {}.toString;

        t.exports = Array.isArray || function (t) {
          return "[object Array]" == r.call(t);
        };
      }, function (t, e, r) {
        "use strict";

        r.r(e), r.d(e, "__extends", function () {
          return i;
        }), r.d(e, "__assign", function () {
          return _o5;
        }), r.d(e, "__rest", function () {
          return a;
        }), r.d(e, "__decorate", function () {
          return s;
        }), r.d(e, "__param", function () {
          return f;
        }), r.d(e, "__metadata", function () {
          return u;
        }), r.d(e, "__awaiter", function () {
          return c;
        }), r.d(e, "__generator", function () {
          return h;
        }), r.d(e, "__exportStar", function () {
          return l;
        }), r.d(e, "__values", function () {
          return d;
        }), r.d(e, "__read", function () {
          return p;
        }), r.d(e, "__spread", function () {
          return g;
        }), r.d(e, "__await", function () {
          return A;
        }), r.d(e, "__asyncGenerator", function () {
          return b;
        }), r.d(e, "__asyncDelegator", function () {
          return v;
        }), r.d(e, "__asyncValues", function () {
          return y;
        }), r.d(e, "__makeTemplateObject", function () {
          return w;
        }), r.d(e, "__importStar", function () {
          return m;
        }), r.d(e, "__importDefault", function () {
          return _;
        });
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        var _n5 = function n(t, e) {
          return (_n5 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) {
              e.hasOwnProperty(r) && (t[r] = e[r]);
            }
          })(t, e);
        };

        function i(t, e) {
          function r() {
            this.constructor = t;
          }

          _n5(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
        }

        var _o5 = function o() {
          return (_o5 = Object.assign || function (t) {
            for (var e, r = 1, n = arguments.length; r < n; r++) {
              for (var i in e = arguments[r]) {
                Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
              }
            }

            return t;
          }).apply(this, arguments);
        };

        function a(t, e) {
          var r = {};

          for (var n in t) {
            Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
          }

          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var i = 0;

            for (n = Object.getOwnPropertySymbols(t); i < n.length; i++) {
              e.indexOf(n[i]) < 0 && (r[n[i]] = t[n[i]]);
            }
          }

          return r;
        }

        function s(t, e, r, n) {
          var i,
              o = arguments.length,
              a = o < 3 ? e : null === n ? n = Object.getOwnPropertyDescriptor(e, r) : n;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, e, r, n);else for (var s = t.length - 1; s >= 0; s--) {
            (i = t[s]) && (a = (o < 3 ? i(a) : o > 3 ? i(e, r, a) : i(e, r)) || a);
          }
          return o > 3 && a && Object.defineProperty(e, r, a), a;
        }

        function f(t, e) {
          return function (r, n) {
            e(r, n, t);
          };
        }

        function u(t, e) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
        }

        function c(t, e, r, n) {
          return new (r || (r = Promise))(function (i, o) {
            function a(t) {
              try {
                f(n.next(t));
              } catch (t) {
                o(t);
              }
            }

            function s(t) {
              try {
                f(n.throw(t));
              } catch (t) {
                o(t);
              }
            }

            function f(t) {
              t.done ? i(t.value) : new r(function (e) {
                e(t.value);
              }).then(a, s);
            }

            f((n = n.apply(t, e || [])).next());
          });
        }

        function h(t, e) {
          var r,
              n,
              i,
              o,
              a = {
            label: 0,
            sent: function sent() {
              if (1 & i[0]) throw i[1];
              return i[1];
            },
            trys: [],
            ops: []
          };
          return o = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
            return this;
          }), o;

          function s(o) {
            return function (s) {
              return function (o) {
                if (r) throw new TypeError("Generator is already executing.");

                for (; a;) {
                  try {
                    if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                    switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                      case 0:
                      case 1:
                        i = o;
                        break;

                      case 4:
                        return a.label++, {
                          value: o[1],
                          done: !1
                        };

                      case 5:
                        a.label++, n = o[1], o = [0];
                        continue;

                      case 7:
                        o = a.ops.pop(), a.trys.pop();
                        continue;

                      default:
                        if (!(i = (i = a.trys).length > 0 && i[i.length - 1]) && (6 === o[0] || 2 === o[0])) {
                          a = 0;
                          continue;
                        }

                        if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                          a.label = o[1];
                          break;
                        }

                        if (6 === o[0] && a.label < i[1]) {
                          a.label = i[1], i = o;
                          break;
                        }

                        if (i && a.label < i[2]) {
                          a.label = i[2], a.ops.push(o);
                          break;
                        }

                        i[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }

                    o = e.call(t, a);
                  } catch (t) {
                    o = [6, t], n = 0;
                  } finally {
                    r = i = 0;
                  }
                }

                if (5 & o[0]) throw o[1];
                return {
                  value: o[0] ? o[1] : void 0,
                  done: !0
                };
              }([o, s]);
            };
          }
        }

        function l(t, e) {
          for (var r in t) {
            e.hasOwnProperty(r) || (e[r] = t[r]);
          }
        }

        function d(t) {
          var e = "function" == typeof Symbol && t[Symbol.iterator],
              r = 0;
          return e ? e.call(t) : {
            next: function next() {
              return t && r >= t.length && (t = void 0), {
                value: t && t[r++],
                done: !t
              };
            }
          };
        }

        function p(t, e) {
          var r = "function" == typeof Symbol && t[Symbol.iterator];
          if (!r) return t;
          var n,
              i,
              o = r.call(t),
              a = [];

          try {
            for (; (void 0 === e || e-- > 0) && !(n = o.next()).done;) {
              a.push(n.value);
            }
          } catch (t) {
            i = {
              error: t
            };
          } finally {
            try {
              n && !n.done && (r = o.return) && r.call(o);
            } finally {
              if (i) throw i.error;
            }
          }

          return a;
        }

        function g() {
          for (var t = [], e = 0; e < arguments.length; e++) {
            t = t.concat(p(arguments[e]));
          }

          return t;
        }

        function A(t) {
          return this instanceof A ? (this.v = t, this) : new A(t);
        }

        function b(t, e, r) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var n,
              i = r.apply(t, e || []),
              o = [];
          return n = {}, a("next"), a("throw"), a("return"), n[Symbol.asyncIterator] = function () {
            return this;
          }, n;

          function a(t) {
            i[t] && (n[t] = function (e) {
              return new Promise(function (r, n) {
                o.push([t, e, r, n]) > 1 || s(t, e);
              });
            });
          }

          function s(t, e) {
            try {
              (r = i[t](e)).value instanceof A ? Promise.resolve(r.value.v).then(f, u) : c(o[0][2], r);
            } catch (t) {
              c(o[0][3], t);
            }

            var r;
          }

          function f(t) {
            s("next", t);
          }

          function u(t) {
            s("throw", t);
          }

          function c(t, e) {
            t(e), o.shift(), o.length && s(o[0][0], o[0][1]);
          }
        }

        function v(t) {
          var e, r;
          return e = {}, n("next"), n("throw", function (t) {
            throw t;
          }), n("return"), e[Symbol.iterator] = function () {
            return this;
          }, e;

          function n(n, i) {
            e[n] = t[n] ? function (e) {
              return (r = !r) ? {
                value: A(t[n](e)),
                done: "return" === n
              } : i ? i(e) : e;
            } : i;
          }
        }

        function y(t) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var e,
              r = t[Symbol.asyncIterator];
          return r ? r.call(t) : (t = d(t), e = {}, n("next"), n("throw"), n("return"), e[Symbol.asyncIterator] = function () {
            return this;
          }, e);

          function n(r) {
            e[r] = t[r] && function (e) {
              return new Promise(function (n, i) {
                !function (t, e, r, n) {
                  Promise.resolve(n).then(function (e) {
                    t({
                      value: e,
                      done: r
                    });
                  }, e);
                }(n, i, (e = t[r](e)).done, e.value);
              });
            };
          }
        }

        function w(t, e) {
          return Object.defineProperty ? Object.defineProperty(t, "raw", {
            value: e
          }) : t.raw = e, t;
        }

        function m(t) {
          if (t && t.__esModule) return t;
          var e = {};
          if (null != t) for (var r in t) {
            Object.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
          return e.default = t, e;
        }

        function _(t) {
          return t && t.__esModule ? t : {
            default: t
          };
        }
      }, function (t, e) {
        var r = Object.prototype.toString;

        t.exports = function (t) {
          return "number" == typeof t || function (t) {
            return !!t && "object" == typeof t;
          }(t) && "[object Number]" == r.call(t);
        };
      }]);
    }]);
  }, function (t, e, r) {
    var n = r(65),
        i = r(70),
        o = r(40).inherits,
        a = r(41),
        s = r(154),
        f = r(60),
        u = r(158),
        c = r(159),
        h = r(161),
        l = /^[0-9A-Fa-f]+$/g;

    function d(t) {
      this.nonceLock = u(1), t.getAccounts && (this.getAccounts = t.getAccounts), t.processTransaction && (this.processTransaction = t.processTransaction), t.processMessage && (this.processMessage = t.processMessage), t.processPersonalMessage && (this.processPersonalMessage = t.processPersonalMessage), t.processTypedMessage && (this.processTypedMessage = t.processTypedMessage), this.approveTransaction = t.approveTransaction || this.autoApprove, this.approveMessage = t.approveMessage || this.autoApprove, this.approvePersonalMessage = t.approvePersonalMessage || this.autoApprove, this.approveTypedMessage = t.approveTypedMessage || this.autoApprove, t.signTransaction && (this.signTransaction = t.signTransaction || A("signTransaction")), t.signMessage && (this.signMessage = t.signMessage || A("signMessage")), t.signPersonalMessage && (this.signPersonalMessage = t.signPersonalMessage || A("signPersonalMessage")), t.signTypedMessage && (this.signTypedMessage = t.signTypedMessage || A("signTypedMessage")), t.recoverPersonalSignature && (this.recoverPersonalSignature = t.recoverPersonalSignature), t.publishTransaction && (this.publishTransaction = t.publishTransaction), this.estimateGas = t.estimateGas || this.estimateGas, this.getGasPrice = t.getGasPrice || this.getGasPrice;
    }

    function p(t) {
      return t.toLowerCase();
    }

    function g(t) {
      return "string" == typeof t && "0x" === t.slice(0, 2) && t.slice(2).match(l);
    }

    function A(t) {
      return function (e, r) {
        r(new Error('ProviderEngine - HookedWalletSubprovider - Must provide "' + t + '" fn in constructor options'));
      };
    }

    t.exports = d, o(d, c), d.prototype.handleRequest = function (t, e, r) {
      var i = this;
      var o, s, u, c, h;

      switch (i._parityRequests = {}, i._parityRequestCount = 0, t.method) {
        case "eth_coinbase":
          return void i.getAccounts(function (t, e) {
            if (t) return r(t);
            var n = e[0] || null;
            r(null, n);
          });

        case "eth_accounts":
          return void i.getAccounts(function (t, e) {
            if (t) return r(t);
            r(null, e);
          });

        case "eth_sendTransaction":
          return o = t.params[0], void n([function (t) {
            return i.validateTransaction(o, t);
          }, function (t) {
            return i.processTransaction(o, t);
          }], r);

        case "eth_signTransaction":
          return o = t.params[0], void n([function (t) {
            return i.validateTransaction(o, t);
          }, function (t) {
            return i.processSignTransaction(o, t);
          }], r);

        case "eth_sign":
          return h = t.params[0], c = t.params[1], u = t.params[2] || {}, s = f(u, {
            from: h,
            data: c
          }), void n([function (t) {
            return i.validateMessage(s, t);
          }, function (t) {
            return i.processMessage(s, t);
          }], r);

        case "personal_sign":
          return function () {
            var e = t.params[0];

            if (function (t) {
              var e = a.addHexPrefix(t);
              return !a.isValidAddress(e) && g(t);
            }(t.params[1]) && function (t) {
              var e = a.addHexPrefix(t);
              return a.isValidAddress(e);
            }(e)) {
              var _e = "The eth_personalSign method requires params ordered ";
              _e += "[message, address]. This was previously handled incorrectly, ", _e += "and has been corrected automatically. ", _e += "Please switch this param order for smooth behavior in the future.", console.warn(_e), h = t.params[0], c = t.params[1];
            } else c = t.params[0], h = t.params[1];

            u = t.params[2] || {}, s = f(u, {
              from: h,
              data: c
            }), n([function (t) {
              return i.validatePersonalMessage(s, t);
            }, function (t) {
              return i.processPersonalMessage(s, t);
            }], r);
          }();

        case "personal_ecRecover":
          return function () {
            c = t.params[0];
            var e = t.params[1];
            u = t.params[2] || {}, s = f(u, {
              sig: e,
              data: c
            }), i.recoverPersonalSignature(s, r);
          }();

        case "eth_signTypedData":
          return c = t.params[0], h = t.params[1], u = t.params[2] || {}, s = f(u, {
            from: h,
            data: c
          }), void n([function (t) {
            return i.validateTypedMessage(s, t);
          }, function (t) {
            return i.processTypedMessage(s, t);
          }], r);

        case "parity_postTransaction":
          return o = t.params[0], void i.parityPostTransaction(o, r);

        case "parity_postSign":
          return h = t.params[0], c = t.params[1], void i.parityPostSign(h, c, r);

        case "parity_checkRequest":
          return function () {
            var e = t.params[0];
            i.parityCheckRequest(e, r);
          }();

        case "parity_defaultAccount":
          return void i.getAccounts(function (t, e) {
            if (t) return r(t);
            var n = e[0] || null;
            r(null, n);
          });

        default:
          return void e();
      }
    }, d.prototype.getAccounts = function (t) {
      t(null, []);
    }, d.prototype.processTransaction = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveTransaction(t, e);
      }, function (t, e) {
        return r.checkApproval("transaction", t, e);
      }, function (e) {
        return r.finalizeAndSubmitTx(t, e);
      }], e);
    }, d.prototype.processSignTransaction = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveTransaction(t, e);
      }, function (t, e) {
        return r.checkApproval("transaction", t, e);
      }, function (e) {
        return r.finalizeTx(t, e);
      }], e);
    }, d.prototype.processMessage = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveMessage(t, e);
      }, function (t, e) {
        return r.checkApproval("message", t, e);
      }, function (e) {
        return r.signMessage(t, e);
      }], e);
    }, d.prototype.processPersonalMessage = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approvePersonalMessage(t, e);
      }, function (t, e) {
        return r.checkApproval("message", t, e);
      }, function (e) {
        return r.signPersonalMessage(t, e);
      }], e);
    }, d.prototype.processTypedMessage = function (t, e) {
      var r = this;
      n([function (e) {
        return r.approveTypedMessage(t, e);
      }, function (t, e) {
        return r.checkApproval("message", t, e);
      }, function (e) {
        return r.signTypedMessage(t, e);
      }], e);
    }, d.prototype.autoApprove = function (t, e) {
      e(null, !0);
    }, d.prototype.checkApproval = function (t, e, r) {
      r(e ? null : new Error("User denied " + t + " signature."));
    }, d.prototype.parityPostTransaction = function (t, e) {
      var r = this,
          n = "0x".concat(r._parityRequestCount.toString(16));
      r._parityRequestCount++, r.emitPayload({
        method: "eth_sendTransaction",
        params: [t]
      }, function (t, e) {
        if (t) return void (r._parityRequests[n] = {
          error: t
        });
        var i = e.result;
        r._parityRequests[n] = i;
      }), e(null, n);
    }, d.prototype.parityPostSign = function (t, e, r) {
      var n = this,
          i = "0x".concat(n._parityRequestCount.toString(16));
      n._parityRequestCount++, n.emitPayload({
        method: "eth_sign",
        params: [t, e]
      }, function (t, e) {
        if (t) return void (n._parityRequests[i] = {
          error: t
        });
        var r = e.result;
        n._parityRequests[i] = r;
      }), r(null, i);
    }, d.prototype.parityCheckRequest = function (t, e) {
      var r = this._parityRequests[t] || null;
      return r ? r.error ? e(r.error) : void e(null, r) : e(null, null);
    }, d.prototype.recoverPersonalSignature = function (t, e) {
      var r;

      try {
        r = s.recoverPersonalSignature(t);
      } catch (t) {
        return e(t);
      }

      e(null, r);
    }, d.prototype.validateTransaction = function (t, e) {
      if (void 0 === t.from) return e(new Error("Undefined address - from address required to sign transaction."));
      this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign transaction for this address: \"".concat(t.from, "\"")));
      });
    }, d.prototype.validateMessage = function (t, e) {
      if (void 0 === t.from) return e(new Error("Undefined address - from address required to sign message."));
      this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign message for this address: \"".concat(t.from, "\"")));
      });
    }, d.prototype.validatePersonalMessage = function (t, e) {
      return void 0 === t.from ? e(new Error("Undefined address - from address required to sign personal message.")) : void 0 === t.data ? e(new Error("Undefined message - message required to sign personal message.")) : g(t.data) ? void this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign message for this address: \"".concat(t.from, "\"")));
      }) : e(new Error("HookedWalletSubprovider - validateMessage - message was not encoded as hex."));
    }, d.prototype.validateTypedMessage = function (t, e) {
      return void 0 === t.from ? e(new Error("Undefined address - from address required to sign typed data.")) : void 0 === t.data ? e(new Error("Undefined data - message required to sign typed data.")) : void this.validateSender(t.from, function (r, n) {
        return r ? e(r) : n ? void e() : e(new Error("Unknown address - unable to sign message for this address: \"".concat(t.from, "\"")));
      });
    }, d.prototype.validateSender = function (t, e) {
      if (!t) return e(null, !1);
      this.getAccounts(function (r, n) {
        if (r) return e(r);
        var i = -1 !== n.map(p).indexOf(t.toLowerCase());
        e(null, i);
      });
    }, d.prototype.finalizeAndSubmitTx = function (t, e) {
      var r = this;
      r.nonceLock.take(function () {
        n([r.fillInTxExtras.bind(r, t), r.signTransaction.bind(r), r.publishTransaction.bind(r)], function (t, n) {
          if (r.nonceLock.leave(), t) return e(t);
          e(null, n);
        });
      });
    }, d.prototype.finalizeTx = function (t, e) {
      var r = this;
      r.nonceLock.take(function () {
        n([r.fillInTxExtras.bind(r, t), r.signTransaction.bind(r)], function (n, i) {
          if (r.nonceLock.leave(), n) return e(n);
          e(null, {
            raw: i,
            tx: t
          });
        });
      });
    }, d.prototype.publishTransaction = function (t, e) {
      this.emitPayload({
        method: "eth_sendRawTransaction",
        params: [t]
      }, function (t, r) {
        if (t) return e(t);
        e(null, r.result);
      });
    }, d.prototype.estimateGas = function (t, e) {
      h(this.engine, t, e);
    }, d.prototype.getGasPrice = function (t) {
      this.emitPayload({
        method: "eth_gasPrice",
        params: []
      }, function (e, r) {
        if (e) return t(e);
        t(null, r.result);
      });
    }, d.prototype.fillInTxExtras = function (t, e) {
      var r = this,
          n = t.from,
          o = {};
      void 0 === t.gasPrice && (o.gasPrice = r.getGasPrice.bind(r)), void 0 === t.nonce && (o.nonce = r.emitPayload.bind(r, {
        method: "eth_getTransactionCount",
        params: [n, "pending"]
      })), void 0 === t.gas && (o.gas = r.estimateGas.bind(r, function (t) {
        return {
          from: t.from,
          to: t.to,
          value: t.value,
          data: t.data,
          gas: t.gas,
          gasPrice: t.gasPrice,
          nonce: t.nonce
        };
      }(t))), i(o, function (r, n) {
        if (r) return e(r);
        var i = {};
        n.gasPrice && (i.gasPrice = n.gasPrice), n.nonce && (i.nonce = n.nonce.result), n.gas && (i.gas = n.gas), e(null, f(t, i));
      });
    };
  }, function (t, e, r) {
    "use strict";

    r.r(e), r.d(e, "default", function () {
      return u;
    });
    var n = r(62),
        i = r.n(n),
        o = r(31),
        a = r.n(o),
        s = r(63),
        f = r.n(s);

    var u =
    /*#__PURE__*/
    function (_f$a) {
      _inherits(u, _f$a);

      function u(t) {
        var _this;

        _classCallCheck(this, u);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, {
          getAccounts: function () {
            var _getAccounts = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee(t) {
              var e;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return _this.getWalletConnector();

                    case 2:
                      e = _context.sent.accounts;
                      e && e.length ? t(null, e) : t(new Error("Failed to get accounts"));

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function getAccounts(_x) {
              return _getAccounts.apply(this, arguments);
            }

            return getAccounts;
          }(),
          sendTransaction: function () {
            var _sendTransaction = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee2(t, e) {
              var r;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _this.getWalletConnector();

                    case 2:
                      r = _context2.sent;
                      _context2.prev = 3;
                      _context2.t0 = e;
                      _context2.next = 7;
                      return r.sendTransaction(t);

                    case 7:
                      _context2.t1 = _context2.sent;
                      (0, _context2.t0)(null, _context2.t1);
                      _context2.next = 14;
                      break;

                    case 11:
                      _context2.prev = 11;
                      _context2.t2 = _context2["catch"](3);
                      e(_context2.t2);

                    case 14:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, null, [[3, 11]]);
            }));

            function sendTransaction(_x2, _x3) {
              return _sendTransaction.apply(this, arguments);
            }

            return sendTransaction;
          }(),
          signTransaction: function () {
            var _signTransaction = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee3(t, e) {
              var r;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return _this.getWalletConnector();

                    case 2:
                      r = _context3.sent;
                      _context3.prev = 3;
                      _context3.t0 = e;
                      _context3.next = 7;
                      return r.signTransaction(t);

                    case 7:
                      _context3.t1 = _context3.sent;
                      (0, _context3.t0)(null, _context3.t1);
                      _context3.next = 14;
                      break;

                    case 11:
                      _context3.prev = 11;
                      _context3.t2 = _context3["catch"](3);
                      e(_context3.t2);

                    case 14:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, null, [[3, 11]]);
            }));

            function signTransaction(_x4, _x5) {
              return _signTransaction.apply(this, arguments);
            }

            return signTransaction;
          }(),
          signMessage: function () {
            var _signMessage = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee4(t, e) {
              var r;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _this.getWalletConnector();

                    case 2:
                      r = _context4.sent;
                      _context4.prev = 3;
                      _context4.t0 = e;
                      _context4.next = 7;
                      return r.signMessage(t);

                    case 7:
                      _context4.t1 = _context4.sent;
                      (0, _context4.t0)(null, _context4.t1);
                      _context4.next = 14;
                      break;

                    case 11:
                      _context4.prev = 11;
                      _context4.t2 = _context4["catch"](3);
                      e(_context4.t2);

                    case 14:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, null, [[3, 11]]);
            }));

            function signMessage(_x6, _x7) {
              return _signMessage.apply(this, arguments);
            }

            return signMessage;
          }(),
          signPersonalMessage: function () {
            var _signPersonalMessage = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee5(t, e) {
              var r;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return _this.getWalletConnector();

                    case 2:
                      r = _context5.sent;
                      _context5.prev = 3;
                      _context5.t0 = e;
                      _context5.next = 7;
                      return r.signPersonalMessage(t);

                    case 7:
                      _context5.t1 = _context5.sent;
                      (0, _context5.t0)(null, _context5.t1);
                      _context5.next = 14;
                      break;

                    case 11:
                      _context5.prev = 11;
                      _context5.t2 = _context5["catch"](3);
                      e(_context5.t2);

                    case 14:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, null, [[3, 11]]);
            }));

            function signPersonalMessage(_x8, _x9) {
              return _signPersonalMessage.apply(this, arguments);
            }

            return signPersonalMessage;
          }(),
          signTypedMessage: function () {
            var _signTypedMessage = _asyncToGenerator(
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee6(t, e) {
              var r;
              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _this.getWalletConnector();

                    case 2:
                      r = _context6.sent;
                      _context6.prev = 3;
                      _context6.t0 = e;
                      _context6.next = 7;
                      return r.signTypedData(t);

                    case 7:
                      _context6.t1 = _context6.sent;
                      (0, _context6.t0)(null, _context6.t1);
                      _context6.next = 14;
                      break;

                    case 11:
                      _context6.prev = 11;
                      _context6.t2 = _context6["catch"](3);
                      e(_context6.t2);

                    case 14:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6, null, [[3, 11]]);
            }));

            function signTypedMessage(_x10, _x11) {
              return _signTypedMessage.apply(this, arguments);
            }

            return signTypedMessage;
          }()
        })), _this.qrcode = void 0 === t.qrcode || !1 !== t.qrcode;
        var e = t.bridge || null;
        if (!e || "string" != typeof e) throw new Error("Missing or Invalid bridge field");
        _this._walletConnector = new i.a({
          bridge: e
        });
        return _this;
      }

      _createClass(u, [{
        key: "getWalletConnector",
        value: function getWalletConnector() {
          var _this2 = this;

          return new Promise(function (t, e) {
            var r = _this2._walletConnector;
            console.log("[getWalletConnector] walletConnector", r), r.connected ? t(r) : r.createSession().then(function () {
              _this2.qrcode && a.a.open(r.uri, function () {
                e(new Error("User closed WalletConnect modal"));
              }), r.on("connect", function () {
                _this2.qrcode && a.a.close(), t(r);
              });
            }).catch(function (t) {
              return e(t);
            });
          });
        }
      }, {
        key: "isWalletConnect",
        set: function set(t) {},
        get: function get() {
          return !0;
        }
      }, {
        key: "connected",
        set: function set(t) {},
        get: function get() {
          return this._walletConnector.connected;
        }
      }, {
        key: "uri",
        set: function set(t) {},
        get: function get() {
          return this._walletConnector.uri;
        }
      }, {
        key: "accounts",
        set: function set(t) {},
        get: function get() {
          return this._walletConnector.accounts;
        }
      }]);

      return u;
    }(f.a);
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      if (e = (0, o.default)(e || i.default), !(0, n.default)(t)) return e(new Error("First argument to waterfall must be an array of functions"));
      if (!t.length) return e();
      var r = 0;

      function u(e) {
        var n = (0, f.default)(t[r++]);
        e.push((0, s.default)(c)), n.apply(null, e);
      }

      function c(n) {
        if (n || r === t.length) return e.apply(null, arguments);
        u((0, a.default)(arguments, 1));
      }

      u([]);
    };
    var n = u(r(32)),
        i = u(r(13)),
        o = u(r(20)),
        a = u(r(14)),
        s = u(r(21)),
        f = u(r(15));

    function u(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return (0, i.default)(function (e, r) {
        var i;

        try {
          i = t.apply(this, e);
        } catch (t) {
          return r(t);
        }

        (0, n.default)(i) && "function" == typeof i.then ? i.then(function (t) {
          s(r, null, t);
        }, function (t) {
          s(r, t.message ? t : new Error(t));
        }) : r(null, i);
      });
    };
    var n = a(r(33)),
        i = a(r(67)),
        o = a(r(68));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function s(t, e, r) {
      try {
        t(e, r);
      } catch (t) {
        (0, o.default)(f, t);
      }
    }

    function f(t) {
      throw t;
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function () {
        var e = (0, o.default)(arguments),
            r = e.pop();
        t.call(this, e, r);
      };
    };
    var n,
        i = r(14),
        o = (n = i) && n.__esModule ? n : {
      default: n
    };
    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    (function (t, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.hasNextTick = e.hasSetImmediate = void 0, e.fallback = c, e.wrap = h;
      var i,
          o = r(14),
          a = (i = o) && i.__esModule ? i : {
        default: i
      };
      var s,
          f = e.hasSetImmediate = "function" == typeof t && t,
          u = e.hasNextTick = "object" == typeof n && "function" == typeof n.nextTick;

      function c(t) {
        setTimeout(t, 0);
      }

      function h(t) {
        return function (e) {
          var r = (0, a.default)(arguments, 1);
          t(function () {
            e.apply(null, r);
          });
        };
      }

      s = f ? t : u ? n.nextTick : c, e.default = h(s);
    }).call(this, r(34).setImmediate, r(6));
  }, function (t, e, r) {
    (function (t, e) {
      !function (t, r) {
        "use strict";

        if (!t.setImmediate) {
          var n,
              i,
              o,
              a,
              s,
              f = 1,
              u = {},
              c = !1,
              h = t.document,
              l = Object.getPrototypeOf && Object.getPrototypeOf(t);
          l = l && l.setTimeout ? l : t, "[object process]" === {}.toString.call(t.process) ? n = function n(t) {
            e.nextTick(function () {
              p(t);
            });
          } : !function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  r = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = r, e;
            }
          }() ? t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
            p(t.data);
          }, n = function n(t) {
            o.port2.postMessage(t);
          }) : h && "onreadystatechange" in h.createElement("script") ? (i = h.documentElement, n = function n(t) {
            var e = h.createElement("script");
            e.onreadystatechange = function () {
              p(t), e.onreadystatechange = null, i.removeChild(e), e = null;
            }, i.appendChild(e);
          }) : n = function n(t) {
            setTimeout(p, 0, t);
          } : (a = "setImmediate$" + Math.random() + "$", s = function s(e) {
            e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length));
          }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), n = function n(e) {
            t.postMessage(a + e, "*");
          }), l.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));

            for (var e = new Array(arguments.length - 1), r = 0; r < e.length; r++) {
              e[r] = arguments[r + 1];
            }

            var i = {
              callback: t,
              args: e
            };
            return u[f] = i, n(f), f++;
          }, l.clearImmediate = d;
        }

        function d(t) {
          delete u[t];
        }

        function p(t) {
          if (c) setTimeout(p, 0, t);else {
            var e = u[t];

            if (e) {
              c = !0;

              try {
                !function (t) {
                  var e = t.callback,
                      n = t.args;

                  switch (n.length) {
                    case 0:
                      e();
                      break;

                    case 1:
                      e(n[0]);
                      break;

                    case 2:
                      e(n[0], n[1]);
                      break;

                    case 3:
                      e(n[0], n[1], n[2]);
                      break;

                    default:
                      e.apply(r, n);
                  }
                }(e);
              } finally {
                d(t), c = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, r(5), r(6));
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      (0, i.default)(n.default, t, e);
    };
    var n = o(r(71)),
        i = o(r(96));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r) {
      ((0, n.default)(t) ? l : d)(t, (0, c.default)(e), r);
    };
    var n = h(r(16)),
        i = h(r(39)),
        o = h(r(75)),
        a = h(r(95)),
        s = h(r(13)),
        f = h(r(20)),
        u = h(r(21)),
        c = h(r(15));

    function h(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    function l(t, e, r) {
      r = (0, f.default)(r || s.default);
      var n = 0,
          o = 0,
          a = t.length;

      function c(t, e) {
        t ? r(t) : ++o !== a && e !== i.default || r(null);
      }

      for (0 === a && r(null); n < a; n++) {
        e(t[n], n, (0, u.default)(c));
      }
    }

    var d = (0, a.default)(o.default, 1 / 0);
    t.exports = e.default;
  }, function (t, e, r) {
    var n = r(22),
        i = r(33),
        o = "[object AsyncFunction]",
        a = "[object Function]",
        s = "[object GeneratorFunction]",
        f = "[object Proxy]";

    t.exports = function (t) {
      if (!i(t)) return !1;
      var e = n(t);
      return e == a || e == s || e == o || e == f;
    };
  }, function (t, e, r) {
    var n = r(35),
        i = Object.prototype,
        o = i.hasOwnProperty,
        a = i.toString,
        s = n ? n.toStringTag : void 0;

    t.exports = function (t) {
      var e = o.call(t, s),
          r = t[s];

      try {
        t[s] = void 0;
        var n = !0;
      } catch (t) {}

      var i = a.call(t);
      return n && (e ? t[s] = r : delete t[s]), i;
    };
  }, function (t, e) {
    var r = Object.prototype.toString;

    t.exports = function (t) {
      return r.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r, o) {
      (0, n.default)(e)(t, (0, i.default)(r), o);
    };
    var n = o(r(76)),
        i = o(r(15));

    function o(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return function (e, r, f) {
        if (f = (0, i.default)(f || n.default), t <= 0 || !e) return f(null);
        var u = (0, o.default)(e),
            c = !1,
            h = 0,
            l = !1;

        function d(t, e) {
          if (h -= 1, t) c = !0, f(t);else {
            if (e === s.default || c && h <= 0) return c = !0, f(null);
            l || p();
          }
        }

        function p() {
          for (l = !0; h < t && !c;) {
            var e = u();
            if (null === e) return c = !0, void (h <= 0 && f(null));
            h += 1, r(e.value, e.key, (0, a.default)(d));
          }

          l = !1;
        }

        p();
      };
    };
    var n = f(r(13)),
        i = f(r(20)),
        o = f(r(77)),
        a = f(r(21)),
        s = f(r(39));

    function f(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      if ((0, n.default)(t)) return function (t) {
        var e = -1,
            r = t.length;
        return function () {
          return ++e < r ? {
            value: t[e],
            key: e
          } : null;
        };
      }(t);
      var e = (0, i.default)(t);
      return e ? function (t) {
        var e = -1;
        return function () {
          var r = t.next();
          return r.done ? null : (e++, {
            value: r.value,
            key: e
          });
        };
      }(e) : (r = t, a = (0, o.default)(r), s = -1, f = a.length, function () {
        var t = a[++s];
        return s < f ? {
          value: r[t],
          key: t
        } : null;
      });
      var r, a, s, f;
    };
    var n = a(r(16)),
        i = a(r(78)),
        o = a(r(79));

    function a(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t) {
      return n && t[n] && t[n]();
    };
    var n = "function" == typeof Symbol && Symbol.iterator;
    t.exports = e.default;
  }, function (t, e, r) {
    var n = r(80),
        i = r(91),
        o = r(16);

    t.exports = function (t) {
      return o(t) ? n(t) : i(t);
    };
  }, function (t, e, r) {
    var n = r(81),
        i = r(82),
        o = r(32),
        a = r(84),
        s = r(86),
        f = r(87),
        u = Object.prototype.hasOwnProperty;

    t.exports = function (t, e) {
      var r = o(t),
          c = !r && i(t),
          h = !r && !c && a(t),
          l = !r && !c && !h && f(t),
          d = r || c || h || l,
          p = d ? n(t.length, String) : [],
          g = p.length;

      for (var A in t) {
        !e && !u.call(t, A) || d && ("length" == A || h && ("offset" == A || "parent" == A) || l && ("buffer" == A || "byteLength" == A || "byteOffset" == A) || s(A, g)) || p.push(A);
      }

      return p;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      for (var r = -1, n = Array(t); ++r < t;) {
        n[r] = e(r);
      }

      return n;
    };
  }, function (t, e, r) {
    var n = r(83),
        i = r(23),
        o = Object.prototype,
        a = o.hasOwnProperty,
        s = o.propertyIsEnumerable,
        f = n(function () {
      return arguments;
    }()) ? n : function (t) {
      return i(t) && a.call(t, "callee") && !s.call(t, "callee");
    };
    t.exports = f;
  }, function (t, e, r) {
    var n = r(22),
        i = r(23),
        o = "[object Arguments]";

    t.exports = function (t) {
      return i(t) && n(t) == o;
    };
  }, function (t, e, r) {
    (function (t) {
      var n = r(36),
          i = r(85),
          o = e && !e.nodeType && e,
          a = o && "object" == typeof t && t && !t.nodeType && t,
          s = a && a.exports === o ? n.Buffer : void 0,
          f = (s ? s.isBuffer : void 0) || i;
      t.exports = f;
    }).call(this, r(24)(t));
  }, function (t, e) {
    t.exports = function () {
      return !1;
    };
  }, function (t, e) {
    var r = 9007199254740991,
        n = /^(?:0|[1-9]\d*)$/;

    t.exports = function (t, e) {
      var i = typeof t;
      return !!(e = null == e ? r : e) && ("number" == i || "symbol" != i && n.test(t)) && t > -1 && t % 1 == 0 && t < e;
    };
  }, function (t, e, r) {
    var n = r(88),
        i = r(89),
        o = r(90),
        a = o && o.isTypedArray,
        s = a ? i(a) : n;
    t.exports = s;
  }, function (t, e, r) {
    var n = r(22),
        i = r(38),
        o = r(23),
        a = {};
    a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, t.exports = function (t) {
      return o(t) && i(t.length) && !!a[n(t)];
    };
  }, function (t, e) {
    t.exports = function (t) {
      return function (e) {
        return t(e);
      };
    };
  }, function (t, e, r) {
    (function (t) {
      var n = r(37),
          i = e && !e.nodeType && e,
          o = i && "object" == typeof t && t && !t.nodeType && t,
          a = o && o.exports === i && n.process,
          s = function () {
        try {
          var t = o && o.require && o.require("util").types;

          return t || a && a.binding && a.binding("util");
        } catch (t) {}
      }();

      t.exports = s;
    }).call(this, r(24)(t));
  }, function (t, e, r) {
    var n = r(92),
        i = r(93),
        o = Object.prototype.hasOwnProperty;

    t.exports = function (t) {
      if (!n(t)) return i(t);
      var e = [];

      for (var r in Object(t)) {
        o.call(t, r) && "constructor" != r && e.push(r);
      }

      return e;
    };
  }, function (t, e) {
    var r = Object.prototype;

    t.exports = function (t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || r);
    };
  }, function (t, e, r) {
    var n = r(94)(Object.keys, Object);
    t.exports = n;
  }, function (t, e) {
    t.exports = function (t, e) {
      return function (r) {
        return t(e(r));
      };
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e) {
      return function (r, n, i) {
        return t(r, e, n, i);
      };
    }, t.exports = e.default;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = function (t, e, r) {
      r = r || n.default;
      var s = (0, i.default)(e) ? [] : {};
      t(e, function (t, e, r) {
        (0, a.default)(t)(function (t, n) {
          arguments.length > 2 && (n = (0, o.default)(arguments, 1)), s[e] = n, r(t);
        });
      }, function (t) {
        r(t, s);
      });
    };
    var n = s(r(13)),
        i = s(r(16)),
        o = s(r(14)),
        a = s(r(15));

    function s(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    t.exports = e.default;
  }, function (t, e) {
    t.exports = function (t) {
      return t && "object" == typeof t && "function" == typeof t.copy && "function" == typeof t.fill && "function" == typeof t.readUInt8;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(99),
        i = r(113);

    t.exports = function (t) {
      var e = n(t),
          r = i(t);
      return function (t, n) {
        switch ("string" == typeof t ? t.toLowerCase() : t) {
          case "keccak224":
            return new e(1152, 448, null, 224, n);

          case "keccak256":
            return new e(1088, 512, null, 256, n);

          case "keccak384":
            return new e(832, 768, null, 384, n);

          case "keccak512":
            return new e(576, 1024, null, 512, n);

          case "sha3-224":
            return new e(1152, 448, 6, 224, n);

          case "sha3-256":
            return new e(1088, 512, 6, 256, n);

          case "sha3-384":
            return new e(832, 768, 6, 384, n);

          case "sha3-512":
            return new e(576, 1024, 6, 512, n);

          case "shake128":
            return new r(1344, 256, 31, n);

          case "shake256":
            return new r(1088, 512, 31, n);

          default:
            throw new Error("Invald algorithm: " + t);
        }
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(17).Transform,
        o = r(0);

    t.exports = function (t) {
      function e(e, r, n, o, a) {
        i.call(this, a), this._rate = e, this._capacity = r, this._delimitedSuffix = n, this._hashBitLength = o, this._options = a, this._state = new t(), this._state.initialize(e, r), this._finalized = !1;
      }

      return o(e, i), e.prototype._transform = function (t, e, r) {
        var n = null;

        try {
          this.update(t, e);
        } catch (t) {
          n = t;
        }

        r(n);
      }, e.prototype._flush = function (t) {
        var e = null;

        try {
          this.push(this.digest());
        } catch (t) {
          e = t;
        }

        t(e);
      }, e.prototype.update = function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Digest already called");
        return n.isBuffer(t) || (t = n.from(t, e)), this._state.absorb(t), this;
      }, e.prototype.digest = function (t) {
        if (this._finalized) throw new Error("Digest already called");
        this._finalized = !0, this._delimitedSuffix && this._state.absorbLastFewBits(this._delimitedSuffix);

        var e = this._state.squeeze(this._hashBitLength / 8);

        return void 0 !== t && (e = e.toString(t)), this._resetState(), e;
      }, e.prototype._resetState = function () {
        return this._state.initialize(this._rate, this._capacity), this;
      }, e.prototype._clone = function () {
        var t = new e(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
        return this._state.copy(t._state), t._finalized = this._finalized, t;
      }, e;
    };
  }, function (t, e, r) {
    "use strict";

    e.byteLength = function (t) {
      var e = u(t),
          r = e[0],
          n = e[1];
      return 3 * (r + n) / 4 - n;
    }, e.toByteArray = function (t) {
      for (var e, r = u(t), n = r[0], a = r[1], s = new o(function (t, e, r) {
        return 3 * (e + r) / 4 - r;
      }(0, n, a)), f = 0, c = a > 0 ? n - 4 : n, h = 0; h < c; h += 4) {
        e = i[t.charCodeAt(h)] << 18 | i[t.charCodeAt(h + 1)] << 12 | i[t.charCodeAt(h + 2)] << 6 | i[t.charCodeAt(h + 3)], s[f++] = e >> 16 & 255, s[f++] = e >> 8 & 255, s[f++] = 255 & e;
      }

      2 === a && (e = i[t.charCodeAt(h)] << 2 | i[t.charCodeAt(h + 1)] >> 4, s[f++] = 255 & e);
      1 === a && (e = i[t.charCodeAt(h)] << 10 | i[t.charCodeAt(h + 1)] << 4 | i[t.charCodeAt(h + 2)] >> 2, s[f++] = e >> 8 & 255, s[f++] = 255 & e);
      return s;
    }, e.fromByteArray = function (t) {
      for (var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
        o.push(c(t, a, a + 16383 > s ? s : a + 16383));
      }

      1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
      return o.join("");
    };

    for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, f = a.length; s < f; ++s) {
      n[s] = a[s], i[a.charCodeAt(s)] = s;
    }

    function u(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }

    function c(t, e, r) {
      for (var i, o, a = [], s = e; s < r; s += 3) {
        i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
      }

      return a.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, r, n, i) {
      var o,
          a,
          s = 8 * i - n - 1,
          f = (1 << s) - 1,
          u = f >> 1,
          c = -7,
          h = r ? i - 1 : 0,
          l = r ? -1 : 1,
          d = t[e + h];

      for (h += l, o = d & (1 << -c) - 1, d >>= -c, c += s; c > 0; o = 256 * o + t[e + h], h += l, c -= 8) {
        ;
      }

      for (a = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; a = 256 * a + t[e + h], h += l, c -= 8) {
        ;
      }

      if (0 === o) o = 1 - u;else {
        if (o === f) return a ? NaN : 1 / 0 * (d ? -1 : 1);
        a += Math.pow(2, n), o -= u;
      }
      return (d ? -1 : 1) * a * Math.pow(2, o - n);
    }, e.write = function (t, e, r, n, i, o) {
      var a,
          s,
          f,
          u = 8 * o - i - 1,
          c = (1 << u) - 1,
          h = c >> 1,
          l = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          d = n ? 0 : o - 1,
          p = n ? 1 : -1,
          g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), (e += a + h >= 1 ? l / f : l * Math.pow(2, 1 - h)) * f >= 2 && (a++, f /= 2), a + h >= c ? (s = 0, a = c) : a + h >= 1 ? (s = (e * f - 1) * Math.pow(2, i), a += h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + d] = 255 & s, d += p, s /= 256, i -= 8) {
        ;
      }

      for (a = a << i | s, u += i; u > 0; t[r + d] = 255 & a, d += p, a /= 256, u -= 8) {
        ;
      }

      t[r + d - p] |= 128 * g;
    };
  }, function (t, e) {
    var r = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == r.call(t);
    };
  }, function (t, e) {
    var r = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == r.call(t);
    };
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(106);
    t.exports = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.head = null, this.tail = null, this.length = 0;
      }

      return t.prototype.push = function (t) {
        var e = {
          data: t,
          next: null
        };
        this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
      }, t.prototype.unshift = function (t) {
        var e = {
          data: t,
          next: this.head
        };
        0 === this.length && (this.tail = e), this.head = e, ++this.length;
      }, t.prototype.shift = function () {
        if (0 !== this.length) {
          var t = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
        }
      }, t.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, t.prototype.join = function (t) {
        if (0 === this.length) return "";

        for (var e = this.head, r = "" + e.data; e = e.next;) {
          r += t + e.data;
        }

        return r;
      }, t.prototype.concat = function (t) {
        if (0 === this.length) return n.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var e, r, i, o = n.allocUnsafe(t >>> 0), a = this.head, s = 0; a;) {
          e = a.data, r = o, i = s, e.copy(r, i), s += a.data.length, a = a.next;
        }

        return o;
      }, t;
    }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function () {
      var t = i.inspect({
        length: this.length
      });
      return this.constructor.name + " " + t;
    });
  }, function (t, e) {}, function (t, e, r) {
    (function (e) {
      function r(t) {
        try {
          if (!e.localStorage) return !1;
        } catch (t) {
          return !1;
        }

        var r = e.localStorage[t];
        return null != r && "true" === String(r).toLowerCase();
      }

      t.exports = function (t, e) {
        if (r("noDeprecation")) return t;
        var n = !1;
        return function () {
          if (!n) {
            if (r("throwDeprecation")) throw new Error(e);
            r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
          }

          return t.apply(this, arguments);
        };
      };
    }).call(this, r(5));
  }, function (t, e, r) {
    "use strict";

    t.exports = o;
    var n = r(46),
        i = r(11);

    function o(t) {
      if (!(this instanceof o)) return new o(t);
      n.call(this, t);
    }

    i.inherits = r(0), i.inherits(o, n), o.prototype._transform = function (t, e, r) {
      r(null, t);
    };
  }, function (t, e, r) {
    t.exports = r(27);
  }, function (t, e, r) {
    t.exports = r(8);
  }, function (t, e, r) {
    t.exports = r(26).Transform;
  }, function (t, e, r) {
    t.exports = r(26).PassThrough;
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(17).Transform,
        o = r(0);

    t.exports = function (t) {
      function e(e, r, n, o) {
        i.call(this, o), this._rate = e, this._capacity = r, this._delimitedSuffix = n, this._options = o, this._state = new t(), this._state.initialize(e, r), this._finalized = !1;
      }

      return o(e, i), e.prototype._transform = function (t, e, r) {
        var n = null;

        try {
          this.update(t, e);
        } catch (t) {
          n = t;
        }

        r(n);
      }, e.prototype._flush = function () {}, e.prototype._read = function (t) {
        this.push(this.squeeze(t));
      }, e.prototype.update = function (t, e) {
        if (!n.isBuffer(t) && "string" != typeof t) throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Squeeze already called");
        return n.isBuffer(t) || (t = n.from(t, e)), this._state.absorb(t), this;
      }, e.prototype.squeeze = function (t, e) {
        this._finalized || (this._finalized = !0, this._state.absorbLastFewBits(this._delimitedSuffix));

        var r = this._state.squeeze(t);

        return void 0 !== e && (r = r.toString(e)), r;
      }, e.prototype._resetState = function () {
        return this._state.initialize(this._rate, this._capacity), this;
      }, e.prototype._clone = function () {
        var t = new e(this._rate, this._capacity, this._delimitedSuffix, this._options);
        return this._state.copy(t._state), t._finalized = this._finalized, t;
      }, e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(115);

    function o() {
      this.state = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], this.blockSize = null, this.count = 0, this.squeezing = !1;
    }

    o.prototype.initialize = function (t, e) {
      for (var r = 0; r < 50; ++r) {
        this.state[r] = 0;
      }

      this.blockSize = t / 8, this.count = 0, this.squeezing = !1;
    }, o.prototype.absorb = function (t) {
      for (var e = 0; e < t.length; ++e) {
        this.state[~~(this.count / 4)] ^= t[e] << this.count % 4 * 8, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
      }
    }, o.prototype.absorbLastFewBits = function (t) {
      this.state[~~(this.count / 4)] ^= t << this.count % 4 * 8, 0 != (128 & t) && this.count === this.blockSize - 1 && i.p1600(this.state), this.state[~~((this.blockSize - 1) / 4)] ^= 128 << (this.blockSize - 1) % 4 * 8, i.p1600(this.state), this.count = 0, this.squeezing = !0;
    }, o.prototype.squeeze = function (t) {
      this.squeezing || this.absorbLastFewBits(1);

      for (var e = n.alloc(t), r = 0; r < t; ++r) {
        e[r] = this.state[~~(this.count / 4)] >>> this.count % 4 * 8 & 255, this.count += 1, this.count === this.blockSize && (i.p1600(this.state), this.count = 0);
      }

      return e;
    }, o.prototype.copy = function (t) {
      for (var e = 0; e < 50; ++e) {
        t.state[e] = this.state[e];
      }

      t.blockSize = this.blockSize, t.count = this.count, t.squeezing = this.squeezing;
    }, t.exports = o;
  }, function (t, e, r) {
    "use strict";

    var n = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];

    e.p1600 = function (t) {
      for (var e = 0; e < 24; ++e) {
        var r = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40],
            i = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41],
            o = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42],
            a = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43],
            s = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44],
            f = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45],
            u = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46],
            c = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47],
            h = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48],
            l = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49],
            d = h ^ (o << 1 | a >>> 31),
            p = l ^ (a << 1 | o >>> 31),
            g = t[0] ^ d,
            A = t[1] ^ p,
            b = t[10] ^ d,
            v = t[11] ^ p,
            y = t[20] ^ d,
            w = t[21] ^ p,
            m = t[30] ^ d,
            _ = t[31] ^ p,
            I = t[40] ^ d,
            E = t[41] ^ p;

        d = r ^ (s << 1 | f >>> 31), p = i ^ (f << 1 | s >>> 31);
        var P = t[2] ^ d,
            S = t[3] ^ p,
            x = t[12] ^ d,
            C = t[13] ^ p,
            M = t[22] ^ d,
            T = t[23] ^ p,
            k = t[32] ^ d,
            R = t[33] ^ p,
            B = t[42] ^ d,
            L = t[43] ^ p;
        d = o ^ (u << 1 | c >>> 31), p = a ^ (c << 1 | u >>> 31);
        var O = t[4] ^ d,
            j = t[5] ^ p,
            D = t[14] ^ d,
            H = t[15] ^ p,
            z = t[24] ^ d,
            N = t[25] ^ p,
            q = t[34] ^ d,
            U = t[35] ^ p,
            V = t[44] ^ d,
            W = t[45] ^ p;
        d = s ^ (h << 1 | l >>> 31), p = f ^ (l << 1 | h >>> 31);
        var Y = t[6] ^ d,
            F = t[7] ^ p,
            Z = t[16] ^ d,
            X = t[17] ^ p,
            K = t[26] ^ d,
            J = t[27] ^ p,
            G = t[36] ^ d,
            Q = t[37] ^ p,
            $ = t[46] ^ d,
            tt = t[47] ^ p;
        d = u ^ (r << 1 | i >>> 31), p = c ^ (i << 1 | r >>> 31);

        var et = t[8] ^ d,
            rt = t[9] ^ p,
            nt = t[18] ^ d,
            it = t[19] ^ p,
            ot = t[28] ^ d,
            at = t[29] ^ p,
            st = t[38] ^ d,
            ft = t[39] ^ p,
            ut = t[48] ^ d,
            ct = t[49] ^ p,
            ht = g,
            lt = A,
            dt = v << 4 | b >>> 28,
            pt = b << 4 | v >>> 28,
            gt = y << 3 | w >>> 29,
            At = w << 3 | y >>> 29,
            bt = _ << 9 | m >>> 23,
            vt = m << 9 | _ >>> 23,
            yt = I << 18 | E >>> 14,
            wt = E << 18 | I >>> 14,
            mt = P << 1 | S >>> 31,
            _t = S << 1 | P >>> 31,
            It = C << 12 | x >>> 20,
            Et = x << 12 | C >>> 20,
            Pt = M << 10 | T >>> 22,
            St = T << 10 | M >>> 22,
            xt = R << 13 | k >>> 19,
            Ct = k << 13 | R >>> 19,
            Mt = B << 2 | L >>> 30,
            Tt = L << 2 | B >>> 30,
            kt = j << 30 | O >>> 2,
            Rt = O << 30 | j >>> 2,
            Bt = D << 6 | H >>> 26,
            Lt = H << 6 | D >>> 26,
            Ot = N << 11 | z >>> 21,
            jt = z << 11 | N >>> 21,
            Dt = q << 15 | U >>> 17,
            Ht = U << 15 | q >>> 17,
            zt = W << 29 | V >>> 3,
            Nt = V << 29 | W >>> 3,
            qt = Y << 28 | F >>> 4,
            Ut = F << 28 | Y >>> 4,
            Vt = X << 23 | Z >>> 9,
            Wt = Z << 23 | X >>> 9,
            Yt = K << 25 | J >>> 7,
            Ft = J << 25 | K >>> 7,
            Zt = G << 21 | Q >>> 11,
            Xt = Q << 21 | G >>> 11,
            Kt = tt << 24 | $ >>> 8,
            Jt = $ << 24 | tt >>> 8,
            Gt = et << 27 | rt >>> 5,
            Qt = rt << 27 | et >>> 5,
            $t = nt << 20 | it >>> 12,
            te = it << 20 | nt >>> 12,
            ee = at << 7 | ot >>> 25,
            re = ot << 7 | at >>> 25,
            ne = st << 8 | ft >>> 24,
            ie = ft << 8 | st >>> 24,
            oe = ut << 14 | ct >>> 18,
            ae = ct << 14 | ut >>> 18;

        t[0] = ht ^ ~It & Ot, t[1] = lt ^ ~Et & jt, t[10] = qt ^ ~$t & gt, t[11] = Ut ^ ~te & At, t[20] = mt ^ ~Bt & Yt, t[21] = _t ^ ~Lt & Ft, t[30] = Gt ^ ~dt & Pt, t[31] = Qt ^ ~pt & St, t[40] = kt ^ ~Vt & ee, t[41] = Rt ^ ~Wt & re, t[2] = It ^ ~Ot & Zt, t[3] = Et ^ ~jt & Xt, t[12] = $t ^ ~gt & xt, t[13] = te ^ ~At & Ct, t[22] = Bt ^ ~Yt & ne, t[23] = Lt ^ ~Ft & ie, t[32] = dt ^ ~Pt & Dt, t[33] = pt ^ ~St & Ht, t[42] = Vt ^ ~ee & bt, t[43] = Wt ^ ~re & vt, t[4] = Ot ^ ~Zt & oe, t[5] = jt ^ ~Xt & ae, t[14] = gt ^ ~xt & zt, t[15] = At ^ ~Ct & Nt, t[24] = Yt ^ ~ne & yt, t[25] = Ft ^ ~ie & wt, t[34] = Pt ^ ~Dt & Kt, t[35] = St ^ ~Ht & Jt, t[44] = ee ^ ~bt & Mt, t[45] = re ^ ~vt & Tt, t[6] = Zt ^ ~oe & ht, t[7] = Xt ^ ~ae & lt, t[16] = xt ^ ~zt & qt, t[17] = Ct ^ ~Nt & Ut, t[26] = ne ^ ~yt & mt, t[27] = ie ^ ~wt & _t, t[36] = Dt ^ ~Kt & Gt, t[37] = Ht ^ ~Jt & Qt, t[46] = bt ^ ~Mt & kt, t[47] = vt ^ ~Tt & Rt, t[8] = oe ^ ~ht & It, t[9] = ae ^ ~lt & Et, t[18] = zt ^ ~qt & $t, t[19] = Nt ^ ~Ut & te, t[28] = yt ^ ~mt & Bt, t[29] = wt ^ ~_t & Lt, t[38] = Kt ^ ~Gt & dt, t[39] = Jt ^ ~Qt & pt, t[48] = Mt ^ ~kt & Vt, t[49] = Tt ^ ~Rt & Wt, t[0] ^= n[2 * e], t[1] ^= n[2 * e + 1];
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(117),
        i = r(118),
        o = r(48);

    function a(t, e) {
      return void 0 === t ? e : (n.isBoolean(t, o.COMPRESSED_TYPE_INVALID), t);
    }

    t.exports = function (t) {
      return {
        privateKeyVerify: function privateKeyVerify(e) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), 32 === e.length && t.privateKeyVerify(e);
        },
        privateKeyExport: function privateKeyExport(e, r) {
          n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), r = a(r, !0);
          var s = t.privateKeyExport(e, r);
          return i.privateKeyExport(e, s, r);
        },
        privateKeyImport: function privateKeyImport(e) {
          if (n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), (e = i.privateKeyImport(e)) && 32 === e.length && t.privateKeyVerify(e)) return e;
          throw new Error(o.EC_PRIVATE_KEY_IMPORT_DER_FAIL);
        },
        privateKeyNegate: function privateKeyNegate(e) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), t.privateKeyNegate(e);
        },
        privateKeyModInverse: function privateKeyModInverse(e) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), t.privateKeyModInverse(e);
        },
        privateKeyTweakAdd: function privateKeyTweakAdd(e, r) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), t.privateKeyTweakAdd(e, r);
        },
        privateKeyTweakMul: function privateKeyTweakMul(e, r) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), t.privateKeyTweakMul(e, r);
        },
        publicKeyCreate: function publicKeyCreate(e, r) {
          return n.isBuffer(e, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(e, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), r = a(r, !0), t.publicKeyCreate(e, r);
        },
        publicKeyConvert: function publicKeyConvert(e, r) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), r = a(r, !0), t.publicKeyConvert(e, r);
        },
        publicKeyVerify: function publicKeyVerify(e) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), t.publicKeyVerify(e);
        },
        publicKeyTweakAdd: function publicKeyTweakAdd(e, r, i) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), i = a(i, !0), t.publicKeyTweakAdd(e, r, i);
        },
        publicKeyTweakMul: function publicKeyTweakMul(e, r, i) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.TWEAK_TYPE_INVALID), n.isBufferLength(r, 32, o.TWEAK_LENGTH_INVALID), i = a(i, !0), t.publicKeyTweakMul(e, r, i);
        },
        publicKeyCombine: function publicKeyCombine(e, r) {
          n.isArray(e, o.EC_PUBLIC_KEYS_TYPE_INVALID), n.isLengthGTZero(e, o.EC_PUBLIC_KEYS_LENGTH_INVALID);

          for (var i = 0; i < e.length; ++i) {
            n.isBuffer(e[i], o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e[i], 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID);
          }

          return r = a(r, !0), t.publicKeyCombine(e, r);
        },
        signatureNormalize: function signatureNormalize(e) {
          return n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(e, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), t.signatureNormalize(e);
        },
        signatureExport: function signatureExport(e) {
          n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(e, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID);
          var r = t.signatureExport(e);
          return i.signatureExport(r);
        },
        signatureImport: function signatureImport(e) {
          n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isLengthGTZero(e, o.ECDSA_SIGNATURE_LENGTH_INVALID);
          var r = i.signatureImport(e);
          if (r) return t.signatureImport(r);
          throw new Error(o.ECDSA_SIGNATURE_PARSE_DER_FAIL);
        },
        signatureImportLax: function signatureImportLax(e) {
          n.isBuffer(e, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isLengthGTZero(e, o.ECDSA_SIGNATURE_LENGTH_INVALID);
          var r = i.signatureImportLax(e);
          if (r) return t.signatureImport(r);
          throw new Error(o.ECDSA_SIGNATURE_PARSE_DER_FAIL);
        },
        sign: function sign(e, r, i) {
          n.isBuffer(e, o.MSG32_TYPE_INVALID), n.isBufferLength(e, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID);
          var a = null,
              s = null;
          return void 0 !== i && (n.isObject(i, o.OPTIONS_TYPE_INVALID), void 0 !== i.data && (n.isBuffer(i.data, o.OPTIONS_DATA_TYPE_INVALID), n.isBufferLength(i.data, 32, o.OPTIONS_DATA_LENGTH_INVALID), a = i.data), void 0 !== i.noncefn && (n.isFunction(i.noncefn, o.OPTIONS_NONCEFN_TYPE_INVALID), s = i.noncefn)), t.sign(e, r, s, a);
        },
        verify: function verify(e, r, i) {
          return n.isBuffer(e, o.MSG32_TYPE_INVALID), n.isBufferLength(e, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(r, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), n.isBuffer(i, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(i, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), t.verify(e, r, i);
        },
        recover: function recover(e, r, i, s) {
          return n.isBuffer(e, o.MSG32_TYPE_INVALID), n.isBufferLength(e, 32, o.MSG32_LENGTH_INVALID), n.isBuffer(r, o.ECDSA_SIGNATURE_TYPE_INVALID), n.isBufferLength(r, 64, o.ECDSA_SIGNATURE_LENGTH_INVALID), n.isNumber(i, o.RECOVERY_ID_TYPE_INVALID), n.isNumberInInterval(i, -1, 4, o.RECOVERY_ID_VALUE_INVALID), s = a(s, !0), t.recover(e, r, i, s);
        },
        ecdh: function ecdh(e, r) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), t.ecdh(e, r);
        },
        ecdhUnsafe: function ecdhUnsafe(e, r, i) {
          return n.isBuffer(e, o.EC_PUBLIC_KEY_TYPE_INVALID), n.isBufferLength2(e, 33, 65, o.EC_PUBLIC_KEY_LENGTH_INVALID), n.isBuffer(r, o.EC_PRIVATE_KEY_TYPE_INVALID), n.isBufferLength(r, 32, o.EC_PRIVATE_KEY_LENGTH_INVALID), i = a(i, !0), t.ecdhUnsafe(e, r, i);
        }
      };
    };
  }, function (t, e, r) {
    "use strict";

    (function (t) {
      var r = Object.prototype.toString;
      e.isArray = function (t, e) {
        if (!Array.isArray(t)) throw TypeError(e);
      }, e.isBoolean = function (t, e) {
        if ("[object Boolean]" !== r.call(t)) throw TypeError(e);
      }, e.isBuffer = function (e, r) {
        if (!t.isBuffer(e)) throw TypeError(r);
      }, e.isFunction = function (t, e) {
        if ("[object Function]" !== r.call(t)) throw TypeError(e);
      }, e.isNumber = function (t, e) {
        if ("[object Number]" !== r.call(t)) throw TypeError(e);
      }, e.isObject = function (t, e) {
        if ("[object Object]" !== r.call(t)) throw TypeError(e);
      }, e.isBufferLength = function (t, e, r) {
        if (t.length !== e) throw RangeError(r);
      }, e.isBufferLength2 = function (t, e, r, n) {
        if (t.length !== e && t.length !== r) throw RangeError(n);
      }, e.isLengthGTZero = function (t, e) {
        if (0 === t.length) throw RangeError(e);
      }, e.isNumberInInterval = function (t, e, r, n) {
        if (t <= e || t >= r) throw RangeError(n);
      };
    }).call(this, r(7).Buffer);
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(119),
        o = n.from([48, 129, 211, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 133, 48, 129, 130, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 33, 2, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 36, 3, 34, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
        a = n.from([48, 130, 1, 19, 2, 1, 1, 4, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 160, 129, 165, 48, 129, 162, 2, 1, 1, 48, 44, 6, 7, 42, 134, 72, 206, 61, 1, 1, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 255, 255, 252, 47, 48, 6, 4, 1, 0, 4, 1, 7, 4, 65, 4, 121, 190, 102, 126, 249, 220, 187, 172, 85, 160, 98, 149, 206, 135, 11, 7, 2, 155, 252, 219, 45, 206, 40, 217, 89, 242, 129, 91, 22, 248, 23, 152, 72, 58, 218, 119, 38, 163, 196, 101, 93, 164, 251, 252, 14, 17, 8, 168, 253, 23, 180, 72, 166, 133, 84, 25, 156, 71, 208, 143, 251, 16, 212, 184, 2, 33, 0, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 254, 186, 174, 220, 230, 175, 72, 160, 59, 191, 210, 94, 140, 208, 54, 65, 65, 2, 1, 1, 161, 68, 3, 66, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    e.privateKeyExport = function (t, e, r) {
      var i = n.from(r ? o : a);
      return t.copy(i, r ? 8 : 9), e.copy(i, r ? 181 : 214), i;
    }, e.privateKeyImport = function (t) {
      var e = t.length,
          r = 0;

      if (!(e < r + 1 || 48 !== t[r]) && !(e < (r += 1) + 1) && 128 & t[r]) {
        var n = 127 & t[r];

        if (r += 1, !(n < 1 || n > 2 || e < r + n)) {
          var i = t[r + n - 1] | (n > 1 ? t[r + n - 2] << 8 : 0);
          if (!(e < (r += n) + i || e < r + 3 || 2 !== t[r] || 1 !== t[r + 1] || 1 !== t[r + 2] || e < (r += 3) + 2 || 4 !== t[r] || t[r + 1] > 32 || e < r + 2 + t[r + 1])) return t.slice(r + 2, r + 2 + t[r + 1]);
        }
      }
    }, e.signatureExport = function (t) {
      for (var e = n.concat([n.from([0]), t.r]), r = 33, o = 0; r > 1 && 0 === e[o] && !(128 & e[o + 1]); --r, ++o) {
        ;
      }

      for (var a = n.concat([n.from([0]), t.s]), s = 33, f = 0; s > 1 && 0 === a[f] && !(128 & a[f + 1]); --s, ++f) {
        ;
      }

      return i.encode(e.slice(o), a.slice(f));
    }, e.signatureImport = function (t) {
      var e = n.alloc(32, 0),
          r = n.alloc(32, 0);

      try {
        var o = i.decode(t);
        if (33 === o.r.length && 0 === o.r[0] && (o.r = o.r.slice(1)), o.r.length > 32) throw new Error("R length is too long");
        if (33 === o.s.length && 0 === o.s[0] && (o.s = o.s.slice(1)), o.s.length > 32) throw new Error("S length is too long");
      } catch (t) {
        return;
      }

      return o.r.copy(e, 32 - o.r.length), o.s.copy(r, 32 - o.s.length), {
        r: e,
        s: r
      };
    }, e.signatureImportLax = function (t) {
      var e = n.alloc(32, 0),
          r = n.alloc(32, 0),
          i = t.length,
          o = 0;

      if (48 === t[o++]) {
        var a = t[o++];

        if (!(128 & a && (o += a - 128) > i) && 2 === t[o++]) {
          var s = t[o++];

          if (128 & s) {
            if (o + (a = s - 128) > i) return;

            for (; a > 0 && 0 === t[o]; o += 1, a -= 1) {
              ;
            }

            for (s = 0; a > 0; o += 1, a -= 1) {
              s = (s << 8) + t[o];
            }
          }

          if (!(s > i - o)) {
            var f = o;

            if (o += s, 2 === t[o++]) {
              var u = t[o++];

              if (128 & u) {
                if (o + (a = u - 128) > i) return;

                for (; a > 0 && 0 === t[o]; o += 1, a -= 1) {
                  ;
                }

                for (u = 0; a > 0; o += 1, a -= 1) {
                  u = (u << 8) + t[o];
                }
              }

              if (!(u > i - o)) {
                var c = o;

                for (o += u; s > 0 && 0 === t[f]; s -= 1, f += 1) {
                  ;
                }

                if (!(s > 32)) {
                  var h = t.slice(f, f + s);

                  for (h.copy(e, 32 - h.length); u > 0 && 0 === t[c]; u -= 1, c += 1) {
                    ;
                  }

                  if (!(u > 32)) {
                    var l = t.slice(c, c + u);
                    return l.copy(r, 32 - l.length), {
                      r: e,
                      s: r
                    };
                  }
                }
              }
            }
          }
        }
      }
    };
  }, function (t, e, r) {
    var n = r(1).Buffer;
    t.exports = {
      check: function check(t) {
        if (t.length < 8) return !1;
        if (t.length > 72) return !1;
        if (48 !== t[0]) return !1;
        if (t[1] !== t.length - 2) return !1;
        if (2 !== t[2]) return !1;
        var e = t[3];
        if (0 === e) return !1;
        if (5 + e >= t.length) return !1;
        if (2 !== t[4 + e]) return !1;
        var r = t[5 + e];
        return !(0 === r || 6 + e + r !== t.length || 128 & t[4] || e > 1 && 0 === t[4] && !(128 & t[5]) || 128 & t[e + 6] || r > 1 && 0 === t[e + 6] && !(128 & t[e + 7]));
      },
      decode: function decode(t) {
        if (t.length < 8) throw new Error("DER sequence length is too short");
        if (t.length > 72) throw new Error("DER sequence length is too long");
        if (48 !== t[0]) throw new Error("Expected DER sequence");
        if (t[1] !== t.length - 2) throw new Error("DER sequence length is invalid");
        if (2 !== t[2]) throw new Error("Expected DER integer");
        var e = t[3];
        if (0 === e) throw new Error("R length is zero");
        if (5 + e >= t.length) throw new Error("R length is too long");
        if (2 !== t[4 + e]) throw new Error("Expected DER integer (2)");
        var r = t[5 + e];
        if (0 === r) throw new Error("S length is zero");
        if (6 + e + r !== t.length) throw new Error("S length is invalid");
        if (128 & t[4]) throw new Error("R value is negative");
        if (e > 1 && 0 === t[4] && !(128 & t[5])) throw new Error("R value excessively padded");
        if (128 & t[e + 6]) throw new Error("S value is negative");
        if (r > 1 && 0 === t[e + 6] && !(128 & t[e + 7])) throw new Error("S value excessively padded");
        return {
          r: t.slice(4, 4 + e),
          s: t.slice(6 + e)
        };
      },
      encode: function encode(t, e) {
        var r = t.length,
            i = e.length;
        if (0 === r) throw new Error("R length is zero");
        if (0 === i) throw new Error("S length is zero");
        if (r > 33) throw new Error("R length is too long");
        if (i > 33) throw new Error("S length is too long");
        if (128 & t[0]) throw new Error("R value is negative");
        if (128 & e[0]) throw new Error("S value is negative");
        if (r > 1 && 0 === t[0] && !(128 & t[1])) throw new Error("R value excessively padded");
        if (i > 1 && 0 === e[0] && !(128 & e[1])) throw new Error("S value excessively padded");
        var o = n.allocUnsafe(6 + r + i);
        return o[0] = 48, o[1] = o.length - 2, o[2] = 2, o[3] = t.length, t.copy(o, 4), o[4 + r] = 2, o[5 + r] = e.length, e.copy(o, 6 + r), o;
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1).Buffer,
        i = r(29),
        o = r(2),
        a = r(3).ec,
        s = r(48),
        f = new a("secp256k1"),
        u = f.curve;

    function c(t) {
      var e = t[0];

      switch (e) {
        case 2:
        case 3:
          return 33 !== t.length ? null : function (t, e) {
            var r = new o(e);
            if (r.cmp(u.p) >= 0) return null;
            var n = (r = r.toRed(u.red)).redSqr().redIMul(r).redIAdd(u.b).redSqrt();
            return 3 === t !== n.isOdd() && (n = n.redNeg()), f.keyPair({
              pub: {
                x: r,
                y: n
              }
            });
          }(e, t.slice(1, 33));

        case 4:
        case 6:
        case 7:
          return 65 !== t.length ? null : function (t, e, r) {
            var n = new o(e),
                i = new o(r);
            if (n.cmp(u.p) >= 0 || i.cmp(u.p) >= 0) return null;
            if (n = n.toRed(u.red), i = i.toRed(u.red), (6 === t || 7 === t) && i.isOdd() !== (7 === t)) return null;
            var a = n.redSqr().redIMul(n);
            return i.redSqr().redISub(a.redIAdd(u.b)).isZero() ? f.keyPair({
              pub: {
                x: n,
                y: i
              }
            }) : null;
          }(e, t.slice(1, 33), t.slice(33, 65));

        default:
          return null;
      }
    }

    e.privateKeyVerify = function (t) {
      var e = new o(t);
      return e.cmp(u.n) < 0 && !e.isZero();
    }, e.privateKeyExport = function (t, e) {
      var r = new o(t);
      if (r.cmp(u.n) >= 0 || r.isZero()) throw new Error(s.EC_PRIVATE_KEY_EXPORT_DER_FAIL);
      return n.from(f.keyFromPrivate(t).getPublic(e, !0));
    }, e.privateKeyNegate = function (t) {
      var e = new o(t);
      return e.isZero() ? n.alloc(32) : u.n.sub(e).umod(u.n).toArrayLike(n, "be", 32);
    }, e.privateKeyModInverse = function (t) {
      var e = new o(t);
      if (e.cmp(u.n) >= 0 || e.isZero()) throw new Error(s.EC_PRIVATE_KEY_RANGE_INVALID);
      return e.invm(u.n).toArrayLike(n, "be", 32);
    }, e.privateKeyTweakAdd = function (t, e) {
      var r = new o(e);
      if (r.cmp(u.n) >= 0) throw new Error(s.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
      if (r.iadd(new o(t)), r.cmp(u.n) >= 0 && r.isub(u.n), r.isZero()) throw new Error(s.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
      return r.toArrayLike(n, "be", 32);
    }, e.privateKeyTweakMul = function (t, e) {
      var r = new o(e);
      if (r.cmp(u.n) >= 0 || r.isZero()) throw new Error(s.EC_PRIVATE_KEY_TWEAK_MUL_FAIL);
      return r.imul(new o(t)), r.cmp(u.n) && (r = r.umod(u.n)), r.toArrayLike(n, "be", 32);
    }, e.publicKeyCreate = function (t, e) {
      var r = new o(t);
      if (r.cmp(u.n) >= 0 || r.isZero()) throw new Error(s.EC_PUBLIC_KEY_CREATE_FAIL);
      return n.from(f.keyFromPrivate(t).getPublic(e, !0));
    }, e.publicKeyConvert = function (t, e) {
      var r = c(t);
      if (null === r) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
      return n.from(r.getPublic(e, !0));
    }, e.publicKeyVerify = function (t) {
      return null !== c(t);
    }, e.publicKeyTweakAdd = function (t, e, r) {
      var i = c(t);
      if (null === i) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
      if ((e = new o(e)).cmp(u.n) >= 0) throw new Error(s.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
      var a = u.g.mul(e).add(i.pub);
      if (a.isInfinity()) throw new Error(s.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
      return n.from(a.encode(!0, r));
    }, e.publicKeyTweakMul = function (t, e, r) {
      var i = c(t);
      if (null === i) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
      if ((e = new o(e)).cmp(u.n) >= 0 || e.isZero()) throw new Error(s.EC_PUBLIC_KEY_TWEAK_MUL_FAIL);
      return n.from(i.pub.mul(e).encode(!0, r));
    }, e.publicKeyCombine = function (t, e) {
      for (var r = new Array(t.length), i = 0; i < t.length; ++i) {
        if (r[i] = c(t[i]), null === r[i]) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
      }

      for (var o = r[0].pub, a = 1; a < r.length; ++a) {
        o = o.add(r[a].pub);
      }

      if (o.isInfinity()) throw new Error(s.EC_PUBLIC_KEY_COMBINE_FAIL);
      return n.from(o.encode(!0, e));
    }, e.signatureNormalize = function (t) {
      var e = new o(t.slice(0, 32)),
          r = new o(t.slice(32, 64));
      if (e.cmp(u.n) >= 0 || r.cmp(u.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);
      var i = n.from(t);
      return 1 === r.cmp(f.nh) && u.n.sub(r).toArrayLike(n, "be", 32).copy(i, 32), i;
    }, e.signatureExport = function (t) {
      var e = t.slice(0, 32),
          r = t.slice(32, 64);
      if (new o(e).cmp(u.n) >= 0 || new o(r).cmp(u.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);
      return {
        r: e,
        s: r
      };
    }, e.signatureImport = function (t) {
      var e = new o(t.r);
      e.cmp(u.n) >= 0 && (e = new o(0));
      var r = new o(t.s);
      return r.cmp(u.n) >= 0 && (r = new o(0)), n.concat([e.toArrayLike(n, "be", 32), r.toArrayLike(n, "be", 32)]);
    }, e.sign = function (t, e, r, i) {
      if ("function" == typeof r) {
        var a = r;

        r = function r(_r) {
          var f = a(t, e, null, i, _r);
          if (!n.isBuffer(f) || 32 !== f.length) throw new Error(s.ECDSA_SIGN_FAIL);
          return new o(f);
        };
      }

      var c = new o(e);
      if (c.cmp(u.n) >= 0 || c.isZero()) throw new Error(s.ECDSA_SIGN_FAIL);
      var h = f.sign(t, e, {
        canonical: !0,
        k: r,
        pers: i
      });
      return {
        signature: n.concat([h.r.toArrayLike(n, "be", 32), h.s.toArrayLike(n, "be", 32)]),
        recovery: h.recoveryParam
      };
    }, e.verify = function (t, e, r) {
      var n = {
        r: e.slice(0, 32),
        s: e.slice(32, 64)
      },
          i = new o(n.r),
          a = new o(n.s);
      if (i.cmp(u.n) >= 0 || a.cmp(u.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);
      if (1 === a.cmp(f.nh) || i.isZero() || a.isZero()) return !1;
      var h = c(r);
      if (null === h) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
      return f.verify(t, n, {
        x: h.pub.x,
        y: h.pub.y
      });
    }, e.recover = function (t, e, r, i) {
      var a = {
        r: e.slice(0, 32),
        s: e.slice(32, 64)
      },
          c = new o(a.r),
          h = new o(a.s);
      if (c.cmp(u.n) >= 0 || h.cmp(u.n) >= 0) throw new Error(s.ECDSA_SIGNATURE_PARSE_FAIL);

      try {
        if (c.isZero() || h.isZero()) throw new Error();
        var l = f.recoverPubKey(t, a, r);
        return n.from(l.encode(!0, i));
      } catch (t) {
        throw new Error(s.ECDSA_RECOVER_FAIL);
      }
    }, e.ecdh = function (t, r) {
      var n = e.ecdhUnsafe(t, r, !0);
      return i("sha256").update(n).digest();
    }, e.ecdhUnsafe = function (t, e, r) {
      var i = c(t);
      if (null === i) throw new Error(s.EC_PUBLIC_KEY_PARSE_FAIL);
      var a = new o(e);
      if (a.cmp(u.n) >= 0 || a.isZero()) throw new Error(s.ECDH_FAIL);
      return n.from(i.pub.mul(a).encode(!0, r));
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(0),
        i = r(49),
        o = r(1).Buffer,
        a = new Array(16);

    function s() {
      i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
    }

    function f(t, e) {
      return t << e | t >>> 32 - e;
    }

    function u(t, e, r, n, i, o, a) {
      return f(t + (e & r | ~e & n) + i + o | 0, a) + e | 0;
    }

    function c(t, e, r, n, i, o, a) {
      return f(t + (e & n | r & ~n) + i + o | 0, a) + e | 0;
    }

    function h(t, e, r, n, i, o, a) {
      return f(t + (e ^ r ^ n) + i + o | 0, a) + e | 0;
    }

    function l(t, e, r, n, i, o, a) {
      return f(t + (r ^ (e | ~n)) + i + o | 0, a) + e | 0;
    }

    n(s, i), s.prototype._update = function () {
      for (var t = a, e = 0; e < 16; ++e) {
        t[e] = this._block.readInt32LE(4 * e);
      }

      var r = this._a,
          n = this._b,
          i = this._c,
          o = this._d;
      r = u(r, n, i, o, t[0], 3614090360, 7), o = u(o, r, n, i, t[1], 3905402710, 12), i = u(i, o, r, n, t[2], 606105819, 17), n = u(n, i, o, r, t[3], 3250441966, 22), r = u(r, n, i, o, t[4], 4118548399, 7), o = u(o, r, n, i, t[5], 1200080426, 12), i = u(i, o, r, n, t[6], 2821735955, 17), n = u(n, i, o, r, t[7], 4249261313, 22), r = u(r, n, i, o, t[8], 1770035416, 7), o = u(o, r, n, i, t[9], 2336552879, 12), i = u(i, o, r, n, t[10], 4294925233, 17), n = u(n, i, o, r, t[11], 2304563134, 22), r = u(r, n, i, o, t[12], 1804603682, 7), o = u(o, r, n, i, t[13], 4254626195, 12), i = u(i, o, r, n, t[14], 2792965006, 17), r = c(r, n = u(n, i, o, r, t[15], 1236535329, 22), i, o, t[1], 4129170786, 5), o = c(o, r, n, i, t[6], 3225465664, 9), i = c(i, o, r, n, t[11], 643717713, 14), n = c(n, i, o, r, t[0], 3921069994, 20), r = c(r, n, i, o, t[5], 3593408605, 5), o = c(o, r, n, i, t[10], 38016083, 9), i = c(i, o, r, n, t[15], 3634488961, 14), n = c(n, i, o, r, t[4], 3889429448, 20), r = c(r, n, i, o, t[9], 568446438, 5), o = c(o, r, n, i, t[14], 3275163606, 9), i = c(i, o, r, n, t[3], 4107603335, 14), n = c(n, i, o, r, t[8], 1163531501, 20), r = c(r, n, i, o, t[13], 2850285829, 5), o = c(o, r, n, i, t[2], 4243563512, 9), i = c(i, o, r, n, t[7], 1735328473, 14), r = h(r, n = c(n, i, o, r, t[12], 2368359562, 20), i, o, t[5], 4294588738, 4), o = h(o, r, n, i, t[8], 2272392833, 11), i = h(i, o, r, n, t[11], 1839030562, 16), n = h(n, i, o, r, t[14], 4259657740, 23), r = h(r, n, i, o, t[1], 2763975236, 4), o = h(o, r, n, i, t[4], 1272893353, 11), i = h(i, o, r, n, t[7], 4139469664, 16), n = h(n, i, o, r, t[10], 3200236656, 23), r = h(r, n, i, o, t[13], 681279174, 4), o = h(o, r, n, i, t[0], 3936430074, 11), i = h(i, o, r, n, t[3], 3572445317, 16), n = h(n, i, o, r, t[6], 76029189, 23), r = h(r, n, i, o, t[9], 3654602809, 4), o = h(o, r, n, i, t[12], 3873151461, 11), i = h(i, o, r, n, t[15], 530742520, 16), r = l(r, n = h(n, i, o, r, t[2], 3299628645, 23), i, o, t[0], 4096336452, 6), o = l(o, r, n, i, t[7], 1126891415, 10), i = l(i, o, r, n, t[14], 2878612391, 15), n = l(n, i, o, r, t[5], 4237533241, 21), r = l(r, n, i, o, t[12], 1700485571, 6), o = l(o, r, n, i, t[3], 2399980690, 10), i = l(i, o, r, n, t[10], 4293915773, 15), n = l(n, i, o, r, t[1], 2240044497, 21), r = l(r, n, i, o, t[8], 1873313359, 6), o = l(o, r, n, i, t[15], 4264355552, 10), i = l(i, o, r, n, t[6], 2734768916, 15), n = l(n, i, o, r, t[13], 1309151649, 21), r = l(r, n, i, o, t[4], 4149444226, 6), o = l(o, r, n, i, t[11], 3174756917, 10), i = l(i, o, r, n, t[2], 718787259, 15), n = l(n, i, o, r, t[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
    }, s.prototype._digest = function () {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var t = o.allocUnsafe(16);
      return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t;
    }, t.exports = s;
  }, function (t, e, r) {
    "use strict";

    var n = r(7).Buffer,
        i = r(0),
        o = r(49),
        a = new Array(16),
        s = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        f = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        u = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        c = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11],
        h = [0, 1518500249, 1859775393, 2400959708, 2840853838],
        l = [1352829926, 1548603684, 1836072691, 2053994217, 0];

    function d() {
      o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
    }

    function p(t, e) {
      return t << e | t >>> 32 - e;
    }

    function g(t, e, r, n, i, o, a, s) {
      return p(t + (e ^ r ^ n) + o + a | 0, s) + i | 0;
    }

    function A(t, e, r, n, i, o, a, s) {
      return p(t + (e & r | ~e & n) + o + a | 0, s) + i | 0;
    }

    function b(t, e, r, n, i, o, a, s) {
      return p(t + ((e | ~r) ^ n) + o + a | 0, s) + i | 0;
    }

    function v(t, e, r, n, i, o, a, s) {
      return p(t + (e & n | r & ~n) + o + a | 0, s) + i | 0;
    }

    function y(t, e, r, n, i, o, a, s) {
      return p(t + (e ^ (r | ~n)) + o + a | 0, s) + i | 0;
    }

    i(d, o), d.prototype._update = function () {
      for (var t = a, e = 0; e < 16; ++e) {
        t[e] = this._block.readInt32LE(4 * e);
      }

      for (var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, o = 0 | this._d, d = 0 | this._e, w = 0 | this._a, m = 0 | this._b, _ = 0 | this._c, I = 0 | this._d, E = 0 | this._e, P = 0; P < 80; P += 1) {
        var S, x;
        P < 16 ? (S = g(r, n, i, o, d, t[s[P]], h[0], u[P]), x = y(w, m, _, I, E, t[f[P]], l[0], c[P])) : P < 32 ? (S = A(r, n, i, o, d, t[s[P]], h[1], u[P]), x = v(w, m, _, I, E, t[f[P]], l[1], c[P])) : P < 48 ? (S = b(r, n, i, o, d, t[s[P]], h[2], u[P]), x = b(w, m, _, I, E, t[f[P]], l[2], c[P])) : P < 64 ? (S = v(r, n, i, o, d, t[s[P]], h[3], u[P]), x = A(w, m, _, I, E, t[f[P]], l[3], c[P])) : (S = y(r, n, i, o, d, t[s[P]], h[4], u[P]), x = g(w, m, _, I, E, t[f[P]], l[4], c[P])), r = d, d = o, o = p(i, 10), i = n, n = S, w = E, E = I, I = p(_, 10), _ = m, m = x;
      }

      var C = this._b + i + I | 0;
      this._b = this._c + o + E | 0, this._c = this._d + d + w | 0, this._d = this._e + r + m | 0, this._e = this._a + n + _ | 0, this._a = C;
    }, d.prototype._digest = function () {
      this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
      var t = n.alloc ? n.alloc(20) : new n(20);
      return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t.writeInt32LE(this._e, 16), t;
    }, t.exports = d;
  }, function (t, e, r) {
    (e = t.exports = function (t) {
      t = t.toLowerCase();
      var r = e[t];
      if (!r) throw new Error(t + " is not supported (we accept pull requests)");
      return new r();
    }).sha = r(124), e.sha1 = r(125), e.sha224 = r(126), e.sha256 = r(50), e.sha384 = r(127), e.sha512 = r(51);
  }, function (t, e, r) {
    var n = r(0),
        i = r(10),
        o = r(1).Buffer,
        a = [1518500249, 1859775393, -1894007588, -899497514],
        s = new Array(80);

    function f() {
      this.init(), this._w = s, i.call(this, 64, 56);
    }

    function u(t) {
      return t << 30 | t >>> 2;
    }

    function c(t, e, r, n) {
      return 0 === t ? e & r | ~e & n : 2 === t ? e & r | e & n | r & n : e ^ r ^ n;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, f.prototype._update = function (t) {
      for (var e, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, h = 0; h < 16; ++h) {
        r[h] = t.readInt32BE(4 * h);
      }

      for (; h < 80; ++h) {
        r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
      }

      for (var l = 0; l < 80; ++l) {
        var d = ~~(l / 20),
            p = 0 | ((e = n) << 5 | e >>> 27) + c(d, i, o, s) + f + r[l] + a[d];
        f = s, s = o, o = u(i), i = n, n = p;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0;
    }, f.prototype._hash = function () {
      var t = o.allocUnsafe(20);
      return t.writeInt32BE(0 | this._a, 0), t.writeInt32BE(0 | this._b, 4), t.writeInt32BE(0 | this._c, 8), t.writeInt32BE(0 | this._d, 12), t.writeInt32BE(0 | this._e, 16), t;
    }, t.exports = f;
  }, function (t, e, r) {
    var n = r(0),
        i = r(10),
        o = r(1).Buffer,
        a = [1518500249, 1859775393, -1894007588, -899497514],
        s = new Array(80);

    function f() {
      this.init(), this._w = s, i.call(this, 64, 56);
    }

    function u(t) {
      return t << 5 | t >>> 27;
    }

    function c(t) {
      return t << 30 | t >>> 2;
    }

    function h(t, e, r, n) {
      return 0 === t ? e & r | ~e & n : 2 === t ? e & r | e & n | r & n : e ^ r ^ n;
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
    }, f.prototype._update = function (t) {
      for (var e, r = this._w, n = 0 | this._a, i = 0 | this._b, o = 0 | this._c, s = 0 | this._d, f = 0 | this._e, l = 0; l < 16; ++l) {
        r[l] = t.readInt32BE(4 * l);
      }

      for (; l < 80; ++l) {
        r[l] = (e = r[l - 3] ^ r[l - 8] ^ r[l - 14] ^ r[l - 16]) << 1 | e >>> 31;
      }

      for (var d = 0; d < 80; ++d) {
        var p = ~~(d / 20),
            g = u(n) + h(p, i, o, s) + f + r[d] + a[p] | 0;
        f = s, s = o, o = c(i), i = n, n = g;
      }

      this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = o + this._c | 0, this._d = s + this._d | 0, this._e = f + this._e | 0;
    }, f.prototype._hash = function () {
      var t = o.allocUnsafe(20);
      return t.writeInt32BE(0 | this._a, 0), t.writeInt32BE(0 | this._b, 4), t.writeInt32BE(0 | this._c, 8), t.writeInt32BE(0 | this._d, 12), t.writeInt32BE(0 | this._e, 16), t;
    }, t.exports = f;
  }, function (t, e, r) {
    var n = r(0),
        i = r(50),
        o = r(10),
        a = r(1).Buffer,
        s = new Array(64);

    function f() {
      this.init(), this._w = s, o.call(this, 64, 56);
    }

    n(f, i), f.prototype.init = function () {
      return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
    }, f.prototype._hash = function () {
      var t = a.allocUnsafe(28);
      return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t;
    }, t.exports = f;
  }, function (t, e, r) {
    var n = r(0),
        i = r(51),
        o = r(10),
        a = r(1).Buffer,
        s = new Array(160);

    function f() {
      this.init(), this._w = s, o.call(this, 128, 112);
    }

    n(f, i), f.prototype.init = function () {
      return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
    }, f.prototype._hash = function () {
      var t = a.allocUnsafe(48);

      function e(e, r, n) {
        t.writeInt32BE(e, n), t.writeInt32BE(r, n + 4);
      }

      return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), t;
    }, t.exports = f;
  }, function (t, e, r) {
    var n = r(1).Buffer,
        i = r(17).Transform,
        o = r(28).StringDecoder;

    function a(t) {
      i.call(this), this.hashMode = "string" == typeof t, this.hashMode ? this[t] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
    }

    r(0)(a, i), a.prototype.update = function (t, e, r) {
      "string" == typeof t && (t = n.from(t, e));

      var i = this._update(t);

      return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
    }, a.prototype.setAutoPadding = function () {}, a.prototype.getAuthTag = function () {
      throw new Error("trying to get auth tag in unsupported state");
    }, a.prototype.setAuthTag = function () {
      throw new Error("trying to set auth tag in unsupported state");
    }, a.prototype.setAAD = function () {
      throw new Error("trying to set aad in unsupported state");
    }, a.prototype._transform = function (t, e, r) {
      var n;

      try {
        this.hashMode ? this._update(t) : this.push(this._update(t));
      } catch (t) {
        n = t;
      } finally {
        r(n);
      }
    }, a.prototype._flush = function (t) {
      var e;

      try {
        this.push(this.__final());
      } catch (t) {
        e = t;
      }

      t(e);
    }, a.prototype._finalOrDigest = function (t) {
      var e = this.__final() || n.alloc(0);
      return t && (e = this._toString(e, t, !0)), e;
    }, a.prototype._toString = function (t, e, r) {
      if (this._decoder || (this._decoder = new o(e), this._encoding = e), this._encoding !== e) throw new Error("can't switch encodings");

      var n = this._decoder.write(t);

      return r && (n += this._decoder.end()), n;
    }, t.exports = a;
  }, function (t, e) {}, function (t) {
    t.exports = {
      _from: "elliptic@^6.2.3",
      _id: "elliptic@6.4.1",
      _inBundle: !1,
      _integrity: "sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==",
      _location: "/elliptic",
      _phantomChildren: {},
      _requested: {
        type: "range",
        registry: !0,
        raw: "elliptic@^6.2.3",
        name: "elliptic",
        escapedName: "elliptic",
        rawSpec: "^6.2.3",
        saveSpec: null,
        fetchSpec: "^6.2.3"
      },
      _requiredBy: ["/browserify-sign", "/create-ecdh", "/secp256k1"],
      _resolved: "https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz",
      _shasum: "c2d0b7776911b86722c632c3c06c60f2f819939a",
      _spec: "elliptic@^6.2.3",
      _where: "/Users/pedrogomes/_walletconnect/walletconnect-monorepo/packages/web3-subprovider/node_modules/secp256k1",
      author: {
        name: "Fedor Indutny",
        email: "fedor@indutny.com"
      },
      bugs: {
        url: "https://github.com/indutny/elliptic/issues"
      },
      bundleDependencies: !1,
      dependencies: {
        "bn.js": "^4.4.0",
        brorand: "^1.0.1",
        "hash.js": "^1.0.0",
        "hmac-drbg": "^1.0.0",
        inherits: "^2.0.1",
        "minimalistic-assert": "^1.0.0",
        "minimalistic-crypto-utils": "^1.0.0"
      },
      deprecated: !1,
      description: "EC cryptography",
      devDependencies: {
        brfs: "^1.4.3",
        coveralls: "^2.11.3",
        grunt: "^0.4.5",
        "grunt-browserify": "^5.0.0",
        "grunt-cli": "^1.2.0",
        "grunt-contrib-connect": "^1.0.0",
        "grunt-contrib-copy": "^1.0.0",
        "grunt-contrib-uglify": "^1.0.1",
        "grunt-mocha-istanbul": "^3.0.1",
        "grunt-saucelabs": "^8.6.2",
        istanbul: "^0.4.2",
        jscs: "^2.9.0",
        jshint: "^2.6.0",
        mocha: "^2.1.0"
      },
      files: ["lib"],
      homepage: "https://github.com/indutny/elliptic",
      keywords: ["EC", "Elliptic", "curve", "Cryptography"],
      license: "MIT",
      main: "lib/elliptic.js",
      name: "elliptic",
      repository: {
        type: "git",
        url: "git+ssh://git@github.com/indutny/elliptic.git"
      },
      scripts: {
        jscs: "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
        jshint: "jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js",
        lint: "npm run jscs && npm run jshint",
        test: "npm run lint && npm run unit",
        unit: "istanbul test _mocha --reporter=spec test/index.js",
        version: "grunt dist && git add dist/"
      },
      version: "6.4.1"
    };
  }, function (t, e, r) {
    "use strict";

    var n = e,
        i = r(2),
        o = r(9),
        a = r(52);
    n.assert = o, n.toArray = a.toArray, n.zero2 = a.zero2, n.toHex = a.toHex, n.encode = a.encode, n.getNAF = function (t, e) {
      for (var r = [], n = 1 << e + 1, i = t.clone(); i.cmpn(1) >= 0;) {
        var o;

        if (i.isOdd()) {
          var a = i.andln(n - 1);
          o = a > (n >> 1) - 1 ? (n >> 1) - a : a, i.isubn(o);
        } else o = 0;

        r.push(o);

        for (var s = 0 !== i.cmpn(0) && 0 === i.andln(n - 1) ? e + 1 : 1, f = 1; f < s; f++) {
          r.push(0);
        }

        i.iushrn(s);
      }

      return r;
    }, n.getJSF = function (t, e) {
      var r = [[], []];
      t = t.clone(), e = e.clone();

      for (var n = 0, i = 0; t.cmpn(-n) > 0 || e.cmpn(-i) > 0;) {
        var o,
            a,
            s,
            f = t.andln(3) + n & 3,
            u = e.andln(3) + i & 3;
        3 === f && (f = -1), 3 === u && (u = -1), o = 0 == (1 & f) ? 0 : 3 != (s = t.andln(7) + n & 7) && 5 !== s || 2 !== u ? f : -f, r[0].push(o), a = 0 == (1 & u) ? 0 : 3 != (s = e.andln(7) + i & 7) && 5 !== s || 2 !== f ? u : -u, r[1].push(a), 2 * n === o + 1 && (n = 1 - n), 2 * i === a + 1 && (i = 1 - i), t.iushrn(1), e.iushrn(1);
      }

      return r;
    }, n.cachedProperty = function (t, e, r) {
      var n = "_" + e;

      t.prototype[e] = function () {
        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
      };
    }, n.parseBytes = function (t) {
      return "string" == typeof t ? n.toArray(t, "hex") : t;
    }, n.intFromLE = function (t) {
      return new i(t, "hex", "le");
    };
  }, function (t, e, r) {
    var n;

    function i(t) {
      this.rand = t;
    }

    if (t.exports = function (t) {
      return n || (n = new i(null)), n.generate(t);
    }, t.exports.Rand = i, i.prototype.generate = function (t) {
      return this._rand(t);
    }, i.prototype._rand = function (t) {
      if (this.rand.getBytes) return this.rand.getBytes(t);

      for (var e = new Uint8Array(t), r = 0; r < e.length; r++) {
        e[r] = this.rand.getByte();
      }

      return e;
    }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function (t) {
      var e = new Uint8Array(t);
      return self.crypto.getRandomValues(e), e;
    } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function (t) {
      var e = new Uint8Array(t);
      return self.msCrypto.getRandomValues(e), e;
    } : "object" == typeof window && (i.prototype._rand = function () {
      throw new Error("Not implemented yet");
    });else try {
      var o = r(133);
      if ("function" != typeof o.randomBytes) throw new Error("Not supported");

      i.prototype._rand = function (t) {
        return o.randomBytes(t);
      };
    } catch (t) {}
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(3).utils,
        o = i.getNAF,
        a = i.getJSF,
        s = i.assert;

    function f(t, e) {
      this.type = t, this.p = new n(e.p, 16), this.red = e.prime ? n.red(e.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = e.n && new n(e.n, 16), this.g = e.g && this.pointFromJSON(e.g, e.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4);
      var r = this.n && this.p.div(this.n);
      !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
    }

    function u(t, e) {
      this.curve = t, this.type = e, this.precomputed = null;
    }

    t.exports = f, f.prototype.point = function () {
      throw new Error("Not implemented");
    }, f.prototype.validate = function () {
      throw new Error("Not implemented");
    }, f.prototype._fixedNafMul = function (t, e) {
      s(t.precomputed);

      var r = t._getDoubles(),
          n = o(e, 1),
          i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);

      i /= 3;

      for (var a = [], f = 0; f < n.length; f += r.step) {
        var u = 0;

        for (e = f + r.step - 1; e >= f; e--) {
          u = (u << 1) + n[e];
        }

        a.push(u);
      }

      for (var c = this.jpoint(null, null, null), h = this.jpoint(null, null, null), l = i; l > 0; l--) {
        for (f = 0; f < a.length; f++) {
          (u = a[f]) === l ? h = h.mixedAdd(r.points[f]) : u === -l && (h = h.mixedAdd(r.points[f].neg()));
        }

        c = c.add(h);
      }

      return c.toP();
    }, f.prototype._wnafMul = function (t, e) {
      var r = 4,
          n = t._getNAFPoints(r);

      r = n.wnd;

      for (var i = n.points, a = o(e, r), f = this.jpoint(null, null, null), u = a.length - 1; u >= 0; u--) {
        for (e = 0; u >= 0 && 0 === a[u]; u--) {
          e++;
        }

        if (u >= 0 && e++, f = f.dblp(e), u < 0) break;
        var c = a[u];
        s(0 !== c), f = "affine" === t.type ? c > 0 ? f.mixedAdd(i[c - 1 >> 1]) : f.mixedAdd(i[-c - 1 >> 1].neg()) : c > 0 ? f.add(i[c - 1 >> 1]) : f.add(i[-c - 1 >> 1].neg());
      }

      return "affine" === t.type ? f.toP() : f;
    }, f.prototype._wnafMulAdd = function (t, e, r, n, i) {
      for (var s = this._wnafT1, f = this._wnafT2, u = this._wnafT3, c = 0, h = 0; h < n; h++) {
        var l = (P = e[h])._getNAFPoints(t);

        s[h] = l.wnd, f[h] = l.points;
      }

      for (h = n - 1; h >= 1; h -= 2) {
        var d = h - 1,
            p = h;

        if (1 === s[d] && 1 === s[p]) {
          var g = [e[d], null, null, e[p]];
          0 === e[d].y.cmp(e[p].y) ? (g[1] = e[d].add(e[p]), g[2] = e[d].toJ().mixedAdd(e[p].neg())) : 0 === e[d].y.cmp(e[p].y.redNeg()) ? (g[1] = e[d].toJ().mixedAdd(e[p]), g[2] = e[d].add(e[p].neg())) : (g[1] = e[d].toJ().mixedAdd(e[p]), g[2] = e[d].toJ().mixedAdd(e[p].neg()));
          var A = [-3, -1, -5, -7, 0, 7, 5, 1, 3],
              b = a(r[d], r[p]);
          c = Math.max(b[0].length, c), u[d] = new Array(c), u[p] = new Array(c);

          for (var v = 0; v < c; v++) {
            var y = 0 | b[0][v],
                w = 0 | b[1][v];
            u[d][v] = A[3 * (y + 1) + (w + 1)], u[p][v] = 0, f[d] = g;
          }
        } else u[d] = o(r[d], s[d]), u[p] = o(r[p], s[p]), c = Math.max(u[d].length, c), c = Math.max(u[p].length, c);
      }

      var m = this.jpoint(null, null, null),
          _ = this._wnafT4;

      for (h = c; h >= 0; h--) {
        for (var I = 0; h >= 0;) {
          var E = !0;

          for (v = 0; v < n; v++) {
            _[v] = 0 | u[v][h], 0 !== _[v] && (E = !1);
          }

          if (!E) break;
          I++, h--;
        }

        if (h >= 0 && I++, m = m.dblp(I), h < 0) break;

        for (v = 0; v < n; v++) {
          var P,
              S = _[v];
          0 !== S && (S > 0 ? P = f[v][S - 1 >> 1] : S < 0 && (P = f[v][-S - 1 >> 1].neg()), m = "affine" === P.type ? m.mixedAdd(P) : m.add(P));
        }
      }

      for (h = 0; h < n; h++) {
        f[h] = null;
      }

      return i ? m : m.toP();
    }, f.BasePoint = u, u.prototype.eq = function () {
      throw new Error("Not implemented");
    }, u.prototype.validate = function () {
      return this.curve.validate(this);
    }, f.prototype.decodePoint = function (t, e) {
      t = i.toArray(t, e);
      var r = this.p.byteLength();
      if ((4 === t[0] || 6 === t[0] || 7 === t[0]) && t.length - 1 == 2 * r) return 6 === t[0] ? s(t[t.length - 1] % 2 == 0) : 7 === t[0] && s(t[t.length - 1] % 2 == 1), this.point(t.slice(1, 1 + r), t.slice(1 + r, 1 + 2 * r));
      if ((2 === t[0] || 3 === t[0]) && t.length - 1 === r) return this.pointFromX(t.slice(1, 1 + r), 3 === t[0]);
      throw new Error("Unknown point format");
    }, u.prototype.encodeCompressed = function (t) {
      return this.encode(t, !0);
    }, u.prototype._encode = function (t) {
      var e = this.curve.p.byteLength(),
          r = this.getX().toArray("be", e);
      return t ? [this.getY().isEven() ? 2 : 3].concat(r) : [4].concat(r, this.getY().toArray("be", e));
    }, u.prototype.encode = function (t, e) {
      return i.encode(this._encode(e), t);
    }, u.prototype.precompute = function (t) {
      if (this.precomputed) return this;
      var e = {
        doubles: null,
        naf: null,
        beta: null
      };
      return e.naf = this._getNAFPoints(8), e.doubles = this._getDoubles(4, t), e.beta = this._getBeta(), this.precomputed = e, this;
    }, u.prototype._hasDoubles = function (t) {
      if (!this.precomputed) return !1;
      var e = this.precomputed.doubles;
      return !!e && e.points.length >= Math.ceil((t.bitLength() + 1) / e.step);
    }, u.prototype._getDoubles = function (t, e) {
      if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;

      for (var r = [this], n = this, i = 0; i < e; i += t) {
        for (var o = 0; o < t; o++) {
          n = n.dbl();
        }

        r.push(n);
      }

      return {
        step: t,
        points: r
      };
    }, u.prototype._getNAFPoints = function (t) {
      if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;

      for (var e = [this], r = (1 << t) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++) {
        e[i] = e[i - 1].add(n);
      }

      return {
        wnd: t,
        points: e
      };
    }, u.prototype._getBeta = function () {
      return null;
    }, u.prototype.dblp = function (t) {
      for (var e = this, r = 0; r < t; r++) {
        e = e.dbl();
      }

      return e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(19),
        i = r(3),
        o = r(2),
        a = r(0),
        s = n.base,
        f = i.utils.assert;

    function u(t) {
      s.call(this, "short", t), this.a = new o(t.a, 16).toRed(this.red), this.b = new o(t.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(t), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
    }

    function c(t, e, r, n) {
      s.BasePoint.call(this, t, "affine"), null === e && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new o(e, 16), this.y = new o(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
    }

    function h(t, e, r, n) {
      s.BasePoint.call(this, t, "jacobian"), null === e && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new o(0)) : (this.x = new o(e, 16), this.y = new o(r, 16), this.z = new o(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
    }

    a(u, s), t.exports = u, u.prototype._getEndomorphism = function (t) {
      if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
        var e, r;
        if (t.beta) e = new o(t.beta, 16).toRed(this.red);else {
          var n = this._getEndoRoots(this.p);

          e = (e = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
        }
        if (t.lambda) r = new o(t.lambda, 16);else {
          var i = this._getEndoRoots(this.n);

          0 === this.g.mul(i[0]).x.cmp(this.g.x.redMul(e)) ? r = i[0] : (r = i[1], f(0 === this.g.mul(r).x.cmp(this.g.x.redMul(e))));
        }
        return {
          beta: e,
          lambda: r,
          basis: t.basis ? t.basis.map(function (t) {
            return {
              a: new o(t.a, 16),
              b: new o(t.b, 16)
            };
          }) : this._getEndoBasis(r)
        };
      }
    }, u.prototype._getEndoRoots = function (t) {
      var e = t === this.p ? this.red : o.mont(t),
          r = new o(2).toRed(e).redInvm(),
          n = r.redNeg(),
          i = new o(3).toRed(e).redNeg().redSqrt().redMul(r);
      return [n.redAdd(i).fromRed(), n.redSub(i).fromRed()];
    }, u.prototype._getEndoBasis = function (t) {
      for (var e, r, n, i, a, s, f, u, c, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), l = t, d = this.n.clone(), p = new o(1), g = new o(0), A = new o(0), b = new o(1), v = 0; 0 !== l.cmpn(0);) {
        var y = d.div(l);
        u = d.sub(y.mul(l)), c = A.sub(y.mul(p));
        var w = b.sub(y.mul(g));
        if (!n && u.cmp(h) < 0) e = f.neg(), r = p, n = u.neg(), i = c;else if (n && 2 == ++v) break;
        f = u, d = l, l = u, A = p, p = c, b = g, g = w;
      }

      a = u.neg(), s = c;
      var m = n.sqr().add(i.sqr());
      return a.sqr().add(s.sqr()).cmp(m) >= 0 && (a = e, s = r), n.negative && (n = n.neg(), i = i.neg()), a.negative && (a = a.neg(), s = s.neg()), [{
        a: n,
        b: i
      }, {
        a: a,
        b: s
      }];
    }, u.prototype._endoSplit = function (t) {
      var e = this.endo.basis,
          r = e[0],
          n = e[1],
          i = n.b.mul(t).divRound(this.n),
          o = r.b.neg().mul(t).divRound(this.n),
          a = i.mul(r.a),
          s = o.mul(n.a),
          f = i.mul(r.b),
          u = o.mul(n.b);
      return {
        k1: t.sub(a).sub(s),
        k2: f.add(u).neg()
      };
    }, u.prototype.pointFromX = function (t, e) {
      (t = new o(t, 16)).red || (t = t.toRed(this.red));
      var r = t.redSqr().redMul(t).redIAdd(t.redMul(this.a)).redIAdd(this.b),
          n = r.redSqrt();
      if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
      var i = n.fromRed().isOdd();
      return (e && !i || !e && i) && (n = n.redNeg()), this.point(t, n);
    }, u.prototype.validate = function (t) {
      if (t.inf) return !0;
      var e = t.x,
          r = t.y,
          n = this.a.redMul(e),
          i = e.redSqr().redMul(e).redIAdd(n).redIAdd(this.b);
      return 0 === r.redSqr().redISub(i).cmpn(0);
    }, u.prototype._endoWnafMulAdd = function (t, e, r) {
      for (var n = this._endoWnafT1, i = this._endoWnafT2, o = 0; o < t.length; o++) {
        var a = this._endoSplit(e[o]),
            s = t[o],
            f = s._getBeta();

        a.k1.negative && (a.k1.ineg(), s = s.neg(!0)), a.k2.negative && (a.k2.ineg(), f = f.neg(!0)), n[2 * o] = s, n[2 * o + 1] = f, i[2 * o] = a.k1, i[2 * o + 1] = a.k2;
      }

      for (var u = this._wnafMulAdd(1, n, i, 2 * o, r), c = 0; c < 2 * o; c++) {
        n[c] = null, i[c] = null;
      }

      return u;
    }, a(c, s.BasePoint), u.prototype.point = function (t, e, r) {
      return new c(this, t, e, r);
    }, u.prototype.pointFromJSON = function (t, e) {
      return c.fromJSON(this, t, e);
    }, c.prototype._getBeta = function () {
      if (this.curve.endo) {
        var t = this.precomputed;
        if (t && t.beta) return t.beta;
        var e = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);

        if (t) {
          var r = this.curve,
              n = function n(t) {
            return r.point(t.x.redMul(r.endo.beta), t.y);
          };

          t.beta = e, e.precomputed = {
            beta: null,
            naf: t.naf && {
              wnd: t.naf.wnd,
              points: t.naf.points.map(n)
            },
            doubles: t.doubles && {
              step: t.doubles.step,
              points: t.doubles.points.map(n)
            }
          };
        }

        return e;
      }
    }, c.prototype.toJSON = function () {
      return this.precomputed ? [this.x, this.y, this.precomputed && {
        doubles: this.precomputed.doubles && {
          step: this.precomputed.doubles.step,
          points: this.precomputed.doubles.points.slice(1)
        },
        naf: this.precomputed.naf && {
          wnd: this.precomputed.naf.wnd,
          points: this.precomputed.naf.points.slice(1)
        }
      }] : [this.x, this.y];
    }, c.fromJSON = function (t, e, r) {
      "string" == typeof e && (e = JSON.parse(e));
      var n = t.point(e[0], e[1], r);
      if (!e[2]) return n;

      function i(e) {
        return t.point(e[0], e[1], r);
      }

      var o = e[2];
      return n.precomputed = {
        beta: null,
        doubles: o.doubles && {
          step: o.doubles.step,
          points: [n].concat(o.doubles.points.map(i))
        },
        naf: o.naf && {
          wnd: o.naf.wnd,
          points: [n].concat(o.naf.points.map(i))
        }
      }, n;
    }, c.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
    }, c.prototype.isInfinity = function () {
      return this.inf;
    }, c.prototype.add = function (t) {
      if (this.inf) return t;
      if (t.inf) return this;
      if (this.eq(t)) return this.dbl();
      if (this.neg().eq(t)) return this.curve.point(null, null);
      if (0 === this.x.cmp(t.x)) return this.curve.point(null, null);
      var e = this.y.redSub(t.y);
      0 !== e.cmpn(0) && (e = e.redMul(this.x.redSub(t.x).redInvm()));
      var r = e.redSqr().redISub(this.x).redISub(t.x),
          n = e.redMul(this.x.redSub(r)).redISub(this.y);
      return this.curve.point(r, n);
    }, c.prototype.dbl = function () {
      if (this.inf) return this;
      var t = this.y.redAdd(this.y);
      if (0 === t.cmpn(0)) return this.curve.point(null, null);
      var e = this.curve.a,
          r = this.x.redSqr(),
          n = t.redInvm(),
          i = r.redAdd(r).redIAdd(r).redIAdd(e).redMul(n),
          o = i.redSqr().redISub(this.x.redAdd(this.x)),
          a = i.redMul(this.x.redSub(o)).redISub(this.y);
      return this.curve.point(o, a);
    }, c.prototype.getX = function () {
      return this.x.fromRed();
    }, c.prototype.getY = function () {
      return this.y.fromRed();
    }, c.prototype.mul = function (t) {
      return t = new o(t, 16), this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [t]) : this.curve._wnafMul(this, t);
    }, c.prototype.mulAdd = function (t, e, r) {
      var n = [this, e],
          i = [t, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
    }, c.prototype.jmulAdd = function (t, e, r) {
      var n = [this, e],
          i = [t, r];
      return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
    }, c.prototype.eq = function (t) {
      return this === t || this.inf === t.inf && (this.inf || 0 === this.x.cmp(t.x) && 0 === this.y.cmp(t.y));
    }, c.prototype.neg = function (t) {
      if (this.inf) return this;
      var e = this.curve.point(this.x, this.y.redNeg());

      if (t && this.precomputed) {
        var r = this.precomputed,
            n = function n(t) {
          return t.neg();
        };

        e.precomputed = {
          naf: r.naf && {
            wnd: r.naf.wnd,
            points: r.naf.points.map(n)
          },
          doubles: r.doubles && {
            step: r.doubles.step,
            points: r.doubles.points.map(n)
          }
        };
      }

      return e;
    }, c.prototype.toJ = function () {
      return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
    }, a(h, s.BasePoint), u.prototype.jpoint = function (t, e, r) {
      return new h(this, t, e, r);
    }, h.prototype.toP = function () {
      if (this.isInfinity()) return this.curve.point(null, null);
      var t = this.z.redInvm(),
          e = t.redSqr(),
          r = this.x.redMul(e),
          n = this.y.redMul(e).redMul(t);
      return this.curve.point(r, n);
    }, h.prototype.neg = function () {
      return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    }, h.prototype.add = function (t) {
      if (this.isInfinity()) return t;
      if (t.isInfinity()) return this;
      var e = t.z.redSqr(),
          r = this.z.redSqr(),
          n = this.x.redMul(e),
          i = t.x.redMul(r),
          o = this.y.redMul(e.redMul(t.z)),
          a = t.y.redMul(r.redMul(this.z)),
          s = n.redSub(i),
          f = o.redSub(a);
      if (0 === s.cmpn(0)) return 0 !== f.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var u = s.redSqr(),
          c = u.redMul(s),
          h = n.redMul(u),
          l = f.redSqr().redIAdd(c).redISub(h).redISub(h),
          d = f.redMul(h.redISub(l)).redISub(o.redMul(c)),
          p = this.z.redMul(t.z).redMul(s);
      return this.curve.jpoint(l, d, p);
    }, h.prototype.mixedAdd = function (t) {
      if (this.isInfinity()) return t.toJ();
      if (t.isInfinity()) return this;
      var e = this.z.redSqr(),
          r = this.x,
          n = t.x.redMul(e),
          i = this.y,
          o = t.y.redMul(e).redMul(this.z),
          a = r.redSub(n),
          s = i.redSub(o);
      if (0 === a.cmpn(0)) return 0 !== s.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
      var f = a.redSqr(),
          u = f.redMul(a),
          c = r.redMul(f),
          h = s.redSqr().redIAdd(u).redISub(c).redISub(c),
          l = s.redMul(c.redISub(h)).redISub(i.redMul(u)),
          d = this.z.redMul(a);
      return this.curve.jpoint(h, l, d);
    }, h.prototype.dblp = function (t) {
      if (0 === t) return this;
      if (this.isInfinity()) return this;
      if (!t) return this.dbl();

      if (this.curve.zeroA || this.curve.threeA) {
        for (var e = this, r = 0; r < t; r++) {
          e = e.dbl();
        }

        return e;
      }

      var n = this.curve.a,
          i = this.curve.tinv,
          o = this.x,
          a = this.y,
          s = this.z,
          f = s.redSqr().redSqr(),
          u = a.redAdd(a);

      for (r = 0; r < t; r++) {
        var c = o.redSqr(),
            h = u.redSqr(),
            l = h.redSqr(),
            d = c.redAdd(c).redIAdd(c).redIAdd(n.redMul(f)),
            p = o.redMul(h),
            g = d.redSqr().redISub(p.redAdd(p)),
            A = p.redISub(g),
            b = d.redMul(A);
        b = b.redIAdd(b).redISub(l);
        var v = u.redMul(s);
        r + 1 < t && (f = f.redMul(l)), o = g, s = v, u = b;
      }

      return this.curve.jpoint(o, u.redMul(i), s);
    }, h.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
    }, h.prototype._zeroDbl = function () {
      var t, e, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
        a = a.redIAdd(a);
        var s = n.redAdd(n).redIAdd(n),
            f = s.redSqr().redISub(a).redISub(a),
            u = o.redIAdd(o);
        u = (u = u.redIAdd(u)).redIAdd(u), t = f, e = s.redMul(a.redISub(f)).redISub(u), r = this.y.redAdd(this.y);
      } else {
        var c = this.x.redSqr(),
            h = this.y.redSqr(),
            l = h.redSqr(),
            d = this.x.redAdd(h).redSqr().redISub(c).redISub(l);
        d = d.redIAdd(d);
        var p = c.redAdd(c).redIAdd(c),
            g = p.redSqr(),
            A = l.redIAdd(l);
        A = (A = A.redIAdd(A)).redIAdd(A), t = g.redISub(d).redISub(d), e = p.redMul(d.redISub(t)).redISub(A), r = (r = this.y.redMul(this.z)).redIAdd(r);
      }

      return this.curve.jpoint(t, e, r);
    }, h.prototype._threeDbl = function () {
      var t, e, r;

      if (this.zOne) {
        var n = this.x.redSqr(),
            i = this.y.redSqr(),
            o = i.redSqr(),
            a = this.x.redAdd(i).redSqr().redISub(n).redISub(o);
        a = a.redIAdd(a);
        var s = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a),
            f = s.redSqr().redISub(a).redISub(a);
        t = f;
        var u = o.redIAdd(o);
        u = (u = u.redIAdd(u)).redIAdd(u), e = s.redMul(a.redISub(f)).redISub(u), r = this.y.redAdd(this.y);
      } else {
        var c = this.z.redSqr(),
            h = this.y.redSqr(),
            l = this.x.redMul(h),
            d = this.x.redSub(c).redMul(this.x.redAdd(c));
        d = d.redAdd(d).redIAdd(d);
        var p = l.redIAdd(l),
            g = (p = p.redIAdd(p)).redAdd(p);
        t = d.redSqr().redISub(g), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(c);
        var A = h.redSqr();
        A = (A = (A = A.redIAdd(A)).redIAdd(A)).redIAdd(A), e = d.redMul(p.redISub(t)).redISub(A);
      }

      return this.curve.jpoint(t, e, r);
    }, h.prototype._dbl = function () {
      var t = this.curve.a,
          e = this.x,
          r = this.y,
          n = this.z,
          i = n.redSqr().redSqr(),
          o = e.redSqr(),
          a = r.redSqr(),
          s = o.redAdd(o).redIAdd(o).redIAdd(t.redMul(i)),
          f = e.redAdd(e),
          u = (f = f.redIAdd(f)).redMul(a),
          c = s.redSqr().redISub(u.redAdd(u)),
          h = u.redISub(c),
          l = a.redSqr();
      l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
      var d = s.redMul(h).redISub(l),
          p = r.redAdd(r).redMul(n);
      return this.curve.jpoint(c, d, p);
    }, h.prototype.trpl = function () {
      if (!this.curve.zeroA) return this.dbl().add(this);
      var t = this.x.redSqr(),
          e = this.y.redSqr(),
          r = this.z.redSqr(),
          n = e.redSqr(),
          i = t.redAdd(t).redIAdd(t),
          o = i.redSqr(),
          a = this.x.redAdd(e).redSqr().redISub(t).redISub(n),
          s = (a = (a = (a = a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),
          f = n.redIAdd(n);
      f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
      var u = i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(f),
          c = e.redMul(u);
      c = (c = c.redIAdd(c)).redIAdd(c);
      var h = this.x.redMul(s).redISub(c);
      h = (h = h.redIAdd(h)).redIAdd(h);
      var l = this.y.redMul(u.redMul(f.redISub(u)).redISub(a.redMul(s)));
      l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
      var d = this.z.redAdd(a).redSqr().redISub(r).redISub(s);
      return this.curve.jpoint(h, l, d);
    }, h.prototype.mul = function (t, e) {
      return t = new o(t, e), this.curve._wnafMul(this, t);
    }, h.prototype.eq = function (t) {
      if ("affine" === t.type) return this.eq(t.toJ());
      if (this === t) return !0;
      var e = this.z.redSqr(),
          r = t.z.redSqr();
      if (0 !== this.x.redMul(r).redISub(t.x.redMul(e)).cmpn(0)) return !1;
      var n = e.redMul(this.z),
          i = r.redMul(t.z);
      return 0 === this.y.redMul(i).redISub(t.y.redMul(n)).cmpn(0);
    }, h.prototype.eqXToP = function (t) {
      var e = this.z.redSqr(),
          r = t.toRed(this.curve.red).redMul(e);
      if (0 === this.x.cmp(r)) return !0;

      for (var n = t.clone(), i = this.curve.redN.redMul(e);;) {
        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
      }
    }, h.prototype.inspect = function () {
      return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
    }, h.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(19),
        i = r(2),
        o = r(0),
        a = n.base,
        s = r(3).utils;

    function f(t) {
      a.call(this, "mont", t), this.a = new i(t.a, 16).toRed(this.red), this.b = new i(t.b, 16).toRed(this.red), this.i4 = new i(4).toRed(this.red).redInvm(), this.two = new i(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    }

    function u(t, e, r) {
      a.BasePoint.call(this, t, "projective"), null === e && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new i(e, 16), this.z = new i(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
    }

    o(f, a), t.exports = f, f.prototype.validate = function (t) {
      var e = t.normalize().x,
          r = e.redSqr(),
          n = r.redMul(e).redAdd(r.redMul(this.a)).redAdd(e);
      return 0 === n.redSqrt().redSqr().cmp(n);
    }, o(u, a.BasePoint), f.prototype.decodePoint = function (t, e) {
      return this.point(s.toArray(t, e), 1);
    }, f.prototype.point = function (t, e) {
      return new u(this, t, e);
    }, f.prototype.pointFromJSON = function (t) {
      return u.fromJSON(this, t);
    }, u.prototype.precompute = function () {}, u.prototype._encode = function () {
      return this.getX().toArray("be", this.curve.p.byteLength());
    }, u.fromJSON = function (t, e) {
      return new u(t, e[0], e[1] || t.one);
    }, u.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, u.prototype.isInfinity = function () {
      return 0 === this.z.cmpn(0);
    }, u.prototype.dbl = function () {
      var t = this.x.redAdd(this.z).redSqr(),
          e = this.x.redSub(this.z).redSqr(),
          r = t.redSub(e),
          n = t.redMul(e),
          i = r.redMul(e.redAdd(this.curve.a24.redMul(r)));
      return this.curve.point(n, i);
    }, u.prototype.add = function () {
      throw new Error("Not supported on Montgomery curve");
    }, u.prototype.diffAdd = function (t, e) {
      var r = this.x.redAdd(this.z),
          n = this.x.redSub(this.z),
          i = t.x.redAdd(t.z),
          o = t.x.redSub(t.z).redMul(r),
          a = i.redMul(n),
          s = e.z.redMul(o.redAdd(a).redSqr()),
          f = e.x.redMul(o.redISub(a).redSqr());
      return this.curve.point(s, f);
    }, u.prototype.mul = function (t) {
      for (var e = t.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== e.cmpn(0); e.iushrn(1)) {
        i.push(e.andln(1));
      }

      for (var o = i.length - 1; o >= 0; o--) {
        0 === i[o] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
      }

      return n;
    }, u.prototype.mulAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, u.prototype.jumlAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }, u.prototype.eq = function (t) {
      return 0 === this.getX().cmp(t.getX());
    }, u.prototype.normalize = function () {
      return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
    }, u.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(19),
        i = r(3),
        o = r(2),
        a = r(0),
        s = n.base,
        f = i.utils.assert;

    function u(t) {
      this.twisted = 1 != (0 | t.a), this.mOneA = this.twisted && -1 == (0 | t.a), this.extended = this.mOneA, s.call(this, "edwards", t), this.a = new o(t.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new o(t.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new o(t.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), f(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | t.c);
    }

    function c(t, e, r, n, i) {
      s.BasePoint.call(this, t, "projective"), null === e && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new o(e, 16), this.y = new o(r, 16), this.z = n ? new o(n, 16) : this.curve.one, this.t = i && new o(i, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
    }

    a(u, s), t.exports = u, u.prototype._mulA = function (t) {
      return this.mOneA ? t.redNeg() : this.a.redMul(t);
    }, u.prototype._mulC = function (t) {
      return this.oneC ? t : this.c.redMul(t);
    }, u.prototype.jpoint = function (t, e, r, n) {
      return this.point(t, e, r, n);
    }, u.prototype.pointFromX = function (t, e) {
      (t = new o(t, 16)).red || (t = t.toRed(this.red));
      var r = t.redSqr(),
          n = this.c2.redSub(this.a.redMul(r)),
          i = this.one.redSub(this.c2.redMul(this.d).redMul(r)),
          a = n.redMul(i.redInvm()),
          s = a.redSqrt();
      if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
      var f = s.fromRed().isOdd();
      return (e && !f || !e && f) && (s = s.redNeg()), this.point(t, s);
    }, u.prototype.pointFromY = function (t, e) {
      (t = new o(t, 16)).red || (t = t.toRed(this.red));
      var r = t.redSqr(),
          n = r.redSub(this.c2),
          i = r.redMul(this.d).redMul(this.c2).redSub(this.a),
          a = n.redMul(i.redInvm());

      if (0 === a.cmp(this.zero)) {
        if (e) throw new Error("invalid point");
        return this.point(this.zero, t);
      }

      var s = a.redSqrt();
      if (0 !== s.redSqr().redSub(a).cmp(this.zero)) throw new Error("invalid point");
      return s.fromRed().isOdd() !== e && (s = s.redNeg()), this.point(s, t);
    }, u.prototype.validate = function (t) {
      if (t.isInfinity()) return !0;
      t.normalize();
      var e = t.x.redSqr(),
          r = t.y.redSqr(),
          n = e.redMul(this.a).redAdd(r),
          i = this.c2.redMul(this.one.redAdd(this.d.redMul(e).redMul(r)));
      return 0 === n.cmp(i);
    }, a(c, s.BasePoint), u.prototype.pointFromJSON = function (t) {
      return c.fromJSON(this, t);
    }, u.prototype.point = function (t, e, r, n) {
      return new c(this, t, e, r, n);
    }, c.fromJSON = function (t, e) {
      return new c(t, e[0], e[1], e[2]);
    }, c.prototype.inspect = function () {
      return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
    }, c.prototype.isInfinity = function () {
      return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
    }, c.prototype._extDbl = function () {
      var t = this.x.redSqr(),
          e = this.y.redSqr(),
          r = this.z.redSqr();
      r = r.redIAdd(r);

      var n = this.curve._mulA(t),
          i = this.x.redAdd(this.y).redSqr().redISub(t).redISub(e),
          o = n.redAdd(e),
          a = o.redSub(r),
          s = n.redSub(e),
          f = i.redMul(a),
          u = o.redMul(s),
          c = i.redMul(s),
          h = a.redMul(o);

      return this.curve.point(f, u, h, c);
    }, c.prototype._projDbl = function () {
      var t,
          e,
          r,
          n = this.x.redAdd(this.y).redSqr(),
          i = this.x.redSqr(),
          o = this.y.redSqr();

      if (this.curve.twisted) {
        var a = (u = this.curve._mulA(i)).redAdd(o);

        if (this.zOne) t = n.redSub(i).redSub(o).redMul(a.redSub(this.curve.two)), e = a.redMul(u.redSub(o)), r = a.redSqr().redSub(a).redSub(a);else {
          var s = this.z.redSqr(),
              f = a.redSub(s).redISub(s);
          t = n.redSub(i).redISub(o).redMul(f), e = a.redMul(u.redSub(o)), r = a.redMul(f);
        }
      } else {
        var u = i.redAdd(o);
        s = this.curve._mulC(this.z).redSqr(), f = u.redSub(s).redSub(s);
        t = this.curve._mulC(n.redISub(u)).redMul(f), e = this.curve._mulC(u).redMul(i.redISub(o)), r = u.redMul(f);
      }

      return this.curve.point(t, e, r);
    }, c.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
    }, c.prototype._extAdd = function (t) {
      var e = this.y.redSub(this.x).redMul(t.y.redSub(t.x)),
          r = this.y.redAdd(this.x).redMul(t.y.redAdd(t.x)),
          n = this.t.redMul(this.curve.dd).redMul(t.t),
          i = this.z.redMul(t.z.redAdd(t.z)),
          o = r.redSub(e),
          a = i.redSub(n),
          s = i.redAdd(n),
          f = r.redAdd(e),
          u = o.redMul(a),
          c = s.redMul(f),
          h = o.redMul(f),
          l = a.redMul(s);
      return this.curve.point(u, c, l, h);
    }, c.prototype._projAdd = function (t) {
      var e,
          r,
          n = this.z.redMul(t.z),
          i = n.redSqr(),
          o = this.x.redMul(t.x),
          a = this.y.redMul(t.y),
          s = this.curve.d.redMul(o).redMul(a),
          f = i.redSub(s),
          u = i.redAdd(s),
          c = this.x.redAdd(this.y).redMul(t.x.redAdd(t.y)).redISub(o).redISub(a),
          h = n.redMul(f).redMul(c);
      return this.curve.twisted ? (e = n.redMul(u).redMul(a.redSub(this.curve._mulA(o))), r = f.redMul(u)) : (e = n.redMul(u).redMul(a.redSub(o)), r = this.curve._mulC(f).redMul(u)), this.curve.point(h, e, r);
    }, c.prototype.add = function (t) {
      return this.isInfinity() ? t : t.isInfinity() ? this : this.curve.extended ? this._extAdd(t) : this._projAdd(t);
    }, c.prototype.mul = function (t) {
      return this._hasDoubles(t) ? this.curve._fixedNafMul(this, t) : this.curve._wnafMul(this, t);
    }, c.prototype.mulAdd = function (t, e, r) {
      return this.curve._wnafMulAdd(1, [this, e], [t, r], 2, !1);
    }, c.prototype.jmulAdd = function (t, e, r) {
      return this.curve._wnafMulAdd(1, [this, e], [t, r], 2, !0);
    }, c.prototype.normalize = function () {
      if (this.zOne) return this;
      var t = this.z.redInvm();
      return this.x = this.x.redMul(t), this.y = this.y.redMul(t), this.t && (this.t = this.t.redMul(t)), this.z = this.curve.one, this.zOne = !0, this;
    }, c.prototype.neg = function () {
      return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
    }, c.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    }, c.prototype.getY = function () {
      return this.normalize(), this.y.fromRed();
    }, c.prototype.eq = function (t) {
      return this === t || 0 === this.getX().cmp(t.getX()) && 0 === this.getY().cmp(t.getY());
    }, c.prototype.eqXToP = function (t) {
      var e = t.toRed(this.curve.red).redMul(this.z);
      if (0 === this.x.cmp(e)) return !0;

      for (var r = t.clone(), n = this.curve.redN.redMul(this.z);;) {
        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
        if (e.redIAdd(n), 0 === this.x.cmp(e)) return !0;
      }
    }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
  }, function (t, e, r) {
    "use strict";

    var n,
        i = e,
        o = r(30),
        a = r(3),
        s = a.utils.assert;

    function f(t) {
      "short" === t.type ? this.curve = new a.curve.short(t) : "edwards" === t.type ? this.curve = new a.curve.edwards(t) : this.curve = new a.curve.mont(t), this.g = this.curve.g, this.n = this.curve.n, this.hash = t.hash, s(this.g.validate(), "Invalid curve"), s(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }

    function u(t, e) {
      Object.defineProperty(i, t, {
        configurable: !0,
        enumerable: !0,
        get: function get() {
          var r = new f(e);
          return Object.defineProperty(i, t, {
            configurable: !0,
            enumerable: !0,
            value: r
          }), r;
        }
      });
    }

    i.PresetCurve = f, u("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: o.sha256,
      gRed: !1,
      g: ["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012", "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]
    }), u("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: o.sha256,
      gRed: !1,
      g: ["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21", "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]
    }), u("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: o.sha256,
      gRed: !1,
      g: ["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296", "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]
    }), u("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: o.sha384,
      gRed: !1,
      g: ["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7", "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]
    }), u("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: o.sha512,
      gRed: !1,
      g: ["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66", "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]
    }), u("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: ["9"]
    }), u("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: ["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a", "6666666666666666666666666666666666666666666666666666666666666658"]
    });

    try {
      n = r(145);
    } catch (t) {
      n = void 0;
    }

    u("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: o.sha256,
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [{
        a: "3086d221a7d46bcde86c90e49284eb15",
        b: "-e4437ed6010e88286f547fa90abfe4c3"
      }, {
        a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
        b: "3086d221a7d46bcde86c90e49284eb15"
      }],
      gRed: !1,
      g: ["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798", "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8", n]
    });
  }, function (t, e, r) {
    "use strict";

    e.sha1 = r(140), e.sha224 = r(141), e.sha256 = r(54), e.sha384 = r(142), e.sha512 = r(55);
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(12),
        o = r(53),
        a = n.rotl32,
        s = n.sum32,
        f = n.sum32_5,
        u = o.ft_1,
        c = i.BlockHash,
        h = [1518500249, 1859775393, 2400959708, 3395469782];

    function l() {
      if (!(this instanceof l)) return new l();
      c.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.W = new Array(80);
    }

    n.inherits(l, c), t.exports = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 80, l.padLength = 64, l.prototype._update = function (t, e) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n++) {
        r[n] = a(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
      }

      var i = this.h[0],
          o = this.h[1],
          c = this.h[2],
          l = this.h[3],
          d = this.h[4];

      for (n = 0; n < r.length; n++) {
        var p = ~~(n / 20),
            g = f(a(i, 5), u(p, o, c, l), d, r[n], h[p]);
        d = l, l = c, c = a(o, 30), o = i, i = g;
      }

      this.h[0] = s(this.h[0], i), this.h[1] = s(this.h[1], o), this.h[2] = s(this.h[2], c), this.h[3] = s(this.h[3], l), this.h[4] = s(this.h[4], d);
    }, l.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(54);

    function o() {
      if (!(this instanceof o)) return new o();
      i.call(this), this.h = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428];
    }

    n.inherits(o, i), t.exports = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(55);

    function o() {
      if (!(this instanceof o)) return new o();
      i.call(this), this.h = [3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697, 1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813, 3204075428];
    }

    n.inherits(o, i), t.exports = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(12),
        o = n.rotl32,
        a = n.sum32,
        s = n.sum32_3,
        f = n.sum32_4,
        u = i.BlockHash;

    function c() {
      if (!(this instanceof c)) return new c();
      u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
    }

    function h(t, e, r, n) {
      return t <= 15 ? e ^ r ^ n : t <= 31 ? e & r | ~e & n : t <= 47 ? (e | ~r) ^ n : t <= 63 ? e & n | r & ~n : e ^ (r | ~n);
    }

    function l(t) {
      return t <= 15 ? 0 : t <= 31 ? 1518500249 : t <= 47 ? 1859775393 : t <= 63 ? 2400959708 : 2840853838;
    }

    function d(t) {
      return t <= 15 ? 1352829926 : t <= 31 ? 1548603684 : t <= 47 ? 1836072691 : t <= 63 ? 2053994217 : 0;
    }

    n.inherits(c, u), e.ripemd160 = c, c.blockSize = 512, c.outSize = 160, c.hmacStrength = 192, c.padLength = 64, c.prototype._update = function (t, e) {
      for (var r = this.h[0], n = this.h[1], i = this.h[2], u = this.h[3], c = this.h[4], v = r, y = n, w = i, m = u, _ = c, I = 0; I < 80; I++) {
        var E = a(o(f(r, h(I, n, i, u), t[p[I] + e], l(I)), A[I]), c);
        r = c, c = u, u = o(i, 10), i = n, n = E, E = a(o(f(v, h(79 - I, y, w, m), t[g[I] + e], d(I)), b[I]), _), v = _, _ = m, m = o(w, 10), w = y, y = E;
      }

      E = s(this.h[1], i, m), this.h[1] = s(this.h[2], u, _), this.h[2] = s(this.h[3], c, v), this.h[3] = s(this.h[4], r, y), this.h[4] = s(this.h[0], n, w), this.h[0] = E;
    }, c.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
    };
    var p = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13],
        g = [5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11],
        A = [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6],
        b = [8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11];
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(9);

    function o(t, e, r) {
      if (!(this instanceof o)) return new o(t, e, r);
      this.Hash = t, this.blockSize = t.blockSize / 8, this.outSize = t.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(e, r));
    }

    t.exports = o, o.prototype._init = function (t) {
      t.length > this.blockSize && (t = new this.Hash().update(t).digest()), i(t.length <= this.blockSize);

      for (var e = t.length; e < this.blockSize; e++) {
        t.push(0);
      }

      for (e = 0; e < t.length; e++) {
        t[e] ^= 54;
      }

      for (this.inner = new this.Hash().update(t), e = 0; e < t.length; e++) {
        t[e] ^= 106;
      }

      this.outer = new this.Hash().update(t);
    }, o.prototype.update = function (t, e) {
      return this.inner.update(t, e), this;
    }, o.prototype.digest = function (t) {
      return this.outer.update(this.inner.digest()), this.outer.digest(t);
    };
  }, function (t, e) {
    t.exports = {
      doubles: {
        step: 4,
        points: [["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a", "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"], ["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508", "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"], ["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739", "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"], ["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640", "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"], ["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c", "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"], ["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda", "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"], ["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa", "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"], ["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0", "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"], ["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d", "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"], ["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d", "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"], ["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1", "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"], ["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0", "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"], ["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047", "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"], ["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862", "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"], ["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7", "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"], ["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd", "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"], ["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83", "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"], ["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a", "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"], ["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8", "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"], ["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d", "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"], ["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725", "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"], ["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754", "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"], ["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c", "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"], ["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6", "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"], ["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39", "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"], ["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891", "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"], ["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b", "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"], ["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03", "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"], ["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d", "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"], ["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070", "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"], ["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4", "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"], ["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da", "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"], ["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11", "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"], ["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e", "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"], ["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41", "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"], ["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef", "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"], ["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8", "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"], ["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d", "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"], ["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96", "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"], ["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd", "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"], ["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5", "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"], ["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266", "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"], ["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71", "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"], ["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac", "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"], ["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751", "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"], ["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e", "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"], ["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241", "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"], ["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3", "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"], ["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f", "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"], ["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19", "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"], ["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be", "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"], ["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9", "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"], ["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2", "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"], ["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13", "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"], ["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c", "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"], ["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba", "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"], ["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151", "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"], ["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073", "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"], ["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458", "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"], ["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b", "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"], ["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366", "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"], ["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa", "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"], ["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0", "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"], ["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787", "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"], ["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e", "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]
      },
      naf: {
        wnd: 7,
        points: [["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9", "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"], ["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4", "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"], ["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc", "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"], ["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe", "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"], ["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb", "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"], ["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8", "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"], ["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e", "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"], ["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34", "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"], ["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c", "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"], ["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5", "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"], ["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f", "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"], ["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714", "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"], ["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729", "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"], ["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db", "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"], ["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4", "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"], ["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5", "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"], ["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479", "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"], ["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d", "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"], ["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f", "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"], ["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb", "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"], ["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9", "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"], ["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963", "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"], ["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74", "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"], ["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530", "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"], ["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b", "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"], ["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247", "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"], ["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1", "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"], ["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120", "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"], ["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435", "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"], ["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18", "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"], ["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8", "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"], ["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb", "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"], ["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f", "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"], ["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143", "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"], ["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba", "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"], ["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45", "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"], ["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a", "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"], ["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e", "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"], ["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8", "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"], ["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c", "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"], ["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519", "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"], ["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab", "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"], ["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca", "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"], ["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf", "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"], ["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610", "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"], ["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4", "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"], ["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c", "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"], ["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940", "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"], ["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980", "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"], ["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3", "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"], ["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf", "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"], ["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63", "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"], ["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448", "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"], ["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf", "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"], ["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5", "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"], ["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6", "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"], ["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5", "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"], ["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99", "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"], ["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51", "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"], ["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5", "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"], ["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5", "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"], ["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997", "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"], ["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881", "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"], ["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5", "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"], ["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66", "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"], ["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726", "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"], ["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede", "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"], ["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94", "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"], ["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31", "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"], ["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51", "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"], ["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252", "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"], ["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5", "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"], ["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b", "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"], ["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4", "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"], ["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f", "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"], ["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889", "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"], ["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246", "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"], ["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984", "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"], ["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a", "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"], ["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030", "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"], ["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197", "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"], ["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593", "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"], ["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef", "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"], ["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38", "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"], ["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a", "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"], ["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111", "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"], ["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502", "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"], ["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea", "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"], ["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26", "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"], ["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986", "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"], ["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e", "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"], ["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4", "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"], ["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda", "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"], ["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859", "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"], ["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f", "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"], ["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c", "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"], ["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942", "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"], ["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a", "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"], ["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80", "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"], ["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d", "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"], ["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1", "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"], ["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63", "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"], ["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352", "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"], ["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193", "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"], ["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00", "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"], ["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58", "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"], ["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7", "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"], ["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8", "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"], ["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e", "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"], ["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d", "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"], ["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b", "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"], ["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f", "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"], ["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6", "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"], ["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297", "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"], ["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a", "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"], ["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c", "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"], ["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52", "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"], ["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb", "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"], ["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065", "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"], ["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917", "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"], ["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9", "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"], ["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3", "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"], ["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57", "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"], ["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66", "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"], ["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8", "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"], ["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721", "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"], ["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180", "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(147),
        o = r(3),
        a = o.utils.assert,
        s = r(148),
        f = r(149);

    function u(t) {
      if (!(this instanceof u)) return new u(t);
      "string" == typeof t && (a(o.curves.hasOwnProperty(t), "Unknown curve " + t), t = o.curves[t]), t instanceof o.curves.PresetCurve && (t = {
        curve: t
      }), this.curve = t.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = t.curve.g, this.g.precompute(t.curve.n.bitLength() + 1), this.hash = t.hash || t.curve.hash;
    }

    t.exports = u, u.prototype.keyPair = function (t) {
      return new s(this, t);
    }, u.prototype.keyFromPrivate = function (t, e) {
      return s.fromPrivate(this, t, e);
    }, u.prototype.keyFromPublic = function (t, e) {
      return s.fromPublic(this, t, e);
    }, u.prototype.genKeyPair = function (t) {
      t || (t = {});

      for (var e = new i({
        hash: this.hash,
        pers: t.pers,
        persEnc: t.persEnc || "utf8",
        entropy: t.entropy || o.rand(this.hash.hmacStrength),
        entropyEnc: t.entropy && t.entropyEnc || "utf8",
        nonce: this.n.toArray()
      }), r = this.n.byteLength(), a = this.n.sub(new n(2));;) {
        var s = new n(e.generate(r));
        if (!(s.cmp(a) > 0)) return s.iaddn(1), this.keyFromPrivate(s);
      }
    }, u.prototype._truncateToN = function (t, e) {
      var r = 8 * t.byteLength() - this.n.bitLength();
      return r > 0 && (t = t.ushrn(r)), !e && t.cmp(this.n) >= 0 ? t.sub(this.n) : t;
    }, u.prototype.sign = function (t, e, r, o) {
      "object" == typeof r && (o = r, r = null), o || (o = {}), e = this.keyFromPrivate(e, r), t = this._truncateToN(new n(t, 16));

      for (var a = this.n.byteLength(), s = e.getPrivate().toArray("be", a), u = t.toArray("be", a), c = new i({
        hash: this.hash,
        entropy: s,
        nonce: u,
        pers: o.pers,
        persEnc: o.persEnc || "utf8"
      }), h = this.n.sub(new n(1)), l = 0;; l++) {
        var d = o.k ? o.k(l) : new n(c.generate(this.n.byteLength()));

        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
          var p = this.g.mul(d);

          if (!p.isInfinity()) {
            var g = p.getX(),
                A = g.umod(this.n);

            if (0 !== A.cmpn(0)) {
              var b = d.invm(this.n).mul(A.mul(e.getPrivate()).iadd(t));

              if (0 !== (b = b.umod(this.n)).cmpn(0)) {
                var v = (p.getY().isOdd() ? 1 : 0) | (0 !== g.cmp(A) ? 2 : 0);
                return o.canonical && b.cmp(this.nh) > 0 && (b = this.n.sub(b), v ^= 1), new f({
                  r: A,
                  s: b,
                  recoveryParam: v
                });
              }
            }
          }
        }
      }
    }, u.prototype.verify = function (t, e, r, i) {
      t = this._truncateToN(new n(t, 16)), r = this.keyFromPublic(r, i);
      var o = (e = new f(e, "hex")).r,
          a = e.s;
      if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
      if (a.cmpn(1) < 0 || a.cmp(this.n) >= 0) return !1;
      var s,
          u = a.invm(this.n),
          c = u.mul(t).umod(this.n),
          h = u.mul(o).umod(this.n);
      return this.curve._maxwellTrick ? !(s = this.g.jmulAdd(c, r.getPublic(), h)).isInfinity() && s.eqXToP(o) : !(s = this.g.mulAdd(c, r.getPublic(), h)).isInfinity() && 0 === s.getX().umod(this.n).cmp(o);
    }, u.prototype.recoverPubKey = function (t, e, r, i) {
      a((3 & r) === r, "The recovery param is more than two bits"), e = new f(e, i);
      var o = this.n,
          s = new n(t),
          u = e.r,
          c = e.s,
          h = 1 & r,
          l = r >> 1;
      if (u.cmp(this.curve.p.umod(this.curve.n)) >= 0 && l) throw new Error("Unable to find sencond key candinate");
      u = l ? this.curve.pointFromX(u.add(this.curve.n), h) : this.curve.pointFromX(u, h);
      var d = e.r.invm(o),
          p = o.sub(s).mul(d).umod(o),
          g = c.mul(d).umod(o);
      return this.g.mulAdd(p, u, g);
    }, u.prototype.getKeyRecoveryParam = function (t, e, r, n) {
      if (null !== (e = new f(e, n)).recoveryParam) return e.recoveryParam;

      for (var i = 0; i < 4; i++) {
        var o;

        try {
          o = this.recoverPubKey(t, e, i);
        } catch (t) {
          continue;
        }

        if (o.eq(r)) return i;
      }

      throw new Error("Unable to find valid recovery factor");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(30),
        i = r(52),
        o = r(9);

    function a(t) {
      if (!(this instanceof a)) return new a(t);
      this.hash = t.hash, this.predResist = !!t.predResist, this.outLen = this.hash.outSize, this.minEntropy = t.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
      var e = i.toArray(t.entropy, t.entropyEnc || "hex"),
          r = i.toArray(t.nonce, t.nonceEnc || "hex"),
          n = i.toArray(t.pers, t.persEnc || "hex");
      o(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(e, r, n);
    }

    t.exports = a, a.prototype._init = function (t, e, r) {
      var n = t.concat(e).concat(r);
      this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);

      for (var i = 0; i < this.V.length; i++) {
        this.K[i] = 0, this.V[i] = 1;
      }

      this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
    }, a.prototype._hmac = function () {
      return new n.hmac(this.hash, this.K);
    }, a.prototype._update = function (t) {
      var e = this._hmac().update(this.V).update([0]);

      t && (e = e.update(t)), this.K = e.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([1]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
    }, a.prototype.reseed = function (t, e, r, n) {
      "string" != typeof e && (n = r, r = e, e = null), t = i.toArray(t, e), r = i.toArray(r, n), o(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(t.concat(r || [])), this._reseed = 1;
    }, a.prototype.generate = function (t, e, r, n) {
      if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
      "string" != typeof e && (n = r, r = e, e = null), r && (r = i.toArray(r, n || "hex"), this._update(r));

      for (var o = []; o.length < t;) {
        this.V = this._hmac().update(this.V).digest(), o = o.concat(this.V);
      }

      var a = o.slice(0, t);
      return this._update(r), this._reseed++, i.encode(a, e);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(3).utils.assert;

    function o(t, e) {
      this.ec = t, this.priv = null, this.pub = null, e.priv && this._importPrivate(e.priv, e.privEnc), e.pub && this._importPublic(e.pub, e.pubEnc);
    }

    t.exports = o, o.fromPublic = function (t, e, r) {
      return e instanceof o ? e : new o(t, {
        pub: e,
        pubEnc: r
      });
    }, o.fromPrivate = function (t, e, r) {
      return e instanceof o ? e : new o(t, {
        priv: e,
        privEnc: r
      });
    }, o.prototype.validate = function () {
      var t = this.getPublic();
      return t.isInfinity() ? {
        result: !1,
        reason: "Invalid public key"
      } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? {
        result: !0,
        reason: null
      } : {
        result: !1,
        reason: "Public key * N != O"
      } : {
        result: !1,
        reason: "Public key is not a point"
      };
    }, o.prototype.getPublic = function (t, e) {
      return "string" == typeof t && (e = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), e ? this.pub.encode(e, t) : this.pub;
    }, o.prototype.getPrivate = function (t) {
      return "hex" === t ? this.priv.toString(16, 2) : this.priv;
    }, o.prototype._importPrivate = function (t, e) {
      this.priv = new n(t, e || 16), this.priv = this.priv.umod(this.ec.curve.n);
    }, o.prototype._importPublic = function (t, e) {
      if (t.x || t.y) return "mont" === this.ec.curve.type ? i(t.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(t.x && t.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(t.x, t.y));
      this.pub = this.ec.curve.decodePoint(t, e);
    }, o.prototype.derive = function (t) {
      return t.mul(this.priv).getX();
    }, o.prototype.sign = function (t, e, r) {
      return this.ec.sign(t, this, e, r);
    }, o.prototype.verify = function (t, e) {
      return this.ec.verify(t, e, this);
    }, o.prototype.inspect = function () {
      return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(3).utils,
        o = i.assert;

    function a(t, e) {
      if (t instanceof a) return t;
      this._importDER(t, e) || (o(t.r && t.s, "Signature without r or s"), this.r = new n(t.r, 16), this.s = new n(t.s, 16), void 0 === t.recoveryParam ? this.recoveryParam = null : this.recoveryParam = t.recoveryParam);
    }

    function s() {
      this.place = 0;
    }

    function f(t, e) {
      var r = t[e.place++];
      if (!(128 & r)) return r;

      for (var n = 15 & r, i = 0, o = 0, a = e.place; o < n; o++, a++) {
        i <<= 8, i |= t[a];
      }

      return e.place = a, i;
    }

    function u(t) {
      for (var e = 0, r = t.length - 1; !t[e] && !(128 & t[e + 1]) && e < r;) {
        e++;
      }

      return 0 === e ? t : t.slice(e);
    }

    function c(t, e) {
      if (e < 128) t.push(e);else {
        var r = 1 + (Math.log(e) / Math.LN2 >>> 3);

        for (t.push(128 | r); --r;) {
          t.push(e >>> (r << 3) & 255);
        }

        t.push(e);
      }
    }

    t.exports = a, a.prototype._importDER = function (t, e) {
      t = i.toArray(t, e);
      var r = new s();
      if (48 !== t[r.place++]) return !1;
      if (f(t, r) + r.place !== t.length) return !1;
      if (2 !== t[r.place++]) return !1;
      var o = f(t, r),
          a = t.slice(r.place, o + r.place);
      if (r.place += o, 2 !== t[r.place++]) return !1;
      var u = f(t, r);
      if (t.length !== u + r.place) return !1;
      var c = t.slice(r.place, u + r.place);
      return 0 === a[0] && 128 & a[1] && (a = a.slice(1)), 0 === c[0] && 128 & c[1] && (c = c.slice(1)), this.r = new n(a), this.s = new n(c), this.recoveryParam = null, !0;
    }, a.prototype.toDER = function (t) {
      var e = this.r.toArray(),
          r = this.s.toArray();

      for (128 & e[0] && (e = [0].concat(e)), 128 & r[0] && (r = [0].concat(r)), e = u(e), r = u(r); !(r[0] || 128 & r[1]);) {
        r = r.slice(1);
      }

      var n = [2];
      c(n, e.length), (n = n.concat(e)).push(2), c(n, r.length);
      var o = n.concat(r),
          a = [48];
      return c(a, o.length), a = a.concat(o), i.encode(a, t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(30),
        i = r(3),
        o = i.utils,
        a = o.assert,
        s = o.parseBytes,
        f = r(151),
        u = r(152);

    function c(t) {
      if (a("ed25519" === t, "only tested with ed25519 so far"), !(this instanceof c)) return new c(t);
      t = i.curves[t].curve;
      this.curve = t, this.g = t.g, this.g.precompute(t.n.bitLength() + 1), this.pointClass = t.point().constructor, this.encodingLength = Math.ceil(t.n.bitLength() / 8), this.hash = n.sha512;
    }

    t.exports = c, c.prototype.sign = function (t, e) {
      t = s(t);
      var r = this.keyFromSecret(e),
          n = this.hashInt(r.messagePrefix(), t),
          i = this.g.mul(n),
          o = this.encodePoint(i),
          a = this.hashInt(o, r.pubBytes(), t).mul(r.priv()),
          f = n.add(a).umod(this.curve.n);
      return this.makeSignature({
        R: i,
        S: f,
        Rencoded: o
      });
    }, c.prototype.verify = function (t, e, r) {
      t = s(t), e = this.makeSignature(e);
      var n = this.keyFromPublic(r),
          i = this.hashInt(e.Rencoded(), n.pubBytes(), t),
          o = this.g.mul(e.S());
      return e.R().add(n.pub().mul(i)).eq(o);
    }, c.prototype.hashInt = function () {
      for (var t = this.hash(), e = 0; e < arguments.length; e++) {
        t.update(arguments[e]);
      }

      return o.intFromLE(t.digest()).umod(this.curve.n);
    }, c.prototype.keyFromPublic = function (t) {
      return f.fromPublic(this, t);
    }, c.prototype.keyFromSecret = function (t) {
      return f.fromSecret(this, t);
    }, c.prototype.makeSignature = function (t) {
      return t instanceof u ? t : new u(this, t);
    }, c.prototype.encodePoint = function (t) {
      var e = t.getY().toArray("le", this.encodingLength);
      return e[this.encodingLength - 1] |= t.getX().isOdd() ? 128 : 0, e;
    }, c.prototype.decodePoint = function (t) {
      var e = (t = o.parseBytes(t)).length - 1,
          r = t.slice(0, e).concat(-129 & t[e]),
          n = 0 != (128 & t[e]),
          i = o.intFromLE(r);
      return this.curve.pointFromY(i, n);
    }, c.prototype.encodeInt = function (t) {
      return t.toArray("le", this.encodingLength);
    }, c.prototype.decodeInt = function (t) {
      return o.intFromLE(t);
    }, c.prototype.isPoint = function (t) {
      return t instanceof this.pointClass;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(3).utils,
        i = n.assert,
        o = n.parseBytes,
        a = n.cachedProperty;

    function s(t, e) {
      this.eddsa = t, this._secret = o(e.secret), t.isPoint(e.pub) ? this._pub = e.pub : this._pubBytes = o(e.pub);
    }

    s.fromPublic = function (t, e) {
      return e instanceof s ? e : new s(t, {
        pub: e
      });
    }, s.fromSecret = function (t, e) {
      return e instanceof s ? e : new s(t, {
        secret: e
      });
    }, s.prototype.secret = function () {
      return this._secret;
    }, a(s, "pubBytes", function () {
      return this.eddsa.encodePoint(this.pub());
    }), a(s, "pub", function () {
      return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
    }), a(s, "privBytes", function () {
      var t = this.eddsa,
          e = this.hash(),
          r = t.encodingLength - 1,
          n = e.slice(0, t.encodingLength);
      return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
    }), a(s, "priv", function () {
      return this.eddsa.decodeInt(this.privBytes());
    }), a(s, "hash", function () {
      return this.eddsa.hash().update(this.secret()).digest();
    }), a(s, "messagePrefix", function () {
      return this.hash().slice(this.eddsa.encodingLength);
    }), s.prototype.sign = function (t) {
      return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(t, this);
    }, s.prototype.verify = function (t, e) {
      return this.eddsa.verify(t, e, this);
    }, s.prototype.getSecret = function (t) {
      return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), t);
    }, s.prototype.getPublic = function (t) {
      return n.encode(this.pubBytes(), t);
    }, t.exports = s;
  }, function (t, e, r) {
    "use strict";

    var n = r(2),
        i = r(3).utils,
        o = i.assert,
        a = i.cachedProperty,
        s = i.parseBytes;

    function f(t, e) {
      this.eddsa = t, "object" != typeof e && (e = s(e)), Array.isArray(e) && (e = {
        R: e.slice(0, t.encodingLength),
        S: e.slice(t.encodingLength)
      }), o(e.R && e.S, "Signature without R or S"), t.isPoint(e.R) && (this._R = e.R), e.S instanceof n && (this._S = e.S), this._Rencoded = Array.isArray(e.R) ? e.R : e.Rencoded, this._Sencoded = Array.isArray(e.S) ? e.S : e.Sencoded;
    }

    a(f, "S", function () {
      return this.eddsa.decodeInt(this.Sencoded());
    }), a(f, "R", function () {
      return this.eddsa.decodePoint(this.Rencoded());
    }), a(f, "Rencoded", function () {
      return this.eddsa.encodePoint(this.R());
    }), a(f, "Sencoded", function () {
      return this.eddsa.encodeInt(this.S());
    }), f.prototype.toBytes = function () {
      return this.Rencoded().concat(this.Sencoded());
    }, f.prototype.toHex = function () {
      return i.encode(this.toBytes(), "hex").toUpperCase();
    }, t.exports = f;
  }, function (t, e, r) {
    var n = r(59);

    t.exports = function (t) {
      return "string" != typeof t ? t : n(t) ? t.slice(2) : t;
    };
  }, function (t, e, r) {
    var n = r(41),
        i = r(155);

    function o(t) {
      var e = new Error("Expect argument to be non-empty array");
      if ("object" != typeof t || !t.length) throw e;
      var r = t.map(function (t) {
        return "bytes" === t.type ? n.toBuffer(t.value) : t.value;
      }),
          o = t.map(function (t) {
        return t.type;
      }),
          a = t.map(function (t) {
        if (!t.name) throw e;
        return t.type + " " + t.name;
      });
      return i.soliditySHA3(["bytes32", "bytes32"], [i.soliditySHA3(new Array(t.length).fill("string"), a), i.soliditySHA3(o, r)]);
    }

    function a(t, e) {
      var r = n.toBuffer(e),
          i = n.fromRpcSig(r);
      return n.ecrecover(t, i.v, i.r, i.s);
    }

    function s(t) {
      var e = n.toBuffer(t.data);
      return a(n.hashPersonalMessage(e), t.sig);
    }

    function f(t, e) {
      for (var r = "" + t; r.length < e;) {
        r = "0" + r;
      }

      return r;
    }

    t.exports = {
      concatSig: function concatSig(t, e, r) {
        var i = n.fromSigned(e),
            o = n.fromSigned(r),
            a = n.bufferToInt(t),
            s = f(n.toUnsigned(i).toString("hex"), 64),
            u = f(n.toUnsigned(o).toString("hex"), 64),
            c = n.stripHexPrefix(n.intToHex(a));
        return n.addHexPrefix(s.concat(u, c)).toString("hex");
      },
      normalize: function normalize(t) {
        if (t) {
          if ("number" == typeof t) {
            var _e2 = n.toBuffer(t);

            t = n.bufferToHex(_e2);
          }

          if ("string" != typeof t) {
            var e = "eth-sig-util.normalize() requires hex string or integer input.";
            throw new Error(e += " received " + typeof t + ": " + t);
          }

          return n.addHexPrefix(t.toLowerCase());
        }
      },
      personalSign: function personalSign(t, e) {
        var r = n.toBuffer(e.data),
            i = n.hashPersonalMessage(r),
            o = n.ecsign(i, t);
        return n.bufferToHex(this.concatSig(o.v, o.r, o.s));
      },
      recoverPersonalSignature: function recoverPersonalSignature(t) {
        var e = s(t),
            r = n.publicToAddress(e);
        return n.bufferToHex(r);
      },
      extractPublicKey: function extractPublicKey(t) {
        return "0x" + s(t).toString("hex");
      },
      typedSignatureHash: function typedSignatureHash(t) {
        var e = o(t);
        return n.bufferToHex(e);
      },
      signTypedData: function signTypedData(t, e) {
        var r = o(e.data),
            i = n.ecsign(r, t);
        return n.bufferToHex(this.concatSig(i.v, i.r, i.s));
      },
      recoverTypedSignature: function recoverTypedSignature(t) {
        var e = a(o(t.data), t.sig),
            r = n.publicToAddress(e);
        return n.bufferToHex(r);
      }
    };
  }, function (t, e, r) {
    t.exports = r(156);
  }, function (t, e, r) {
    (function (e) {
      var n = r(157),
          i = r(2);

      var o = function o() {};

      function a(t) {
        return t.startsWith("int[") ? "int256" + t.slice(3) : "int" === t ? "int256" : t.startsWith("uint[") ? "uint256" + t.slice(4) : "uint" === t ? "uint256" : t.startsWith("fixed[") ? "fixed128x128" + t.slice(5) : "fixed" === t ? "fixed128x128" : t.startsWith("ufixed[") ? "ufixed128x128" + t.slice(6) : "ufixed" === t ? "ufixed128x128" : t;
      }

      function s(t) {
        return parseInt(/^\D+(\d+)$/.exec(t)[1], 10);
      }

      function f(t) {
        var e = /^\D+(\d+)x(\d+)$/.exec(t);
        return [parseInt(e[1], 10), parseInt(e[2], 10)];
      }

      function u(t) {
        var e = t.match(/(.*)\[(.*?)\]$/);
        return e ? "" === e[2] ? "dynamic" : parseInt(e[2], 10) : null;
      }

      function c(t) {
        var e = typeof t;
        if ("string" === e) return n.isHexPrefixed(t) ? new i(n.stripHexPrefix(t), 16) : new i(t, 10);
        if ("number" === e) return new i(t);
        if (t.toArray) return t;
        throw new Error("Argument is not a number");
      }

      function h(t) {
        var e = /^(\w+)\((.*)\)$/.exec(t);
        if (3 !== e.length) throw new Error("Invalid method signature");
        var r = /^(.+)\):\((.+)$/.exec(e[2]);
        if (null !== r && 3 === r.length) return {
          method: e[1],
          args: r[1].split(","),
          retargs: r[2].split(",")
        };
        var n = e[2].split(",");
        return 1 === n.length && "" === n[0] && (n = []), {
          method: e[1],
          args: n
        };
      }

      function l(t, r) {
        var o, a, h, d;
        if ("address" === t) return l("uint160", c(r));
        if ("bool" === t) return l("uint8", r ? 1 : 0);
        if ("string" === t) return l("bytes", e.from(r, "utf8"));

        if (A(t)) {
          if (void 0 === r.length) throw new Error("Not an array?");
          if ("dynamic" !== (o = u(t)) && 0 !== o && r.length > o) throw new Error("Elements exceed array size: " + o);

          for (d in h = [], t = t.slice(0, t.lastIndexOf("[")), "string" == typeof r && (r = JSON.parse(r)), r) {
            h.push(l(t, r[d]));
          }

          if ("dynamic" === o) {
            var p = l("uint256", r.length);
            h.unshift(p);
          }

          return e.concat(h);
        }

        if ("bytes" === t) return r = e.from(r), h = e.concat([l("uint256", r.length), r]), r.length % 32 != 0 && (h = e.concat([h, n.zeros(32 - r.length % 32)])), h;

        if (t.startsWith("bytes")) {
          if ((o = s(t)) < 1 || o > 32) throw new Error("Invalid bytes<N> width: " + o);
          return n.setLengthRight(r, 32);
        }

        if (t.startsWith("uint")) {
          if ((o = s(t)) % 8 || o < 8 || o > 256) throw new Error("Invalid uint<N> width: " + o);
          if ((a = c(r)).bitLength() > o) throw new Error("Supplied uint exceeds width: " + o + " vs " + a.bitLength());
          if (a < 0) throw new Error("Supplied uint is negative");
          return a.toArrayLike(e, "be", 32);
        }

        if (t.startsWith("int")) {
          if ((o = s(t)) % 8 || o < 8 || o > 256) throw new Error("Invalid int<N> width: " + o);
          if ((a = c(r)).bitLength() > o) throw new Error("Supplied int exceeds width: " + o + " vs " + a.bitLength());
          return a.toTwos(256).toArrayLike(e, "be", 32);
        }

        if (t.startsWith("ufixed")) {
          if (o = f(t), (a = c(r)) < 0) throw new Error("Supplied ufixed is negative");
          return l("uint256", a.mul(new i(2).pow(new i(o[1]))));
        }

        if (t.startsWith("fixed")) return o = f(t), l("int256", c(r).mul(new i(2).pow(new i(o[1]))));
        throw new Error("Unsupported or invalid type: " + t);
      }

      function d(t, r, n) {
        var o, a, s, f;
        if ("string" == typeof t && (t = p(t)), "address" === t.name) return d(t.rawType, r, n).toArrayLike(e, "be", 20).toString("hex");
        if ("bool" === t.name) return d(t.rawType, r, n).toString() === new i(1).toString();

        if ("string" === t.name) {
          var u = d(t.rawType, r, n);
          return e.from(u, "utf8").toString();
        }

        if (t.isArray) {
          for (s = [], o = t.size, "dynamic" === t.size && (n = d("uint256", r, n).toNumber(), o = d("uint256", r, n).toNumber(), n += 32), f = 0; f < o; f++) {
            var c = d(t.subArray, r, n);
            s.push(c), n += t.subArray.memoryUsage;
          }

          return s;
        }

        if ("bytes" === t.name) return n = d("uint256", r, n).toNumber(), o = d("uint256", r, n).toNumber(), r.slice(n + 32, n + 32 + o);
        if (t.name.startsWith("bytes")) return r.slice(n, n + t.size);

        if (t.name.startsWith("uint")) {
          if ((a = new i(r.slice(n, n + 32), 16, "be")).bitLength() > t.size) throw new Error("Decoded int exceeds width: " + t.size + " vs " + a.bitLength());
          return a;
        }

        if (t.name.startsWith("int")) {
          if ((a = new i(r.slice(n, n + 32), 16, "be").fromTwos(256)).bitLength() > t.size) throw new Error("Decoded uint exceeds width: " + t.size + " vs " + a.bitLength());
          return a;
        }

        if (t.name.startsWith("ufixed")) {
          if (o = new i(2).pow(new i(t.size[1])), !(a = d("uint256", r, n)).mod(o).isZero()) throw new Error("Decimals not supported yet");
          return a.div(o);
        }

        if (t.name.startsWith("fixed")) {
          if (o = new i(2).pow(new i(t.size[1])), !(a = d("int256", r, n)).mod(o).isZero()) throw new Error("Decimals not supported yet");
          return a.div(o);
        }

        throw new Error("Unsupported or invalid type: " + t.name);
      }

      function p(t) {
        var e, r, n;

        if (A(t)) {
          e = u(t);
          var i = t.slice(0, t.lastIndexOf("["));
          return i = p(i), r = {
            isArray: !0,
            name: t,
            size: e,
            memoryUsage: "dynamic" === e ? 32 : i.memoryUsage * e,
            subArray: i
          };
        }

        switch (t) {
          case "address":
            n = "uint160";
            break;

          case "bool":
            n = "uint8";
            break;

          case "string":
            n = "bytes";
        }

        if (r = {
          rawType: n,
          name: t,
          memoryUsage: 32
        }, t.startsWith("bytes") && "bytes" !== t || t.startsWith("uint") || t.startsWith("int") ? r.size = s(t) : (t.startsWith("ufixed") || t.startsWith("fixed")) && (r.size = f(t)), t.startsWith("bytes") && "bytes" !== t && (r.size < 1 || r.size > 32)) throw new Error("Invalid bytes<N> width: " + r.size);
        if ((t.startsWith("uint") || t.startsWith("int")) && (r.size % 8 || r.size < 8 || r.size > 256)) throw new Error("Invalid int/uint<N> width: " + r.size);
        return r;
      }

      function g(t) {
        return "string" === t || "bytes" === t || "dynamic" === u(t);
      }

      function A(t) {
        return t.lastIndexOf("]") === t.length - 1;
      }

      function b(t, e) {
        return t.startsWith("address") || t.startsWith("bytes") ? "0x" + e.toString("hex") : e.toString();
      }

      o.eventID = function (t, r) {
        var i = t + "(" + r.map(a).join(",") + ")";
        return n.keccak256(e.from(i));
      }, o.methodID = function (t, e) {
        return o.eventID(t, e).slice(0, 4);
      }, o.rawEncode = function (t, r) {
        var n = [],
            i = [],
            o = 0;
        t.forEach(function (t) {
          if (A(t)) {
            var e = u(t);
            o += "dynamic" !== e ? 32 * e : 32;
          } else o += 32;
        });

        for (var s = 0; s < t.length; s++) {
          var f = a(t[s]),
              c = l(f, r[s]);
          g(f) ? (n.push(l("uint256", o)), i.push(c), o += c.length) : n.push(c);
        }

        return e.concat(n.concat(i));
      }, o.rawDecode = function (t, r) {
        var n = [];
        r = e.from(r);

        for (var i = 0, o = 0; o < t.length; o++) {
          var s = p(a(t[o])),
              f = d(s, r, i);
          i += s.memoryUsage, n.push(f);
        }

        return n;
      }, o.simpleEncode = function (t) {
        var r = Array.prototype.slice.call(arguments).slice(1),
            n = h(t);
        if (r.length !== n.args.length) throw new Error("Argument count mismatch");
        return e.concat([o.methodID(n.method, n.args), o.rawEncode(n.args, r)]);
      }, o.simpleDecode = function (t, e) {
        var r = h(t);
        if (!r.retargs) throw new Error("No return values in method");
        return o.rawDecode(r.retargs, e);
      }, o.stringify = function (t, e) {
        var r = [];

        for (var n in t) {
          var i = t[n],
              o = e[n];
          o = /^[^\[]+\[.*\]$/.test(i) ? o.map(function (t) {
            return b(i, t);
          }).join(", ") : b(i, o), r.push(o);
        }

        return r;
      }, o.solidityPack = function (t, r) {
        if (t.length !== r.length) throw new Error("Number of types are not matching the values");

        for (var i, o, f = [], u = 0; u < t.length; u++) {
          var h = a(t[u]),
              l = r[u];
          if ("bytes" === h) f.push(l);else if ("string" === h) f.push(e.from(l, "utf8"));else if ("bool" === h) f.push(e.from(l ? "01" : "00", "hex"));else if ("address" === h) f.push(n.setLengthLeft(l, 20));else if (h.startsWith("bytes")) {
            if ((i = s(h)) < 1 || i > 32) throw new Error("Invalid bytes<N> width: " + i);
            f.push(n.setLengthRight(l, i));
          } else if (h.startsWith("uint")) {
            if ((i = s(h)) % 8 || i < 8 || i > 256) throw new Error("Invalid uint<N> width: " + i);
            if ((o = c(l)).bitLength() > i) throw new Error("Supplied uint exceeds width: " + i + " vs " + o.bitLength());
            f.push(o.toArrayLike(e, "be", i / 8));
          } else {
            if (!h.startsWith("int")) throw new Error("Unsupported or invalid type: " + h);
            if ((i = s(h)) % 8 || i < 8 || i > 256) throw new Error("Invalid int<N> width: " + i);
            if ((o = c(l)).bitLength() > i) throw new Error("Supplied int exceeds width: " + i + " vs " + o.bitLength());
            f.push(o.toTwos(i).toArrayLike(e, "be", i / 8));
          }
        }

        return e.concat(f);
      }, o.soliditySHA3 = function (t, e) {
        return n.keccak256(o.solidityPack(t, e));
      }, o.soliditySHA256 = function (t, e) {
        return n.sha256(o.solidityPack(t, e));
      }, o.solidityRIPEMD160 = function (t, e) {
        return n.ripemd160(o.solidityPack(t, e), !0);
      }, o.fromSerpent = function (t) {
        for (var e, r = [], n = 0; n < t.length; n++) {
          var i = t[n];
          if ("s" === i) r.push("bytes");else if ("b" === i) {
            for (var o = "bytes", a = n + 1; a < t.length && (e = t[a]) >= "0" && e <= "9";) {
              o += t[a] - "0", a++;
            }

            n = a - 1, r.push(o);
          } else if ("i" === i) r.push("int256");else {
            if ("a" !== i) throw new Error("Unsupported or invalid type: " + i);
            r.push("int256[]");
          }
        }

        return r;
      }, o.toSerpent = function (t) {
        for (var e = [], r = 0; r < t.length; r++) {
          var n = t[r];
          if ("bytes" === n) e.push("s");else if (n.startsWith("bytes")) e.push("b" + s(n));else if ("int256" === n) e.push("i");else {
            if ("int256[]" !== n) throw new Error("Unsupported or invalid type: " + n);
            e.push("a");
          }
        }

        return e.join("");
      }, t.exports = o;
    }).call(this, r(7).Buffer);
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n = r(2);
    e.BN = n;
    var i = r(57);
    e.rlp = i;
    var o = r(42),
        a = r(47);
    e.secp256k1 = a;
    var s = r(56),
        f = r(29),
        u = r(1).Buffer,
        c = r(58);

    function h(t, e) {
      return e ? t - (2 * e + 35) : t - 27;
    }

    function l(t) {
      return 0 === t || 1 === t;
    }

    Object.assign(e, c), e.MAX_INTEGER = new n("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16), e.TWO_POW256 = new n("10000000000000000000000000000000000000000000000000000000000000000", 16), e.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470", e.KECCAK256_NULL = u.from(e.KECCAK256_NULL_S, "hex"), e.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347", e.KECCAK256_RLP_ARRAY = u.from(e.KECCAK256_RLP_ARRAY_S, "hex"), e.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421", e.KECCAK256_RLP = u.from(e.KECCAK256_RLP_S, "hex"), e.zeros = function (t) {
      return u.allocUnsafe(t).fill(0);
    }, e.zeroAddress = function () {
      var t = e.zeros(20);
      return e.bufferToHex(t);
    }, e.setLengthLeft = function (t, r, n) {
      void 0 === n && (n = !1);
      var i = e.zeros(r);
      return t = e.toBuffer(t), n ? t.length < r ? (t.copy(i), i) : t.slice(0, r) : t.length < r ? (t.copy(i, r - t.length), i) : t.slice(-r);
    }, e.setLength = e.setLengthLeft, e.setLengthRight = function (t, r) {
      return e.setLength(t, r, !0);
    }, e.unpad = function (t) {
      for (var e = (t = c.stripHexPrefix(t))[0]; t.length > 0 && "0" === e.toString();) {
        e = (t = t.slice(1))[0];
      }

      return t;
    }, e.stripZeros = e.unpad, e.toBuffer = function (t) {
      if (!u.isBuffer(t)) if (Array.isArray(t)) t = u.from(t);else if ("string" == typeof t) t = e.isHexString(t) ? u.from(e.padToEven(e.stripHexPrefix(t)), "hex") : u.from(t);else if ("number" == typeof t) t = e.intToBuffer(t);else if (null == t) t = u.allocUnsafe(0);else if (n.isBN(t)) t = t.toArrayLike(u);else {
        if (!t.toArray) throw new Error("invalid type");
        t = u.from(t.toArray());
      }
      return t;
    }, e.bufferToInt = function (t) {
      return new n(e.toBuffer(t)).toNumber();
    }, e.bufferToHex = function (t) {
      return "0x" + (t = e.toBuffer(t)).toString("hex");
    }, e.fromSigned = function (t) {
      return new n(t).fromTwos(256);
    }, e.toUnsigned = function (t) {
      return u.from(t.toTwos(256).toArray());
    }, e.keccak = function (t, r) {
      return void 0 === r && (r = 256), t = e.toBuffer(t), r || (r = 256), o("keccak" + r).update(t).digest();
    }, e.keccak256 = function (t) {
      return e.keccak(t);
    }, e.sha256 = function (t) {
      return t = e.toBuffer(t), f("sha256").update(t).digest();
    }, e.ripemd160 = function (t, r) {
      t = e.toBuffer(t);
      var n = f("rmd160").update(t).digest();
      return !0 === r ? e.setLength(n, 32) : n;
    }, e.rlphash = function (t) {
      return e.keccak(i.encode(t));
    }, e.isValidPrivate = function (t) {
      return a.privateKeyVerify(t);
    }, e.isValidPublic = function (t, e) {
      return void 0 === e && (e = !1), 64 === t.length ? a.publicKeyVerify(u.concat([u.from([4]), t])) : !!e && a.publicKeyVerify(t);
    }, e.pubToAddress = function (t, r) {
      return void 0 === r && (r = !1), t = e.toBuffer(t), r && 64 !== t.length && (t = a.publicKeyConvert(t, !1).slice(1)), s(64 === t.length), e.keccak(t).slice(-20);
    }, e.publicToAddress = e.pubToAddress, e.privateToPublic = function (t) {
      return t = e.toBuffer(t), a.publicKeyCreate(t, !1).slice(1);
    }, e.importPublic = function (t) {
      return 64 !== (t = e.toBuffer(t)).length && (t = a.publicKeyConvert(t, !1).slice(1)), t;
    }, e.ecsign = function (t, e, r) {
      var n = a.sign(t, e),
          i = n.recovery;
      return {
        r: n.signature.slice(0, 32),
        s: n.signature.slice(32, 64),
        v: r ? i + (2 * r + 35) : i + 27
      };
    }, e.hashPersonalMessage = function (t) {
      var r = e.toBuffer("Ethereum Signed Message:\n" + t.length.toString());
      return e.keccak(u.concat([r, t]));
    }, e.ecrecover = function (t, r, n, i, o) {
      var s = u.concat([e.setLength(n, 32), e.setLength(i, 32)], 64),
          f = h(r, o);
      if (!l(f)) throw new Error("Invalid signature v value");
      var c = a.recover(t, s, f);
      return a.publicKeyConvert(c, !1).slice(1);
    }, e.toRpcSig = function (t, r, n, i) {
      if (!l(h(t, i))) throw new Error("Invalid signature v value");
      return e.bufferToHex(u.concat([e.setLengthLeft(r, 32), e.setLengthLeft(n, 32), e.toBuffer(t)]));
    }, e.fromRpcSig = function (t) {
      var r = e.toBuffer(t);
      if (65 !== r.length) throw new Error("Invalid signature length");
      var n = r[64];
      return n < 27 && (n += 27), {
        v: n,
        r: r.slice(0, 32),
        s: r.slice(32, 64)
      };
    }, e.privateToAddress = function (t) {
      return e.publicToAddress(e.privateToPublic(t));
    }, e.isValidAddress = function (t) {
      return /^0x[0-9a-fA-F]{40}$/.test(t);
    }, e.isZeroAddress = function (t) {
      return e.zeroAddress() === e.addHexPrefix(t);
    }, e.toChecksumAddress = function (t) {
      t = c.stripHexPrefix(t).toLowerCase();

      for (var r = e.keccak(t).toString("hex"), n = "0x", i = 0; i < t.length; i++) {
        parseInt(r[i], 16) >= 8 ? n += t[i].toUpperCase() : n += t[i];
      }

      return n;
    }, e.isValidChecksumAddress = function (t) {
      return e.isValidAddress(t) && e.toChecksumAddress(t) === t;
    }, e.generateAddress = function (t, r) {
      t = e.toBuffer(t);
      var i = new n(r);
      return i.isZero() ? e.rlphash([t, null]).slice(-20) : e.rlphash([t, u.from(i.toArray())]).slice(-20);
    }, e.generateAddress2 = function (t, r, n) {
      var i = e.toBuffer(t),
          o = e.toBuffer(r),
          a = e.toBuffer(n);
      return s(20 === i.length), s(32 === o.length), e.keccak256(u.concat([u.from("ff", "hex"), i, o, e.keccak256(a)])).slice(-20);
    }, e.isPrecompiled = function (t) {
      var r = e.unpad(t);
      return 1 === r.length && r[0] >= 1 && r[0] <= 8;
    }, e.addHexPrefix = function (t) {
      return "string" != typeof t ? t : c.isHexPrefixed(t) ? t : "0x" + t;
    }, e.isValidSignature = function (t, e, r, i, o) {
      void 0 === i && (i = !0);
      var a = new n("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16),
          s = new n("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
      if (32 !== e.length || 32 !== r.length) return !1;
      if (!l(h(t, o))) return !1;
      var f = new n(e),
          u = new n(r);
      return !(f.isZero() || f.gt(s) || u.isZero() || u.gt(s)) && (!i || 1 !== u.cmp(a));
    }, e.baToJSON = function (t) {
      if (u.isBuffer(t)) return "0x" + t.toString("hex");

      if (t instanceof Array) {
        for (var r = [], n = 0; n < t.length; n++) {
          r.push(e.baToJSON(t[n]));
        }

        return r;
      }
    }, e.defineProperties = function (t, r, n) {
      if (t.raw = [], t._fields = [], t.toJSON = function (r) {
        if (void 0 === r && (r = !1), r) {
          var n = {};
          return t._fields.forEach(function (e) {
            n[e] = "0x" + t[e].toString("hex");
          }), n;
        }

        return e.baToJSON(t.raw);
      }, t.serialize = function () {
        return i.encode(t.raw);
      }, r.forEach(function (r, n) {
        function i() {
          return t.raw[n];
        }

        function o(i) {
          "00" !== (i = e.toBuffer(i)).toString("hex") || r.allowZero || (i = u.allocUnsafe(0)), r.allowLess && r.length ? (i = e.stripZeros(i), s(r.length >= i.length, "The field " + r.name + " must not have more " + r.length + " bytes")) : r.allowZero && 0 === i.length || !r.length || s(r.length === i.length, "The field " + r.name + " must have byte length of " + r.length), t.raw[n] = i;
        }

        t._fields.push(r.name), Object.defineProperty(t, r.name, {
          enumerable: !0,
          configurable: !0,
          get: i,
          set: o
        }), r.default && (t[r.name] = r.default), r.alias && Object.defineProperty(t, r.alias, {
          enumerable: !1,
          configurable: !0,
          set: o,
          get: i
        });
      }), n) if ("string" == typeof n && (n = u.from(c.stripHexPrefix(n), "hex")), u.isBuffer(n) && (n = i.decode(n)), Array.isArray(n)) {
        if (n.length > t._fields.length) throw new Error("wrong number of fields in data");
        n.forEach(function (r, n) {
          t[t._fields[n]] = e.toBuffer(r);
        });
      } else {
        if ("object" != typeof n) throw new Error("invalid data");
        var o = Object.keys(n);
        r.forEach(function (e) {
          -1 !== o.indexOf(e.name) && (t[e.name] = n[e.name]), -1 !== o.indexOf(e.alias) && (t[e.alias] = n[e.alias]);
        });
      }
    };
  }, function (t, e, r) {
    (function (e) {
      !function (r) {
        "use strict";

        var n = function n(t) {
          setTimeout(t, 0);
        };

        void 0 !== e && e && "function" == typeof e.nextTick && (n = e.nextTick), t.exports = function (t) {
          var e = {
            capacity: t || 1,
            current: 0,
            queue: [],
            firstHere: !1,
            take: function take() {
              if (!1 === e.firstHere) {
                e.current++, e.firstHere = !0;
                var t = 1;
              } else t = 0;

              var r = {
                n: 1
              };
              "function" == typeof arguments[0] ? r.task = arguments[0] : r.n = arguments[0], arguments.length >= 2 && ("function" == typeof arguments[1] ? r.task = arguments[1] : r.n = arguments[1]);
              var n = r.task;
              if (r.task = function () {
                n(e.leave);
              }, e.current + r.n - t > e.capacity) return 1 === t && (e.current--, e.firstHere = !1), e.queue.push(r);
              e.current += r.n - t, r.task(e.leave), 1 === t && (e.firstHere = !1);
            },
            leave: function leave(t) {
              if (t = t || 1, e.current -= t, e.queue.length) {
                var r = e.queue[0];
                r.n + e.current > e.capacity || (e.queue.shift(), e.current += r.n, n(r.task));
              } else if (e.current < 0) throw new Error("leave called too many times.");
            },
            available: function available(t) {
              return t = t || 1, e.current + t <= e.capacity;
            }
          };
          return e;
        };
      }();
    }).call(this, r(6));
  }, function (t, e, r) {
    var n = r(61);

    function i() {}

    t.exports = i, i.prototype.setEngine = function (t) {
      var e = this;
      e.engine || (e.engine = t, t.on("block", function (t) {
        e.currentBlock = t;
      }), t.on("start", function () {
        e.start();
      }), t.on("stop", function () {
        e.stop();
      }));
    }, i.prototype.handleRequest = function (t, e, r) {
      throw new Error("Subproviders should override `handleRequest`.");
    }, i.prototype.emitPayload = function (t, e) {
      this.engine.sendAsync(n(t), e);
    }, i.prototype.stop = function () {}, i.prototype.start = function () {};
  }, function (t, e) {
    var r = 3;

    t.exports = function () {
      var t = new Date().getTime() * Math.pow(10, r),
          e = Math.floor(Math.random() * Math.pow(10, r));
      return t + e;
    };
  }, function (t, e, r) {
    var n = r(61);

    t.exports = function (t, e, r) {
      t.sendAsync(n({
        method: "eth_estimateGas",
        params: [e]
      }), function (t, e) {
        if (t) return "no contract code at given address" === t.message ? r(null, "0xcf08") : r(t);
        r(null, e.result);
      });
    };
  }]);
});